<script>
  import { onMount } from "svelte";

  let viewer;
  let colorString = "";
  let colors = [];
  let styles = '';
  let color_scheme = {};
  let aggCodeValues = 0;

  onMount(async () => {
    await load();
	  //setInterval(await load(), 1000);
  });

  let loaded = false;
  const load = async () => {
	loaded = false;
  console.log('randomString', randomString(34));
    viewer =
      new URLSearchParams(window.location.search).get("viewer") || 'tz2NHCNf862d1j9pfEk37vRRwv8tMCE2hJFv';
    colorString = await calcColorString(reverseString(viewer));
   
    colors = await calcGradientColors(colorString);
    await setColorScheme();
    await setSVGStyles();

	loaded = true;

	
  };

  function reverseString(str) {
    return str.split("").reverse().join("");
}

  const randomString = (length = 36) => {
    return Math.random().toString(16).substr(0, length);
	};

  const setColorScheme = async () => {
	color_scheme = {
	  background_color: await getColor(0),
	  fur_color: await getColor(1),
	  skin_color: await getColor(2),
	  beard_skin_color: await getColor(3),
	  highlight_color: await getColor(4),
	  right_ear_highlight_color: await getColor(5),
	  major_shadows_color: await getColor(6),
	  eye_whites_color: await getColor(7),
	  show_hat: (aggCodeValues % 2 == 0 ? true : false),
	  hat_color: await getColor(8),
	  hat_shadow_color: await getColor(9),
	  show_sunglasses: (aggCodeValues % 3 == 0 ? true : false),
	  sunglass_color: await getColor(10),
	  sunglass_lens_color: await getColor(11),
	  sunglass_lens_reflection_color: await getColor(12),
	  show_sweater: (aggCodeValues % 4 == 0 ? true : false),
	  sweater_color: await getColor(13),
	  sweater_shadow_color: await getColor(14)
  };
  
	console.log('aggCodeValues', aggCodeValues)
	console.log('aggCodeValues', aggCodeValues % 2)
	console.log('aggCodeValues', aggCodeValues % 3)
	console.log('aggCodeValues', aggCodeValues % 4)
	console.log('aggCodeValues', aggCodeValues % 5)
	return;
  }


  const getColor = async (index) => {
	  try{
		  return colors[index];
	  }
	  catch(e){
		  //cycle through from the start to re-use another index
		  colors[index - colors.length];
	  }
  }

  const setSVGStyles = async () => {
	styles = `<style type="text/css">
	/*background - should match*/
	.st0 {
	  fill: ${color_scheme.background_color};
	}
	.st1 {
	  fill: ${color_scheme.background_color};
	}
  
	/*
	  *********
	  ape
	  *********
	  */
  
	/*fur*/
	.st2 {
	  fill: ${color_scheme.fur_color};
	}
  
	/*skin*/
	.st3 {
	  fill: ${color_scheme.skin_color};
	}
  
	/*beard skin*/
	.st13 {
	  fill: ${color_scheme.beard_skin_color};
	}
  
	/*highlight*/
	.st4 {
	  fill: ${color_scheme.highlight_color};
	}
  
	/*right ear highlight*/
	.st6 {
	  fill: ${color_scheme.right_ear_highlight_color};
	}
  
	/*major shadows - should be slightly darker than skin tone*/
	.st7 {
	  fill: ${color_scheme.major_shadows_color};
	}
  
	/*eye whites*/
	.st8 {
	  fill: #ffffff;
	}
  
	/*outlines*/
	.st5 {
	  fill: none;
	  stroke: #000000;
	  stroke-width: 3.5;
	  stroke-linecap: round;
	  stroke-linejoin: round;
	  stroke-miterlimit: 10;
	}
	.st12 {
	  fill: none;
	  stroke: #000000;
	  stroke-width: 3.4742;
	  stroke-linecap: round;
	  stroke-linejoin: round;
	  stroke-miterlimit: 10;
	}
	.st16 {
	  fill: none;
	  stroke: #000000;
	  stroke-width: 4;
	  stroke-miterlimit: 10;
	}
  
	/*
	  *********
	  accessories
	  *********
	  */
  
	
	  #militaryHat{display:${(color_scheme.show_hat ? '' : 'none')};}
	  
  
	/*hat color*/
	.st17 {
	  fill: ${color_scheme.hat_color};
	}
  
	/*hat shadow*/
	.st18 {
	  fill: ${color_scheme.hat_shadow_color};
	}
  
	
	#sunglasses{display:${(color_scheme.show_sunglasses ? '' : 'none')};}
	
  
	/*sunglass color*/
	.st9 {
	  fill: ${color_scheme.sunglass_color};
	  opacity:0.65;
	}
  
	/*sunglass lens */
	.st10 {
	  fill: ${color_scheme.sunglass_lens_color};
	  opacity:0.5;
	}
  
	/*sunglass lens reflection*/
	.st11 {
	  fill: ${color_scheme.sunglass_lens_reflection_color};
	  opacity:0.5;
	}
  
	 #frames-fill{
		opacity: 1
	 }
	
	#woolSweater-6068{display:${(color_scheme.show_sweater ? '' : 'none')};}
	
  
	/*sweater color*/
	.st14 {
	  fill: ${color_scheme.sweater_color};
	}
  
	/*sweater shadows*/
	.st15 {
	  fill: ${color_scheme.sweater_shadow_color};
	}

	</style>
	`;

	return;
  }

  const calcColorString = async (wallet_address) => {
    let color_string = "";
    for (let i = 0; i < wallet_address.length; i++) {
      color_string += await translateCharToColor(wallet_address.charAt(i));
    }
    return color_string;
  };
  const calcGradientColors = async (color_string) => {
    let colors = [];
    let runs = Math.floor(color_string.length / 6);
    for (let i = 0; i < runs; i++) {
      let hex = color_string.substring(i * 6, (i + 1) * 6);
      colors.push("#" + hex);
    }
    return colors;
  };
  const translateCharToColor = async (character) => {
    let code = character.charCodeAt(0);
	aggCodeValues += code;
    return code;
  };
</script>


<style type="text/css">
  
	main {
	  text-align: center;
	 
	  margin: 0 auto;
	}
  
	h1 {
	  color: #ff3e00;
	  text-transform: uppercase;
	  font-size: 4em;
	  font-weight: 100;
	}

  </style>

{#if loaded}
<main>
  <div>
	  
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      style="enable-background:new 0 0 1000 1000;"
      xml:space="preserve"
    >

	{@html styles}

      <metadata
        ><!--?xpacket begin="﻿" id="W5M0MpCehiHzreSzNTczkc9d"?-->
        <x:xmpmeta
          xmlns:x="adobe:ns:meta/"
          x:xmptk="Adobe XMP Core 6.0-c004 79.164570, 2020/11/18-15:51:46        "
        >
          <rdf:rdf xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
            <rdf:description
              rdf:about=""
              xmlns:dc="http://purl.org/dc/elements/1.1/"
              xmlns:xmp="http://ns.adobe.com/xap/1.0/"
              xmlns:xmpgimg="http://ns.adobe.com/xap/1.0/g/img/"
              xmlns:xmpmm="http://ns.adobe.com/xap/1.0/mm/"
              xmlns:stref="http://ns.adobe.com/xap/1.0/sType/ResourceRef#"
              xmlns:stevt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#"
              xmlns:illustrator="http://ns.adobe.com/illustrator/1.0/"
              xmlns:xmptpg="http://ns.adobe.com/xap/1.0/t/pg/"
              xmlns:stdim="http://ns.adobe.com/xap/1.0/sType/Dimensions#"
              xmlns:xmpg="http://ns.adobe.com/xap/1.0/g/"
              xmlns:pdf="http://ns.adobe.com/pdf/1.3/"
              xmlns:pdfx="http://ns.adobe.com/pdfx/1.3/"
              xmlns:xmprights="http://ns.adobe.com/xap/1.0/rights/"
              xmlns:photoshop="http://ns.adobe.com/photoshop/1.0/"
            >
              <dc:format>image/svg+xml</dc:format>
              <dc:title>
                <rdf:alt>
                  <rdf:li xml:lang="x-default">Ape6068</rdf:li>
                </rdf:alt>
              </dc:title>
              <dc:creator>
                <rdf:seq>
                  <rdf:li>Mike Three</rdf:li>
                </rdf:seq>
              </dc:creator>
              <dc:description>
                <rdf:alt>
                  <rdf:li xml:lang="x-default"
                    >https://twitter.com/ape6068</rdf:li
                  >
                </rdf:alt>
              </dc:description>
              <dc:subject>
                <rdf:bag>
                  <rdf:li>BAYC</rdf:li>
                  <rdf:li>Bored Ape Yacht Club</rdf:li>
                  <rdf:li>Bored Ape</rdf:li>
                  <rdf:li>Ape 6068</rdf:li>
                  <rdf:li>6068</rdf:li>
                </rdf:bag>
              </dc:subject>
              <dc:rights>
                <rdf:alt>
                  <rdf:li xml:lang="x-default"
                    >YOU ARE FREE TO SHARE AND ADAPT Share: copy and
                    redistribute the material in any medium or format Adapt:
                    remix, transform, and build upon the material for any
                    purpose, even commercially.</rdf:li
                  >
                </rdf:alt>
              </dc:rights>
              <xmp:creatortool
                >Adobe Illustrator 25.2 (Macintosh)</xmp:creatortool
              >
              <xmp:createdate>2021-06-29T05:42:35-04:00</xmp:createdate>
              <xmp:modifydate>2021-06-29T05:42:35-04:00</xmp:modifydate>
              <xmp:metadatadate>2021-06-29T05:42:35-04:00</xmp:metadatadate>
              <xmp:thumbnails>
                <rdf:alt>
                  <rdf:li rdf:parsetype="Resource">
                    <xmpgimg:width>256</xmpgimg:width>
                    <xmpgimg:height>256</xmpgimg:height>
                    <xmpgimg:format>JPEG</xmpgimg:format>
                    <xmpgimg:image
                      >/9j/4AAQSkZJRgABAgEASABIAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA+0AAAAAABAASAAAAAEA
                      AQBIAAAAAQAB/+4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK
                      DBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f
                      Hx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAAEAAwER
                      AAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA
                      AQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB
                      UtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE
                      1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1+f3OEhYaHiImKi4yNjo+Ck5SVlpeYmZ
                      qbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy
                      obHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp
                      0+PzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1+f3OEhYaHiImKi4yNjo
                      +DlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq+v/aAAwDAQACEQMRAD8A75nOtzsVdirsVdirsVdi
                      rsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdiqy4/uJP9Vv1YY8wg
                      8l+BLsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirs
                      Vdiqy4/uJP8AVb9WGPMIPJfgS7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7
                      FXYq7FXYq7FXYq7FXYq7FXYqsuP7iT/Vb9WGPMIPJfgS7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7F
                      XYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYqsuP7iT/Vb9WGPMIPJfgS7FXYq7FXYq7FX
                      Yq7FXYq7FXYqgdX13RdGtxc6tf29hATxWS5lSJWaleK8yKn2GGMSeQQwq+/PXyJCwSxN5qshNClp
                      bOv0hrn6ujD/AFScyBpZnyRxBIdT/Pu5hQlNKtbBD9iXUL0K1PExInH/AJK5bHR95RxsVvfz58w3
                      QpFq8EXYHS7CSUnf+aX64uWjSRCOIpRP+Znm6/bj9b1y6cjpGYrEU/55m1p92WDBAdAiyhpNe88X
                      Gxi1BlrUC71m4IB33orzjJeHDuHyRaR6rq2uWd/YWl5aWpbVHaNZGuLiYc9tpCyr9otTvXJCIVMV
                      0rWFIZLXTIJAftRpJWnsy8CMdlTKxn812bL6F69sgI2tL28gAHc8AWRvGhFDkTCJ6Lb2/wDK7zbe
                      a7pVzaanKJdW0uQJNNQKZYZQWgmKqFUFuLI1P2kJoAc1uoxcJ25FsibZrlDJ2KuxV2KuxV2KuxV2
                      KuxV2KrLj+4k/wBVv1YY8wg8l+BLsVdirsVdirsVdirsVdirsVSfzh5mtfLPly91q5QyraoPSgBo
                      ZZZGCRRg705uwFe3XJ44cUqQS+UdRufMXmHW5NQvrmOXUbonlO4eTgpJb04lJHpRpX4VFfeprm3j
                      ERFBqJRcHlCYg/WtTuHDfbjib0VI8P3fA0+eHiVG2nlLQLVuUdqrSd5H3Y/NuuPEVTFbGzU1EKV8
                      SoJ/HAqqqIooqhR7CmBV2Ksa8/27PoJuUJWaylSeJl68weKf8OynJx5qyC1uI7m1huYv7udFkSv8
                      rgMP15FVXAqf/l3qZ03zzp7FuMGpLJp9xU0WrKZoWPuJIuC/65yjUxuHuZRO73fNa2OxV2KuxV2K
                      uxV2KuxV2KuxVZcf3En+q36sMeYQeS/Al2KuxV2KuxV2KuxV2KuxV2KvLv8AnIZm/wAI6YoJCvqs
                      YceIFtcMK/7JQcytH9R9zGXJ475fgBlkmP7A4r8z1zYlrT3Iq7FXYq7FXYqgdbjMmj3qgVYQuyV/
                      mVSy/iMI5qgfJsxfy/BCz85LNpLRyO3oOUUf8AFwy5qnmRVSnuzZelqA66fNDej3+qyrPT6fTwEW
                      KUPpvNO3OxV2KuxV2KuxV2KuxV2KuxVZcf3En+q36sMeYQeS/Al2KuxV2KuxV2KuxV2KuxV2KvPf
                      z3s1n/L6a4PWyu7SZfm8y2/ge02ZGlPrYy5PEfLrf36/6pH45si1p1gV2KoW71TTbME3d3Db06+r
                      IqfrIw0qB/xTpj/7yJcXx/5doJHX/g+Ij/4bDwqhbnzXPEaNZxWvgb+7ggP/AAKGZvopjwqofp3U
                      7kcVmh4t1FtZ3d3t/wAZP3SdPEYaVB6Vp+sWSTray6gUnczOsdtaRfvGoCV9d9tgNv44SQqN+p+Y
                      5JAWudSVKb1Onofl8AcYNldcaTq81tNHLeagkbIwcvJZstCKEELFXpjYV9O/l5q99rPkTQNVv3El
                      9e2FvNcygBecjRgs3FQAOR3oBTNPliBIgd7aGQ5Wl2KuxV2KuxV2KuxV2KuxVZcf3En+q36sMeYQ
                      eS/Al2KuxV2KuxV2KuxV2KuxV2KsY/M6yS8/L3zDE4r6djNcIKV+O3UzJ/w0Yy3CamPeg8nzHpmu
                      2FnO6EtPNIgMdvbqZZG32+Feg36mgzb01K97retGgKwaSjdBNyuror/MIIPhH0scaCoMWN9ffFL+
                      kNQB+0biZbG2I8QkA5fQwxtVa00KKBh6ctpYt3Wxt1ln+mWUSkn/AGONqmA0W1mp60V1enubud+H
                      /IvkE/4TBatLeeXNL+ES6dYMOkcfDl9AXgfwxolVf/E2liPkhnmUdZEt5in/AAfAJ+ONKl1x5+0q
                      JuCRPI/Tj6tsp+lTLz/4XDwqoDzxfS/7y6S8h7b3Ddv+KreQfjjwqjINf1ae0kSbRbn6w/JVEQAj
                      oRsS05hI3P8ALgpXuX5P+bdC/wAIaH5cuLlbTXLG1itZbC4Ijd3iXiTCT8MwPGv7smnema3UYpCR
                      PRsBejZjMnYq7FXYq7FXYq7FXYq7FVlx/cSf6rfqwx5hB5L8CXYq7FXYq7FXYq7FXYqkvmzzhoPl
                      TSW1TWrj0YOQjhjQF5ZpW+zHFGN3Y/2mg3yUIGRoK8qu/wDnJO7EjNZ+VGNt+w93fpbyEe6Rw3Cj
                      /g8u8GP877GzwZJz5R/Pnyp5ouF0PXLJtGu78GCKOeRZ7ScyDj6SzqE+JgaAOi16CpxlgI3ibayC
                      ObwjSbD9H8LVFW1njYw3BHwfvEPB+RG/UHNpdtLIYLa3DfBKGfuYU5mv+u3On4ZFVW7OlWkPrX8q
                      Rg9GupBSvhRjQ/IYqlAv9QufgtGupgfs/VLeO0hI/wCMl1yYj3TJUrR8t6nef71GGJD1E7zag/3S
                      tHCv0IRjaou28oWkX27q4NftLCyWq/KlssO304OJUTH5W8vK3NrGKZx+3ODO33ylzjxFUwhtreBe
                      MESRL4IoUfhgVVwK0SACSaAdTiqT3/mDyxvbXNzDcH9qBAbggjxSMOa5IAqnWgfnN5g0JlW2+v6v
                      pg2azvra6fiB/vu64NMn+zEgHZRlGTTRl5FkJPVvJn52+R/M00Vj9YfStYk2XTdQUwOzCgpE7USS
                      p6AHl/kjMLJppx8wyEmf5QydirsVdirsVdirsVWXH9xJ/qt+rDHmEHkvwJdirsVdirsVdirsVcSA
                      CSaAbknFXyP+Zfna680+aJdUty08HqGw8t2qAuxh5cTLGlN3uHoakfZKjfoc+GOvT826A4RxdSmO
                      l/kb5gkjS91+KYztRvqsHByn+S8p9R2Pjw4rXpkZ562iGwY73KV+a/ypMEEsmlCSK6RSZLCcbSAd
                      qkK3L/XJ9ivXDj1O9SRPDtsxfTdcFuKXvqXE3L1yzcpHk9Riz+ox+Llz5Ak9czo7jZwpxoo+888a
                      hI8SW8LWdoHHryxiNphH34K3NK/PJCDFH6JeaVEEmvXU3cxpDrhPOOfc0HN6+i3jEab9MiQrJ35F
                      R6sYlXqHTqPenX7jkVaQ1NIZ9/8AfcgqR9B4v9+Kr+d0OsasPFW/gR/HFVwlkP8Auph8ytPwOKtm
                      WMNx5Dkf2RufuGKpTrfmzRNIBS5uAbnottEPUlJPT4Qdv9kRhESVYXdXPmzWCWh0t5IuqvqLAL7F
                      besUX3q3zyewRxBQk0jz1HFVrq4gjH+6rPhGv0JbsP8AiOG4o4gkkk/mO2Kyw6vMFb7LG4da0BYA
                      knjvTCaDMC1SHzzryg2+penqlmTSS3uUVwf9V1Fa+BqcHCEU+yPyS1DUdQ/LPSLy+keVpPXFu0ze
                      pKLdJ3SFZH/aZUUCvXx3zT6kATNNo5M5yhLsVdirsVdirsVWXH9xJ/qt+rDHmEHkvwJdirsVdirs
                      VdirsVed/nj5rOj+UG0u2kKalr5aygKmjJBSt1L/ALGM8AezMuXYY733JjHiNPKfyq0vSk8wXXmC
                      +jraeXoIY7WNVLM93ds0cKRr+06qCqr4uuX78PvcqdX7nsap54vI/V9ax0gOAUtXgkvZU3r8cqz2
                      8dexCqQOzHrkPSPNd0l8xalNZxx23nCCFLad/SsddsFdlEzCqRyWx9SaMvSg4tIp7kGmPhiXJeMj
                      m+cPP+mz6V53Yx2txHbaoA8KzwS23KRmIbgs6xt8TfFuBTlvmdp51Dfo4uaNy26qUWiajJ/eNHbr
                      9Mj/AHDio+84JasdGcdKeqHkgm0i/eOxuX/epzuRIqujFjssiU4MGANNqjxyzDMzG7XmxiJ2T+xN
                      /a2sNxFFPYxyoslbD/Sbb4wG+K0k+NP+eWSLj8QTSz12e6Ii56ffsOqiV7eUfO3lSRh/wWRIZJqZ
                      LWCD1b4pZdagzcVA/wBaqDAqWal5n0i0tkuIori/jkJWKSMOYGYCtPWkIiPvxJyQgVUvNej+d7by
                      fpnmG4lh0vStWkVIrK0LfWlSaIyxNJKVUDkEOyUpUV9ownEyMe5sljIFu8vaZoltpdpJZWyeuUY3
                      F4RylkkZiXq5qaL9kAbbV6k5OZcaRTXIMWTeQ9FN/qwuZFrbWdJGr0Mn7A/j9GTxxspYr+WNpFqH
                      nnUdRTTjeoGuW06JZlt+VZAZvT5rwd0ilT4ea7N37VavcVbm6fY2n35vWOkW1lpnmGx06bTrxrs6
                      bqdtcIUkYNC06MzVeOT01hbi0bsPipXwxIQ2I+Lk8VG2ff8AOPF28vkq+tSax2GqXMMS/wAqyJHc
                      kf8ABXDHKM/MHycfIKkXqGUsXYq7FXYq7FXYqsuP7iT/AFW/VhjzCDyX4EuxV2KuxV2KuxV2Kvmn
                      869VmuPzF1L16mDR7WC3t4132eIXUrAfzOZAP9iMyoD0gd7kYBVlkv5H6XDe6Nd30jGlvrDzJHTZ
                      iljDGnP/AFDI7D3oe2SmaAHl+lnzJP45PU728trGyuL26cR21rG808h6KkalmY/IDKgLZEsf8raX
                      NetH5o1lC2q3ic7O2koVsLaTdIYx0EhUgzP1Ztq8QBlkzWw5MIjqUp/Ovy/aan5Dv7x4wbrSFF/b
                      y03X0GDvT/YA44vq96z5PD8g5ChdwWlx5Nv7pADfWmsQesR1FtPayIlfb1Y6DM/AaIHk4Gfe/em2
                      iOG0izoahYUSo33QcT+rLDzcA81e5srO6XjcwRzqO0iK4/4YHBa2zzyH+WeiacF1S60y3S7be3iM
                      SVjB/aO32vAdvnl8InmU2WAfmfrf+KvPFvpNhG95YaXWKVYUeQUDA3UlIgXCfCsdfatab4MkqDbj
                      iyX82fOfl/zXoun6LBI+nyLfCb1J3tvTBS1uBEsjQyz+kDM0atz40BzBwwMDfNy8khIUwXyhdB7K
                      S2I4tA/IJ0IWSp3r35hq5lzcCY3ZFb281xPHBCpeWVgqIOpJ2yDB6Xftb+TfI17cBwJraB3Dn/dl
                      044xj6XKqMyYigyAY7+XOhrpnlfyEQhTUNR1WfUD4+hJY3K8j/ktbrF9JGa3NK5S9zsccaAb/wCc
                      hdRWddE0GOjyes2oXAHVI1U26E/64mkp/q5Vj2BLYRZAZr+QmmPafl9FduCG1a6uL5VP++2f0oj/
                      ALKKFW+nKc/1V3BxpGyS9FylDsVdirsVdirsVWXH9xJ/qt+rDHmEHkvwJdirsVdirsVdirsVfOn5
                      8aKbPz6t2Vpba9Yj4vGe0PpSj/kVJFmVjNw9xb8B3ITf/nHPUkl0LWNNc/6VbXaTyr4CWBIT/wAl
                      baTJ5hyLOB5s6/MWGabyJryRVLfUpiygcuSKhaRePfkgIyGL6gmfIsghlimiSaJg8Uih43U1DKwq
                      CD7jIMmNfmXf21r5J1WCVWll1K3l0+0t0FXkmuY2RVA8FFXbwUE9sniFyDCZ2fOlnJ6lpBJ15xq1
                      fmoOMhRLdE7JXe/XIVu4bd+K3SCOaNq8JEDiVK07pIisp+jcEg5GKdOPlhajpnmPUNLi9GaAmBST
                      xKlgCxr8DpWgJNfiGZdxl1cKeIvU9A0zzHYJBq2t6fp2kpJ8VlFq9+YXYih5C3jhkZiKj4SVI8Mq
                      8aIPekaY9U+lvvNHmmOXR7TzLo+lS3AK/wCjLctdFKUb0/X+r9a9VFfA4y1ddGyOm80Jo/8Azjda
                      WgC3vmCW5SoJWK0hjFR34Tm6j5eDFKjMaWovo3xw11b/ADP8jzaB5M9fS9e1alqZZHgkuQInjjtZ
                      peHpRpFGByjFdulRhwzuXILkjQ5qdv8AlR5Os9MHmLU9ZvdL9Xl/vN9XVaFqf3f1eXmWO/2ffIw1
                      Mjtss9PFvSdFlie4vvIev2Wv6jbxFl0zVITFccT1ZDE1vQn7I5RBe3IZfDPwn1BoOmB5FDaP5R88
                      /mStpqPmi8is/LKys36Nt6pK7xMY5EKCpjPJWRi7ll3AUHfJ5tUBsOa49Pe5Z7fX9ho0l55r1aE2
                      mmaPA2n6HZ8eMjAsokaOI0o07xpHEP5Fr0bbD57D4uV5vHbSy8wfmJ5za2dil/qZEmoTR/EljYJt
                      Rf8AVU8U/mc8vHDYG/8ACPtLGcuEV/EX1PY2VrYWNvY2kYitbWJILeJeixxqFRR8lFMwibNuMr4p
                      dirsVdirsVdiqy4/uJP9Vv1YY8wg8l+BLsVdirsVdirsVdirAPzr8qS695MlubNOep6K/wCkLNR9
                      p1jUieEf8ZIi1B/Nxy7DKjR5FMZUbeEeSvNY8reZ7XXYo2k0q8Qxav6dSTA4UpME7mIqG23pUd8y
                      ALBieblT/nB9M2t1aX1pFdWsqXFpcIJIZoyHR0cVDKRsQRlBFMkrtIdP8r6U0Mly50+OQixgKmR4
                      0YVW2hVAZJApB4KAW4/D0GSNyLEbBj+sXkVvbXfnHzUw0ywsLeWPSLGQgyR+svFppADQ3Ew+BEX7
                      K1Fas1JxH8MWJ7y8B0di2k2THqbeIn6UGDJ9R97dj+ke5ESwxSijrWnQ98iDTIi3WAtNO1TT9Se2
                      N3FY3cFzLbdS6RSBmCgkAsAKqD3AyyE92ucNtnoHn3WNG8028t/5T8yaZbX13CIHN3cJZ3cXAggB
                      J+Dqv2gdqgmo6YxxkH1AkNcpgjY0XjT+W/O1lO0z+ZbGFgatMut2zsad+MczSH/gczbgf4fscapD
                      r9r2T8v9Q/MbQv0brHmTVjqflbUGW3mu1WdhAW/dwmSO4jt2SMtxpNGOO/xBqhhjTEDtEbt0TIbn
                      kzb847sweVo43uvq1reXAtbwceRkgmikWcdDQRw85T/qU75VgG7PKdniv5leVfO3mJ7bWtbuDptk
                      6UsNI9C5ljs7elY1PoJJyfjT1G49fYbZGLLCPpDVkhKW5XflhceTfKF02prrEvmK+tWMltY2FvJD
                      GjvE8LcpLv0eqy/FQdh1pjnuXP0riAHLd6p5Tv70eSJvM19ryaPo97Pe311HFbo0sDy3cnKOOaTm
                      HPL4V/cksenUZTKuKgLbI3V2wDWtc8z/AJieYbPS9JtZHECkaZp8z1EMf2Wvr+TejFfnT7K1ZjVo
                      AeXU/oCylw7nn0e/+QPIel+TdF+o2rG4vJ2EupajIAJLialORA+yi9EQbKPepOJkycR8nHJvcsmy
                      CuxV2KuxV2KuxV2KrLj+4k/1W/VhjzCDyX4EuxV2KuxV2KuxV2KuxV86/mH+U2t+X9TuL/QLGTUf
                      Ll07TC2tEMk9k7tyeMQrVpIamqFBVehFADmVGYmN/q+9uxZeHY8mF6T5w1jyrIy6Zqsmko7FpbC6
                      T/Ryx3J9G4A4Me5jKk98tqR5i2y4dDTIZfz585iAD63o5NAPUjtpTJ897sr/AMLgGMfzT+PgpPmP
                      x8WD+Yb/AM6efg0am71y6To44C3t0B+Nljh/cxCgozyFTTqxy7HUTvsGnIQR3qujgrpFiDsRbxAj
                      /YDMbJ9R97l4/pHuRmQZuxVS0zyPJ5r8w2uhwBQLnlJcTleX1eBP7yT57hV/yiO2ZGPIQL7nHywB
                      NPY9H/J7yF5Khgv1sDqd39ZtbcTTkMQ1zcRwCQBthxMnIgdcrlklPmUCEY8gzSZNN81eXNT08K0d
                      rc/XdLmDqvJWikktXYLUilU5J7UOQFxILLmGN/mJp63mseUNMu4mutIuLm5gvQ5O5ks3gQswH2uM
                      r98njlQJ6sZiyGaarFNJpt0sEEVzcek5t4J9o3lCngrmhoC1KnKhXVseG/mh5YtLC40fzPZ2j2UO
                      sRfVr21lUq8M/H1oleorWgkU8vAb5aB6SO5iD6ge9IPJHkfzt5yDWVmXj0bT7ydUv7yQtaWzSOZn
                      9C3DVeY+sT0HXdsnOYAF9zVKfCT32+kvJXkbQvJ+lmx0tGaSUh729lPKe4kApzkb2/ZUUVewzDnk
                      Mi0shyCuxV2KuxV2KuxV2KuxVZcf3En+q36sMeYQeS/Al2KuxV2KuxV2KuxV2KuxV2Koc6dp5bkb
                      WHlWtfTWtfuw2UMY/N3Vjpf5b69OppLPbGyhp19S9YWyEe6mWuWYRcwmrfNKIqIqKKKoAA9hlhdi
                      3gSsmmjhieWVgkcYLOx6ADrhAs0gmntX5P8Al620bQX1W9Zf0tq5Ek6g8jBChIitzToyVJcfzkjs
                      MlkPQdGmO+7Pfr1m2xcHvuD2+jK2Snp9pYWz3T2p3vJjczLyqPUZFRio/Zrwqfep74SbQAx78y5B
                      b6Rp2osaJpuq2V3KaVpFHLSU/wDIpmww50iXJPrvXdOtdQg0+Rz9cuY5ZYYwpIKwlA9W+yCPVXat
                      fuOCtrTbEfPt5p/mPy8ulxIZLTVFra6tGRJHb3aMr2buqVb0nkBVnHToftVE8Yo7sZbrP+ccXc+V
                      daWRGimGryerCwNY3FpbI6E9KrIjVpkNQKIHl+kuPM2besZjsXYq7FXYq7FXYq7FXYq7FVlx/cSf
                      6rfqwx5hB5L8CXYq7FXYq7FXYq7FXYq7FXYq7FXkH/ORurRw6PoeltIIxd3j3ctTQGKziNa17CWa
                      M5fgHMs8Q9QeGwrMuqXHJqxuitGvgAAv6wcsNcIcsXxFG5BsTDypoV1r/mS3txbyPpVo3qX90hCo
                      kiryjHJlZSVbi3Dvttx5ZdH0i+vRoyGzT1a0TSLO88sw6TEJLWS1nitZFkIRbRo45TLSh9RneOIc
                      if2ie+QNkG0CtqTG0l1q80wSNxs7v642zIR/okd4QAVbl8UlqtK/zGopkTQLIXSlZahNrOmXhY/U
                      oruWe10uVWKyvGilBMPskMWR3Wn7FDhIooBsIHzNyvfLH6CmmNzqN1ZSPGEYssz2oT1l5n+ctx38
                      TiOdqeVILyhr8N5oNrrOsyxvNbTR2NvcKH5K0yww1lHQevJSQE7BWXvkpx3oIidrKZX1voFrNqEt
                      vdHTLzT9PlNxLClRFb3LPKs3AqyvwkikZadPiFN8AJNdd0mln5dX0flzzYdJnmijXzLGl3dWkbBo
                      7fVzGWf06AUS8jikZa/tR7daY5hxRvu+79jj5I0Xr2YjB2KuxV2KuxV2KuxV2KuxVZcf3En+q36s
                      MeYQeS/Al2KuxV2KuxV2KuxV2KuxV2KuxV80/wDOS+q+p570jTGIMMVrbg/O6uXZxXwItY6/PM3T
                      x9BPv+79rKHP5MDsXVppQ7lpw8oWtdow+w8NtsEhs5kSiriVooWdVLv0jjX7TOxoqivdmIAyMY2a
                      ZSlQt6d5OsrHSfK+kyXE8gQA22o6fH8TzahqMkQrOFP2kV/sN9hTv9nLJ7k1+AGiPJP5LzULEXUg
                      tkPDULaw0mNk4cLSYW0cvFl3KhvUf6AO2QoH5MrpGXsUOmS6p5iuJGl9K02i6LHDbK8rAbkcnZiS
                      1PAdsA3oJO26HvzHHDo2sajC0L2hiQWEI9ThdXxjtVo1V2j9Zl6dDXtiOoCD0JQjwwWOmTWWhQtL
                      qnlmCOO3Eq8mkR0SV0BFAzzpHxJp9rfJczZ5FHIbdEkj8s29l5slsorox6bdcry5sXBaN0mLr6bR
                      fCCrqXAJ3UolNhTAMm26eBmkN7b3l48ItvUtLi1jmhvgA8M8blg0fID9kFWoeobbocjVBNsR1mKL
                      9CXWo2Vms8egPaHRaRs9ys+m3JVreUMWZk5xfbP7Dk+5tjzo9efxa5iwXuFhfW1/Y219av6ltdxJ
                      PBIP2o5FDKfpBzCIo046vgV2KuxV2KuxV2KuxV2KrLj+4k/1W/VhjzCDyX4EuxV2KuxV2KuxV2Ku
                      xV2KuxV2Kvmf85fLF3rPmP8AMXWxU/4csNLWzoP25Whnlavikcb/APBZsdPMARHfbEvKbvVZI7OT
                      VLfbmsU1AdgJGiBU/wCyikU5KOPfhP45/scqU9uIfjkzXykIL3zj5bBUzWr3BuQq9SY4meJuo+FX
                      4sfllMRQk2ZDdPZtH+pC91CwS2VIrG7LRzuQzSXVzH9amZQRsQtx27V7ZCV0CgNQapdx6Mbu+gN1
                      NHfyW/GNOJEf19rZJAvxfYio58QMTHfbu/Qt7LL641izutRvPTM8UsthZWFo7fuyJJAss1F5Eb3B
                      5VHRPDEAGh71NqgsdMjubjT7u5MlzfznVVjqylVtXgAINSAEZY/Cvh1xs8/gtBq3nfUtKTV9HT6r
                      eX4tZ/34HN7dZA3FlqQvqQ8gD1FfEYkUaK8xYYd5qWVbe88zaZeMLiwu5wYbipkhhUpbXQCkn91F
                      NHHcL2pX+bLAL2P4/HJiT1Cc6PqY1XT5bjQ71bL6zZC1isHNDbaiIjcosKP8DfBK3qAbfBt0agIr
                      n+AkG+SbXqpJcWiTwnT+KfpOS9RgqpJCUWeKanwUeOTiSWNRX+UHID9iSyX8p7iQ+UE090K/oa6u
                      tLiJIIaG1mZICKEkD0eA3328KHKs/wBV97iEUaZjlSuxV2KuxV2KuxV2KuxVZcf3En+q36sMeYQe
                      S/Al2KuxV2KuxV2KuxV2KuxV2KuxVhv5s21tF+Wnm6aKJEluNOuGnkVQGkZYeALkbsQqgCvbLsB9
                      cfeg8nxu0E1po15o9yaFv3kD+0coLj/gQH+k5sLBkJBuqomJTb8utacaxo1i9x9VuI7gwesWKlVL
                      K6qSN6MUMZHyw5Y1Z6MYSuh1D6WvrKa+1OP6wgjstONve2d0COTT/v450YHooiK7/wCUfDMEGg5J
                      FlMEuUuLNbmydJkmjEltIp5I4ZeSMCOqmuCt90pZb6hrhjszcWao0untcXRAakd2oj/c0qdjzbvX
                      bJED7UWUP9cdLLRNWvLESareJBZz0JQRC74PNUHlsrINj8q74a3I6IvkVO7tNFuVuPMEd81vbW7x
                      i9moyosWjzzM8VPgZVEvPn1Bp4Ygnl+N0EDn+NlLXtD0fUNVtrIRtBeXYnvWuQCUkh4w2l5A1Tt6
                      sEiUFKcgG6rhjIgWsgCWIflv60+inRWh/wByWnz6kLbUweJS8hiRCD8Pxb6jLxrWnE7ZZk2N9Nvx
                      9jCHKmUazcrZWd4t4ZfqEcjvq/MhhNFJp7+pHAtKkepwag7k9tsqB+fT5s2WfkmssnkZdQduSane
                      3l3AaUb0WnZIi3iSkYOVZ/qruDik2We5SrsVdirsVdirsVdirsVWXH9xJ/qt+rDHmEHkvwJdirsV
                      dirsVdirsVdirsVdirsVYh+b7Kv5XeaCxCj9G3AqdtyhAH0nLcH1j3oPJ8ra5pEd9ZSqPhl+0jjq
                      DSmZGLJwlzsuPiCUz6EFX1wTHdOBJHOhICy0U8l/2SjLo5enRplieq/lz+Zk11o17YSTL/iRJDIl
                      rdsxQkKgZY6Hl6b8GI414FuhUCtWXHwkH+FMJ3/WZY3mT8vbG402JNXiRNHjeO1sEZnK81EaEqAz
                      fAnJVHvkAJG9ubLYdVrfmRo0llA01+LG59dWnCwysnoiWvDlIgALx0UnsTtj4ZvkvGG4/wAxfLaa
                      peXC6n9YtJIIVt7RFZyksbSmVvhU0Dh4x9GPAa5J4hfNCt5y0e7sIdO/R1zLaXqTHVY7K1u5gssv
                      7xxEVhHPlIzcjQeOS4Td/qY8Q5Kia95humuTa6Jqc0wu1ksLmWCC3eO1JieWH/S3i48+EiVodqHr
                      jQ7x+PctlJ9M0Xzzot/qGpG40/RrLUb6fUHjvLktwEwaqMir6bEMwckOOg675KUoyAHNiAQbS7zN
                      daBfKsOqee7a4vZeSW8el2puGEkqNCF4xyXTb+pSm3Xam1GGMjfhPxWUx3voPyW18fKeki+sF0u6
                      S1jjksErxi4LxVQCWKjiB8JJI6HfMPJXEaNuOnWQS7FXYq7FXYq7FXYq7FVlx/cSf6rfqwx5hB5L
                      8CXYq7FXYq7FXYq7FXYq7FXYqxTz5+ZnlPyTZetrF0pu3Cm30yFkN1KGJXksbMtEHE1dqLt47Zbi
                      wymdkE08D/MX/nIbVfMui6j5ftNEhtNP1ELD60sxlnMDtx5qECxgluPc0961Gfj0ggeInkxu9kiz
                      DdqpyQRvF6RHw0oPanTCCghjvmLyx9bjFxCALpBRj2anjmThz1seTj5cN7jmr+XfzK1vRIjp51K8
                      0fjt+5htrqICtB+6mj5f7L1Dl08XFuKLjxnWx2Z9ovnjzdfxXFzpvmw6rFZRia8H6FeRYkAJLTNb
                      hOC/Cdz4ZjyjXONf5zaJ/wBL7E5fzx+ZEJYMumyCJkjlLWGpRENJQIGozgFuQp88jwx7j8wnjPeF
                      y/mL5qkR6XejoyEq7ehdSBWH2gR6sf68iYjuky4j3hCXmu67qZKXHnW2tLdgQ8enC2tG69pZZLiR
                      foOEGuUPmvPnJLrX8tvKN7cme8nutbu33LyyXN9Mw8eNqrM33ZI5cnlFjwYxz3Z1on5YX16Leys7
                      A6LoQlSS7nmjW3lkRGDFYLcFpAz8eJeYKR1o2UGdGybKJZBVAPbMx2l2KuxV2KuxV2KuxV2KuxVZ
                      cf3En+q36sMeYQeS/Al2KuxV2KuxV2KuxV2KuxVj35g+aj5U8m6nr6xCaSzjUQRNUIZZpFhi5kb8
                      Ocg5e2WYsfHIBBL4317zBq2varca3qVzc3V9c8fUu1EMcdEAVVSM8QEAGwA9+prm7hARFBqJY9pg
                      lu/MVtBUcEmMlKcRRaO3wn7NeHTxyOaVQLZhFyD0bNU7R2KuxVBX+j6dfpxuYQx7MNmHyIyyGSUe
                      TCWMS5p3+T/nTQfyz8039vfxXE1hq8EH+kRgO8JjeXrGBycH26ZdOMs0L6hwckBCVPp3yz5z8reZ
                      7X6xoWp29+oRHliidTLEJBVRLFXnGdujAZgTxyjzDG05AA6CldzkEuxV2KuxV2KuxV2KuxV2KuxV
                      2KuxV2KrLj+4k/1W/VhjzCDyX4EuxV2KuxV2KuxV2KuxV2KsB/Pew1K9/KrXIrCMTSRJFczwkgco
                      LaZJpgCfBIyad6UGX6UgZBbGXJ8hq0Mi8gUmmCB7i5lHJI1O9FX+A+nN21rdPYabqK34gLpKpj9K
                      gWU1IJaONenTv9OVZsfHGm3Fk4TbMLO/s7yPnbyhx+0vRl7UZTuPpzWSgY83YxmJckRkWTsVdirF
                      /OcLRG3v1TkgrDOP8k7qPkdwczNJPmHD1UeRd5Y83615e1QatoWoC3v+Bg9QtCFeMsrNH6TKwKFk
                      GxNflmXkxiYouIC+zfIfmuHzX5S03XY1Ecl1FS6hFQI7iMlJ4xXeiyKwB7jfNJlx8EiGwFP8rS7F
                      XYq7FXYq7FXYq7FXYq7FXYq7FVlx/cSf6rfqwx5hB5L8CXYq7FXYq7FXYq7FXYqg9Z1fT9G0q71X
                      UZfRsbKJp7iShNEQVNANyfADqcMYkmgh8Y/mb+a3mvzzdsbqR7PQObCy0eFqIwU7NLT+8cd2bYH7
                      IGbrDp4wHm1k2wi3nkgpGq87cSLJIi1pVabEn7XTL0JvBP8AWAhV/wDSryvNl6xQr2Hgf4nFW2jj
                      CyTQAxhP9HsxExjJcmhbktCfi/VXAQDzSCRyRcOr6zC5QTJcqJREvqrRmYrV6MlKBevTKJaWJ5bN
                      8dTIc90Vb+Zb2QKPqaMXVnVhKVBCNxJoUPXtlR0fm2DV+Sm3mXUJIg0NrGhaL10LOXqm1NgF+L6c
                      I0g6lB1R6BA31zqN9FLHNMJok4y/V0HBZYiKggj4q1B2JIrl8MMY7hpnmlLmhnjW1jWSFgYJIzJH
                      UABgq8ijqPhNV6NSuWtT68/IPTr2w/LDS47qE26zPcXFrAy8GWCaZnjJ/wBcHmPYjNLqiDkNNkeT
                      0PMdk7FXYq7FXYq7FXYq7FXYq7FXYq7FVlx/cSf6rfqwx5hB5L8CXYq7FXYq7FXYq7FXnHn389fJ
                      3lQyWkTNq2rhVKWlrvEHkoY1luN0TkGrtyNN6dMycWllPfkGJk8E89/mx5086m60m9nXTtNKI8en
                      Wf8AdyFH5BpZHHqOQ4XaoXbpXNji00Yb9WBLziK4nSJpJoiqsFthOvSJAeLgL1r3zIQqyxWk8byQ
                      Djax8YoI12Msm34b/TiqgdOuoZZPRl4mNK3DjaNKjlwHj44qr2t5dRPai4gZo442+rJGPjY0oHZa
                      /wAtcVXR6jb+ijc+LxQyP8Xw8p5OtK+Br9+KpjF6ME4HIenb2yjl7VP/ADTiqGtbuGL6sWYfu7Sr
                      j3YqQPwOKqEepRwfVCN/TtirnpuQpAPypiqWu9zcRxRMCI7eMngPtcTuzd+mKsp8l/mD+YHl4/Vt
                      D124tbU+pDHASs9uvWSqQXCyRIWKE1VQcqnhhLmE29X8tf8AOUvmC3Kf4n0mC8tnhEizacGhlXgw
                      EhdZpHRzxNaLx32+WJPQj+EshJ7/AOXPM+geZdNXUtDvY76yZihkjrVXFCVdSAytQg0IzXzgYmiy
                      tNMil2KuxV2KuxV2KuxV2KuxV2KrLj+4k/1W/VhjzCDyX4EuxV2KuxV2KrJ54beGSeeRYoIlLyyu
                      QqKiirMzHYADqcQFfK35kfnlrfmyUaZpgOneVrlnQGNitzcqAQBOymixvv8Au1+TE9M2+DSCO53L
                      WZPNWtE4X9pGvENxliA2ALLQU/2UeZbFV585LC7G3qqUb5SJzH4riqnNHGLfU0IrH8T09zECfx3x
                      VDNpR/SP+jv6LpGsoJHJeZJXcH5YqhwdSFrArRrLDNNzIBo0h5FqMem+Kqv6WEd3cTzW7rJxEUS/
                      aAI3K1G25IxVTXUNP9OGFyeMEL15ChMjADb/AIbFV8J0ngkPqRoslqfXdSoPIlevv12xVCobIiCR
                      pwC9UlUL9lamjH7h9+Kqbi0UuIxJOI2qNgqmACp677NWmKqz2l06NE6CJY4pJo+5Za/ZZv2qbDFU
                      xjiS3lCJ9lZopAf+MiGPFVsq/ujHTdBdQgezAsv4UxVnX5NfmLN5N802qTyIugapDaxat6lAI6s0
                      cVwGP2fTL/F/kV7gZjarDxx8wmJfYCsrKGUgqRUEbgg5pm1vFXYq7FXYq7FXYq7FXYq7FVlx/cSf
                      6rfqwx5hB5L8CXYq7FXYq7FXhP8Azkt58Nrb2nlO0molxxudcKkCkBbjBEx/y3HNl68VHZt8/RYr
                      PEWEi+eighhvIVFfqkyXEfgFNHoP+GzZsEeNtRPvCK/Qxp+vFUPF/vLYDpxkAH+xVh/DFXXG8Oo+
                      7BB9Maf81YqiCeOoV7NCa/7Bv+bsVQ9uC0OmIevH1W+iMj9b4q0qK5g5CvK7mYj/AFBIB+KjFUPq
                      FvF9W1FgoDiZAGHXdY9v+GOKrbjTbGMXhWPaONFSpJPI1Ndz3qMVVbjTbD1rlREFCwB9qgA1ff8A
                      4XFVn6Ks5JY1oUElszNRm+1VaHc9q4q3KG+pQ0Zlb6jK7H7R39MkHlXrirbiWOJ3dy7NAlwagDiY
                      SGoKdsVVZFrdMh2Buf8AhXtqf8SxVBoyMLZTuHgtEp8pt/1Yq+xvyK1k6r+VPl+ZiPVtoDZSKDUr
                      9UdoEr4ExorfTmk1MayFsjyZ5lDJ2KuxV2KuxV2KuxV2KuxVZcf3En+q36sMeYQeS/Al2KuxV2Ko
                      LW9YsdF0e91a+fhZ2MLzzsNzxjWtFHcnoB3OGMSTQQ+IPNeu3mu63fatqI53F1Iby6i+0A7/AAW8
                      A6fDGoCj2AzfY4CMQA1lK7KR5Hu7WWjSpbelIw35FCwB+5smhMYX5XUL9fUt6n71P8cVUof95tPH
                      dpK/8I7HFXT/AN1qH/GZP+TcWKqs7Uu3brxt2IHzP9mKrYRR7EeELD8ExVZFsbYnp9auF+8y/wBM
                      VW3iB4NQQmnKRGqP9SP/AJpxVA6la6gJbkib1FWNZ5dgoopYKKV/yMVWPDrHqXEZJLSRL6h6/D8Q
                      FNziq0T6tIQVjr6luVSldozTcUGKr5L6cwEfVmpJaFIqVNF/ab5UIxVE/WPrRliijdSbURqrKQTy
                      PE/dXFUTJ/vTI38tzEtf+eY/5rxVJ0uIY7uOFixNuwQgCtfSkkYAe5PADFX0v/zilqwby9q+iEUa
                      2lt75STuRdQiJlA/yXtST/rZrNfH1As4vdcwGbsVdirsVdirsVdirsVdiqy4/uJP9Vv1YY8wg8l+
                      BLsVdirsVeJ/85KeaxDp+n+VYXo16fr2ogGlLeBv3KsPCSYcv+eZzO0OOyZdzCRfN5etZ2HSt26n
                      xI4wJ9wr882jBYCljeRB919ERXMg3pJKWcfiDiqKglCR2MzdPqrch9EZxVTsZvUt7HahjneM/RHI
                      BiqrN/cXx8Zl/BYx/DFV90aTXJ7rbbfSW/piq8ALcWgHQROPwTFVFP7uA9hdy/i8gxV1z/d6gfBk
                      P3IpxV19/wBLH/mEX/mbiqJH/HRf3hWn0M39cVQln/d2n/MF/BMVaK8oYFG1LGQf8EI/6Yq64c0Z
                      hsWt4yKdqP8A24qvk/vJx/y9wn/hI8VSS9HDVpG/aUyOPcjkR+NMVex/8466mbH8zY7QEenqNvdW
                      lCSK7LeoVp1IEbDftXMTWxuF9zKPN9WZqGx2KuxV2KuxV2KuxV2KuxVZcf3En+q36sMeYQeTvrEH
                      +/F/4IY8J7lsO+sQf78X/ghjwnuWw76xB/vxf+CGPCe5bDvrEH+/F/4IY8J7lsPjn8z9ZvfMvnbV
                      rwpJ6VxO9tbLRiEsbM+nUbbB6Fj4F83WngIwAayWJwo0zxAqazsbmQeEcdPTX/iP45faENPGbiN3
                      aMtzVrgrQ9X/AHVuPu3+eNrS/U0a3W1tqGkcJUk7GgKgf8RxVD6QzM8EQBPOYyADw4SH+mKpg6M0
                      NwApLNcqAoFT9tF6fRja0q3tvdBtQPpPVLRT9k7f3v8ATBa0rtZ3Iv7dPRkoIZSPhPZox4e+NhNI
                      dbW59CL90/8AvZIPsnr6z42inXNrc+lqX7l9qV+E/wC+1xtadf2tz/uR/cvtZqT8J/4t9sbTSJ+q
                      XX6R/uX/ALn+U/zfLGwtIS1tbn07GkL72T/snwixtFNC3uBHB+6f4rFz9k9AE3/HG1pbPa3PpSH0
                      n+G0jYfCf5if4Y2tKs1rc+tN+5f/AHpg/ZPgmNrSR3sbjWhzVlrKEIINaGRhhVl/5fahNpnnLQdR
                      HJPQuLGScgVIjZ/QuP8AklIcqzC4EeSQ+2frEH+/F/4IZo+E9zZYd9Yg/wB+L/wQx4T3LYd9Yg/3
                      4v8AwQx4T3LYd9Yg/wB+L/wQx4T3LYd9Yg/34v8AwQx4T3LYd9Yg/wB+L/wQx4T3LYd9Yg/34v8A
                      wQx4T3LYd9Yg/wB+L/wQx4T3LYd9Yg/34v8AwQx4T3LYU554DBIBIpJU0FR4ZKMTY2QSKf/Z</xmpgimg:image
                    >
                  </rdf:li>
                </rdf:alt>
              </xmp:thumbnails>
              <xmpmm:originaldocumentid
                >uuid:C1BCCE1871B8DB11993190FCD52B4E9F</xmpmm:originaldocumentid
              >
              <xmpmm:documentid
                >xmp.did:164f5c2b-99b1-43b4-845a-4db8fbd41e3e</xmpmm:documentid
              >
              <xmpmm:instanceid
                >xmp.iid:164f5c2b-99b1-43b4-845a-4db8fbd41e3e</xmpmm:instanceid
              >
              <xmpmm:renditionclass>default</xmpmm:renditionclass>
              <xmpmm:derivedfrom rdf:parsetype="Resource">
                <stref:instanceid
                  >xmp.iid:6d53d7de-7bd9-4a1f-96fa-a7bce6d216af</stref:instanceid
                >
                <stref:documentid
                  >xmp.did:6d53d7de-7bd9-4a1f-96fa-a7bce6d216af</stref:documentid
                >
                <stref:originaldocumentid
                  >uuid:C1BCCE1871B8DB11993190FCD52B4E9F</stref:originaldocumentid
                >
                <stref:renditionclass>default</stref:renditionclass>
              </xmpmm:derivedfrom>
              <xmpmm:history>
                <rdf:seq>
                  <rdf:li rdf:parsetype="Resource">
                    <stevt:action>saved</stevt:action>
                    <stevt:instanceid
                      >xmp.iid:d059b5a5-8ba4-4a6a-9871-23c36862f846</stevt:instanceid
                    >
                    <stevt:when>2021-06-21T02:11:31-04:00</stevt:when>
                    <stevt:softwareagent
                      >Adobe Illustrator 25.2 (Macintosh)</stevt:softwareagent
                    >
                    <stevt:changed>/</stevt:changed>
                  </rdf:li>
                  <rdf:li rdf:parsetype="Resource">
                    <stevt:action>saved</stevt:action>
                    <stevt:instanceid
                      >xmp.iid:164f5c2b-99b1-43b4-845a-4db8fbd41e3e</stevt:instanceid
                    >
                    <stevt:when>2021-06-29T05:42:35-04:00</stevt:when>
                    <stevt:softwareagent
                      >Adobe Illustrator 25.2 (Macintosh)</stevt:softwareagent
                    >
                    <stevt:changed>/</stevt:changed>
                  </rdf:li>
                </rdf:seq>
              </xmpmm:history>
              <illustrator:startupprofile>Mobile</illustrator:startupprofile>
              <illustrator:creatorsubtool
                >Adobe Illustrator</illustrator:creatorsubtool
              >
              <xmptpg:npages>1</xmptpg:npages>
              <xmptpg:hasvisibletransparency
                >False</xmptpg:hasvisibletransparency
              >
              <xmptpg:hasvisibleoverprint>False</xmptpg:hasvisibleoverprint>
              <xmptpg:maxpagesize rdf:parsetype="Resource">
                <stdim:w>1080.000000</stdim:w>
                <stdim:h>1080.000000</stdim:h>
                <stdim:unit>Pixels</stdim:unit>
              </xmptpg:maxpagesize>
              <xmptpg:platenames>
                <rdf:seq>
                  <rdf:li>Cyan</rdf:li>
                  <rdf:li>Magenta</rdf:li>
                  <rdf:li>Yellow</rdf:li>
                  <rdf:li>Black</rdf:li>
                </rdf:seq>
              </xmptpg:platenames>
              <xmptpg:swatchgroups>
                <rdf:seq>
                  <rdf:li rdf:parsetype="Resource">
                    <xmpg:groupname>Default Swatch Group</xmpg:groupname>
                    <xmpg:grouptype>0</xmpg:grouptype>
                    <xmpg:colorants>
                      <rdf:seq>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>White</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>255</xmpg:red>
                          <xmpg:green>255</xmpg:green>
                          <xmpg:blue>255</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>Black</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>0</xmpg:green>
                          <xmpg:blue>0</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>RGB Red</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>255</xmpg:red>
                          <xmpg:green>0</xmpg:green>
                          <xmpg:blue>0</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>RGB Yellow</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>255</xmpg:red>
                          <xmpg:green>255</xmpg:green>
                          <xmpg:blue>0</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>RGB Green</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>255</xmpg:green>
                          <xmpg:blue>0</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>RGB Cyan</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>255</xmpg:green>
                          <xmpg:blue>255</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>RGB Blue</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>0</xmpg:green>
                          <xmpg:blue>255</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>RGB Magenta</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>255</xmpg:red>
                          <xmpg:green>0</xmpg:green>
                          <xmpg:blue>255</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=193 G=39 B=45</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>193</xmpg:red>
                          <xmpg:green>39</xmpg:green>
                          <xmpg:blue>45</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=237 G=28 B=36</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>237</xmpg:red>
                          <xmpg:green>28</xmpg:green>
                          <xmpg:blue>36</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=241 G=90 B=36</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>241</xmpg:red>
                          <xmpg:green>90</xmpg:green>
                          <xmpg:blue>36</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=247 G=147 B=30</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>247</xmpg:red>
                          <xmpg:green>147</xmpg:green>
                          <xmpg:blue>30</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=251 G=176 B=59</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>251</xmpg:red>
                          <xmpg:green>176</xmpg:green>
                          <xmpg:blue>59</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=252 G=238 B=33</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>252</xmpg:red>
                          <xmpg:green>238</xmpg:green>
                          <xmpg:blue>33</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=217 G=224 B=33</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>217</xmpg:red>
                          <xmpg:green>224</xmpg:green>
                          <xmpg:blue>33</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=140 G=198 B=63</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>140</xmpg:red>
                          <xmpg:green>198</xmpg:green>
                          <xmpg:blue>63</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=57 G=181 B=74</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>57</xmpg:red>
                          <xmpg:green>181</xmpg:green>
                          <xmpg:blue>74</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=0 G=146 B=69</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>146</xmpg:green>
                          <xmpg:blue>69</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=0 G=104 B=55</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>104</xmpg:green>
                          <xmpg:blue>55</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=34 G=181 B=115</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>34</xmpg:red>
                          <xmpg:green>181</xmpg:green>
                          <xmpg:blue>115</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=0 G=169 B=157</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>169</xmpg:green>
                          <xmpg:blue>157</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=41 G=171 B=226</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>41</xmpg:red>
                          <xmpg:green>171</xmpg:green>
                          <xmpg:blue>226</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=0 G=113 B=188</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>113</xmpg:green>
                          <xmpg:blue>188</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=46 G=49 B=146</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>46</xmpg:red>
                          <xmpg:green>49</xmpg:green>
                          <xmpg:blue>146</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=27 G=20 B=100</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>27</xmpg:red>
                          <xmpg:green>20</xmpg:green>
                          <xmpg:blue>100</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=102 G=45 B=145</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>102</xmpg:red>
                          <xmpg:green>45</xmpg:green>
                          <xmpg:blue>145</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=147 G=39 B=143</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>147</xmpg:red>
                          <xmpg:green>39</xmpg:green>
                          <xmpg:blue>143</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=158 G=0 B=93</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>158</xmpg:red>
                          <xmpg:green>0</xmpg:green>
                          <xmpg:blue>93</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=212 G=20 B=90</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>212</xmpg:red>
                          <xmpg:green>20</xmpg:green>
                          <xmpg:blue>90</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=237 G=30 B=121</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>237</xmpg:red>
                          <xmpg:green>30</xmpg:green>
                          <xmpg:blue>121</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=199 G=178 B=153</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>199</xmpg:red>
                          <xmpg:green>178</xmpg:green>
                          <xmpg:blue>153</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=153 G=134 B=117</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>153</xmpg:red>
                          <xmpg:green>134</xmpg:green>
                          <xmpg:blue>117</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=115 G=99 B=87</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>115</xmpg:red>
                          <xmpg:green>99</xmpg:green>
                          <xmpg:blue>87</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=83 G=71 B=65</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>83</xmpg:red>
                          <xmpg:green>71</xmpg:green>
                          <xmpg:blue>65</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=198 G=156 B=109</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>198</xmpg:red>
                          <xmpg:green>156</xmpg:green>
                          <xmpg:blue>109</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=166 G=124 B=82</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>166</xmpg:red>
                          <xmpg:green>124</xmpg:green>
                          <xmpg:blue>82</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=140 G=98 B=57</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>140</xmpg:red>
                          <xmpg:green>98</xmpg:green>
                          <xmpg:blue>57</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=117 G=76 B=36</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>117</xmpg:red>
                          <xmpg:green>76</xmpg:green>
                          <xmpg:blue>36</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=96 G=56 B=19</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>96</xmpg:red>
                          <xmpg:green>56</xmpg:green>
                          <xmpg:blue>19</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=66 G=33 B=11</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>66</xmpg:red>
                          <xmpg:green>33</xmpg:green>
                          <xmpg:blue>11</xmpg:blue>
                        </rdf:li>
                      </rdf:seq>
                    </xmpg:colorants>
                  </rdf:li>
                  <rdf:li rdf:parsetype="Resource">
                    <xmpg:groupname>Grays</xmpg:groupname>
                    <xmpg:grouptype>1</xmpg:grouptype>
                    <xmpg:colorants>
                      <rdf:seq>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=0 G=0 B=0</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>0</xmpg:red>
                          <xmpg:green>0</xmpg:green>
                          <xmpg:blue>0</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=26 G=26 B=26</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>26</xmpg:red>
                          <xmpg:green>26</xmpg:green>
                          <xmpg:blue>26</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=51 G=51 B=51</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>51</xmpg:red>
                          <xmpg:green>51</xmpg:green>
                          <xmpg:blue>51</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=77 G=77 B=77</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>77</xmpg:red>
                          <xmpg:green>77</xmpg:green>
                          <xmpg:blue>77</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=102 G=102 B=102</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>102</xmpg:red>
                          <xmpg:green>102</xmpg:green>
                          <xmpg:blue>102</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=128 G=128 B=128</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>128</xmpg:red>
                          <xmpg:green>128</xmpg:green>
                          <xmpg:blue>128</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=153 G=153 B=153</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>153</xmpg:red>
                          <xmpg:green>153</xmpg:green>
                          <xmpg:blue>153</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=179 G=179 B=179</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>179</xmpg:red>
                          <xmpg:green>179</xmpg:green>
                          <xmpg:blue>179</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=204 G=204 B=204</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>204</xmpg:red>
                          <xmpg:green>204</xmpg:green>
                          <xmpg:blue>204</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=230 G=230 B=230</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>230</xmpg:red>
                          <xmpg:green>230</xmpg:green>
                          <xmpg:blue>230</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=242 G=242 B=242</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>242</xmpg:red>
                          <xmpg:green>242</xmpg:green>
                          <xmpg:blue>242</xmpg:blue>
                        </rdf:li>
                      </rdf:seq>
                    </xmpg:colorants>
                  </rdf:li>
                  <rdf:li rdf:parsetype="Resource">
                    <xmpg:groupname>Mobile Color Group</xmpg:groupname>
                    <xmpg:grouptype>1</xmpg:grouptype>
                    <xmpg:colorants>
                      <rdf:seq>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=136 G=168 B=13</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>136</xmpg:red>
                          <xmpg:green>168</xmpg:green>
                          <xmpg:blue>13</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=127 G=71 B=221</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>127</xmpg:red>
                          <xmpg:green>71</xmpg:green>
                          <xmpg:blue>221</xmpg:blue>
                        </rdf:li>
                        <rdf:li rdf:parsetype="Resource">
                          <xmpg:swatchname>R=251 G=174 B=23</xmpg:swatchname>
                          <xmpg:mode>RGB</xmpg:mode>
                          <xmpg:type>PROCESS</xmpg:type>
                          <xmpg:red>251</xmpg:red>
                          <xmpg:green>174</xmpg:green>
                          <xmpg:blue>23</xmpg:blue>
                        </rdf:li>
                      </rdf:seq>
                    </xmpg:colorants>
                  </rdf:li>
                </rdf:seq>
              </xmptpg:swatchgroups>
              <pdf:producer>Adobe PDF library 15.00</pdf:producer>
              <pdfx:creatorversion>21.0.0</pdfx:creatorversion>
              <xmprights:marked>False</xmprights:marked>
              <xmprights:webstatement>www.ape6068.info</xmprights:webstatement>
              <photoshop:captionwriter>Mike Three</photoshop:captionwriter>
            </rdf:description>
          </rdf:rdf>
        </x:xmpmeta>

        <!--?xpacket end="w"?-->
      </metadata>
      <g id="Background">
        <rect class="st0" width="1080" height="1080" />
        <rect class="st1" width="1080" height="1080" />
      </g>
      <g id="body">
        <g id="fur-fill">
          <path
            class="st2"
            d="M402.1,640.7c2,36,0.7,95.6,0.5,106.4c-0.2,8.5-3.9,62-23.8,93.7c-24,38.2-60.8,56.6-74.6,60
						c-22.3,5.5-51.4,13.6-72.9,28.7c-20.9,14.7-37.8,42.4-41,49.5c-3.2,7.1-12.1,24.2-14.3,39c6.2-8.3,14.5-21.5,21.3-27
						c-4.8,7.9-27.9,48.3-29.2,77.5c4.6-7.6,5.2-9.1,9.9-14c0,0-0.4,1.8-1,4.5c-2.6,8.4-4.8,16.5-4.9,20.8h0.3l0.5-1.8
						c-0.1,0.7-0.3,1.3-0.4,1.8h238.9c0.7,0,1.3,0.1,1.8,0.3h315.7l-8.9-34.3c3.2,10,8.2,27.5,9.3,34l-1.9-23.9c0-0.1-0.1-0.2-0.1-0.3
						l0.1,0.2l0,0.1c1.5,3.4,2.9,7,3.8,10.7c-0.6-4.5-1.3-9-2.1-13.3c-1.5-11.6-3.8-29.6-3.8-29.6c1,2.7,6.1,9.6,6.1,9.6
						c-2.9-6.8-11.4-32.7-15.4-56.7c-4.2-25.2-21.3-49.1-28.8-55.7c-13.2-11.5-23.6-14.4-73.8-37.6c-43.2-20-54.7-57.8-55.9-66.4
						c-1.5-11.2-1.8-20.5-1.8-23.9c0-3.4,0.5-21.5,0.5-32.7"
          />
        </g>
        <g id="chest-fill">
          <path
            class="st3"
            d="M691.6,1079.7c-18.5-63.4-69.6-114.4-70.1-114.8c-0.2-0.1-0.4-0.2-0.6-0.1c-0.2-0.8-0.5-1.7-0.8-2.5
						c-1.9-5.5-4.4-10.9-7.6-15.8l-2.5-3.6c-0.9-1.2-1.8-2.3-2.7-3.4l-1.4-1.7c-0.5-0.5-1-1-1.5-1.6l-3.1-3.1c-0.1-0.1-0.2-0.1-0.3,0
						c-0.1,0.1-0.1,0.2,0,0.3l0,0c4,4.2,7.8,8.6,10.8,13.5c3,4.9,5.6,10.1,7.4,15.6c1.9,5.5,3,11.2,3.5,17c0.1,1.4,0.2,2.9,0.2,4.3
						l0,2.2l0,1.1l-0.1,1.1c-0.1,2.2-0.4,4.4-0.9,6.5c0.2-2.4,0.1-4.8-0.4-7.2c-0.6-3.1-1.6-6-3-8.8c-1.4-2.8-3-5.5-4.8-8
						c-1.8-2.5-3.8-4.9-5.9-7.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.2c-0.7-2.8-1.5-5.5-2.3-8.2c-1.1-3.4-2.3-6.9-3.7-10.2
						c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.1,0.2c2.5,6.8,4.5,13.7,6,20.7c1.5,7,2.4,14.2,2.8,21.4c0.3,7.2,0.1,14.4-1.1,21.5
						c-1.1,6.7-3.1,13.4-6.2,19.5c1.6-5.2,2.8-10.6,3.2-16c0.3-2.9,0.4-5.8,0.4-8.7c-0.1-2.9-0.2-5.8-0.6-8.7c-0.6-5.8-1.9-11.5-3.5-17
						c-0.8-2.8-1.8-5.5-2.9-8.2c-1.1-2.7-2.3-5.3-3.7-7.9l0,0c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2l0,0
						c1.3,6.3,2.5,12.6,3.3,19c0.8,6.4,1.2,12.8,0.9,19.2c-0.3,6.4-1.3,12.8-3.4,18.8c-2,5.9-5.3,11.3-9.8,15.7c0.8-3.4,1.5-6.8,2-10.2
						c0.5-3.9,0.8-7.8,0.9-11.8c0-3.9,0-7.9-0.7-11.8c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2l0,0c0.6,3.8,0.6,7.8,0.5,11.7
						c-0.2,3.9-0.5,7.8-1,11.7c-0.6,3.9-1.3,7.7-2.4,11.4c-1,3.6-2.3,7.1-3.9,10.4l-26.1-15c-8.9-5-17.6-10.4-25.5-16.8
						c-3.9-3.2-7.7-6.6-11.1-10.4c-3.4-3.7-6.5-7.8-9.1-12.2c-5.2-8.7-8-18.8-8-29c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2
						c-0.4,8,1.2,16.1,4.4,23.5c-0.1,0.1-0.1,0.2,0,0.3l1.3,5.4c0.5,1.8,0.9,3.6,1.5,5.3c1,3.5,2.4,7,3.9,10.4c1.5,3.4,3.5,6.6,5.9,9.5
						c2.2,2.7,4.9,4.9,7.5,7.3c-3.4-1.4-6.8-2.8-10.1-4.6c-3.4-1.9-6.7-4-9.7-6.5c-3-2.5-5.6-5.3-7.9-8.5c-2.3-3.1-4.1-6.6-5.5-10.2
						c-1.4-3.6-2.4-7.4-3-11.2l-0.2-1.4c-0.1-0.5-0.1-1-0.2-1.4c-0.1-1-0.2-1.9-0.3-2.9c-0.1-1.9-0.2-3.9-0.1-5.8
						c0.1-7.8,1.3-15.5,2.9-23.1c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2,0-0.2,0.1c-2.1,7.5-3.4,15.3-3.6,23.2c0,0.6,0,1.2,0,1.9
						c-1,4.7-1.5,9.5-1.8,14.3c-0.3,5-0.2,10,0.5,15c0.6,5,1.7,9.9,3.7,14.6c0.5,1.1,1,2.2,1.6,3.3c-2-2.6-3.8-5.4-5.5-8.3
						c-3.5-6.1-6.2-12.8-7.9-19.6c-1.7-6.9-2.3-14-2-21c0.2-3.5,0.6-7,1.3-10.5c0.6-3.5,1.6-6.9,2.6-10.3l0,0c0-0.1,0-0.2-0.1-0.3
						c-0.1-0.1-0.3,0-0.3,0.1l0,0c-2.6,4-5.2,7.9-8,11.7c-2.7,3.8-5.5,7.6-8.5,11.3c-3,3.6-6.1,7.2-9.6,10.4c-2.8,2.5-5.7,5-9,6.8
						c1.5-1.2,2.8-2.5,4.2-3.8c2-2,3.9-4,5.7-6.1c3.6-4.2,6.9-8.7,10-13.4c3.1-4.6,5.9-9.5,8.3-14.5c2.4-5,4.4-10.3,5.7-15.7
						c0-0.1,0-0.3-0.2-0.3c-0.1,0-0.3,0-0.3,0.2c-1.6,5.3-3.6,10.5-6,15.4c-1.3,2.7-2.6,5.3-4.1,7.8c-0.1,0-0.3,0-0.4,0
						c-13.8,6.7-46.6,25.7-82.2,54.3c-26.7,21.4-42,46.1-50.3,59.3c-1.3,2.1-2.4,3.9-3.4,5.3h80c0.7,0,1.3,0.1,1.8,0.3h278
						c0,0,0.1,0,0.1-0.1C691.6,1080,691.7,1079.8,691.6,1079.7z"
          />
        </g>
        <g id="fur-shadows">
          <g>
            <path
              class="st4"
              d="M399.2,646.1l6.8,42.3c2.3,8.8,12.1,38.8,12.1,38.8s-0.7-15.3,0.3-18.2c2.9,2.9,22.8,36.5,24.8,44.6
							l-1.3-31.9c0,0,9.8,16.6,11.1,18.6c0,0-1-6.2,0-9.4c0,0,15,25.1,27,35.2c0,0-6.2-19.9-4.9-24.8c0,0,11.1,21.5,30,33.6
							s48.9,17.6,48.9,17.6v-32.9"
            />
            <path
              class="st4"
              d="M297.3,904.2c28.3-4.4,73.3-8.8,82.3-11.5c9-2.7,64.5-11,104.3-9c-24.9-6.4-94.1-4.4-110.4-1
							c-16.4,3.4-32,4.2-34.4,2L297.3,904.2z"
            />
            <path
              class="st4"
              d="M622.2,886.3c-13.4-1.7-51.5-5.1-74.5-0.2c15.6,0.2,76.5,4.4,84.3,6.8L622.2,886.3z"
            />
            <path
              class="st4"
              d="M472.5,955c2.2-2.9,9.5-8.6,9.5-8.6c0,4.2-2,22.2,3.9,32l2.2-10.3c2,6.1,10,24.7,19.8,30.3c0,0-0.9-4-2-9.4
							c-2-9.4-4.8-22.7-4.8-24.9c2.2,2.7,26.1,42.3,45.4,51.5c-2.2-7.6-6.1-26.6-2-43c1,8.1,5.4,29.1,15.1,41.3
							c9.8,12.2,20,27.1,20.5,31.3c0,0-54.5-29.6-62.3-42s-11.7-0.5,6.4,20.8c-8.1-3.4-29.3-16.6-37.4-40.8c0,0-2,22.2,1.2,32.2
							c0,0-17.3-27.9-11.2-58.9c0,0-14.4,18.3-18.3,21L472.5,955z"
            />
            <path
              class="st4"
              d="M642,986.3c11.5,10.5,32,41,32.7,43.2c1.2-3.4,7.3-18.6,7.3-21c1.2,4.6,4.9,33.2,4.9,35.4
							c2.7-5.4,11.5-18.1,11.7-19.8c-0.5,6.6-6.1,28.1-11.5,38.6L642,986.3z"
            />
            <path
              class="st4"
              d="M331.8,1079.9c6.9-11.3,28-39.8,45.4-56.7c-9.1,4.5-48.6,38.1-50.1,48.9c0,0-2.7-7.6-1.2-20
							c0,0-8.1,17.8-8.8,23c0,0-5.6-36.4-3.7-49.6c-3.2,5.4-4.4,41.5-4.4,47.1c0,4.2,0.1,6.5,0.2,7.4H331.8z"
            />
            <path
              class="st4"
              d="M218.1,1079.9c4.3-4.4,15.2-17.6,16.7-32.8c-6.1,0.2-14.2,6.6-18.3,12.2c-4.2,5.6-10,17.8-10,20.3l6.9,0.3
							H218.1z"
            />
            <path
              class="st4"
              d="M190.3,1079.9l2.4-0.5c1.7-4.2,11.5-24.9,11.5-30c-3.9,1.2-26.7,20.8-29.3,26.1c-0.9,1.7-1.4,3.2-1.7,4.4
							H190.3z"
            />
          </g>
        </g>
        <g id="body-lines">
          <path
            d="M403.1,640.7c1.6,20.3,2,40.6,2.2,60.9c0,10.2,0,20.3-0.1,30.5l-0.2,15.2c-0.2,5.2-0.6,10.3-1.1,15.4
						c-1.1,10.2-2.6,20.3-4.8,30.3c-2.2,10-4.8,20-8.6,29.6c-1.9,4.8-4,9.5-6.4,14.1c-2.5,4.6-5.3,8.9-8.3,13.1
						c-6,8.4-12.9,16.1-20.5,23.1c-7.6,7-15.9,13.2-24.7,18.5c-4.4,2.7-9,5.1-13.7,7.3c-2.4,1.1-4.8,2.1-7.2,2.9
						c-2.4,0.9-5.1,1.6-7.5,2.2c-9.8,2.4-19.5,5.1-29.1,8.3c-4.8,1.6-9.5,3.3-14.1,5.2c-4.6,1.9-9.2,4-13.6,6.4
						c-4.4,2.4-8.7,4.9-12.7,7.8c-4,2.9-7.8,6.1-11.3,9.6c-7.1,7-13.4,14.8-19.1,23.1c-2.8,4.1-5.5,8.4-8,12.7
						c-0.6,1.1-1.2,2.2-1.7,3.2l-1.6,3.5c-1.1,2.3-2.2,4.6-3.2,6.8c-2.1,4.6-4.1,9.2-5.7,13.9l-2.6,7c-0.9,2.3-1.7,4.7-2.6,7.1
						l-1.4-0.6h0c1.3-2.6,2.8-5.1,4.4-7.4c1.7-2.3,3.3-4.7,5.1-7c1.7-2.3,3.6-4.6,5.5-6.8c1-1.1,2-2.1,3.1-3.1c1.1-1,2.2-2,3.4-2.8l0,0
						c0.3-0.3,0.8-0.2,1.1,0.2c0.2,0.2,0.2,0.5,0.1,0.8l0,0.1c-2.7,6.4-5.7,12.7-8.6,18.9c-2.9,6.3-5.8,12.5-8.5,18.9
						c-1.3,3.2-2.6,6.4-3.9,9.6c-1.2,3.2-2.5,6.4-3.6,9.7c-2.1,6.5-3.8,13.2-4.5,20.1l0,0l-1.4-0.4c0.6-1.3,1.3-2.6,1.9-3.9
						c0.7-1.3,1.4-2.5,2.2-3.8c0.8-1.3,1.7-2.5,2.6-3.6c1-1.1,2-2.1,3.2-3c0.4-0.3,1-0.3,1.3,0.1c0.3,0.3,0.3,0.8,0,1.2
						c-0.9,1.2-1.7,2.3-2.6,3.4c-0.9,1.1-1.7,2.2-2.5,3.4c-1.6,2.3-3.1,4.8-4.9,7l0,0c-0.3,0.3-0.7,0.4-1.1,0.1
						c-0.2-0.1-0.3-0.4-0.3-0.6l0,0c0-7.1,1.2-14.1,2.8-20.9c1.6-6.9,3.7-13.6,6.3-20.1c2.6-6.5,5.5-12.9,8.8-19.1
						c3.3-6.2,6.9-12.2,11.3-17.7l1.1,1h0c-2,1.9-3.8,4.1-5.5,6.4c-1.7,2.2-3.4,4.6-5,6.9l-4.9,7c-1.7,2.3-3.5,4.6-5.7,6.6l0,0
						c-0.2,0.4-0.6,0.5-0.9,0.4c-0.3-0.1-0.4-0.3-0.4-0.6l0-0.3c-0.1-2.6,0.1-5.3,0.5-7.8c0.4-2.6,1.1-5.1,1.9-7.5
						c1.7-4.9,3.6-9.7,5.7-14.3c1-2.3,2.1-4.7,3.2-7l1.6-3.4c0.6-1.3,1.2-2.4,1.8-3.6c2.5-4.5,5.3-8.9,8.2-13.1
						c5.9-8.4,12.4-16.4,19.8-23.6c3.7-3.6,7.7-7,11.9-10c4.3-2.9,8.7-5.6,13.3-8c18.3-9.6,38-15.5,57.7-20.5c2.5-0.6,4.8-1.2,7.1-2.1
						c2.3-0.8,4.6-1.8,6.8-2.8c4.5-2.1,8.9-4.5,13.1-7.1c8.5-5.2,16.5-11.3,23.8-18.1c7.3-6.8,14-14.3,19.8-22.4
						c2.9-4.1,5.6-8.2,7.9-12.6c2.3-4.4,4.4-8.9,6.1-13.6c3.5-9.3,6.3-19,8.4-28.8c2.1-9.8,3.7-19.8,4.8-29.8c0.5-5,1-10,1.1-15
						l0.4-15.2c0.2-10.1,0.4-20.3,0.5-30.4c0.2-10.1,0.3-20.3,0.3-30.4c0-10.1,0-20.3-0.3-30.4l0,0c0-0.6,0.4-1.1,1-1.1
						C402.6,639.7,403.1,640.1,403.1,640.7z"
          />
          <path
            d="M558.3,747.8c0,15.2,0,30.4-0.1,45.6c0.1,7.5,0.8,15,1.8,22.4c0.1,1,0.3,1.8,0.4,2.6c0.2,0.9,0.4,1.8,0.7,2.6l0.8,2.6
						l0.9,2.6c0.3,0.9,0.6,1.7,1,2.6c0.4,0.9,0.7,1.7,1.1,2.6l1.2,2.5c0.4,0.8,0.8,1.7,1.2,2.5c3.4,6.6,7.6,12.7,12.4,18.4
						c4.8,5.7,10.3,10.7,16.2,15.2c1.5,1.1,3,2.2,4.5,3.3l4.8,2.9c0.8,0.5,1.6,1,2.4,1.4l2.5,1.3c1.7,0.8,3.3,1.7,5,2.5l20.7,9.5
						l20.8,9.4c3.5,1.6,6.9,3.2,10.4,4.9c3.4,1.7,6.9,3.5,10.2,5.4c3.3,2,6.6,4.2,9.6,6.7l2.2,1.9c0.7,0.7,1.5,1.4,2.2,2.1
						c1.4,1.4,2.6,2.9,3.9,4.5c2.4,3,4.7,6.2,6.7,9.5c2.1,3.2,4,6.6,5.8,10c3.5,6.9,6.5,14,8.7,21.5c0.5,1.9,1,3.8,1.4,5.7
						c0.4,1.9,0.8,3.8,1.1,5.7c0.6,3.7,1.4,7.4,2.1,11.1c1.6,7.4,3.5,14.7,5.5,22c1,3.6,2.2,7.2,3.3,10.9c1.1,3.6,2.1,7.3,3.1,10.9l0,0
						l0,0.2c0.1,0.5-0.2,0.9-0.6,1.1c-0.4,0.1-0.7-0.1-0.9-0.4c-0.5-0.8-1.1-1.6-1.7-2.3c-0.6-0.8-1.2-1.5-1.7-2.3l-1.8-2.3
						c-0.3-0.4-0.6-0.8-0.9-1.2c-0.3-0.4-0.6-0.9-0.9-1.4l-0.1-0.1c-0.5-0.9-0.2-2,0.6-2.5c0.9-0.5,2-0.2,2.5,0.6
						c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.7,0.4,1.6,0.8,2.5c0.4,0.9,0.8,1.7,1.3,2.5c0.5,0.8,0.9,1.6,1.5,2.4c0.5,0.8,1.1,1.6,1.6,2.3
						l-1.5,0.9l0,0c-3.8-6.8-5.9-14.2-8.1-21.5c-2.1-7.3-4.1-14.7-5.8-22.2c-0.8-3.7-1.6-7.5-2.3-11.3c-0.3-1.9-0.7-3.7-1.1-5.5
						c-0.4-1.8-0.9-3.6-1.4-5.4c-2.1-7.1-5-14-8.5-20.6c-1.8-3.3-3.6-6.5-5.7-9.6c-2-3.1-4.2-6.2-6.5-9c-1.2-1.4-2.4-2.8-3.6-4.1
						c-0.6-0.7-1.3-1.2-1.9-1.8l-2.1-1.8c-2.9-2.3-5.9-4.4-9.1-6.3c-3.2-1.9-6.5-3.6-9.9-5.2c-3.4-1.7-6.8-3.2-10.3-4.8l-20.8-9.4
						l-20.7-9.5c-1.7-0.8-3.5-1.7-5.2-2.6l-2.6-1.3c-0.9-0.4-1.7-1-2.5-1.5l-5-3c-1.6-1.1-3.2-2.3-4.7-3.4c-6.2-4.7-12-9.9-17-15.9
						c-5-5.9-9.4-12.4-12.9-19.4c-0.5-0.9-0.9-1.7-1.3-2.6l-1.2-2.6c-0.4-0.9-0.7-1.8-1.1-2.7c-0.4-0.9-0.7-1.8-1-2.7l-1-2.8l-0.8-2.8
						c-0.3-1-0.5-1.9-0.7-2.9c-0.2-1-0.4-2.1-0.5-3c-1-7.6-1.5-15.3-1.6-23c0.2-15.2,0.6-30.4,0.9-45.6l0,0c0-1,0.8-1.7,1.8-1.7
						C557.5,746.1,558.3,746.9,558.3,747.8z"
          />
          <path
            d="M589,1000.5c0.9,4,1.1,7.9,1.1,11.9c0,4-0.3,7.9-0.7,11.9c-0.5,3.9-1.2,7.9-2.2,11.7c-1,3.9-2.3,7.7-4.1,11.4l0,0
						c-0.4,0.8-1.4,1.2-2.2,0.8l-0.1-0.1l-0.1-0.1l-13.3-7.5l-13.3-7.6c-8.9-5-17.8-10.4-25.8-17c-4-3.3-7.8-6.8-11.3-10.7
						c-3.5-3.9-6.7-8.1-9.3-12.6c-1.3-2.3-2.5-4.6-3.5-7c-1-2.4-1.9-4.9-2.4-7.5c-1.2-5.1-1.6-10.4-1-15.6c0-0.4,0.4-0.7,0.8-0.6
						c0.4,0,0.6,0.3,0.6,0.7c0.7,10.1,3.4,19.8,8.5,28.3c2.5,4.3,5.6,8.2,9,11.9c3.4,3.7,7.1,7.1,11,10.2c7.8,6.3,16.4,11.7,25.3,16.7
						l13.3,7.7l13.2,7.7l-2.4,0.7l0,0c1.8-3.3,3.1-6.9,4.2-10.6c1.1-3.7,1.9-7.5,2.5-11.3c0.6-3.8,1-7.7,1.2-11.6
						c0.2-3.9,0.3-7.8-0.2-11.6l0,0c0-0.4,0.2-0.7,0.6-0.8C588.6,999.9,588.9,1000.2,589,1000.5z"
          />
          <path
            d="M585.1,1033.8c4.5-4.3,7.8-9.6,9.8-15.5c2.1-5.9,3-12.2,3.3-18.5c0.2-6.3-0.2-12.7-0.9-19c-0.7-6.3-1.8-12.6-2.5-19.1
						l0-0.2c0-0.4,0.3-0.8,0.7-0.9c0.4,0,0.7,0.2,0.8,0.5l0,0c3.1,5,5.3,10.5,7.1,16.1c1.7,5.6,3.1,11.4,3.8,17.2
						c0.3,2.9,0.5,5.9,0.5,8.8c0,1.5,0,2.9-0.1,4.4c-0.1,0.7-0.1,1.5-0.2,2.2l-0.2,2.2c-0.7,5.8-2.2,11.6-4.4,17l-0.6-0.3l0,0
						c3-6.5,4.8-13.5,5.7-20.5c0.9-7,1.1-14.1,0.7-21.2c-0.4-7.1-1.2-14.1-2.5-21.1c-1.4-7-3.2-13.9-5.2-20.8c-0.1-0.3,0.1-0.7,0.4-0.8
						c0.3-0.1,0.6,0.1,0.7,0.3c3.3,6.5,5.7,13.4,7.4,20.5c1.8,7.1,2.9,14.4,3.2,21.7c0.3,7.3-0.2,14.7-1.7,21.9
						c-1.5,7.2-4.2,14.2-8.2,20.3l0,0c-0.1,0.2-0.3,0.2-0.4,0.2c-0.1-0.1-0.2-0.2-0.2-0.4l0-0.1c1.1-5.7,1.9-11.3,2.2-17
						c0.1-2.8,0.1-5.7,0.1-8.5c-0.1-2.8-0.4-5.7-0.6-8.5c-0.7-5.6-1.6-11.3-3.2-16.8c-0.8-2.7-1.6-5.5-2.6-8.2c-0.9-2.7-2-5.4-3.1-8
						l0,0l1.5-0.6c2.4,6.1,3.7,12.5,4.6,19c0.9,6.5,1.2,13,0.9,19.6c-0.3,6.6-1.4,13.2-3.6,19.5c-1.1,3.1-2.6,6.2-4.3,9.1
						c-1.8,2.8-4,5.5-6.4,7.8l0,0c-0.7,0.7-1.8,0.6-2.5-0.1C584.4,1035.5,584.4,1034.4,585.1,1033.8L585.1,1033.8z"
          />
          <path
            d="M609,962.6c2.1,2.3,4.1,4.7,5.9,7.3c1.8,2.6,3.4,5.4,4.8,8.2c1.3,2.9,2.3,6,2.8,9.2c0.5,3.2,0.4,6.4-0.3,9.5l0,0l-1.1-0.3
						c0.8-2.7,1.1-5.5,1.2-8.4l0.1-1.1l0-1.1l0-2.1c-0.1-1.4-0.2-2.9-0.3-4.3c-0.6-5.7-1.8-11.3-3.7-16.7c-1.9-5.4-4.3-10.5-7.2-15.4
						l-2.3-3.6c-0.8-1.2-1.7-2.3-2.6-3.4l-1.3-1.7c-0.5-0.6-0.9-1.1-1.4-1.6c-0.9-1.1-1.9-2.2-2.8-3.3l0,0c-0.3-0.3-0.2-0.8,0.1-1.1
						c0.3-0.2,0.7-0.2,1,0c1.1,1,2.2,2,3.2,3c0.5,0.5,1.1,1,1.6,1.5l1.4,1.7c0.9,1.1,2,2.2,2.8,3.4l2.6,3.6c3.3,4.9,5.9,10.3,7.8,16
						c1.8,5.7,2.9,11.5,3.2,17.5c0.1,1.5,0.1,3,0.1,4.4l-0.1,2.2l-0.1,1.1l-0.1,1.1c-0.1,0.7-0.2,1.5-0.3,2.2l-0.4,2.2
						c-0.1,0.7-0.4,1.5-0.5,2.2c-0.2,0.7-0.5,1.4-0.8,2.1c-0.1,0.3-0.4,0.5-0.7,0.4c-0.3-0.1-0.4-0.4-0.4-0.6l0,0l0,0
						c0.2-3,0-6-0.8-8.9c-0.7-2.9-1.8-5.7-3.3-8.3c-1.4-2.6-3-5.1-4.8-7.6c-1.8-2.4-3.7-4.7-5.8-7c-0.6-0.7-0.6-1.8,0.2-2.5
						C607.3,961.8,608.4,961.9,609,962.6L609,962.6z"
          />
          <path class="st5" d="M621.2,965.2c5.1,4.6,52.6,55,70,114.6" />
          <path
            d="M720,1079.7c-0.6-4.4-1.6-8.8-3.1-13l0,0c-0.1-0.4,0.1-0.8,0.4-1c0.4-0.1,0.8,0,0.9,0.3c2.2,4.1,3.9,8.4,5.2,12.9
						c0.3,0.9-0.3,1.9-1.2,2.2c-0.9,0.3-1.9-0.3-2.2-1.2C720,1079.9,720,1079.8,720,1079.7L720,1079.7z"
          />
          <path
            d="M727.8,1080.1c-0.5-3.2-1.4-6.5-2.2-9.7c-0.8-3.3-1.7-6.5-2.7-9.8c-0.9-3.2-1.9-6.5-2.9-9.7c-1-3.2-2-6.4-3.1-9.6l0,0
						c-0.3-0.9,0.2-1.9,1.1-2.2c0.7-0.3,1.5,0,1.9,0.5l0,0c1.6,1.9,3,4,4.3,6.1c1.3,2.1,2.5,4.3,3.5,6.6c1,2.2,1.9,4.6,2.6,6.9
						c0.7,2.4,1.2,4.8,1.4,7.3l0,0l-0.6,0.1c-1.7-4.4-2.6-8.9-3.5-13.5c-0.9-4.5-1.8-9.1-2.7-13.6c-0.9-4.6-1.7-9.2-2.2-13.8
						c-0.3-2.3-0.5-4.7-0.6-7.1c-0.1-2.4-0.1-4.8,0.1-7.2c0.1-1,0.9-1.7,1.9-1.6c0.9,0.1,1.6,0.9,1.6,1.8l0,0c-0.2,4.5,0.2,9,0.7,13.5
						c0.6,4.5,1.3,9.1,2,13.6c0.8,4.6,1.5,9.1,2.2,13.7c0.7,4.6,1.3,9.2,0.9,14l0,0c0,0.2-0.2,0.3-0.3,0.3c-0.1,0-0.2-0.1-0.2-0.2l0,0
						c-1-2.2-2-4.4-3-6.6c-1.1-2.1-2.2-4.2-3.4-6.3c-2.4-4.1-5-8.1-7.7-12l3-1.7l0,0c1.2,3.3,2.2,6.5,3.2,9.7c1,3.2,2,6.5,2.9,9.8
						c0.9,3.3,1.8,6.5,2.7,9.8c0.8,3.3,1.7,6.6,2.3,10.1c0.2,1-0.5,1.9-1.4,2S727.9,1081.1,727.8,1080.1L727.8,1080.1L727.8,1080.1z"
          />
          <path
            d="M682.2,1022.7c0.2,5.5,0.4,10.9,0.8,16.4c0.2,2.7,0.3,5.4,0.6,8.1c0.2,2.7,0.5,5.5,1,7.9l0,0l-3.3-0.3
						c1.3-2.9,2.8-5.7,4.3-8.5c0.8-1.4,1.5-2.8,2.4-4.1c0.8-1.4,1.7-2.7,2.9-3.9c0.2-0.2,0.6-0.3,0.8,0c0.2,0.2,0.3,0.5,0.1,0.8l0,0
						c-0.9,1.2-1.6,2.6-2.2,4c-0.6,1.4-1.2,2.8-1.8,4.3c-1.1,2.9-2.2,5.9-3.1,8.8l0,0c-0.3,0.9-1.3,1.4-2.2,1.1
						c-0.7-0.2-1.1-0.8-1.2-1.4l0,0c-0.4-3-0.4-5.7-0.5-8.4c0-2.8,0-5.5,0-8.2c0.1-5.5,0.2-10.9,0.4-16.4c0-0.3,0.3-0.6,0.6-0.6
						C682,1022.1,682.2,1022.3,682.2,1022.7z"
          />
          <path
            d="M639.5,897.1l-13.9-2.9c-4.6-0.9-9.3-1.8-13.9-2.5c-1.1-0.1-2.3-0.3-3.4-0.3l-1.8-0.1c-0.6,0-1.2-0.1-1.8-0.1
						c-2.4-0.2-4.8-0.5-7.1-0.9c-2.4-0.4-4.7-0.8-7-1.3c-2.3-0.5-4.7-1.1-6.9-2c-0.2-0.1-0.2-0.2-0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.2l0,0
						c4.6,0.9,9.3,1.3,14,1.8c2.4,0.2,4.7,0.4,7,0.5c0.6,0,1.2,0,1.7,0.1l1.8,0c1.3,0,2.5,0.1,3.7,0.2c4.8,0.5,9.5,1.3,14.2,2.1
						c4.7,0.8,9.4,1.8,14,2.7c0.9,0.2,1.6,1.1,1.4,2.1S640.5,897.3,639.5,897.1L639.5,897.1L639.5,897.1z"
          />
          <path
            d="M299.4,900.5l11.5-2.7c3.8-0.9,7.7-1.8,11.5-2.6c2-0.4,3.9-0.8,5.9-1l1.5-0.2l1.5-0.1c1-0.1,1.9-0.1,2.9-0.3
						c3.9-0.4,7.8-0.9,11.6-1.4c7.7-1.2,15.5-2.5,23.2-4c3.8-0.8,7.7-1.6,11.5-2.5c3.8-0.9,7.6-1.9,11.2-3.2l0,0c0.3-0.1,0.6,0,0.7,0.3
						c0.1,0.3,0,0.6-0.3,0.7c-3.7,1.6-7.5,2.7-11.2,3.9c-3.8,1.1-7.6,2.1-11.5,3c-7.7,1.8-15.4,3.5-23.2,4.8c-3.9,0.7-7.8,1.3-11.7,1.8
						c-1,0.1-2,0.2-3,0.4l-2.9,0.3c-1.9,0.3-3.8,0.7-5.7,1.1c-7.6,1.7-15.3,3.6-23,5.1c-0.9,0.2-1.9-0.4-2-1.4
						C297.9,901.6,298.5,900.7,299.4,900.5L299.4,900.5z"
          />
          <path
            d="M491.9,948.8c-0.9,7.8-2.1,15.4-2.1,23c-0.1,1.9,0.1,3.8,0.2,5.7c0.1,0.9,0.2,1.9,0.3,2.8c0.1,0.5,0.1,0.9,0.2,1.4
						l0.2,1.4c0.6,3.7,1.6,7.4,2.9,10.9c1.4,3.5,3.1,6.8,5.3,9.9c2.2,3.1,4.7,5.8,7.6,8.3c2.9,2.5,6,4.7,9.3,6.6
						c3.3,2,6.8,3.6,10.4,5.3l-0.4,0.7l0,0c-2.9-2.2-5.9-4.4-8.5-7.3c-2.6-2.8-4.6-6.1-6.2-9.5c-1.6-3.4-3-6.9-4.1-10.5
						c-0.3-0.9-0.5-1.8-0.8-2.7c-0.2-0.9-0.5-1.8-0.7-2.7c-0.4-1.8-0.8-3.6-1.2-5.5c-0.2-0.9,0.4-1.9,1.4-2.1c0.9-0.2,1.8,0.4,2,1.2
						l0,0.1c0.5,1.8,0.9,3.5,1.4,5.3c0.5,1.7,0.9,3.5,1.5,5.2c1,3.5,2.2,6.9,3.6,10.2c1.4,3.3,3.1,6.4,5.2,9.3c2,2.9,4.7,5.5,6.9,8.5
						l0,0c0.2,0.1,0.2,0.4,0,0.6c-0.1,0.1-0.3,0.2-0.4,0.1l-0.1,0c-3.7-1-7.6-2.3-11.2-3.9c-3.6-1.7-7.1-3.7-10.3-6.2
						c-6.3-5-11.4-11.8-14.3-19.3c-0.3-1-0.8-1.9-1-2.9l-0.9-2.9c-0.4-2-0.9-3.9-1.2-5.9l-0.2-1.5c-0.1-0.5-0.1-1-0.1-1.5
						c-0.1-1-0.2-2-0.3-3c0-2-0.1-4,0-6c0.2-8,1.5-15.9,4.4-23.3c0.1-0.3,0.5-0.5,0.8-0.4C491.8,948.2,492,948.5,491.9,948.8z"
          />
          <path
            d="M489.3,973.5c-0.7,4.8-1.1,9.8-1.3,14.6c-0.2,4.9-0.1,9.8,0.4,14.6c0.5,4.8,1.5,9.6,3.2,14.1c1.7,4.5,4.3,8.6,7.9,11.9
						l0,0l-1.3,1.5c-5.5-4.8-10-10.5-13.8-16.7c-3.8-6.2-6.6-13-8.5-20c-1.8-7.1-2.6-14.4-2.1-21.7c0.3-3.6,0.8-7.2,1.7-10.8
						c0.9-3.5,2-7,3.5-10.3v0l1.6,0.7c-2,4.4-4.4,8.5-7.1,12.4c-1.3,2-2.8,3.9-4.2,5.8c-1.5,1.9-2.9,3.8-4.5,5.6
						c-3.1,3.7-6.4,7.2-10,10.4c-1.8,1.6-3.7,3.1-5.7,4.4c-2,1.3-4.2,2.5-6.5,3.3l-0.1,0c-0.5,0.2-1-0.1-1.2-0.6
						c-0.1-0.4,0-0.9,0.4-1.1l0,0c4.3-3.2,7.9-7.5,11.4-11.7c3.5-4.2,6.7-8.7,9.7-13.3c3-4.6,5.7-9.4,8-14.3c2.3-4.9,4.4-10,6.4-15.1
						l0,0c0.2-0.5,0.8-0.8,1.3-0.6c0.4,0.2,0.7,0.6,0.6,1.1c-0.9,5.6-2.8,11-5.3,16.1c-2.5,5.1-5.3,9.9-8.4,14.6
						c-3.1,4.7-6.6,9.1-10.2,13.4c-1.8,2.1-3.8,4.2-5.8,6.1c-2,1.9-4.2,3.8-6.6,5.4l0,0l-0.9-1.6c4.1-1.9,7.6-5,11-8.2
						c3.3-3.2,6.4-6.8,9.3-10.4c2.9-3.6,5.7-7.4,8.5-11.2c2.8-3.8,5.5-7.6,8.4-11.3l0.1-0.2c0.3-0.4,0.9-0.4,1.2-0.1
						c0.3,0.3,0.4,0.7,0.3,1.1l0,0c-0.8,3.5-1.5,6.9-2,10.3c-0.5,3.4-0.9,6.9-1,10.4c-0.2,6.9,0.3,13.9,1.9,20.6
						c1.6,6.8,4.1,13.3,7.5,19.4c1.7,3.1,3.6,6,5.7,8.8c2.1,2.8,4.4,5.5,6.9,7.9l0.1,0.1c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.3,0l0,0
						c-4.1-3.1-7.2-7.5-9.3-12.3c-2.1-4.7-3.3-9.8-4-14.8c-0.7-5.1-0.8-10.2-0.5-15.2c0.3-5.1,1-10.1,2.2-15c0.2-0.7,0.9-1.2,1.7-1
						C489,972.1,489.4,972.7,489.3,973.5L489.3,973.5z"
          />
          <path class="st5" d="M467.6,961.3C415,989,363,1025,333,1078.5" />
          <path
            d="M321.5,1071.4c-0.4,2.3-0.1,4.6,0.2,7l0,0c0.1,1-0.6,1.9-1.6,2c-1,0.1-1.9-0.6-2-1.6c0-0.2,0-0.4,0-0.6
						c0.6-2.4,1.1-5,2.4-7.2c0.1-0.2,0.4-0.3,0.7-0.2C321.4,1071,321.5,1071.2,321.5,1071.4L321.5,1071.4z"
          />
          <path
            d="M307.8,1078.2c0.8-10.7,1.3-21.5,3.3-32.2c0.1-0.4,0.5-0.7,0.9-0.6c0.4,0.1,0.6,0.4,0.6,0.8c-1.3,10.6-1.1,21.3-1.2,32.1
						c0,1-0.8,1.7-1.8,1.7s-1.7-0.8-1.7-1.8C307.7,1078.3,307.7,1078.2,307.8,1078.2z"
          />
          <path
            d="M186.6,1034.1c-1.1,3.7-2.4,7.4-3.7,11.1c-1.2,3.7-2.5,7.3-3.7,11c-1.2,3.7-2.3,7.4-3.2,11.1c-0.9,3.7-1.6,7.5-2.2,11.2
						c-0.1,0.8-0.9,1.4-1.7,1.3c-0.8-0.1-1.4-0.8-1.3-1.6c0.3-4,1.1-7.9,2.1-11.7c1-3.8,2.2-7.6,3.5-11.2c1.4-3.7,2.8-7.3,4.3-10.9
						c1.5-3.6,3.1-7.1,4.6-10.7c0.1-0.3,0.5-0.5,0.9-0.3C186.5,1033.5,186.6,1033.8,186.6,1034.1z"
          />
          <path
            d="M183.1,1077c0.8-1.1,1.7-2.1,2.5-3.2l2.6-3.1c1.7-2,3.4-4.1,4.9-6.3l0,0c0.2-0.3,0.6-0.4,0.9-0.2c0.2,0.2,0.4,0.5,0.3,0.7
						c-0.8,2.7-2,5.2-3.3,7.6c-0.7,1.2-1.4,2.4-2.1,3.5c-0.7,1.1-1.5,2.3-2.3,3.3c-0.7,0.9-2,1.1-3,0.4
						C182.7,1079.2,182.5,1077.9,183.1,1077z"
          />
          <path
            d="M582.4,1046.8c3.5,10.4,6.8,20.9,9.3,31.7c0.1,0.5-0.2,1-0.7,1.1c-0.5,0.1-1-0.2-1.1-0.7l0,0c-2.4-10.7-5.7-21.2-9.1-31.6
						c-0.1-0.4,0.1-0.9,0.5-1.1C581.8,1046.1,582.2,1046.4,582.4,1046.8z"
          />
          <path
            d="M589.6,1057.6c1.7,3.3,3,6.7,4.1,10.2c0.6,1.8,1,3.5,1.4,5.3l0.6,2.7l0.3,1.3l0.1,0.7l0.1,0.3l0,0.2c0,0.1,0,0.1-0.3,0.2
						c-0.5,0.2-1,0.3-1.5,0.3l0,0c-0.4,0-0.4,0-0.4-0.1l0-0.2l-0.1-0.3l-0.1-0.7l-0.2-1.3l-0.5-2.7c-0.4-1.8-0.8-3.5-1.2-5.3
						c-0.9-3.5-1.9-6.9-3.3-10.3c-0.1-0.3,0-0.6,0.3-0.7C589.2,1057.3,589.5,1057.4,589.6,1057.6z"
          />
        </g>
      </g>
      <g id="ears">
        <g id="innerEars-fill">
          <path
            class="st3"
            d="M717.3,516.2c9.3-0.2,21-10.5,22.2-11.7c1.2-1.2,10.5-11.2,14.9-14.7c4.4-3.4,25.2-30.8,32.5-40.8
						c7.3-10,13.7-29.3,14.2-41.3c0.5-11.2-1-39.1-22.7-39.1c-21.7,0-50.1,18.1-59.6,26.1c0,0-13.7,47.4-18.9,55.2c2,3.9,2,3.9,2,3.9
						l2.5,5.2c1.8,3.7,8.1,26,8.9,30L717.3,516.2z"
          />
          <path
            class="st3"
            d="M388.3,399.1c-1.2-6-15-52.8-47.6-53.3s-56.1,31.6-59.8,72c-1.7,18.6-2.1,38.9,5.2,56.7
						c8.6,21.1,22.8,44.1,59.1,47.4c46.3,4.2,62-26.5,62-26.5"
          />
          <polyline
            class="st3"
            points="388.3,399.1 399.7,412.9 405.1,458.6 407.2,495.3 		"
          />
        </g>
        <g id="innerEars-shadow">
          <path
            class="st6"
            d="M714.8,410.4c7.6-5.9,27.1-28.1,80.1-32.2c0,0-1.6-6.8-11.4-9.3c-9.8-2.4-33.1,2.9-50.9,16.6
						c0,0-6.1,3.9-12.5,7.1C717.8,393.8,715.6,403.4,714.8,410.4z"
          />
          <path
            class="st7"
            d="M400.2,424.9c-9.8-14.3-19.2-26.1-26.4-33.9s-18.9-19.9-27.7-22.5c-8.8-2.6-32.8-6.5-42.5-4.6
						c0,0,9-14,25.7-17.1c11.1-2,22.8-0.2,30.5,5.7c11.4,8.8,21.8,24.4,27.4,43c4.6,8.5,11.4,13.4,11.4,13.4L400.2,424.9z"
          />
        </g>
        <g id="ears-fill-fur">
          <path
            class="st2"
            d="M719.2,533.1c4.6-0.2,13.7-5.6,21.7-11.7c8.1-6.1,19-16.8,24.7-21.4c5.9-4.7,12.4-12.4,28.8-30
						c16.1-17.4,26.6-44.6,26.6-68.3s-6.4-53.5-38.9-53.5s-54.2,23.5-58.6,29.6l-4.9,17.1c9.5-8.1,37.9-26.1,59.6-26.1
						c21.7,0,23.2,27.9,22.7,39.1c-0.5,12-6.8,31.3-14.2,41.3c-7.3,10-28.1,37.4-32.5,40.8c-4.4,3.4-13.7,13.4-14.9,14.7
						c-1.2,1.2-12.9,11.5-22.2,11.7L719.2,533.1z"
          />
          <g>
            <path
              class="st2"
              d="M406.8,526.1c-10.6,11.1-19.9,11.6-31.4,13c-4,0.5-18.2,1.1-30.2,0.5c-12.8-0.6-28.1-2.1-39.1-3.8
							s-22.3-11.6-26.6-17.9c-7-10.2-10.9-20.9-16-30.6c-2.5-4.8-8.9-21-13.4-38.2c-4.1-15.6-0.8-27.6,0.2-30.6
							c1.9-5.7,8.6-19.2,12.2-26.8c6.1-12.7,10.1-22.2,14.9-31.4c3.1-5.9,9.5-17.8,18.6-25.6c14.6-12.5,36.2-11.7,46.9-10
							c20.7,3.3,40.7,32.2,50.5,44.9l5.2,39.6l-10.2-9.9c-1.2-6-15-52.8-47.6-53.3s-56.1,31.6-59.8,72c-1.7,18.6-2.1,38.9,5.2,56.7
							c8.6,21.1,22.8,44.1,59.1,47.4c46.3,4.2,62-26.5,62-26.5L406.8,526.1z"
            />
          </g>
        </g>
        <g id="ears-shadow-fur">
          <path
            class="st4"
            d="M368.2,358.6c-6.1-10.7-23.1-27.6-37.5-33.2c7.8-0.5,21.9-0.5,37.5,13.9s25.2,30.1,25.2,30.1l5.2,39.6
						c0,0-10-8.4-11.2-12.3C386.1,392.7,382.1,369.9,368.2,358.6z"
          />
          <path
            class="st4"
            d="M738,381.4c-3.3,1-5.5-2.7-3.5-4.6s16.5-20.4,21-23.9c-6.8,2.8-30.3,19.9-31.6,22.2l-5.7,22.4
						C721.1,392.6,740,380.8,738,381.4z"
          />
        </g>
        <g id="ears-lines">
          <path
            d="M722.4,376.8c2.1-2.8,4.4-5.2,6.8-7.6c2.4-2.3,5-4.5,7.7-6.6c5.3-4.1,11.2-7.6,17.4-10.2c6.2-2.7,12.8-4.5,19.5-5.4
						c3.4-0.5,6.7-0.6,10.1-0.5c3.4,0.1,6.8,0.5,10.2,1.4c3.3,0.9,6.6,2.3,9.5,4.2c2.9,1.9,5.6,4.2,7.8,6.9c4.4,5.4,7.2,11.9,8.9,18.4
						c1.7,6.6,2.5,13.3,2.7,20c0.3,6.7-0.2,13.5-1.4,20.1c-1.2,6.6-3,13.1-5.3,19.4c-2.3,6.3-5.1,12.4-8.5,18.2
						c-3.4,5.8-7.3,11.3-11.9,16.3l-13.4,14.6c-2.2,2.4-4.5,4.9-6.8,7.3c-2.3,2.4-4.6,4.8-7.2,7c-1.3,1.1-2.6,2.1-3.8,3.2
						c-1.2,1.1-2.5,2.2-3.7,3.3l-7.4,6.6c-2.5,2.2-5,4.4-7.5,6.5c-2.6,2.1-5.3,4.2-8,6.1c-2.8,1.9-5.6,3.7-8.6,5.4
						c-1.5,0.8-3,1.6-4.6,2.3c-1.6,0.7-3.3,1.3-5.4,1.4c-1,0.1-2-0.7-2-1.7s0.7-2,1.7-2l0,0l0.1,0c1.2-0.1,2.7-0.6,4.1-1.2
						c1.4-0.6,2.9-1.3,4.3-2.1c2.8-1.5,5.6-3.3,8.2-5.1c5.4-3.7,10.3-7.9,15.2-12.3l7.4-6.6c1.2-1.1,2.5-2.2,3.7-3.3
						c1.3-1.1,2.6-2.2,3.8-3.2c2.4-2.1,4.7-4.4,7-6.8c2.3-2.4,4.5-4.8,6.7-7.2l13.4-14.6c4.4-4.7,8.2-10,11.5-15.6
						c6.6-11.2,11.2-23.6,13.4-36.4c0.5-3.2,0.9-6.4,1.1-9.6c0.2-3.2,0.2-6.5,0.1-9.7c-0.2-6.5-0.9-13-2.5-19.2
						c-1.6-6.2-4.1-12.2-8.1-17.1c-3.9-4.9-9.4-8.4-15.5-10c-6.1-1.7-12.6-1.6-19-0.9c-6.4,0.8-12.7,2.5-18.6,5.1
						c-5.9,2.5-11.6,5.9-16.7,9.8c-2.6,1.9-5.1,4.1-7.4,6.3c-2.3,2.2-4.6,4.6-6.5,7.1l0,0c-0.5,0.7-1.5,0.8-2.2,0.3
						C722,378.4,721.9,377.5,722.4,376.8z"
          />
          <path
            d="M717.2,515c2.5-0.1,5-0.9,7.4-1.9c2.4-1.1,4.7-2.4,6.9-3.9c2.2-1.5,4.3-3.1,6.3-4.8c0.5-0.4,0.9-0.8,1.4-1.3l1.4-1.5
						l2.8-2.9c1.9-2,3.8-3.9,5.8-5.8c1-0.9,2-1.9,3-2.8c0.5-0.5,1.1-0.9,1.6-1.3l0.7-0.6c0.2-0.2,0.4-0.5,0.7-0.7
						c1.8-1.9,3.5-4,5.2-6.1c1.7-2.1,3.4-4.2,5.1-6.3c6.7-8.5,13.2-17.1,19.6-25.8c3.2-4.2,5.6-9,7.6-13.9c2.1-4.9,3.7-10,5-15.2
						c0.6-2.6,1.1-5.2,1.5-7.8c0.4-2.6,0.5-5.2,0.5-7.9c0-5.3-0.5-10.6-1.8-15.7c-1.3-5.1-3.4-10-6.9-13.5c-1.8-1.7-3.9-3.1-6.2-3.9
						c-2.4-0.8-4.8-1.1-7.4-0.9c-5.2,0.2-10.4,1.3-15.5,2.8c-5.1,1.6-10,3.7-14.8,6c-4.8,2.3-9.5,4.9-14.1,7.8c-4.5,2.8-9,5.9-13,9.2
						l0,0c-0.7,0.6-1.8,0.5-2.5-0.2c-0.6-0.7-0.5-1.8,0.2-2.5l0,0c4.3-3.5,8.8-6.6,13.5-9.5c4.7-2.9,9.5-5.5,14.4-7.9
						c4.9-2.4,10-4.4,15.3-6.1c5.3-1.6,10.7-2.8,16.4-2.9c2.8-0.1,5.8,0.2,8.6,1.1c2.8,0.9,5.3,2.6,7.4,4.7c2.1,2.1,3.7,4.5,4.9,7.1
						c1.2,2.6,2.1,5.2,2.8,8c1.3,5.4,1.8,11,1.8,16.5c0,2.7-0.2,5.6-0.5,8.3c-0.4,2.7-0.9,5.4-1.6,8.1c-1.3,5.3-3,10.6-5.2,15.6
						c-2.1,5-4.7,10-8,14.4c-6.5,8.7-13,17.3-19.8,25.8c-1.7,2.1-3.4,4.2-5.1,6.3c-1.7,2.1-3.5,4.2-5.4,6.2c-0.2,0.3-0.5,0.5-0.7,0.8
						l-0.8,0.8c-0.5,0.5-1,0.8-1.5,1.3c-1,0.9-2,1.8-2.9,2.7c-1.9,1.9-3.8,3.8-5.7,5.7l-2.8,2.9l-1.4,1.5c-0.5,0.5-1,1-1.5,1.5
						c-2.1,1.8-4.3,3.5-6.6,5c-2.3,1.5-4.7,2.9-7.3,4c-2.6,1.1-5.3,2-8.3,2.1c-0.7,0-1.2-0.5-1.2-1.1
						C716.1,515.6,716.6,515.1,717.2,515L717.2,515z"
          />
          <path
            d="M773.5,367.5c3.8-0.6,7.5-0.8,11.3-0.6c1.9,0.1,3.8,0.3,5.6,0.6c1.9,0.4,3.8,0.9,5.5,2.1c0.5,0.3,0.6,1,0.3,1.5
						c-0.3,0.5-1,0.6-1.4,0.3l-0.1,0c-1.3-0.8-3-1.3-4.7-1.6c-1.7-0.3-3.5-0.4-5.3-0.4c-3.6,0-7.2,0.2-10.7,0.9l0,0
						c-0.8,0.1-1.5-0.3-1.6-1.1C772.2,368.4,772.7,367.7,773.5,367.5C773.4,367.5,773.4,367.5,773.5,367.5z"
          />
          <path
            d="M713.3,409.6c5.6-4.2,11.6-7.8,17.8-10.8c6.3-3,12.9-5.4,19.7-6.8c6.8-1.4,14-1.9,20.9-0.5c3.5,0.7,6.9,1.7,10,3.2
						c3.2,1.5,6.1,3.5,8.8,5.7c0.4,0.3,0.4,0.9,0.1,1.2c-0.3,0.4-0.8,0.4-1.2,0.2l0,0c-2.7-2-5.6-3.7-8.7-5c-3.1-1.3-6.3-2.2-9.6-2.8
						c-3.3-0.6-6.6-0.7-10-0.6c-3.3,0.1-6.7,0.6-9.9,1.3c-3.3,0.7-6.5,1.7-9.7,2.8c-3.2,1.1-6.3,2.4-9.3,3.9c-6.1,2.9-12,6.3-17.4,10.3
						l0,0c-0.6,0.5-1.5,0.3-1.9-0.3C712.5,410.9,712.6,410,713.3,409.6z"
          />
          <path
            d="M747.2,467.3c4.4-5.1,8.1-10.9,11.2-16.9c1.5-3,2.9-6.1,4.1-9.3c1.2-3.2,2.1-6.4,2.8-9.7c1.3-6.6,1.4-13.3-0.2-19.8
						c-0.2-0.8-0.5-1.6-0.7-2.4c-0.2-0.8-0.5-1.6-0.8-2.3c-0.5-1.6-1.3-3-2-4.5c-1.5-2.9-3.4-5.7-5.5-8.3l0,0c-0.5-0.6-0.4-1.5,0.2-2
						c0.6-0.5,1.4-0.4,1.9,0.2c2.4,2.6,4.6,5.5,6.3,8.6c0.8,1.6,1.7,3.2,2.3,4.9c0.3,0.8,0.7,1.7,0.9,2.5c0.2,0.9,0.6,1.7,0.7,2.6
						c1.8,7,1.4,14.3,0,21.2c-1.5,6.9-4.2,13.5-7.6,19.6c-1.7,3.1-3.5,6-5.6,8.8c-2.1,2.8-4.2,5.6-6.7,8.1c-0.3,0.3-0.9,0.3-1.2,0
						C746.9,468.1,746.9,467.6,747.2,467.3L747.2,467.3z"
          />
          <path
            d="M718,484.2c2.3,0.8,4.7,1.3,7,1.6c2.4,0.2,4.8,0.1,7.2-0.3c2.4-0.4,4.7-1.1,7-2.1c2.2-1,4.4-2.1,6.6-3.4l0,0
						c0.4-0.2,0.9-0.1,1.1,0.3c0.2,0.4,0.1,0.9-0.2,1.1c-2.1,1.5-4.3,2.8-6.6,3.9c-2.3,1.1-4.8,2-7.4,2.6c-2.6,0.6-5.2,0.8-7.9,0.6
						c-2.6-0.2-5.2-0.8-7.7-1.7c-0.7-0.2-1-1-0.8-1.7C716.6,484.4,717.3,484,718,484.2L718,484.2z"
          />
          <path
            d="M392.2,370.3c-3-3.7-5.9-7.5-8.9-11.2c-3-3.7-6-7.3-9.2-10.8c-3.2-3.5-6.5-6.8-10-9.9c-3.5-3-7.3-5.8-11.3-8
						c-2-1.1-4.1-2-6.2-2.7c-2.1-0.7-4.2-1.1-6.6-1.4c-4.6-0.6-9.3-0.7-13.9-0.4c-4.6,0.3-9.2,1-13.6,2.3c-4.4,1.3-8.6,3.2-12.3,5.7
						c-1.9,1.3-3.6,2.7-5.2,4.3c-1.7,1.6-3.2,3.3-4.7,5.1c-2.9,3.6-5.5,7.5-7.9,11.5c-4.8,8.1-8.8,16.7-12.8,25.4
						c-4,8.7-8.4,17.2-12.3,25.9c-1,2.2-2,4.3-2.9,6.5c-0.9,2.2-1.9,4.4-2.5,6.5c-1.3,4.3-1.9,9-2,13.6c-0.1,4.6,0.4,9.3,1.4,13.8
						c1.1,4.5,2.4,9.1,3.8,13.6c1.4,4.5,3,9,4.6,13.4c0.8,2.2,1.7,4.4,2.6,6.6c0.9,2.2,1.8,4.4,2.9,6.4c4.5,8.6,7.9,17.5,12.7,25.5
						c1.2,2,2.5,4,3.8,5.8c1.4,1.8,2.9,3.5,4.6,5.1c3.3,3.2,7.1,6,11.1,8.1c2,1.1,4.1,1.9,6.3,2.5c1.1,0.3,2.1,0.5,3.3,0.7l3.5,0.5
						c4.7,0.6,9.4,1.2,14.1,1.7c4.7,0.5,9.5,0.9,14.2,1.2c4.7,0.3,9.5,0.6,14.2,0.7c4.7,0.1,9.5,0,14.2-0.1c2.4-0.1,4.7-0.2,7.1-0.4
						c2.3-0.2,4.7-0.6,7-0.9c4.7-0.6,9.2-1.6,13.3-3.6c4.1-2,7.6-5,10.8-8.4l0,0c0.7-0.7,1.8-0.8,2.5-0.1c0.7,0.7,0.8,1.8,0.1,2.5
						c0,0,0,0,0,0.1c-3.5,3.5-7.5,6.6-12,8.7c-4.5,2.1-9.5,3.1-14.2,3.7c-2.4,0.3-4.7,0.6-7.2,0.9c-2.4,0.2-4.8,0.4-7.2,0.5
						c-4.8,0.2-9.6,0.3-14.4,0.3c-4.8,0-9.6-0.2-14.4-0.5c-4.8-0.3-9.6-0.7-14.3-1.1c-4.8-0.4-9.5-1-14.3-1.6l-3.6-0.5
						c-1.2-0.2-2.5-0.4-3.7-0.7c-2.5-0.6-4.8-1.6-7-2.7c-4.4-2.3-8.4-5.2-12-8.6c-1.8-1.7-3.5-3.5-5-5.5c-1.5-2-2.8-4-4.1-6.2
						c-5-8.4-8.5-17.3-12.9-25.7c-1.1-2.2-2.1-4.5-3-6.7c-0.9-2.2-1.8-4.5-2.6-6.7c-1.7-4.5-3.2-9.1-4.6-13.6
						c-1.4-4.6-2.8-9.2-3.9-13.9c-1.1-4.8-1.5-9.7-1.5-14.6c0.1-4.9,0.7-9.8,2.2-14.6c0.8-2.4,1.8-4.6,2.8-6.8c1-2.2,2-4.4,3-6.5
						l6.3-12.9c2.1-4.3,4-8.6,6-13c4-8.7,7.8-17.5,12.5-25.9c2.4-4.2,5-8.3,8.1-12.2c3-3.9,6.5-7.5,10.7-10.4c4.1-2.9,8.8-5,13.5-6.4
						c4.8-1.4,9.7-2.2,14.6-2.4c4.9-0.3,9.8-0.1,14.7,0.5c2.4,0.3,5,0.8,7.4,1.6c2.4,0.8,4.7,1.9,6.9,3.1c4.4,2.4,8.2,5.5,11.9,8.7
						c3.6,3.3,7,6.8,10.2,10.4c6.4,7.2,12,15.1,17.6,22.7l0,0c0.5,0.7,0.3,1.6-0.3,2.1C393.5,371.1,392.7,370.9,392.2,370.3z"
          />
          <path
            d="M364.1,402c-2.5-2.8-5.7-5.2-8.9-7.3c-3.3-2.1-6.8-3.9-10.4-5.2c-3.6-1.4-7.4-2.3-11.3-2.7c-3.8-0.3-7.8-0.1-11.6,0.6
						c-3.8,0.7-7.5,2-10.9,3.9c-3.4,1.9-6.4,4.4-8.9,7.4l-0.9,1.1l-0.5,0.6l-0.4,0.6l-1.7,2.4c-0.9,1.7-2,3.4-2.8,5.2
						c-1.7,3.5-2.9,7.3-4,11.1l0,0c-0.1,0.4-0.5,0.6-0.9,0.5c-0.4-0.1-0.6-0.5-0.5-0.9c1-3.9,2.2-7.8,3.9-11.5c0.8-1.9,1.8-3.6,2.8-5.4
						l1.7-2.6l0.4-0.6l0.5-0.6l1-1.2c2.6-3.2,5.7-5.9,9.3-8c3.5-2.1,7.5-3.5,11.5-4.4c4-0.8,8.1-1.2,12.3-0.8c4.1,0.3,8.1,1.3,12,2.7
						c3.9,1.4,7.5,3.2,11,5.4c3.5,2.2,6.8,4.7,9.6,7.8c0.5,0.6,0.5,1.5-0.1,2.1C365.6,402.7,364.7,402.6,364.1,402L364.1,402L364.1,402
						z"
          />
          <path
            d="M360.6,504.6c5-2.2,9.8-4.8,14-8.1c2.1-1.7,4.1-3.5,6-5.4c0.9-1,1.9-1.9,2.8-3c0.9-1,1.9-2.1,2.7-3
						c3.2-4.1,5.7-9.1,8.3-13.8c1.3-2.4,2.7-4.8,4.2-7.2c0.8-1.2,1.5-2.4,2.4-3.5c0.9-1.1,1.9-2.3,3.3-3.2c0.7-0.4,1.6-0.3,2,0.4
						c0.4,0.6,0.3,1.5-0.3,2l-0.1,0c-0.9,0.6-1.7,1.6-2.5,2.6c-0.8,1-1.5,2.1-2.2,3.3c-1.4,2.3-2.7,4.7-4,7.1c-1.3,2.4-2.6,4.8-4.1,7.2
						c-1.4,2.4-2.9,4.8-4.8,7c-1,1.1-1.9,2.1-2.9,3.1c-1,1-2,2-3,2.9c-2,1.9-4.1,3.8-6.4,5.4c-2.3,1.6-4.7,3-7.2,4.3
						c-2.5,1.2-5.1,2.3-7.7,3.1c-0.3,0.1-0.6-0.1-0.7-0.4C360.1,505,360.3,504.7,360.6,504.6z"
          />
          <path
            d="M387.2,399.3c-0.9-3.8-2.2-7.6-3.6-11.4c-1.5-3.7-3.1-7.4-4.9-10.9c-3.7-7.1-8.2-13.8-13.9-19.2c-2.9-2.7-6-5.1-9.5-6.9
						c-3.5-1.8-7.2-3-11-3.5c-1.9-0.3-3.9-0.3-5.8-0.2c-2,0.1-3.9,0.3-5.8,0.6c-3.9,0.6-7.7,1.8-11.2,3.4c-7.2,3.2-13.4,8.3-18.6,14.3
						c-5.2,6-9.2,12.9-12.3,20.3c-3.1,7.3-5.3,15.1-6.6,22.9c-0.7,3.9-1.1,7.9-1.4,11.9c-0.3,4-0.6,8-0.7,12c-0.2,8,0.1,16,1.3,23.9
						c0.6,3.9,1.5,7.8,2.7,11.6c0.3,0.9,0.6,1.9,0.9,2.8l1.1,2.8c0.8,1.9,1.5,3.7,2.4,5.5c3.3,7.3,7.3,14.2,12.5,20.2
						c5.1,6,11.4,10.9,18.6,14.3c7.1,3.4,14.9,5.4,22.8,6.2c2,0.3,4,0.3,5.9,0.5c2,0,4,0.1,6,0c4-0.1,7.9-0.4,11.8-1.2
						c7.8-1.4,15.3-4.2,21.9-8.4c3.3-2.1,6.4-4.6,9.2-7.3c1.4-1.4,2.7-2.8,3.9-4.4c0.6-0.8,1.2-1.5,1.7-2.3c0.5-0.8,1.1-1.6,1.5-2.4
						l0-0.1c0.5-0.9,1.5-1.2,2.4-0.7c0.9,0.5,1.2,1.5,0.7,2.4l0,0c-0.6,1-1.1,1.9-1.7,2.8c-0.6,0.9-1.2,1.7-1.9,2.5
						c-1.3,1.6-2.7,3.2-4.2,4.7c-3,2.9-6.3,5.5-9.8,7.8c-7,4.5-15,7.4-23.2,8.8c-4.1,0.8-8.2,1.1-12.3,1.2c-2.1,0.1-4.1,0-6.2-0.1
						c-2.1-0.2-4.1-0.2-6.2-0.5c-8.2-0.9-16.3-3-23.8-6.6c-7.5-3.6-14.2-8.9-19.6-15.2c-5.4-6.3-9.6-13.5-13-21
						c-0.9-1.9-1.6-3.7-2.4-5.6l-1.1-2.9c-0.4-1-0.6-2-1-2.9c-1.2-3.9-2.1-8-2.8-12c-1.3-8.1-1.6-16.4-1.3-24.5
						c0.1-4.1,0.4-8.1,0.7-12.2c0.3-4,0.8-8.2,1.5-12.2c1.4-8.1,3.6-16,6.9-23.6c3.2-7.6,7.5-14.7,12.9-21c5.4-6.3,12-11.6,19.6-15
						c7.6-3.4,16.1-4.9,24.5-3.9c4.2,0.5,8.3,1.9,12,3.8c3.7,2,7.1,4.5,10,7.4c6,5.8,10.5,12.8,14.3,20c1.9,3.6,3.5,7.4,5,11.2
						c1.4,3.8,2.8,7.7,3.7,11.8c0.1,0.6-0.3,1.3-0.9,1.4C388,400.4,387.3,400,387.2,399.3L387.2,399.3z"
          />
          <path
            d="M283.5,376.9c1.5-1.7,2.8-3.6,4.3-5.4c1.4-1.9,2.9-3.7,4.5-5.4c3.2-3.5,6.8-6.6,10.7-9.4c3.9-2.8,8.1-5,12.5-6.9
						c4.3-1.9,8.9-3.2,13.5-4.3c0.8-0.2,1.6,0.3,1.8,1.1c0.2,0.8-0.3,1.6-1.1,1.8l-0.1,0c-4.4,1.2-8.8,2.4-13.1,4.2
						c-4.2,1.7-8.3,3.7-12.1,6.3c-3.8,2.5-7.3,5.4-10.5,8.7c-1.6,1.6-3.1,3.4-4.6,5.1c-1.5,1.8-2.9,3.6-4.6,5.4c-0.3,0.3-0.9,0.3-1.2,0
						C283.2,377.8,283.2,377.3,283.5,376.9L283.5,376.9z"
          />
          <path
            d="M374.5,360.7c-2.1-3.2-4.7-6.2-7.6-8.8c-2.9-2.6-6-5-9.3-6.9c-3.3-1.9-6.9-3.4-10.6-4.4c-1.8-0.5-3.7-0.8-5.6-0.9
						c-1.8-0.1-3.9,0-5.8,0.1c-3.9,0.2-7.8,0.7-11.6,1.6c-3.8,0.9-7.5,2-11.1,3.5c-7.2,3-13.8,7.4-19.1,13.1c-0.2,0.3-0.6,0.3-0.9,0
						c-0.2-0.2-0.3-0.6-0.1-0.8c2.5-3.1,5.4-6,8.7-8.4c3.2-2.4,6.8-4.5,10.4-6.2c7.4-3.4,15.4-5.1,23.5-5.7c2-0.1,4-0.2,6.1-0.1
						c2.1,0.1,4.1,0.5,6.1,1c4,1,7.8,2.7,11.3,4.9c6.9,4.3,12.9,10.1,16.9,17.2c0.2,0.4,0.1,0.8-0.3,1
						C375.1,361.1,374.7,361,374.5,360.7L374.5,360.7z"
          />
          <path
            d="M282,480.6c-2.5-3.8-4.8-7.8-6.6-12c-1.8-4.2-3.3-8.6-4.4-13c-1.1-4.4-1.8-9-2.2-13.5c-0.4-4.5-0.6-9.1-0.6-13.7
						c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2v0l0,0c0,4.5,0.1,9,0.4,13.4c0.4,4.5,1.1,8.9,2.1,13.2c1,4.3,2.4,8.6,4.1,12.7
						c1.8,4.1,3.9,8,6.3,11.8l0,0c0.3,0.4,0.2,1-0.3,1.3C282.8,481.1,282.2,481,282,480.6z"
          />
          <path
            d="M294.3,499.3c-1.4-1.3-2.7-2.6-3.9-4c-1.3-1.4-2.5-2.7-3.7-4.3c-0.3-0.4-0.2-0.9,0.2-1.2c0.4-0.3,0.9-0.2,1.2,0.2
						c0,0,0,0,0,0l0,0c1,1.5,2.2,2.9,3.3,4.3c1.2,1.4,2.4,2.8,3.6,4.1c0.2,0.2,0.2,0.6,0,0.8C294.8,499.5,294.5,499.5,294.3,499.3z"
          />
          <path
            d="M361.8,531.6c8.1,0.5,16.3-0.7,23.9-3.3c7.6-2.6,14.8-6.7,20.5-12.1l0,0c0.7-0.7,1.8-0.6,2.5,0.1s0.6,1.8-0.1,2.5
						c0,0,0,0-0.1,0c-6.4,5.6-14.1,9.5-22.1,11.9c-8,2.4-16.5,3.3-24.8,2.5c-0.4,0-0.7-0.4-0.7-0.8
						C361.1,531.9,361.4,531.6,361.8,531.6z"
          />
          <path
            d="M398.2,413.8c-1.4-2.5-2.9-5-4.7-7.3c-1.7-2.2-3.7-4.3-6-5.8c-1.1-0.7-2.4-1.3-3.7-1.7l-1-0.2c-0.3-0.1-0.7-0.1-1-0.1
						c-0.7-0.1-1.3-0.1-2,0c-2.7,0.3-5.5,1.2-8.1,2.4c-5.2,2.4-10.1,5.6-14.6,9.3c-4.5,3.7-8.6,7.9-11.8,12.6c-3.2,4.8-5.7,10-7.4,15.5
						c-0.8,2.7-1.5,5.6-1.9,8.4c-0.4,2.8-0.4,5.6-0.2,8.5c0.3,5.8,1.4,11.5,3.7,16.7c2.4,5.2,6,9.7,10.3,13.7l0,0
						c0.4,0.3,0.4,0.9,0,1.3c-0.3,0.3-0.9,0.4-1.2,0.1c-2.4-1.9-4.6-4-6.5-6.3c-2-2.3-3.7-4.9-5.1-7.6c-2.8-5.5-4.1-11.6-4.4-17.7
						c-0.1-0.8-0.1-1.5-0.1-2.3c0-0.7,0-1.5,0-2.3c0-1.5,0.2-3.1,0.4-4.6c0.4-3,1.1-6,2-8.9c0.9-2.9,2-5.7,3.3-8.5
						c1.3-2.7,2.9-5.3,4.6-7.8c1.7-2.5,3.7-4.8,5.8-7c2.1-2.2,4.4-4.2,6.7-6c4.7-3.7,9.8-7,15.3-9.5c2.8-1.2,5.7-2.2,8.9-2.5
						c3.3-0.3,6.5,0.7,9.2,2.3c2.8,1.6,5,3.8,7,6.2c2,2.4,3.7,4.9,5.3,7.4c0.5,0.8,0.2,1.9-0.6,2.4
						C399.8,414.9,398.7,414.7,398.2,413.8C398.2,413.8,398.2,413.8,398.2,413.8z"
          />
          <path
            d="M730.1,378.8c2.7-2.5,5.5-4.6,8.4-6.7c2.9-2.1,5.9-4,8.9-5.9c6.1-3.6,12.5-6.9,19.3-9.2l2.6-0.8c0.9-0.2,1.8-0.4,2.6-0.7
						c1.7-0.5,3.6-0.7,5.4-1c3.7-0.4,7.3-0.2,10.9,0.3l2.7,0.5l2.7,0.7c0.9,0.3,1.7,0.6,2.6,1c0.8,0.4,1.7,0.7,2.5,1.2
						c1.6,0.9,3.2,1.9,4.5,3.2c1.4,1.3,2.6,2.6,3.5,4.4c0.2,0.4,0.1,1-0.4,1.2c-0.4,0.2-0.9,0.1-1.1-0.3l-0.1-0.1
						c-0.8-1.3-2.1-2.5-3.4-3.6c-1.3-1-2.7-2-4.3-2.7c-0.7-0.4-1.5-0.7-2.3-1c-0.8-0.3-1.6-0.5-2.4-0.8l-2.5-0.6l-2.5-0.4
						c-3.4-0.5-6.9-0.5-10.2-0.2c-1.7,0.3-3.4,0.4-5.1,0.9c-0.8,0.2-1.7,0.4-2.5,0.6l-2.5,0.8c-0.8,0.2-1.6,0.5-2.5,0.9l-2.4,0.9
						c-1.6,0.7-3.2,1.3-4.8,2.1c-1.6,0.7-3.2,1.5-4.7,2.3c-1.6,0.8-3.1,1.7-4.6,2.5c-6,3.5-12,7.4-17.3,11.8l0,0
						c-0.4,0.3-0.9,0.3-1.2-0.1C729.7,379.6,729.8,379.1,730.1,378.8z"
          />
          <path
            d="M802.1,431.7c2.3-6.9,3.9-14.1,4.6-21.3c0.4-3.6,0.5-7.2,0.1-10.8c-0.4-3.6-1.2-7.1-2.8-10.2l0,0
						c-0.3-0.5-0.1-1.1,0.4-1.4c0.5-0.3,1.1-0.1,1.4,0.4c0,0,0,0,0,0c1.7,3.5,2.4,7.2,2.7,11c0.3,3.7,0.2,7.5-0.2,11.1
						c-0.8,7.4-2.6,14.6-4.9,21.6c-0.1,0.4-0.5,0.6-0.9,0.4C802.2,432.5,802,432.1,802.1,431.7L802.1,431.7z"
          />
          <path
            d="M405.1,500.3c-4.6,2.3-8.3,15.1-8.3,21.7s0.5,11.2-2.4,12.7c0,0,12.9-9.5,12.9-12.5C407.3,519.4,407.5,499.1,405.1,500.3z
						"
          />
          <path
            d="M387,362.2c-1,4.9-0.2,7.2-0.8,9.9c-0.7,2.8-3.6,5.4-4.6,6.5l7,19.5l11.4,12.4l-6.7-41.2l-2.9-4.1L387,362.2z"
          />
        </g>
      </g>
      <g id="skull">
        <g id="skull-fill">
          <path
            class="st2"
            d="M740,721.5c1.2-1.2,13.4-26.5,12-46c-1.4-18.9-14.8-67.5-31.6-96.5c0.4,0.1,0.7,0.3,1.1,0.4
						c0.9-12.4-5.9-74.1-7.6-85.6c-0.1-0.6-0.2-1.1-0.2-1.7c3.8-4.3,5.6-9.8,4.2-15.5c-2.5-10-8.5-16.3-15.8-20.2
						c-0.7-1.8-1.9-4.7-2.1-5c-0.3-0.5,0-2.1,2.3-6.2c2.3-4.1,6.5-17.8,9-25.2c2.4-7.5,9.1-31.8,12.8-43.6
						c3.5-11.2,11.8-43.2,11.6-52.7c0-0.7-0.3-1.4-0.8-2c-9-9.1-26.4-35.8-34.1-46.8c-1.5-2.2,11.5-8,10.9-8.7c0,0-17.4,4.3-22.2,4.1
						c-2.5-0.1,15.3-8.8,12.2-8.8c-3.3,0.1-27.6,8.9-31,9.3c-1.9,0.2,1.1-0.1-5.6,0c-5.7,0.1,24.3-20.1,19.1-20
						c-2.8,0-50.6,20.9-52.5,20.9c-19.3,0.2-27.4-0.1-35.7-0.1c-12.5,0-40.3,5.9-51.3,8.8c-11,2.9-44,16.1-52.8,20.5
						c-8.8,4.4-35.9,19.8-44.7,25.6c-8.8,5.9-15.6,11-23.5,16.9c-7.6,5.7-22.7,18.3-30,26.4c2.2,14.7,8.1,51.3,11,77.7
						c2.9,26.4,5,76.9,2.2,91.6c-7.3,38.8-23.9,90-23.1,139.8c3.5-12.4,7.6-28.4,11.1-42.3l2.8-10.5c1.1,36.9,33.4,92.2,42.9,103.6
						c-9.1-39.2-8.1-65.2-7.3-79.2c4.4,16.1,19.8,58.6,27.9,68.9c0-11.7-2-33.2-1.2-41.3c0,0,0.2-0.2,0.5-0.7c0,11.8,1.9,25,7.9,35.7
						c11.3,20,27.7,33.5,35.7,32.7l-3.5,2c-2.2,3.9,3.4,7.1,9.7,9.6c6.2,2.5,34.5,14.8,44.5,14.5c8.9-0.3,40.5,0.7,64.3,1.6
						c23.7,0.9,58.6,1.3,74.9-0.2c16.3-1.5,33.6-6.8,42-14.3c4.8-4.3,4.9-7.9,4.7-11.7c-0.1-2.2-0.8-4.3-1.6-5.9c0,0,0,0,0,0
						c-0.6-1.2-1.4-2.1-2.1-2.7l-9.4,0.3c4.1-0.7,8.7-1.5,14.9-2.4c5.4-0.8,7.4-4.2,5.5-7.8C745.9,725.6,742.3,722.8,740,721.5z"
          />
        </g>
        <g id="skull-shadows">
          <g>
            <path
              class="st4"
              d="M460.3,383.3c-8.3,10.3-27.9,53-12.5,80.6c15.4,27.6,43.2,18.3,43.2,18.3s14.9-4.4,22-7.1
							c7.1-2.7,43.7-16.1,43.7-16.1c-15.6,1.5-44.2,7.6-60.1,6.1c-15.9-1.5-39.8-12-43.5-27.6C449.5,421.9,450.3,408,460.3,383.3z"
            />
            <path
              class="st4"
              d="M709.3,418.4c0,0-13.6,29.2-21.9,31.9c-8.3,2.7-31.5,2.9-31.5,2.9s29.1,8.3,31.3,11
							c2.2,2.7,6.4,8.8,6.4,10.7s-4.6,9.8-6.1,10.7l8.1,10.7c1.5-8.3,5.5-30.8,6-39.8l-2.4-7.6C702.9,445.3,708.1,425,709.3,418.4z"
            />
            <path
              class="st4"
              d="M505.7,500.2c14,5.9,26.5,10.7,34,11.4c-2,5.2-9.2,19.2-9.2,19.2C524.3,530.1,510.9,519.7,505.7,500.2z"
            />
            <path
              class="st4"
              d="M694,522c0,0,2.9-18.9,4.2-20.8c-4.9-1-13.7,1-13.7,1L694,522z"
            />
          </g>
        </g>
        <g id="skull-lines">
          <g>
            <g>
              <path
                d="M398.5,624.7c0.7,9.3,2.9,18.4,5.6,27.3c2.8,8.9,6.3,17.7,10.1,26.2c3.9,8.5,8.1,17,12.6,25.2
								c4.5,8.2,9.6,16.2,14.7,23.8l0,0l-3,1.5c-0.7-3.3-1.5-6.5-2.2-9.8l-1-4.9l-0.9-4.9c-1.1-6.6-2-13.2-2.6-19.9
								c-0.6-6.7-1-13.4-1-20c-0.1-6.7,0.3-13.4,1.2-20l0,0c0-0.5,0.4-0.8,0.9-0.8c0.4,0,0.6,0.3,0.8,0.6l0,0
								c2.1,5.8,4.2,11.6,6.2,17.5c1,2.9,2,5.9,3,8.8c1.1,2.9,2.2,5.8,3.3,8.7c2.3,5.8,4.7,11.5,7.2,17.1c1.3,2.8,2.6,5.6,4,8.3
								c0.7,1.3,1.4,2.7,2.2,4c0.7,1.3,1.5,2.5,2.3,3.7l0,0L459,718c0.1-6.8-0.2-13.7-0.4-20.6c-0.1-3.4-0.2-6.9-0.2-10.3
								c0-3.5-0.1-6.9,0.3-10.4c0-0.5,0.5-0.8,1-0.8c0.5,0,0.8,0.4,0.8,0.9l0,0c-0.2,3.3,0,6.8,0.2,10.2c0.2,3.4,0.4,6.9,0.7,10.3
								c0.5,6.9,1.1,13.7,1.3,20.7l0,0c0,1-0.7,1.8-1.7,1.8c-0.6,0-1.1-0.3-1.4-0.7l0,0l-1.5-2c-0.5-0.7-0.8-1.4-1.3-2.1
								c-0.8-1.4-1.5-2.8-2.3-4.2c-1.4-2.8-2.7-5.7-3.9-8.5c-2.5-5.7-4.7-11.5-6.9-17.4c-1.1-2.9-2.1-5.9-3.2-8.8
								c-1-2.9-2.2-5.8-3.2-8.8c-1-2.9-1.9-5.9-2.8-8.9c-0.9-3-1.6-6-2.2-9.1l1.7-0.2l0,0c0.2,6.7,0.2,13.3,0.3,19.9
								c0.2,6.6,0.6,13.2,1.3,19.8c0.7,6.6,1.6,13.1,2.7,19.6c1.1,6.5,2.4,13,3.8,19.5l0,0c0.2,0.9-0.4,1.9-1.3,2.1
								c-0.7,0.1-1.3-0.1-1.7-0.6l0,0c-3.4-3.6-6-7.6-8.5-11.7c-2.5-4.1-4.9-8.2-7.2-12.3c-4.6-8.3-8.8-16.9-12.6-25.6
								c-3.7-8.7-7.1-17.6-9.8-26.8c-2.6-9.1-4.7-18.6-4.6-28.3c0-0.6,0.5-1.1,1.1-1.1C398,623.6,398.4,624.1,398.5,624.7L398.5,624.7z
								"
              />
            </g>
            <g>
              <path
                d="M720.7,578c-0.4-13.6-2.1-27.2-3.6-40.8c-0.7-6.8-1.6-13.6-2.1-20.4c-0.3-3.4-0.6-6.8-0.9-10.2
								c-0.2-1.7-0.4-3.4-0.5-5.1c-0.2-1.7-0.4-3.4-0.8-5.1c-0.2-0.8-0.3-1.7-0.5-2.5l-0.1-0.6l0-0.3l0-0.2l-0.3-1.2
								c-0.4-1.7-0.8-3.3-1.2-5c-0.8-3.3-1.8-6.6-2.8-9.8c-2-6.5-4.2-13-6.8-19.2l-1.9-4.8l-0.5-1.2l-0.2-0.5c0,0,0-0.1,0,0l0,0
								c0,0-0.1-0.2-0.1-0.2c-0.2-0.4-0.2-0.7-0.2-0.9c0-0.9,0.2-1.4,0.3-1.9c0.2-0.5,0.3-0.9,0.5-1.4c0.4-0.9,0.8-1.6,1.2-2.4l0.6-1.2
								c0.2-0.3,0.4-0.7,0.5-1c0.7-1.5,1.3-3.1,1.9-4.6c2.3-6.4,4.4-12.9,6.5-19.4c2-6.5,3.9-13.1,5.8-19.7c1.9-6.6,3.8-13.2,5.8-19.8
								c2.1-6.6,3.9-13.1,5.6-19.7c1.7-6.6,3.3-13.3,4.7-19.9c0.7-3.3,1.3-6.7,1.8-10c0.2-1.7,0.4-3.3,0.5-5c0-0.4,0-0.8,0-1.2
								c0-0.2,0-0.3,0-0.4c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1l-0.2-0.2l-0.9-1c-2.4-2.6-4.6-5.3-6.7-8
								c-2.1-2.7-4.2-5.5-6.2-8.3c-4.1-5.6-8-11.2-11.9-16.8l-5.8-8.5l-2.9-4.2c-1-1.4-2-2.8-2.9-4l1.1,0.6c-6.7-0.6-13.6-0.8-20.4-0.5
								c-1.7,0.1-3.4,0.2-5.1,0.4c-1.7,0.2-3.5,0.4-5.2,0.4c-3.5,0.2-6.9,0.3-10.4,0.4c-13.8,0.3-27.6,0.2-41.4,0.2l-10.3-0.1l-5.2,0
								c-1.7,0-3.5,0-5.1,0c-3.3,0.1-6.7,0.5-10.1,1c-3.4,0.5-6.7,1.2-10.1,1.8c-6.8,1.2-13.5,2.5-20.2,4c-3.3,0.8-6.7,1.5-9.9,2.5
								c-3.2,0.9-6.5,2.1-9.7,3.2c-6.5,2.3-12.9,4.8-19.3,7.3c-6.4,2.5-12.8,5.2-19,7.9c-3.1,1.4-6.1,3-9.1,4.6c-3,1.6-6,3.3-9,5
								c-6,3.4-12,6.8-17.9,10.3c-3,1.7-5.9,3.5-8.8,5.3c-2.9,1.8-5.7,3.7-8.5,5.7c-5.6,3.9-11.1,8-16.7,12.2
								c-5.5,4.1-10.8,8.4-16,12.9c-5.2,4.5-10.3,9.1-14.9,14l0.5-1.5c3.9,25.7,8,51.5,10.9,77.4c1.4,13,2.2,26,2.8,39.1
								c0.6,13,0.9,26.1,0.5,39.2c-0.1,3.3-0.3,6.6-0.6,9.9c-0.1,1.6-0.4,3.3-0.7,5l-0.9,4.8c-1.3,6.4-2.7,12.8-4.2,19.1
								c-2.9,12.7-6,25.3-8.7,38c-5.4,25.4-9.6,51.1-9.2,77l-3.4-0.4c3.3-11.9,6.4-23.9,9.5-35.9l4.7-18c0.8-3,1.6-6,2.4-9
								c0.9-3,1.7-6,2.8-9c0.3-0.9,1.4-1.4,2.3-1c0.9,0.3,1.4,1.4,1,2.3l0,0l0,0.1c-1,2.7-1.9,5.7-2.7,8.7c-0.8,3-1.6,6-2.4,8.9
								l-4.7,18c-3.1,12-6.2,24-9.5,36c-0.3,0.9-1.2,1.5-2.2,1.2c-0.8-0.2-1.3-0.9-1.3-1.7c-0.4-26.3,3.8-52.3,9.3-77.8
								c2.7-12.8,5.8-25.4,8.7-38.1c1.5-6.3,2.9-12.7,4.2-19l0.9-4.8c0.3-1.6,0.5-3.1,0.7-4.7c0.3-3.2,0.5-6.4,0.6-9.6
								c0.4-12.9,0-25.9-0.6-38.9c-0.6-13-1.4-25.9-2.9-38.8c-3-25.8-7.1-51.5-11-77.2l0,0c-0.1-0.6,0.1-1.1,0.5-1.5
								c4.8-5.2,10-9.8,15.2-14.4c5.3-4.5,10.6-8.9,16.2-13.1c5.5-4.1,11.1-8.3,16.7-12.3c2.8-2,5.7-3.9,8.7-5.8
								c2.9-1.8,5.9-3.6,8.9-5.4c6-3.5,11.9-6.9,18-10.3c3-1.7,6-3.4,9.1-5c3-1.6,6.1-3.3,9.3-4.7c6.3-2.9,12.7-5.5,19.2-8
								c6.4-2.6,12.9-5.1,19.4-7.4c3.3-1.2,6.5-2.3,9.9-3.3c3.4-1,6.8-1.7,10.1-2.5c6.8-1.5,13.5-2.9,20.4-4.1
								c3.4-0.6,6.9-0.9,10.3-1.4c3.5-0.4,6.9-0.8,10.5-0.9c1.8-0.1,3.5,0,5.2,0l5.2,0l10.3,0.1c13.8,0.1,27.6,0.2,41.3-0.1
								c3.4-0.1,6.9-0.2,10.3-0.4c1.7-0.1,3.3-0.3,5.1-0.4c1.7-0.2,3.5-0.3,5.2-0.4c7-0.3,13.9-0.1,20.9,0.5l0,0c0.4,0,0.8,0.3,1.1,0.6
								c0.6,0.7,1.1,1.5,1.6,2.2l1.5,2.1l2.9,4.2l5.8,8.5c3.9,5.6,7.8,11.3,11.8,16.8c2,2.8,4,5.5,6.1,8.2c2.1,2.7,4.2,5.3,6.5,7.8
								l0.9,0.9l0.3,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.3,0.4,0.6,0.5,0.9c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.1,0.7,0.1,0.9
								c0,0.5,0,0.9,0,1.4c-0.1,1.8-0.3,3.5-0.5,5.3c-0.5,3.4-1.2,6.8-1.9,10.2c-1.4,6.7-3,13.4-4.8,20.1c-0.9,3.3-1.8,6.6-2.7,10
								c-0.9,3.3-2,6.6-3,9.9c-4,13.1-7.5,26.3-11.5,39.5c-2.1,6.5-4.1,13.1-6.5,19.6c-0.6,1.6-1.2,3.3-2,4.9c-0.2,0.4-0.4,0.8-0.6,1.3
								l-0.6,1.1c-0.4,0.7-0.8,1.5-1.1,2.2c-0.2,0.4-0.3,0.7-0.4,1c-0.1,0.3-0.2,0.7-0.2,0.6c0,0,0-0.1-0.1-0.3c0,0-0.1-0.2-0.1-0.1
								l0.1,0.2c0.1,0.1,0.1,0.2,0.1,0.2c0.1,0.2,0.2,0.4,0.3,0.7l0.5,1.2l1.9,4.7c2.7,6.4,4.9,12.9,7,19.5c1,3.3,2,6.6,2.8,10
								c0.4,1.7,0.9,3.4,1.2,5l0.3,1.3l0.1,0.4l0,0.3l0.1,0.6c0.1,0.9,0.1,1.7,0.2,2.6c0.1,1.7,0.3,3.4,0.5,5.1l0.7,5.1l1.5,10.2
								c1,6.8,1.6,13.6,2.2,20.5c0.6,6.8,1.1,13.7,1.3,20.6c0.3,6.9,0.5,13.8,0,20.7c0,0.4-0.4,0.7-0.8,0.7
								C721,578.7,720.7,578.4,720.7,578L720.7,578z"
              />
            </g>
            <path
              d="M394.2,638.3c3.2,27.8,12.5,53,17.7,62.9c0.5,1,2,0.5,1.9-0.6c-0.8-9.3-1.4-18.3-1.4-19.2c0-0.1,0-0.1,0-0.2
							c-0.8-2.3-16.2-46.1-15.4-49.7c0.8-3.5-2.3,5.3-2.7,6.5C394.2,638.1,394.2,638.2,394.2,638.3z"
            />
            <path
              d="M432.1,668c3.1,27.1,13,45.3,19.6,53.6c0.8,1.1,2.6,0.3,2.2-1.1c-2.8-11.4-5.3-25.3-5.4-26.3c0-0.1,0-0.1,0-0.1
							l-5.8-14.7l-8.6-24.4c-0.2-0.6-1-0.5-1.1,0.1l-0.9,12.8C432.1,667.9,432.1,667.9,432.1,668z"
            />
            <g>
              <path
                d="M414.3,595.7c0-1.7,0.1-3.3,0.4-4.9c0.2-1.6,0.5-3.2,0.8-4.7c0.3-1.6,0.7-3.1,1.1-4.7c0.4-1.6,0.8-3,1.5-4.7
								c0.3-0.6,0.9-0.9,1.5-0.6s0.9,0.9,0.6,1.5c0,0,0,0,0,0l0,0.1c-0.6,1.2-1.1,2.8-1.6,4.2c-0.5,1.5-0.9,3-1.3,4.5
								c-0.4,1.5-0.7,3-1,4.6c-0.3,1.5-0.5,3.1-0.5,4.6l0,0c0,0.4-0.4,0.8-0.8,0.8C414.6,596.5,414.3,596.1,414.3,595.7z"
              />
            </g>
            <g>
              <path
                d="M422.7,615.6c-0.3-0.8-0.5-1.4-0.6-2.1c-0.1-0.7-0.2-1.3-0.3-2c-0.1-1.3-0.2-2.6-0.3-3.9c-0.1-2.6-0.2-5.2-0.3-7.8
								c-0.1-5.2,0-10.4,0.3-15.7c0-0.6,0.6-1.1,1.2-1.1s1.1,0.6,1.1,1.2c0,0,0,0,0,0l0,0c-0.4,5.1-0.6,10.3-0.7,15.5
								c0,2.6,0,5.2,0,7.8c0,1.3,0.1,2.6,0.2,3.9c0,0.6,0.1,1.3,0.2,1.9c0,0.3,0.1,0.6,0.2,0.9c0,0.3,0.2,0.5,0.2,0.8l0.1,0.2
								c0.1,0.4-0.1,0.7-0.5,0.8C423.1,616.1,422.8,615.9,422.7,615.6z"
              />
            </g>
            <g>
              <path
                d="M426.1,666.9c-0.6-1.4-0.9-2.6-1.2-4c-0.3-1.3-0.6-2.6-0.8-3.9c-0.5-2.6-0.9-5.3-1.3-7.9c-0.4-2.6-0.7-5.3-0.9-8
								c-0.2-2.7-0.4-5.4-0.3-8.1c0-0.7,0.6-1.2,1.3-1.2s1.2,0.6,1.2,1.3c0,0,0,0,0,0l0,0c-0.2,2.5-0.2,5.2-0.1,7.8
								c0.1,2.6,0.3,5.3,0.6,7.9c0.2,2.6,0.5,5.3,0.9,7.9c0.2,1.3,0.4,2.6,0.6,3.9c0.2,1.3,0.5,2.6,0.9,3.7l0,0.1
								c0.1,0.3,0,0.6-0.3,0.7C426.5,667.3,426.2,667.1,426.1,666.9z"
              />
            </g>
            <g>
              <path
                d="M421.6,676.6c-0.6-1.2-1.3-2.4-1.7-3.7l-0.7-1.9l-0.6-1.9c-0.4-1.3-0.8-2.5-1.1-3.8c-0.4-1.3-0.7-2.6-1-3.9
								c-1.2-5.2-2.1-10.4-2.8-15.6c-0.7-5.2-1.2-10.5-1.5-15.8c-0.3-5.3-0.4-10.6,0.2-16c0.1-0.7,0.7-1.2,1.4-1.1
								c0.7,0.1,1.2,0.7,1.1,1.4c0,0,0,0,0,0l0,0c-0.6,5.1-0.6,10.3-0.4,15.5c0.2,5.2,0.6,10.4,1.3,15.6c0.6,5.2,1.5,10.4,2.5,15.5
								c1.1,5.1,2.4,10.2,4.7,14.7l0,0.1c0.2,0.4,0,0.9-0.4,1.1S421.8,677,421.6,676.6C421.6,676.6,421.6,676.6,421.6,676.6z"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="face">
        <g id="hair">
          <g id="hair-fill">
            <path
              class="st2"
              d="M604.9,277.3c5.1-1,52.3-13.7,82.3-29.8c-4.5,9.9-36.9,27.4-42.3,34.9"
            />
            <path
              class="st2"
              d="M688.4,269.3c6.1-0.7,20.1-4,23-4.5c-4.6,3.2-15.9,9.8-19.3,14.7"
            />
            <path
              class="st2"
              d="M677.3,276.6c4.6-3.6,24.1-13.9,28.9-18.1c-5.4,2.2-26.6,8.6-34.5,10.5c0,0-5.9,1.8-8.1,1.6"
            />
          </g>
          <g id="hair-lines">
            <path
              d="M604.7,276.1c3.4-0.8,7-1.8,10.5-2.8c3.5-1,7-2,10.5-3.1c7-2.1,13.9-4.4,20.8-6.9c6.9-2.5,13.7-5,20.4-7.9
							c6.7-2.9,13.3-5.9,19.7-9.3l0,0c0.8-0.4,1.8-0.1,2.2,0.7c0.3,0.5,0.2,1,0,1.5l0,0c-0.8,2.7-2.7,4.4-4.3,6.1
							c-1.7,1.7-3.5,3.2-5.4,4.6c-3.7,2.9-7.4,5.6-11.2,8.2c-3.8,2.6-7.6,5.2-11.4,7.8c-1.9,1.3-3.7,2.6-5.5,4
							c-1.8,1.4-3.6,2.8-4.8,4.4l0,0c-0.5,0.6-1.3,0.7-1.9,0.2c-0.6-0.4-0.7-1.3-0.3-1.9c0.8-1.1,1.6-2,2.5-2.8
							c0.9-0.8,1.8-1.6,2.7-2.3c1.8-1.5,3.6-2.9,5.5-4.3c3.7-2.7,7.5-5.4,11.2-8.1c3.7-2.7,7.4-5.4,10.9-8.2c1.7-1.4,3.5-2.9,5-4.4
							c1.6-1.5,2.9-3.2,4.1-4.7l0,0l2.2,2.1c-6.5,3.4-13.3,6.4-20,9.3c-6.8,2.8-13.7,5.3-20.6,7.8c-6.9,2.4-13.9,4.7-20.9,6.8
							c-3.5,1.1-7,2.1-10.6,3.1c-3.6,1-7,1.9-10.7,2.7c-0.7,0.1-1.3-0.3-1.5-1C603.5,276.9,603.9,276.2,604.7,276.1L604.7,276.1z"
            />
            <path
              d="M688.3,268.3c1.9-0.2,3.8-0.6,5.7-1c1.9-0.4,3.8-0.7,5.7-1.1l5.7-1.2c1.9-0.4,3.8-0.8,5.8-1.1c0.5-0.1,1,0.3,1,0.8
							c0,0.3-0.1,0.7-0.4,0.9l0,0c-1.6,1.2-3.3,2.4-5,3.5l-5,3.4c-1.6,1.1-3.2,2.4-4.8,3.6c-1.5,1.2-3.1,2.5-4.4,3.8l0,0
							c-0.3,0.3-0.8,0.3-1.1,0c-0.2-0.3-0.3-0.6-0.1-0.9c1.1-1.9,2.6-3.4,4.1-4.8c1.6-1.3,3.3-2.5,4.9-3.7c1.7-1.2,3.4-2.3,5.1-3.3
							c1.7-1.1,3.5-2.1,5.2-3.1l0.7,1.6l-5.7,1.3c-1.9,0.4-3.8,0.9-5.7,1.2c-3.8,0.8-7.7,1.6-11.6,2.1c-0.6,0.1-1.1-0.3-1.2-0.9
							C687.3,268.9,687.7,268.3,688.3,268.3L688.3,268.3z"
            />
            <path
              d="M676.8,275.9c2.1-2.1,4.5-3.7,7-5.2c2.4-1.5,4.9-2.9,7.4-4.3l7.4-4.2c2.4-1.4,4.9-2.9,7-4.5l1.1,1.9
							c-1.7,0.8-3.5,1.5-5.2,2.1c-1.8,0.6-3.5,1.2-5.3,1.7c-3.5,1.1-7.1,2.2-10.6,3.2c-3.6,1-7.1,2-10.7,3l-2.7,0.7
							c-0.9,0.2-1.8,0.5-2.7,0.7c-0.9,0.2-1.8,0.4-2.8,0.6c-1,0.1-1.9,0.3-3.1,0.2c-0.6,0-1.1-0.6-1-1.2c0-0.6,0.6-1,1.2-1l0.1,0
							c0.7,0,1.6-0.1,2.4-0.3c0.9-0.2,1.7-0.4,2.6-0.6c0.9-0.2,1.7-0.5,2.6-0.8l2.7-0.7c3.5-1,7.1-2,10.6-3.1c3.5-1.1,7-2.1,10.6-3.3
							c3.5-1.1,7-2.2,10.5-3.3l0.1,0c0.6-0.2,1.2,0.1,1.4,0.7c0.1,0.4,0,0.9-0.3,1.2c-2.3,2-4.7,3.5-7.1,5c-2.4,1.5-4.8,3.1-7.3,4.5
							c-2.4,1.5-4.9,2.9-7.4,4.3c-2.5,1.4-5,2.7-7.4,4l-0.1,0c-0.4,0.2-0.9,0.1-1.2-0.4C676.5,276.6,676.5,276.1,676.8,275.9z"
            />
          </g>
        </g>
        <g id="eyemask-fill">
          <path
            class="st3"
            d="M510.7,464.1c-15.2,4-43.6,0.5-55.5-23.5c-12.6-25.3,5.2-55.3,17.5-70.5c12.1-14.9,44.6-45.3,77.8-45.3
						s72,13.6,86,13.6s27.7-11.9,39.5-18.5c11.7-6.5,16.2-8.5,24.3-6.6c8.1,2,10.6,14.8,11.2,22.1c0.6,6.7,1,64.3-2,78.2
						c-2.5,11.9-13.9,32.5-24.2,36.6"
          />
        </g>
        <g id="eyes-shadow">
          <path
            class="st7"
            d="M640.5,437.4c-5.4-6.7-5.5-18.2-5.5-19.7c0-1.2-2.9-2.5-3.1-1.3c-1.1,5.5-0.6,10.5,1.7,16.7
						c0.8,2.2,1.4,2.2,3.9,3.2C638.4,436.7,641.1,438.1,640.5,437.4z"
          />
          <path
            class="st7"
            d="M697.2,412.2c-4.2-7.2-13.2-31.4-13.2-45.8c0,0-34.1-1.9-49.4,31l-2.9,18.3c0,0,31.3,3.9,34.9,3.6
						S697.2,412.2,697.2,412.2z"
          />
          <path
            class="st7"
            d="M604.3,410.2c-6-9.5-10.6-35.5-10.6-49.9c0,0-46.8-14.1-94.7,41l-13.3,17c0,0,84.4-0.6,88-0.9
						C577.3,417,604.3,410.2,604.3,410.2z"
          />
          <path
            class="st7"
            d="M699.2,414.8c-2.3,2.9-12.4,16.1-29.3,16.1c-16.9,0-30.5-12.1-32.5-14.4c0.7,3.6,4.6,20.8,33,20.8
						C694.5,437.3,699.2,414.8,699.2,414.8z"
          />
          <path
            class="st7"
            d="M602.8,426.2c-2.3,2.9-30,13-46.9,13s-62.2-13.4-67.7-20.1c0.7,3.6,11.6,25.7,64.1,25.7
						C591.1,444.8,602.8,426.2,602.8,426.2z"
          />
          <path
            class="st7"
            d="M605.6,412.1c-0.7,1.5-2.9,9.4,0.6,9.3c-1.1,2-9.6,12.1-28.1,14.2c4-2.6,23.1-14.2,25.8-23.5H605.6z"
          />
        </g>
        <g id="sclera-fill">
          <g>
            <path
              class="st8"
              d="M699,412.8l0.1,0.4c-3.4,6.3-8.8,17.3-29.3,17.8c-18.6,0.5-27.5-9.8-29.8-13.7l0-0.4
							C655.1,417.9,686.6,416.7,699,412.8z"
            />
            <path
              class="st8"
              d="M603.2,410.9l1.7,0c-3.2,3.5-15.6,27.8-46.5,27.8c-26.4,0-59.6-13.2-70.2-17.7l-0.1-2.2
							c10.6-0.3,59.8,0.2,71.7-0.5C571.8,417.8,596.1,414.2,603.2,410.9z"
            />
          </g>
        </g>
        <g id="pupils-fill">
          <path
            d="M655.3,417.8c2,3.8,8.6,6.8,17.1,6.2c6.2-0.4,11.9-5.7,12.6-7.7"
          />
          <path
            d="M538.1,419.8c3.1,6.3,13.2,9.1,24.7,8.2c10.3-0.7,18.3-5.5,21.8-12"
          />
        </g>
        <g id="mask-lines">
          <path
            d="M571,437.1c3.2-0.3,6.4-1.1,9.5-2.1c3.1-0.9,6.2-2.1,9.2-3.3c3-1.3,6-2.7,8.7-4.4c1.4-0.9,2.7-1.8,3.9-2.8
						c1.2-1,2.2-2.2,2.9-3.4l0,0c0.3-0.6,1.1-0.8,1.7-0.5c0.6,0.3,0.8,1.1,0.5,1.7c0,0,0,0,0,0c-1,1.7-2.3,2.9-3.6,4
						c-1.4,1.1-2.8,2-4.3,2.9c-2.9,1.7-6,3.1-9.1,4.3c-3.1,1.2-6.3,2.3-9.5,3.2c-1.6,0.4-3.2,0.8-4.9,1.2c-1.6,0.3-3.3,0.6-5,0.7
						c-0.4,0-0.7-0.3-0.7-0.7C570.3,437.5,570.6,437.1,571,437.1L571,437.1z"
          />
          <path
            d="M636.7,389.3c0.9-1.6,2-2.9,3.1-4.2c1.1-1.3,2.3-2.4,3.5-3.6c2.4-2.3,5.1-4.3,7.8-6.2c5.5-3.8,11.4-7,17.8-9
						c6.4-2,13.4-2.8,20.1-0.9c3.3,0.9,6.4,2.6,9.1,4.7c2.7,2.1,4.9,4.7,6.8,7.4c0.3,0.5,0.2,1.1-0.3,1.5c-0.5,0.3-1.1,0.2-1.4-0.2l0,0
						c-1.9-2.5-4.1-4.8-6.6-6.6c-2.5-1.9-5.3-3.2-8.3-3.9c-6-1.6-12.4-0.7-18.3,1.2c-6,2-11.6,5-16.8,8.7c-2.6,1.8-5.1,3.9-7.4,6
						c-2.3,2.1-4.6,4.5-6.1,6.9l0,0c-0.5,0.8-1.6,1.1-2.4,0.6C636.5,391.2,636.2,390.1,636.7,389.3z"
          />
          <path
            d="M643.7,338.5c0.5,4.1,0.6,8,0.8,12c0.1,4,0.2,8,0.2,12c-0.1,4-0.2,8.1-0.9,12.1c-0.6,4-1.6,8-2.6,11.8
						c-1.1,3.9-2.3,7.6-3.6,11.4c-1.3,3.7-2.5,7.4-3.4,11.2c-0.9,3.8-1.3,7.7-1.4,11.6c-0.1,3.9,0.3,7.8,1,11.6l0,0
						c0.1,0.7-0.3,1.4-1,1.5c-0.7,0.1-1.4-0.3-1.5-1l0,0c-0.8-4-1.2-8-1.2-12.1c0-4.1,0.3-8.1,1-12.1c0.6-4,1.4-8,2.5-11.9
						c1.1-3.9,2.4-7.6,3.7-11.4c1.3-3.7,2.6-7.4,3.5-11.2c0.4-1.9,0.8-3.8,1-5.7c0.2-1.9,0.3-3.9,0.4-5.9c0.2-3.9,0.2-7.9,0.1-11.9
						c-0.1-3.9-0.3-7.9-0.7-11.8l0,0c-0.1-0.6,0.4-1.2,1-1.2C643.1,337.4,643.6,337.8,643.7,338.5L643.7,338.5z"
          />
          <path
            d="M633.4,414.5c1.1,0.4,2.6,0.6,3.9,0.7c1.4,0.2,2.8,0.3,4.3,0.4c2.9,0.2,5.8,0.2,8.6,0.3c5.8,0.1,11.6-0.1,17.3-0.3
						c5.8-0.3,11.5-0.7,17.3-1.4c2.9-0.4,5.7-0.8,8.5-1.3c1.4-0.2,2.8-0.5,4.2-0.9c1.4-0.4,2.6-0.9,4.1-0.9l0,0c0.4,0,0.7,0.3,0.7,0.6
						c0,0.2-0.1,0.3-0.2,0.4c-1.1,1.2-2.6,1.6-4,2.1c-1.4,0.4-2.9,0.8-4.3,1.1c-2.9,0.6-5.8,1-8.7,1.4c-5.8,0.7-11.6,1.1-17.5,1.4
						c-5.8,0.3-11.7,0.5-17.5,0.4c-2.9,0-5.8-0.1-8.8-0.2c-1.5-0.1-2.9-0.2-4.4-0.3c-1.5-0.2-2.9-0.3-4.6-0.9c-0.8-0.2-1.2-1-0.9-1.8
						c0.2-0.8,1-1.2,1.8-0.9l0,0L633.4,414.5z"
          />
          <path
            d="M685.2,366.5c0,2,0.3,4.1,0.5,6.1c0.2,2.1,0.6,4.1,0.9,6.2c0.3,2,0.7,4.1,1.1,6.1c0.4,2,0.9,4.1,1.4,6.1
						c1,4,2.3,8,3.9,11.7c0.8,1.8,1.8,3.6,2.9,5.2c1.1,1.6,2.5,3,4.1,3.7l0.1,0c0.7,0.3,0.9,1.1,0.6,1.8c-0.3,0.7-1.1,0.9-1.8,0.6
						c-2.2-1.1-3.9-2.8-5.2-4.5c-1.3-1.8-2.4-3.7-3.3-5.7c-1.8-3.9-3.1-8-4.1-12.1c-1.1-4.1-1.9-8.3-2.5-12.5c-0.3-2.1-0.5-4.2-0.7-6.3
						c-0.2-2.1-0.3-4.2-0.3-6.4c0-0.6,0.5-1.1,1.2-1.1C684.7,365.3,685.2,365.8,685.2,366.5L685.2,366.5z"
          />
          <path
            d="M641.2,416.6c1.4,2.3,3.4,4.4,5.6,6.2c2.2,1.8,4.7,3.2,7.3,4.3c5.2,2.2,11.1,3,16.8,2.7c5.7-0.2,11.5-1.4,16.4-4.3
						c2.4-1.4,4.6-3.3,6.4-5.5c1.8-2.2,3.2-4.7,4.6-7.3c0.3-0.5,0.9-0.7,1.4-0.4c0.5,0.3,0.7,0.9,0.4,1.4l0,0c-1.4,2.6-2.8,5.3-4.8,7.7
						c-1.9,2.4-4.3,4.5-6.9,6c-5.3,3.2-11.4,4.4-17.4,4.7c-6,0.3-12.2-0.4-17.8-2.7c-2.8-1.1-5.5-2.7-7.9-4.6c-2.4-1.9-4.6-4.1-6.3-6.8
						c-0.4-0.6-0.2-1.4,0.4-1.8C640,415.7,640.8,415.9,641.2,416.6C641.2,416.6,641.2,416.6,641.2,416.6L641.2,416.6z"
          />
          <path
            d="M634.3,338.9c0.2,2.5,0.2,4.9,0.2,7.4c0,2.4,0,4.9,0,7.3c0,2.4-0.1,4.9-0.1,7.3c-0.1,2.5-0.1,4.9-0.4,7.4
						c-0.1,0.4-0.4,0.7-0.8,0.6c-0.4,0-0.7-0.4-0.6-0.8l0-0.1c0.2-2.3,0.2-4.8,0.2-7.2c0-2.4,0-4.9-0.1-7.3c0-2.4-0.1-4.9-0.2-7.3
						c-0.1-2.4-0.2-4.9-0.4-7.2l0,0c-0.1-0.6,0.4-1.2,1-1.3C633.7,337.8,634.2,338.2,634.3,338.9C634.3,338.9,634.3,338.9,634.3,338.9z
						"
          />
          <path
            d="M487.7,417.2c0.3,0.2,0.6,0.2,0.9,0.2l0.9,0l1.8,0l3.6-0.1l7.3-0.1l14.5-0.1l29-0.3c4.8-0.1,9.7-0.1,14.4-0.3
						c4.8-0.3,9.6-0.8,14.3-1.4c4.8-0.6,9.5-1.3,14.3-2.1c2.4-0.4,4.7-0.9,7.1-1.3c2.3-0.5,4.7-1.1,6.7-1.9l0,0
						c0.7-0.3,1.4,0.1,1.7,0.7c0.2,0.6,0,1.3-0.6,1.6c-2.4,1.2-4.7,1.8-7.1,2.5c-2.4,0.7-4.8,1.2-7.2,1.7c-4.8,1-9.6,1.8-14.4,2.5
						c-4.8,0.7-9.7,1.3-14.6,1.6c-4.9,0.2-9.8,0.3-14.6,0.3c-9.7,0-19.4-0.1-29.1-0.2l-14.5-0.1l-7.3,0l-3.6,0l-1.8,0l-0.9,0
						c-0.3,0-0.6,0-0.9,0.2c-0.9,0.7-2.3,0.5-3-0.4c-0.7-0.9-0.5-2.3,0.4-3C485.9,416.7,486.9,416.7,487.7,417.2z"
          />
          <path
            d="M701.1,412.7c-1.1,5.9-4.1,11-7.9,15.3c-1.9,2.1-4.1,4.1-6.4,5.7c-2.3,1.7-4.9,3.1-7.5,4.2c-0.4,0.2-0.9,0-1.1-0.4
						c-0.2-0.4,0-0.9,0.4-1.1l0,0c2.5-1.2,4.9-2.6,7.1-4.2c2.2-1.6,4.2-3.5,6-5.6c1.8-2.1,3.3-4.3,4.6-6.7c1.2-2.4,2.1-5,2.5-7.6l0,0
						c0.1-0.6,0.7-1.1,1.3-1C700.8,411.5,701.2,412.1,701.1,412.7C701.1,412.7,701.1,412.7,701.1,412.7z"
          />
          <path
            d="M540.6,444.2c-10.4-0.1-20.9-1.5-30.8-5.1c-4.9-1.8-9.7-4.1-14.1-7.1c-4.4-3-8.4-6.6-11.9-10.6c-0.6-0.7-0.6-1.8,0.2-2.5
						c0.7-0.6,1.8-0.6,2.5,0.2c0,0,0,0,0,0l0,0.1c3.2,3.9,6.8,7.3,10.9,10.3c4.1,2.9,8.6,5.3,13.3,7.2c4.7,1.9,9.6,3.3,14.7,4.2
						c5,0.9,10.1,1.5,15.3,1.7c0.5,0,0.8,0.4,0.8,0.9C541.4,443.9,541.1,444.3,540.6,444.2L540.6,444.2z"
          />
          <path
            d="M606.1,411.8c-0.1,0.1-0.3,0.3-0.5,0.5c-0.2,0.3-0.4,0.5-0.6,0.8l-1.2,1.7c-0.8,1.1-1.7,2.3-2.5,3.4
						c-1.7,2.2-3.6,4.4-5.6,6.4c-4,4-8.7,7.5-13.8,10.1c-5.1,2.5-10.7,4.2-16.4,4.9c-1.4,0.2-2.8,0.3-4.3,0.4c-1.4,0-2.9,0.1-4.3,0
						c-2.8,0-5.6-0.2-8.5-0.5c-11.2-1.2-22.2-3.8-32.9-7c-10.7-3.3-21.2-7.2-31.5-11.7c-0.6-0.3-0.9-1-0.7-1.6l0.1-0.4
						c0.3-0.8,0.7-1.4,1.1-2l1.4-1.9c0.9-1.2,1.8-2.5,2.8-3.7c1.9-2.4,3.8-4.9,5.8-7.2c4-4.7,8.1-9.3,12.5-13.7
						c2.2-2.2,4.5-4.3,6.8-6.4c2.3-2,4.7-4,7.1-6c4.8-3.9,9.9-7.5,15.3-10.6c2.7-1.6,5.5-2.9,8.4-4.2c2.9-1.2,5.9-2.3,8.9-3.2
						c6-1.8,12.1-3,18.4-3.5c6.2-0.5,12.6-0.2,18.7,1c3.1,0.6,6.1,1.5,9,2.7c2.9,1.2,5.7,2.7,8.3,4.5l0,0c0.5,0.4,0.7,1.1,0.3,1.7
						c-0.4,0.5-1.1,0.7-1.6,0.3c-2.6-1.6-5.2-2.8-8-3.8c-2.8-1-5.7-1.7-8.6-2.2c-5.9-1-11.9-1-17.8-0.4c-3,0.3-5.9,0.8-8.9,1.4
						c-2.9,0.6-5.9,1.3-8.7,2.2c-2.9,0.8-5.6,1.8-8.4,3c-2.7,1.2-5.4,2.5-8,4c-10.4,5.9-19.7,13.8-28.3,22.4
						c-8.7,8.4-16.5,17.8-24.2,27.2l-0.5-2c10.1,4.5,20.5,8.4,31.1,11.6c10.6,3.2,21.4,5.8,32.4,7c2.7,0.3,5.5,0.5,8.2,0.5
						c1.4,0.1,2.7,0,4.1-0.1c1.4-0.1,2.7-0.2,4.1-0.4c5.4-0.7,10.6-2.3,15.5-4.7c4.8-2.4,9.2-5.8,13-9.6c1.9-1.9,3.7-4,5.4-6.2
						c0.8-1.1,1.6-2.2,2.4-3.3l1.2-1.7c0.2-0.3,0.4-0.6,0.7-0.9c0.2-0.3,0.5-0.6,0.9-1c0.6-0.5,1.5-0.5,2,0.1c0.5,0.6,0.5,1.4,0,2
						L606.1,411.8z"
          />
          <path
            d="M595,360.4c-0.1,2,0.1,4.2,0.3,6.4c0.2,2.2,0.4,4.3,0.6,6.5c0.5,4.3,1.1,8.6,1.9,12.9c0.8,4.3,1.8,8.5,3,12.6
						c0.6,2,1.4,4.1,2.3,6c0.9,1.9,2,3.7,3.4,4.9l0.1,0.1c0.6,0.5,0.6,1.4,0.1,2s-1.4,0.6-2,0.1l0,0c-2-1.7-3.1-3.8-4.1-5.8
						c-1-2.1-1.7-4.2-2.4-6.3c-1.3-4.3-2.3-8.6-3.1-12.9c-0.8-4.3-1.4-8.7-2-13.1c-0.3-2.2-0.5-4.4-0.6-6.6c-0.2-2.2-0.3-4.4-0.3-6.8
						c0-0.8,0.7-1.4,1.4-1.3C594.5,358.9,595.1,359.5,595,360.4L595,360.4z"
          />
          <path
            d="M511.1,465.6c-5.7,1.5-11.5,1.8-17.3,1.3c-5.8-0.5-11.5-1.8-16.8-4.1c-5.4-2.2-10.4-5.4-14.6-9.5c-4.2-4.1-7.5-9-9.8-14.4
						c-2.2-5.4-3.3-11.3-3.3-17.1c0-5.8,1-11.6,2.7-17.1c1.6-5.5,3.9-10.8,6.6-15.9c2.7-5.1,5.7-9.9,9-14.5
						c6.7-9.3,14.8-17.4,23.3-24.9c8.6-7.4,18.1-14,28.5-19c5.2-2.4,10.6-4.5,16.3-5.8c2.8-0.7,5.7-1.2,8.6-1.5
						c2.9-0.3,5.9-0.4,8.7-0.3c5.7,0.1,11.4,0.7,17.1,1.3c5.6,0.8,11.3,1.6,16.8,2.7c11.1,2,22.2,4.7,33.1,7.1c1.4,0.3,2.7,0.6,4.1,0.9
						c1.4,0.3,2.7,0.6,4.1,0.8l2,0.4l2,0.3c1.4,0.2,2.7,0.2,4,0.3c2.6,0,5.2-0.4,7.8-1.1c2.6-0.7,5.1-1.8,7.6-2.9
						c5-2.4,9.7-5.3,14.5-8.3c2.4-1.5,4.8-3,7.3-4.5c2.5-1.4,4.9-2.8,7.5-4.1c2.5-1.3,5.1-2.6,8-3.5c1.4-0.4,2.9-0.7,4.5-0.9
						c1.5-0.1,3.1,0,4.6,0.2c0.7,0.1,1.5,0.2,2.2,0.4c0.4,0.1,0.7,0.2,1.1,0.3c0.4,0.1,0.8,0.2,1.2,0.4c1.5,0.7,2.8,1.7,3.9,2.9
						c2.2,2.4,3.4,5.1,4.4,7.9c1,2.8,1.6,5.7,2,8.5c0.5,2.9,0.6,5.8,0.6,8.6c0.2,5.7,0.2,11.3,0.2,16.9c0,11.3-0.1,22.6-0.6,33.9
						c-0.2,5.7-0.5,11.3-1.1,17c-0.2,1.4-0.3,2.8-0.6,4.3c-0.2,1.4-0.6,2.9-1,4.3c-0.8,2.8-1.9,5.5-3,8.1c-2.3,5.3-5.2,10.3-8.6,14.9
						c-0.8,1.2-1.8,2.3-2.7,3.4c-1,1.1-1.9,2.2-3,3.2c-2.1,2-4.4,4-7.3,5.2c-0.8,0.3-1.6-0.1-2-0.8s0.1-1.6,0.8-2l0,0
						c2.3-1,4.4-2.7,6.3-4.6c1-0.9,1.8-2,2.7-3c0.8-1.1,1.7-2.1,2.5-3.3c3.2-4.5,5.9-9.4,8.1-14.4c1.1-2.5,2.1-5.1,2.8-7.7
						c0.4-1.3,0.7-2.6,0.9-4c0.2-1.3,0.4-2.7,0.5-4.1c0.5-5.5,0.8-11.1,1-16.8c0.4-11.2,0.5-22.5,0.4-33.7c0-5.6-0.1-11.3-0.2-16.9
						c-0.1-2.8-0.1-5.5-0.6-8.2c-0.4-2.7-0.9-5.4-1.8-7.9c-0.9-2.5-2-5-3.6-6.8c-0.8-0.9-1.8-1.6-2.8-2.2c-0.3-0.1-0.5-0.2-0.8-0.3
						c-0.3-0.1-0.5-0.2-0.9-0.3c-0.7-0.2-1.3-0.3-2-0.4c-1.3-0.2-2.6-0.3-3.9-0.2c-1.3,0.1-2.6,0.3-3.8,0.7c-2.5,0.8-5,2-7.5,3.2
						c-2.4,1.3-5,2.6-7.3,4c-2.4,1.4-4.7,2.9-7.1,4.5c-4.7,3.1-9.4,6.3-14.6,8.9c-2.6,1.3-5.3,2.5-8.1,3.3c-2.8,0.8-5.8,1.4-8.9,1.4
						c-1.5-0.1-3-0.1-4.4-0.3l-2.2-0.3l-2.1-0.4c-1.4-0.2-2.8-0.5-4.2-0.8c-1.4-0.3-2.8-0.6-4.2-0.9c-11.1-2.4-22-5-33-7.1
						c-5.5-1-11-1.8-16.6-2.5c-5.5-0.6-11.1-1.1-16.7-1.2c-11-0.5-21.7,2.6-31.7,7.2c-5,2.3-9.9,5-14.5,8.1c-4.7,3-9.2,6.3-13.5,9.8
						c-4.3,3.5-8.5,7.3-12.4,11.3c-3.9,4-7.6,8.2-10.8,12.7c-3.3,4.5-6.3,9.2-8.8,14.2c-2.6,4.9-4.7,10.1-6.3,15.4
						c-1.6,5.3-2.5,10.8-2.5,16.2c0,5.5,1.1,10.9,3.1,15.9c2.1,5,5.2,9.6,9.1,13.4c3.9,3.8,8.5,6.8,13.5,8.9c5,2.1,10.4,3.4,15.9,3.9
						c5.5,0.5,11,0.2,16.3-1.1l0,0c0.8-0.2,1.6,0.3,1.8,1.1C512.3,464.6,511.9,465.4,511.1,465.6z"
          />
        </g>
        <g id="sunglasses">
          <g id="frames-fill">
            <path
              class="st9"
              d="M447.7,358.5v23c0,0-15.8,5.1-23.9,8c-8.1,2.9-21.5,5.6-21.5,5.6c-1.5,0.4-3.2,0-4.3-1.1l-8.1-11.9
							c-0.3-0.3-0.5-0.8-0.6-1.2l-2.3-12c0-0.6,0.4-1.2,1-1.4l15.3-4.6c4.3-1.3,13.7-3.3,21-3.8C431.7,358.4,447.7,358.5,447.7,358.5z"
            />
            <path
              class="st9"
              d="M447.7,358.5v23l8.1,5.5c1.3,0.8,2.2,2,2.4,3.6c0,0,3.9,42.6,9.1,55.6c5.1,12.9,18.8,19.9,32.8,20.8
							c8.9,0.6,49.5,2.1,62.1-1.6c13.7-4.1,24.5-16.3,30.4-27.5s19.3-40.6,20.8-43.7c2.4-5.4,5.8-7.1,9.5-7.1c3.7,0,6.5,2.7,8.6,7.8
							c2,5,6.7,22,14.6,41.5c6.6,16.3,17.2,23.7,29.4,26.1c12.3,2.5,38.9,1.5,49.4-3c10.3-4.4,16.8-10.2,22-25.4
							c3.3-9.7,11.6-43.9,11.6-43.9c0.6-2,1.8-5.7,2.6-6.8c0.8-1.1,1.7-1.9,2.8-3.1c1.1-1.1,1.6-3.1,1.7-4.8l2-12.8
							c0.5-2.6,0-4.9-3.7-5.6c-4-0.8-14-2.6-33.5-4.5s-45.2,1.1-60.1,4c-16,3.1-27.5,7.9-30,8.6c-2.5,0.7-9,2.4-14.3,2.4
							c-5.3,0-11.3-1.2-14.3-2s-12.1-5.8-21.7-7.6c-9.6-1.8-23.5-4.2-40.1-4.9c-16.6-0.7-61.8,0.8-69.6,1c-7.8,0.2-19.8,0.2-24.4,0.7
							C451,355.5,447.7,358.5,447.7,358.5z"
            />
          </g>
          <g id="frames-lines">
            <g>
              <path
                class="st5"
                d="M447.7,358.5v23c0,0-15.8,5.1-23.9,8c-8.1,2.9-21.5,5.6-21.5,5.6c-1.5,0.4-3.2,0-4.3-1.1l-8.1-11.9
								c-0.3-0.3-0.5-0.8-0.6-1.2l-2.3-12c0-0.6,0.4-1.2,1-1.4l15.3-4.6c4.3-1.3,13.7-3.3,21-3.8C431.7,358.4,447.7,358.5,447.7,358.5z
								"
              />
              <path
                class="st5"
                d="M447.7,358.5v23l8.1,5.5c1.3,0.8,2.2,2,2.4,3.6c0,0,3.9,42.6,9.1,55.6c5.1,12.9,18.8,19.9,32.8,20.8
								c8.9,0.6,49.5,2.1,62.1-1.6c13.7-4.1,24.5-16.3,30.4-27.5s19.3-40.6,20.8-43.7c2.4-5.4,5.8-7.1,9.5-7.1c3.7,0,6,2.7,8.1,7.8
								c2,5,4.3,21.3,14.6,41.5c8,15.7,17.7,23.7,29.9,26.1c12.3,2.5,38.9,1.5,49.4-3c10.3-4.4,16.8-10.2,22-25.4
								c3.3-9.7,11.6-43.9,11.6-43.9c0.6-2,1.8-5.7,2.6-6.8c0.8-1.1,1.7-1.9,2.8-3.1c1.1-1.1,1.6-3.1,1.7-4.8l2-12.8
								c0.5-2.6,0-4.9-3.7-5.6c-4-0.8-14-2.6-33.5-4.5s-45.2,1.1-60.1,4c-16,3.1-27.5,7.9-30,8.6c-2.5,0.7-9,2.4-14.3,2.4
								c-5.3,0-11.3-1.2-14.3-2s-12.1-5.8-21.7-7.6c-9.6-1.8-23.5-4.2-40.1-4.9c-16.6-0.7-61.8,0.8-69.6,1c-7.8,0.2-19.8,0.2-24.4,0.7
								C451,355.5,447.7,358.5,447.7,358.5z"
              />
            </g>
          </g>
          <g id="lenses-fill">
            <path
              class="st10" 
              d="M474.8,387c0.2-10.9,9.3-22.1,20.7-23.5c9.9-1.1,40.2-1,59.3-0.2c14.9,0.6,35.7,4.2,40.2,12.1
							c4.7,8.1,3,16.4,1.3,24.8c-1.5,7.3-10.2,31.5-22,44c-6.4,6.7-13.7,12.1-28.3,12.9c-13.1,0.7-31.3,0.9-39.3,0.5
							c-8.3-0.4-23.6-3.9-27.4-14.7S474.6,398.7,474.8,387z"
            />
            <path
              class="st10"
              d="M646.4,400.8c-2.5-13,1.9-22.9,8.9-27.9c9.3-6.7,24.4-9.2,34.8-10.2c10.4-1,27.2-1.9,35.4-1.1
							c8.6,0.8,15.5,3.5,17.9,5.8c4.6,4.5,5,10,4.7,16.8c-0.3,5.3-1.6,17.9-3.3,25.9c-1.7,8.2-5.6,33.5-21,40.2
							c-8.2,3.6-35.6,7.2-50.2,2.6c-7-2.2-13.2-8.8-15.4-13.9C655.5,433.4,649.8,419.2,646.4,400.8z"
            />
          </g>
          <g id="lenses-reflection">
            <path
              class="st11"
              d="M554.7,363.4c-17.9-0.8-45.7-1-57.2,0v0l-22.8,28.9l0,0c0.1,14.4,1.3,41.2,4.6,50.6
							c3.7,10.7,19.1,14.3,27.4,14.7c3.3,0.2,8.4,0.2,14.2,0.2c18.4-18,57.5-59.4,71.2-85.3C584.7,366.7,567.5,363.9,554.7,363.4z"
            />
            <path
              class="st11"
              d="M725.5,361.6c-8.3-0.8-25,0.2-35.4,1.1c-6.5,0.6-16.3,2.1-25,4.7l-18.7,32.9c0,0.2,0.1,0.3,0.1,0.5
							c3.5,18.4,9.2,32.7,11.7,38.3c2.3,5.1,8.5,11.7,15.4,13.9c4.6,1.4,10.5,2.1,16.6,2.2c0,0,0,0,0,0c13.6-17,37.7-53.5,52.7-88.1
							C740.1,364.7,733.6,362.3,725.5,361.6z"
            />
          </g>
          <g id="lenses-lines">
            <path
              class="st5"
              d="M474.8,387c0.2-10.9,9.3-22.1,20.7-23.5c9.9-1.1,40.2-1,59.3-0.2c14.9,0.6,35.7,4.2,40.2,12.1
							c4.7,8.1,3,16.4,1.3,24.8c-1.5,7.3-10.2,31.5-22,44c-6.4,6.7-13.7,12.1-28.3,12.9c-13.1,0.7-31.3,0.9-39.3,0.5
							c-8.3-0.4-23.6-3.9-27.4-14.7S474.6,398.7,474.8,387z"
            />
            <path
              class="st12"
              d="M646.9,400.8c-2.5-13,1.9-22.9,8.9-27.9c9.3-6.7,24.4-9.2,34.8-10.2c10.4-1,27.2-1.9,35.4-1.1
							c8.6,0.8,15.5,3.5,17.9,5.8c4.6,4.5,5,10,4.7,16.8c-0.3,5.3-1.6,17.9-3.3,25.9c-1.7,8.2-5.6,33.5-21,40.2
							c-8.2,3.6-35.6,7.2-50.2,2.6c-7-2.2-13.2-8.8-15.4-13.9C656,433.4,650.3,419.2,646.9,400.8z"
            />
          </g>
        </g>
        <g id="mouth">
          <g id="mouth-fill">
            <path
              class="st3"
              d="M740,721.5c1.2-1.2,13.4-26.5,12-46c-1.5-19.5-15.6-70.6-33.2-99.2c-17.6-28.6-28.8-69.4-30.5-77.2
							c17.8,4.4,32.9-8.7,29.6-22.5c-7.3-29.8-46.2-26.4-56.9-26.4c-12-2.4-20-3.2-27.9-3c-7.8,0.2-44.6,5.5-65.1,8.4
							c-11.1,1.6-62.6-2.5-68.6,23.2c-5.9,24.9,40.6,32.7,40.6,32.7c-2.7,6.4-39.8,69.6-47.2,80.6c-7.3,11-25.1,44.3-29.5,60.3
							c-3.1,11.3-6.5,40.5,4.9,60.8c11.3,20,27.7,33.5,35.7,32.7l-3.5,2c-2.2,3.9,3.4,7.1,9.7,9.6c6.2,2.5,34.5,14.8,44.5,14.5
							c8.9-0.3,40.5,0.7,64.3,1.6c23.7,0.9,58.6,1.3,74.9-0.2c16.3-1.5,33.6-6.8,42-14.3c4.8-4.3,4.9-7.9,4.7-11.7
							c-0.1-2.2-0.8-4.3-1.6-5.9c0,0,0,0,0,0c-0.6-1.2-1.4-2.1-2.1-2.7l-9.4,0.3c4.1-0.7,8.7-1.5,14.9-2.4c5.4-0.8,7.4-4.2,5.5-7.8
							C745.9,725.6,742.3,722.8,740,721.5z"
            />
          </g>
          <g id="beard-fill">
            <g>
              <path
                class="st13"
                d="M505.2,574.6c9.8-5.9,37.6-9.8,59.1-7.3s30.3,6.4,42.5,9.3c10.1,2.4,24.4,0.6,30.3,1.5
								c6.8,1,21-11.7,23.9-13.2c2.9-1.5,28.3-9.8,52.3,6.4c6.4,9.8,30.8,55.9,34.7,80.1s5.9,44.6-8.1,70.2c5.1,2.6,7.8,7.7,7.8,8.9
								s-5.8,7.5-9.7,8.2c1.5,2.9,2.5,10.3,1.1,15.6c0,0-4.6,10.3-23.9,14.3s-4.2,9.8-68.2,6c-64-3.7-91-3.7-93.2-3.7
								c-2.2,0.1-43.7-8.7-49.3-14.9s-5.5-9.8-8.8-11.1c-3.3-1.3-19.5-14.3-24.8-24.8c-5.2-10.4-9.8-24.4-10.7-30.9
								c-1-6.5,1.3-39.1,9.8-56.4C478.7,615.5,505.2,574.6,505.2,574.6z"
              />
            </g>
          </g>
          <g id="mouth-shadow">
            <path
              class="st7"
              d="M632.1,506c-2.3,11.7-3.1,51.2,0.7,72c5.9,32.6,45.9,103.3,46.9,117.6c1,14.3,4.6,30.8,4.6,30.8l2.6-2.7
							c0,0,3.9-29.1-11.1-68.9c-15-39.7-34.5-58.6-38.1-91.9C634.1,529.8,632.1,506,632.1,506z"
            />
            <path
              class="st7"
              d="M749,655.6c0,7.5,0.7,34.9-11.7,46.3c-12.4,11.4-34.5,21.5-48.9,24.4c-14.3,2.9-64.5,8.1-106.8,7.8
							s-56.4,2.6-66.4,2c-10.1-0.7-22.5,0.3-39.7-24.4s-14-37.5-14-42.7c-1.3,11.4,0.7,62.2,36.2,77.9l6.5,1.3l20.5-7.8
							c0,0,14-0.7,21.8,0s38.8,1,45.6,1c6.8,0,45-2.9,54.7-3.9c9.8-1,51.8-9.1,56.4-10.4c0,0,33.7-6.5,36.9-5.4s10.3-25.2,11-30.1
							C751.6,686.5,749,655.6,749,655.6z"
            />
            <path
              class="st7"
              d="M503.6,751.1l20.2,3.4l17.3,2.6l26.4,1.6l24.8,1.6l19.5,2.3l17.3-1.3l38.8-5.8l39.7-10.1l17.3-4.9l13.7-2.3
							l1.3,15l-7.2,10.1c-0.7-2.9-5.2-5.9-8.1-5.2c-2.9,0.7-32.9,9.1-39.1,9.4s-11.4,3.3-17.6,3.3S638.5,774,631,774
							s-45.6-2.6-53.1-2.6s-26.6,0.7-34.9-2.3C535.1,766.3,506.5,759.5,503.6,751.1z"
            />
            <path
              class="st7"
              d="M694.6,525.3c-11.2-12-46.7-26-48.6-26.6c-1.1-0.4-3.7-2.5,1.7-2.4c7.3-1.2,11.7,0.8,18.3,1.5l23,9.9
							L694.6,525.3z"
            />
            <path
              class="st7"
              d="M583.4,500.6c-3.2,5.9-21.5,21-50.3,24.1l4.6-7.9L583.4,500.6z"
            />
            <path
              class="st7"
              d="M639.3,486.2c4.6-6.5,10.7-16,10.3-23.5c-0.3-7.5,9.4-12.8,20.4-11.8l-6.4-1.6l-26.8-1.8
							C636.9,447.6,643.9,473.5,639.3,486.2z"
            />
            <path
              class="st7"
              d="M594.9,490.6c-8.5-7.4-19.1-18.6-34.9-21.7c-3.9-0.8-10.1-0.8-14.9-0.7c-10.5,0.4-17.1,2.9-21.5,5.3
							c-4.8,2.6-5.7,4.1-5.9,6.1c-0.3,2.7-3.5,17.9,30,17.9c33.6,0,15.6-19.5,15.6-19.5L594.9,490.6z"
            />
            <path
              class="st7"
              d="M653.9,481.8c4.3-6,8.3-12.3,14.5-12.7c4.4-0.2,23.2-2.1,28.8,3.5s3.7,11.2,1.6,14.2
							c-2,2.9-9.4,9.1-32.9,5.7c-5.4-5.9-9.4-13.2-9.4-13.2"
            />
          </g>
          <g id="mouth-lines">
            <g id="mouth-hair-outlines">
              <path
                d="M585.2,550.9c-1.8-3.1-3.3-6.3-4.4-9.7c-1.1-3.4-1.8-7-1.7-10.8c0-1,0.8-1.7,1.8-1.7c1,0,1.7,0.8,1.7,1.8
								c0,0,0,0.1,0,0.1l0,0c-0.4,3.2,0,6.5,0.8,9.8c0.8,3.3,2,6.5,3.5,9.5c0.2,0.5,0,1-0.4,1.2C586,551.5,585.4,551.3,585.2,550.9z"
              />
              <path
                d="M567.2,540.4c-0.4-2.1-0.8-4.2-0.9-6.3c-0.1-1.1-0.1-2.2-0.1-3.3c0.1-1.1,0.1-2.3,0.7-3.7c0.4-0.9,1.4-1.3,2.3-1
								c0.9,0.4,1.3,1.4,1,2.3c0,0.1-0.1,0.2-0.1,0.3c-0.3,0.5-0.5,1.5-0.7,2.4c-0.1,1-0.2,2-0.2,3c-0.1,2,0,4.1,0.2,6.1l0,0
								c0.1,0.6-0.4,1.1-0.9,1.1C567.8,541.3,567.3,540.9,567.2,540.4z"
              />
              <path
                d="M679.4,535.8c-0.8-0.9-1.4-1.8-2.1-2.7c-0.6-0.9-1.2-1.8-1.8-2.7c-0.6-0.9-1.2-1.9-1.7-2.8c-0.6-1-1.1-1.9-1.6-3.1
								c-0.4-0.9,0.1-1.9,1-2.3c0.9-0.4,1.9,0.1,2.3,1c0,0.1,0,0.1,0.1,0.2l0,0.1c0.2,0.8,0.6,1.8,1,2.8c0.4,1,0.9,1.9,1.3,2.9
								c0.5,1,1,1.9,1.5,2.8c0.5,0.9,1,1.9,1.6,2.6l0,0c0.3,0.4,0.2,1.1-0.2,1.4C680.3,536.3,679.7,536.2,679.4,535.8z"
              />
            </g>
            <path
              d="M542.8,511c-0.7,1.5-1.4,2.7-2.1,4l-2.1,3.8l-4.3,7.5l-8.8,15c-5.9,9.9-11.8,19.9-17.8,29.8c-3,4.9-6,9.9-9.1,14.8
							c-1.5,2.5-3.1,4.9-4.7,7.4c-1.6,2.4-3,4.8-4.5,7.3c-5.8,9.9-11.1,20.2-16,30.6c-2.4,5.2-4.8,10.5-6.8,15.8c-0.5,1.3-1,2.7-1.4,4
							l-0.6,2c-0.2,0.7-0.4,1.4-0.5,2c-0.6,2.7-1.1,5.5-1.5,8.4c-0.7,5.6-1.1,11.4-0.9,17c0.1,5.7,0.7,11.4,2,16.9
							c1.2,5.5,3.1,10.8,5.9,15.7c2.8,4.9,6,9.7,9.6,14.1c3.6,4.4,7.5,8.5,12,12c2.2,1.7,4.6,3.3,7,4.3c1.2,0.5,2.5,0.9,3.7,1
							c0.3,0.1,0.6,0,0.9,0c0.3,0,0.5,0,0.9-0.1l2.1-0.3c2.8-0.4,5.6-1.1,8.3-1.8c2.8-0.7,5.5-1.6,8.4-2.3c2.9-0.7,5.9-1.2,8.8-1.4
							c2.9-0.2,5.8-0.2,8.7-0.3c11.6-0.1,23.2,0.1,34.7,0.2c11.5,0.2,23-0.1,34.6-0.6c11.5-0.6,23-1.3,34.4-2.7
							c11.4-1.4,22.9-3,34.3-4.8c1.4-0.2,2.8-0.5,3.7-1c0.5-0.2,0.6-0.4,0.8-0.7c0.1-0.3,0.2-0.9,0.2-1.5c0-0.6-0.1-1.4-0.2-2.1
							l-0.2-2.1l-0.5-4.3c-0.3-2.9-0.8-5.7-1.2-8.5c-0.4-2.8-1-5.7-1.4-8.5c-2.1-11.3-5.2-22.3-9.4-33c-2.1-5.3-4.4-10.6-6.9-15.7
							c-1.3-2.6-2.5-5.2-3.7-7.8c-0.6-1.3-1.2-2.6-1.8-4c-0.5-1.4-1.1-2.7-1.6-4.1c-0.1-0.2,0-0.5,0.3-0.6c0.2-0.1,0.4,0,0.5,0.2
							c6.2,9.8,11.7,20,16.1,30.8c2.1,5.4,4.1,10.9,5.6,16.6l0.6,2.1l0.5,2.1l1.1,4.2c0.6,2.8,1.2,5.7,1.8,8.5c0.5,2.9,1,5.7,1.5,8.6
							c0.4,2.9,0.9,5.8,1.2,8.6l0.5,4.3l0.2,2.2c0.1,0.7,0.2,1.4,0.2,2.3c0,0.8,0,1.8-0.4,2.8c-0.4,1-1.4,1.9-2.2,2.3
							c-1.7,0.8-3.2,1-4.6,1.3c-11.5,1.8-22.9,3.4-34.4,4.8c-11.5,1.4-23.1,2.2-34.7,2.8c-11.6,0.6-23.2,0.8-34.8,0.6
							c-11.6-0.1-23.1-0.3-34.6-0.2c-2.9,0-5.8,0.1-8.6,0.3c-2.8,0.2-5.5,0.6-8.3,1.3c-2.7,0.7-5.5,1.6-8.3,2.3
							c-2.8,0.8-5.7,1.4-8.6,1.9l-2.2,0.3c-0.3,0.1-0.8,0.1-1.3,0.1c-0.4,0-0.9,0-1.3,0c-1.7-0.2-3.2-0.7-4.6-1.3
							c-2.8-1.3-5.4-2.9-7.7-4.8c-4.7-3.7-8.8-7.9-12.5-12.5c-3.7-4.6-7-9.4-9.9-14.5c-3-5.2-5-10.8-6.3-16.6
							c-1.3-5.8-1.9-11.6-2.1-17.5c-0.1-5.9,0.2-11.7,0.9-17.6c0.4-2.9,0.9-5.8,1.5-8.7c0.2-0.7,0.4-1.4,0.5-2.2l0.6-2.1
							c0.4-1.4,1-2.8,1.4-4.2c2-5.5,4.4-10.8,6.8-16.1c5-10.5,10.3-20.8,16.1-30.9c1.5-2.5,3-5,4.6-7.5c1.6-2.4,3.1-4.8,4.6-7.3
							c3-4.9,6-9.8,9-14.8c6-9.9,11.9-19.8,17.8-29.7l8.8-14.9l4.3-7.5l2.1-3.8c0.7-1.2,1.4-2.6,1.9-3.7l0-0.1c0.4-0.9,1.4-1.3,2.3-0.9
							C542.8,509,543.2,510.1,542.8,511L542.8,511z"
            />
            <path
              d="M740.9,720c2.6,1.5,4.9,3.4,6.8,5.8c0.5,0.6,0.9,1.3,1.3,2c0.4,0.7,0.7,1.5,0.9,2.5c0.2,0.9,0.1,2-0.2,2.9
							c-0.3,0.9-0.9,1.8-1.5,2.4c-2.6,2.5-5.7,3-8.2,3.9c-2.7,0.8-5.4,1.5-8.1,2.1c-5.5,1.2-11,2.1-16.5,2.8c-2.8,0.3-5.5,0.6-8.3,0.9
							c-2.7,0.3-5.4,0.6-8.1,1.2c-5.3,1.1-10.6,2.7-15.8,4.3l-15.9,4.9c-2.7,0.8-5.3,1.6-8.1,2.2c-2.7,0.7-5.6,1.2-8.3,1.6
							c-5.5,0.8-11.1,1.3-16.6,1.8c-5.5,0.4-11.1,0.7-16.6,0.9c-5.6,0.2-11.1,0.4-16.7,0.3c-2.9-0.1-5.6-0.3-8.4-0.5
							c-2.8-0.2-5.5-0.5-8.3-0.7c-5.5-0.5-11-1.1-16.5-1.7l-16.5-1.8c-1.4-0.2-2.7-0.3-4.1-0.4l-4.1-0.3l-8.3-0.6
							c-5.5-0.4-11.1-1.1-16.6-1.9c-2.8-0.4-5.5-0.9-8.3-1.6c-2.7-0.7-5.5-1.4-8-3.1c-0.4-0.3-0.5-0.9-0.2-1.3c0.2-0.3,0.6-0.5,1-0.4
							l0,0c2.6,0.7,5.1,1.3,7.8,1.9c2.7,0.5,5.4,0.9,8.1,1.2c5.4,0.7,10.9,1,16.4,1.4l8.3,0.5l4.2,0.2c1.4,0.1,2.8,0.2,4.2,0.4
							l16.5,1.7l16.5,1.7c5.5,0.5,11,1.1,16.4,1.3c5.4,0.1,11,0,16.5-0.2c5.5-0.2,11-0.4,16.5-0.8c5.5-0.4,11-0.9,16.4-1.6
							c2.7-0.4,5.3-0.8,8-1.5c2.6-0.7,5.3-1.4,7.9-2.2l15.9-4.8c5.3-1.6,10.6-3.2,16.2-4.4c2.8-0.6,5.6-0.9,8.4-1.2
							c2.8-0.3,5.5-0.6,8.2-0.9c5.4-0.7,10.8-1.5,16.2-2.7c2.7-0.6,5.3-1.3,7.9-2c1.3-0.4,2.7-0.7,3.8-1.2c1.1-0.4,2.2-1,2.9-1.7
							c0.7-0.7,0.9-1.4,0.8-2.2c-0.1-0.9-0.8-1.9-1.5-2.9c-1.5-1.9-3.6-3.6-5.8-4.9l0,0c-0.8-0.5-1.1-1.6-0.6-2.4
							C739,719.8,740,719.5,740.9,720L740.9,720z"
            />
            <path
              d="M673.2,652.9c1.5,2.4,2.6,4.9,3.7,7.5c1.1,2.6,2,5.2,2.9,7.8c1.8,5.2,3.3,10.5,4.7,15.9c1.4,5.3,2.5,10.8,3.2,16.3
							c0.4,2.7,0.6,5.5,0.8,8.3c0.2,2.8,0.1,5.7-0.1,8.4c-0.2,2.8-0.4,5.5-0.4,8.1c0,0.7,0,1.3,0.1,1.8c0.1,0.6,0.3,1,0.4,1.2
							c0.2,0.3,0.9,0.4,2.3,0c5.3-1.2,10.7-2.5,16.1-3.6c5.4-1.1,10.9-2.2,16.4-2.8c2.7-0.3,5.5-0.6,8.2-0.9c2.7-0.3,5.5-0.6,8.1-0.9
							l-0.8,0.4c0,0,0,0,0,0l0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.5,0.4-0.7c0.3-0.5,0.5-1,0.8-1.6c0.5-1.1,1-2.2,1.5-3.3
							c1-2.2,1.8-4.4,2.7-6.7c1.6-4.5,3-9.1,4.1-13.8c1.1-4.7,1.8-9.4,1.9-14.1c0.1-4.7-0.7-9.4-1.5-14.2c-1.7-9.5-4.1-18.9-6.9-28.2
							c-2.7-9.3-5.8-18.5-9.3-27.5c-3.5-9-7.4-17.9-12-26.4c-1.1-2.1-2.4-4.2-3.6-6.2c-1.2-2.1-2.5-4.2-3.7-6.4
							c-2.4-4.3-4.6-8.7-6.7-13.1c-4.2-8.9-7.9-17.9-11.2-27.1c-1.6-4.6-3.2-9.2-4.7-13.9c-0.7-2.3-1.5-4.7-2.1-7
							c-0.7-2.4-1.3-4.6-1.9-7.3c-0.2-0.9,0.4-1.9,1.4-2.1c0.9-0.2,1.9,0.4,2.1,1.4l0,0l0,0.1c0.2,1,0.5,2.2,0.8,3.4
							c0.3,1.2,0.6,2.3,1,3.5c0.7,2.3,1.4,4.6,2.1,6.9c1.5,4.6,3,9.2,4.7,13.8c3.3,9.1,6.9,18.1,11,26.9c2,4.4,4.2,8.7,6.6,12.9
							c1.2,2.1,2.4,4.2,3.6,6.3c1.3,2.1,2.5,4.2,3.7,6.4c4.7,8.7,8.6,17.7,12.1,26.8c3.5,9.1,6.6,18.4,9.3,27.8
							c2.7,9.4,5.1,18.9,6.9,28.6c0.4,2.4,0.8,4.9,1.1,7.3c0.3,2.4,0.5,5,0.4,7.5c-0.1,5-0.9,10-2,14.8c-1.1,4.8-2.6,9.5-4.2,14.2
							c-0.8,2.3-1.8,4.6-2.7,6.9c-0.5,1.1-1,2.3-1.5,3.4c-0.3,0.6-0.6,1.1-0.8,1.7c-0.2,0.3-0.3,0.6-0.5,0.9c-0.1,0.1-0.2,0.3-0.3,0.5
							l-0.2,0.2c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.2-0.5,0.4-0.8,0.4l0,0c-2.9,0.4-5.5,0.6-8.3,0.9c-2.7,0.3-5.4,0.6-8.2,0.9
							c-5.4,0.6-10.7,1.6-16.1,2.7c-5.4,1.1-10.7,2.4-16.1,3.6l-1.1,0.2c-0.5,0.1-0.9,0.1-1.4,0.1c-0.5,0-1-0.1-1.5-0.4
							c-0.5-0.2-1-0.7-1.3-1.1c-0.7-0.9-0.8-1.8-0.9-2.6c-0.1-0.8-0.1-1.5-0.1-2.3c0.1-2.8,0.5-5.6,0.7-8.3c0.1-1.4,0.2-2.7,0.2-4
							c0-1.3-0.1-2.7-0.2-4c-0.2-2.7-0.6-5.4-1.1-8.1c-0.9-5.4-2.1-10.7-3.3-16c-1.2-5.3-2.6-10.6-4.2-15.8c-0.8-2.6-1.6-5.2-2.5-7.8
							c-0.9-2.6-1.9-5.1-3.1-7.5l0,0c-0.2-0.4,0-0.8,0.3-1C672.6,652.4,673,652.6,673.2,652.9z"
            />
            <path
              d="M634.9,501.8c-1,5.3-1.2,10.8-1.2,16.3c0,5.5,0.2,11,0.6,16.5c0.2,2.7,0.4,5.5,0.6,8.2c0.3,2.7,0.7,5.4,1.1,8.1
							c0.9,5.4,2,10.8,3.2,16.2c1.2,5.4,2.6,10.7,4.3,15.9c1.7,5.2,3.9,10.2,6,15.3c2.1,5.1,4.2,10.2,6.5,15.2c2.2,5.1,4.6,10,6.7,15.2
							c0.2,0.4,0,0.8-0.4,0.9c-0.3,0.1-0.8,0-0.9-0.4l0,0c-4.6-10-9.6-19.9-14.1-30c-2.2-5.1-4.4-10.2-6.2-15.5
							c-1.8-5.3-3.2-10.7-4.5-16.1c-1.3-5.4-2.4-10.8-3.3-16.3c-0.4-2.8-0.9-5.5-1.1-8.3c-0.2-2.8-0.4-5.5-0.6-8.3
							c-0.3-5.5-0.6-11.1-0.6-16.7c0-5.6,0.2-11.2,1.3-16.8c0.1-0.7,0.8-1.2,1.5-1C634.6,500.4,635.1,501.1,634.9,501.8L634.9,501.8z"
            />
            <path
              d="M650.8,621.4c-0.9-1.7-1.6-3.3-2.4-4.9c-0.7-1.6-1.5-3.3-2.2-5c-1.4-3.3-2.8-6.6-4.1-10c-1.3-3.3-2.6-6.7-3.8-10.1
							c-1.2-3.4-2.3-6.8-3.2-10.3c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.2l0,0c1,3.4,2.2,6.8,3.5,10.2c1.3,3.3,2.7,6.7,4.1,9.9
							c1.4,3.3,2.9,6.6,4.4,9.8c0.8,1.6,1.5,3.2,2.3,4.9c0.8,1.6,1.6,3.2,2.4,4.7l0,0c0.3,0.5,0.1,1.1-0.4,1.4S651.1,621.9,650.8,621.4
							C650.8,621.4,650.8,621.4,650.8,621.4z"
            />
            <path
              d="M653.1,757.4c7.3-1.7,14.6-3.1,21.9-4.4c7.3-1.3,14.6-2.6,21.8-4.1c3.6-0.7,7.2-1.5,10.7-2.5c1.8-0.5,3.5-1,5.1-1.6
							c0.4-0.2,0.8-0.3,1.2-0.5c0.4-0.2,0.7-0.3,1.1-0.6c0.8-0.4,1.7-0.9,2.5-1.3c3.4-1.6,7-3.1,10.8-4c1.9-0.4,3.9-0.7,6-0.6
							c1.1,0.1,2.2,0.3,3.3,0.8c1.1,0.5,2.2,1.4,2.9,2.6c0.5,0.9,0.1,1.9-0.7,2.4c-0.8,0.4-1.9,0.1-2.3-0.7l0,0c-0.2-0.4-0.6-0.8-1.2-1
							c-0.6-0.3-1.3-0.4-2.1-0.4c-1.6-0.1-3.3,0.2-5,0.6c-3.4,0.8-6.8,2.2-10,3.7c-0.8,0.4-1.6,0.8-2.4,1.2c-0.4,0.2-0.9,0.4-1.4,0.7
							c-0.5,0.2-0.9,0.4-1.4,0.6c-1.8,0.7-3.7,1.2-5.5,1.7c-3.7,0.9-7.3,1.7-11,2.3c-7.3,1.3-14.7,2.4-22,3.5l-11,1.6
							c-3.7,0.5-7.3,1.1-11,1.8c-0.4,0.1-0.9-0.2-0.9-0.6C652.4,757.9,652.7,757.5,653.1,757.4z"
            />
            <path
              class="st5"
              d="M504.4,746c-5.1,3.1-1.1,8.9,5.4,11.5c6.2,2.5,34.5,14.8,44.5,14.5c8.9-0.3,40.5,0.7,64.3,1.6
							c23.7,0.9,58.7,1.4,74.9-0.2s33.6-6.9,42-14.3c4.8-4.3,4.9-7.9,4.7-11.7c-0.2-3.8-2-7.3-3.7-8.6"
            />
            <path
              d="M460.3,697.1c2.9,34.4,46.2,80.9,94.3,95.1l1-19.4c0,0-18.6-0.3-40.6-12.7c-8.1-4.5-13.2-3.4-13.7-13.7
							C497.2,744.6,473.7,732.9,460.3,697.1z"
            />
            <path
              d="M659.7,756.5c-2,1.3,19.8-2.2,35.8-5.5c16-3.3,22.6-7.1,25.2-9.9c-5,0.1-22,4.2-31.4,6
							C679.9,748.9,664.5,753.3,659.7,756.5z"
            />
            <path
              d="M611.7,762.1c-3.6-0.5-30.6-0.6-45.7-1.9c-15.1-1.3-16.2-0.7-27.9-1.5s-33.6-7.3-34.4-8.9s5.1-0.2,5.1-0.2
							c0.6,0,1.3,1.3,1.9,1.4c4.6,0.5,24.9,2.6,27.2,2.9c2.6,0.3,27,1.7,28.7,2.2c1.6,0.5,27.7,2.1,30.1,2.4"
            />
          </g>
          <g id="beard-lines">
            <g>
              <g>
                <path
                  d="M514.1,575c-0.7,0.7-1.4,1.7-2.1,2.7c-0.7,1-1.3,2-2,3c-1.3,2-2.6,4.1-3.8,6.1l0,0c-0.2,0.4-0.8,0.5-1.2,0.3
									c-0.4-0.2-0.5-0.7-0.4-1.1c1-2.2,2-4.4,3.1-6.6c0.5-1.1,1.1-2.2,1.7-3.3c0.6-1.1,1.2-2.2,2-3.3c0.6-0.8,1.7-1,2.4-0.4
									c0.8,0.6,1,1.7,0.4,2.4C514.3,574.9,514.2,574.9,514.1,575L514.1,575z"
                />
              </g>
              <g>
                <path
                  d="M499.5,595c-1.2,1.2-2.4,2.5-3.6,3.9c-0.6,0.7-1.1,1.3-1.7,2c-0.5,0.7-1.1,1.4-1.4,2l-0.1,0.1
									c-0.2,0.4-0.7,0.6-1.1,0.4c-0.4-0.2-0.5-0.6-0.4-0.9c0.3-1.1,0.7-1.9,1.2-2.7c0.4-0.8,0.9-1.6,1.4-2.4c1-1.6,1.9-3.1,3-4.6
									c0.6-0.8,1.7-1,2.5-0.4c0.8,0.6,1,1.7,0.4,2.5C499.6,594.9,499.6,595,499.5,595L499.5,595z"
                />
              </g>
              <g>
                <path
                  d="M496.3,615.2l-2.8,5l-1.3,2.5c-0.4,0.8-0.9,1.7-1.2,2.4l0,0.1c-0.2,0.5-0.8,0.7-1.3,0.5c-0.5-0.2-0.7-0.7-0.6-1.2
									c0.3-1.1,0.6-1.9,0.9-2.8l1-2.7l2-5.2l0,0c0.4-0.9,1.4-1.3,2.3-1s1.3,1.4,1,2.3C496.4,615,496.4,615.1,496.3,615.2z"
                />
              </g>
              <g>
                <path
                  d="M479.5,629c-0.5,1-0.9,1.8-1.4,2.6l-1.4,2.5c-0.5,0.8-0.9,1.7-1.4,2.5c-0.4,0.8-0.9,1.7-1.1,2.4l-0.1,0.2
									c-0.2,0.5-0.7,0.8-1.2,0.6c-0.4-0.1-0.7-0.6-0.6-1c0.2-1.2,0.5-2.1,0.9-3c0.3-0.9,0.7-1.8,1-2.7l1.1-2.7c0.3-0.9,0.7-1.8,1-2.6
									l0,0c0.3-0.9,1.3-1.4,2.2-1.1c0.9,0.3,1.4,1.3,1.1,2.2C479.6,628.8,479.5,628.9,479.5,629z"
                />
              </g>
              <g>
                <path
                  d="M484.3,639.8c-1.1,1.9-2.1,3.9-3,5.9c-0.5,1-0.9,2-1.4,3c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.5-0.4,1-0.4,1.4l0,0.1
									c-0.1,0.4-0.5,0.8-0.9,0.7c-0.4-0.1-0.7-0.4-0.7-0.8c0-0.8,0.1-1.3,0.2-1.9c0.1-0.6,0.3-1.1,0.4-1.7c0.3-1.1,0.6-2.2,1-3.3
									c0.7-2.1,1.4-4.3,2.2-6.4c0.3-0.9,1.4-1.4,2.3-1c0.9,0.3,1.4,1.4,1,2.3C484.4,639.7,484.4,639.8,484.3,639.8z"
                />
              </g>
              <g>
                <path
                  d="M466.1,664.2c-0.2,0.6-0.4,1.3-0.5,2.1c-0.1,0.8-0.2,1.6-0.3,2.3c-0.1,0.8-0.2,1.6-0.2,2.4l-0.2,2.5
									c0,0.5-0.5,0.9-1,0.8c-0.4,0-0.8-0.4-0.8-0.8l0,0l-0.2-2.4c-0.1-0.8-0.1-1.7-0.2-2.5c0-0.8-0.1-1.7-0.1-2.5
									c0-0.9,0-1.7,0.2-2.7l0,0c0.2-1,1.1-1.6,2.1-1.4s1.6,1.1,1.4,2.1C466.2,664,466.2,664.1,466.1,664.2z"
                />
              </g>
              <g>
                <path
                  d="M469.4,681.6c-0.1,1.1-0.1,2.3-0.1,3.5c0,1.2,0,2.4,0.1,3.6c0,1.2,0.1,2.4,0.2,3.6c0.1,1.2,0.2,2.4,0.4,3.5l0,0
									c0.1,0.5-0.2,1-0.7,1.1c-0.5,0.1-0.9-0.2-1-0.6c-0.4-1.3-0.6-2.5-0.8-3.7c-0.2-1.2-0.4-2.4-0.6-3.6c-0.2-1.2-0.4-2.4-0.5-3.6
									c-0.1-1.2-0.3-2.4-0.4-3.7c-0.1-1,0.7-1.8,1.6-1.9c1-0.1,1.8,0.7,1.9,1.6C469.4,681.5,469.4,681.5,469.4,681.6L469.4,681.6z"
                />
              </g>
              <path class="st5" d="M509.9,603.2c-1.7,3.4-3.4,9.8-3.4,9.8" />
              <g>
                <path
                  d="M528.1,578.6c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.5-0.4,1.1-0.6,1.7c-0.4,1.1-0.7,2.3-1,3.5l0,0c-0.1,0.5-0.7,0.8-1.2,0.7
									c-0.5-0.1-0.8-0.5-0.7-1c0.1-1.2,0.1-2.4,0.2-3.7c0.1-0.6,0.1-1.2,0.2-1.9c0.1-0.6,0.2-1.3,0.3-1.9l0-0.1
									c0.2-0.9,1.2-1.5,2.1-1.3c0.9,0.2,1.5,1.2,1.3,2.1C528.2,578.3,528.2,578.5,528.1,578.6z"
                />
              </g>
              <g>
                <path
                  d="M531.6,593c-0.4,1.2-0.8,2.7-1.2,4.2c-0.4,1.4-0.7,2.9-1,4.4c-0.3,1.5-0.6,2.9-0.9,4.4c-0.3,1.5-0.6,3-0.7,4.3l0,0.1
									c0,0.5-0.5,0.9-1.1,0.9c-0.5,0-0.9-0.5-0.9-1c0-1.7,0.2-3.1,0.3-4.7c0.2-1.5,0.4-3,0.6-4.5c0.2-1.5,0.4-3,0.7-4.5
									c0.3-1.5,0.5-3,0.9-4.6c0.2-0.9,1.2-1.5,2.1-1.2c0.9,0.2,1.5,1.2,1.2,2.1C531.6,592.8,531.6,592.9,531.6,593L531.6,593z"
                />
              </g>
              <g>
                <path
                  d="M519.7,620.1c-0.6,2.7-1.1,5.4-1.6,8.1l-0.7,4.1c-0.2,1.3-0.5,2.7-0.6,4l0,0.1c0,0.4-0.4,0.8-0.9,0.7
									c-0.4,0-0.7-0.4-0.7-0.8c0-1.5,0.1-2.8,0.1-4.2l0.2-4.1c0.2-2.8,0.4-5.5,0.7-8.3c0.1-1,1-1.7,1.9-1.6c1,0.1,1.7,1,1.6,1.9
									C519.7,619.9,519.7,620,519.7,620.1L519.7,620.1z"
                />
              </g>
              <g>
                <path
                  d="M512,672.8l-0.9-18.1c-0.1-1,0.7-1.8,1.7-1.8c1-0.1,1.8,0.7,1.8,1.7c0,0.1,0,0.1,0,0.2l-0.9,18.1
									c0,0.4-0.4,0.8-0.9,0.8C512.3,673.6,512,673.2,512,672.8z"
                />
              </g>
              <g>
                <path
                  d="M498.7,676.5c-0.1,0.9,0,2,0.1,3c0.1,1,0.2,2.1,0.3,3.2c0.1,1.1,0.3,2.1,0.4,3.2c0.2,1,0.4,2.2,0.6,3l0,0.1
									c0.1,0.4-0.1,0.9-0.5,1.1c-0.4,0.1-0.8-0.1-1-0.4c-0.3-0.6-0.5-1.1-0.7-1.7c-0.2-0.5-0.4-1.1-0.5-1.6c-0.3-1.1-0.6-2.1-0.9-3.2
									c-0.3-1.1-0.5-2.1-0.8-3.2c-0.2-1.1-0.4-2.2-0.5-3.4c-0.1-1,0.7-1.8,1.6-1.9c1-0.1,1.8,0.7,1.9,1.6
									C498.7,676.3,498.7,676.4,498.7,676.5L498.7,676.5z"
                />
              </g>
              <g>
                <path
                  d="M489.6,692.1c-0.2,1.6-0.4,3.2-0.6,4.8l-0.3,2.4c-0.1,0.8-0.2,1.6-0.1,2.2l0,0.1c0,0.4-0.3,0.8-0.8,0.8
									c-0.4,0-0.7-0.3-0.8-0.6c-0.2-1-0.3-1.7-0.4-2.5l-0.2-2.4c-0.1-1.6-0.2-3.2-0.4-4.7l0,0c-0.1-1,0.6-1.8,1.6-1.9
									s1.8,0.6,1.9,1.6C489.6,691.9,489.6,692,489.6,692.1z"
                />
              </g>
              <g>
                <path
                  d="M482.7,714.3c0.1,0.7,0.4,1.5,0.6,2.3l0.7,2.4l0.8,2.4c0.3,0.8,0.5,1.6,0.7,2.5c0.1,0.5-0.2,0.9-0.6,1
									c-0.4,0.1-0.8-0.1-1-0.5l0,0c-0.3-0.7-0.7-1.4-1.1-2.2l-1.2-2.2l-1.2-2.3c-0.4-0.8-0.8-1.5-1.1-2.4l0,0c-0.4-0.9,0.1-1.9,1-2.3
									s1.9,0.1,2.3,1C482.7,714.1,482.7,714.2,482.7,714.3z"
                />
              </g>
              <g>
                <path
                  d="M503.4,724c0.1,0.5,0.4,1.1,0.6,1.7c0.3,0.6,0.5,1.2,0.8,1.8l0.9,1.8l0.5,0.9l0.2,0.5c0.1,0.2,0.2,0.3,0.3,0.7
									c0.1,0.4-0.1,0.9-0.5,1.1c-0.3,0.1-0.6,0-0.8-0.2l-0.4-0.3c-0.1-0.1-0.3-0.4-0.5-0.6l-0.6-0.8l-1.3-1.6
									c-0.4-0.6-0.9-1.1-1.3-1.7c-0.4-0.6-0.8-1.2-1.2-1.9l0-0.1c-0.4-0.9-0.1-1.9,0.8-2.4c0.9-0.4,1.9-0.1,2.4,0.8
									C503.4,723.7,503.4,723.8,503.4,724z"
                />
              </g>
              <g>
                <path
                  d="M510.1,707.1c0,0.7,0.1,1.6,0.2,2.4c0.1,0.8,0.3,1.7,0.4,2.6c0.2,0.9,0.3,1.7,0.5,2.6c0.2,0.8,0.4,1.7,0.6,2.5l0,0
									c0.1,0.5-0.1,1-0.6,1.1c-0.4,0.1-0.9-0.1-1.1-0.5c-0.4-0.9-0.7-1.7-1.1-2.5c-0.3-0.8-0.6-1.7-0.9-2.5c-0.3-0.9-0.6-1.7-0.9-2.6
									c-0.3-0.9-0.5-1.8-0.7-2.8l0,0c-0.2-1,0.5-1.9,1.4-2s1.9,0.5,2,1.4C510.1,706.9,510.1,707,510.1,707.1z"
                />
              </g>
              <g>
                <path
                  d="M537.2,624.9c-0.5,1.5-0.9,3.2-1.3,4.8c-0.4,1.6-0.8,3.3-1.2,4.9c-0.4,1.6-0.7,3.3-1.1,5c-0.3,1.6-0.7,3.3-0.9,4.9
									l0,0.1c0,0.4-0.4,0.6-0.7,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-1.8,0.2-3.5,0.3-5.2c0.2-1.7,0.4-3.4,0.6-5.1c0.2-1.7,0.4-3.4,0.7-5.1
									c0.2-1.7,0.5-3.4,0.8-5.1c0.2-0.9,1.1-1.6,2.1-1.4c0.9,0.2,1.6,1.1,1.4,2.1C537.3,624.7,537.2,624.8,537.2,624.9L537.2,624.9z"
                />
              </g>
              <g>
                <path
                  d="M536.5,662.7l0.2,10.3l0,0c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.3-0.9-0.8l-1.8-10.2c-0.2-1,0.5-1.9,1.4-2
									c1-0.2,1.9,0.5,2,1.4C536.5,662.4,536.5,662.5,536.5,662.7L536.5,662.7z"
                />
              </g>
              <g>
                <path
                  d="M530.9,713c-0.3,1-0.6,1.9-0.9,2.9l-1,2.8l-1,2.7l-0.5,1.4l-0.2,0.7c-0.1,0.2-0.1,0.5-0.2,0.5l-1.7,0.1
									c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0-0.5,0.1-0.7,0.1-0.9l0.1-0.7l0.3-1.4l0.6-2.9l0.6-2.8c0.2-0.9,0.4-1.9,0.5-2.8l0,0
									c0.1-1,1-1.6,2-1.5s1.6,1,1.5,2C530.9,712.8,530.9,712.9,530.9,713z"
                />
              </g>
              <g>
                <path
                  d="M549.2,589.3c-0.6,2.3-1.1,4.5-1.6,6.8l-0.7,3.4c-0.2,1.1-0.5,2.3-0.6,3.4l0,0.1c0,0.4-0.4,0.8-0.9,0.7
									c-0.4,0-0.7-0.4-0.7-0.8c0-1.3,0-2.4,0.1-3.6l0.3-3.5c0.2-2.4,0.4-4.7,0.7-7.1c0.1-1,1-1.7,1.9-1.6s1.7,1,1.6,1.9
									C549.2,589.2,549.2,589.3,549.2,589.3z"
                />
              </g>
              <g>
                <path
                  d="M559.3,612.4c-1.2,1.8-2.3,3.8-3.4,5.8c-0.5,1-1,2-1.5,3c-0.4,1-0.9,2.1-1,3l0,0.1c-0.1,0.4-0.5,0.8-0.9,0.7
									c-0.4-0.1-0.7-0.4-0.7-0.8c0-1.4,0.3-2.5,0.6-3.7c0.3-1.1,0.7-2.3,1.1-3.4c0.8-2.2,1.6-4.4,2.7-6.5c0.4-0.9,1.5-1.2,2.3-0.8
									c0.9,0.4,1.2,1.5,0.8,2.3C559.4,612.2,559.3,612.3,559.3,612.4L559.3,612.4z"
                />
              </g>
              <g>
                <path
                  d="M557.7,650.3c-0.6,1.2-1.1,2.6-1.6,3.9c-0.5,1.4-0.9,2.7-1.3,4.1c-0.8,2.8-1.5,5.6-1.6,8.4l0,0c0,0.5-0.5,1-1,0.9
									c-0.5,0-0.9-0.4-0.9-0.9c-0.1-3.1,0.3-6.1,0.9-9c0.3-1.5,0.6-2.9,1-4.4c0.4-1.5,0.8-2.9,1.3-4.4c0.3-0.9,1.3-1.4,2.2-1.1
									s1.4,1.3,1.1,2.2C557.7,650.2,557.7,650.2,557.7,650.3L557.7,650.3z"
                />
              </g>
              <g>
                <path
                  d="M543.4,690.9c-0.3,3.6-0.4,7.3-0.4,10.9l0,0c0,0.5-0.4,0.8-0.8,0.8c-0.4,0-0.7-0.3-0.8-0.7c-0.5-3.7-1.1-7.3-1.4-11.1
									c-0.1-1,0.6-1.8,1.6-1.9c1-0.1,1.8,0.6,1.9,1.6C543.4,690.7,543.4,690.8,543.4,690.9L543.4,690.9z"
                />
              </g>
              <g>
                <path
                  d="M543.3,732.1c0.2-0.6,0.3-1.1,0.5-1.6l0.5-1.5c0.2-0.5,0.3-1,0.4-1.5c0.1-0.2,0.1-0.5,0.1-0.7c0-0.2,0-0.4,0-0.3
									c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8c-0.1,0.6-0.2,0.9-0.3,1.3c-0.1,0.3-0.3,0.6-0.4,0.8c-0.3,0.5-0.6,1-0.9,1.5l-0.9,1.4
									c-0.3,0.4-0.6,0.9-0.8,1.3l0,0c-0.3,0.4-0.8,0.5-1.2,0.3C543.3,732.9,543.2,732.5,543.3,732.1z"
                />
              </g>
              <g>
                <path
                  d="M569.8,586.3c-0.2,1.4-0.5,2.5-0.7,3.7l-0.4,1.7l-0.2,0.8l-0.1,0.6l0,0.3c-0.1,0.5-0.5,0.8-1,0.7
									c-0.3,0-0.6-0.3-0.7-0.6c-0.1-0.5-0.1-0.8-0.2-1.1c0-0.3,0-0.6,0-0.9l0-1.8c0-1.2,0-2.4-0.2-3.4c-0.1-1,0.5-1.9,1.5-2
									c1-0.1,1.9,0.5,2,1.5C569.8,586,569.8,586.1,569.8,586.3L569.8,586.3z"
                />
              </g>
              <g>
                <path
                  d="M587.1,592.2c-1.9,2.6-3.6,5.3-5.2,8.1c-0.8,1.4-1.5,2.8-2.1,4.3c-0.6,1.5-1.1,3-1.1,4.4l0,0c0,0.5-0.5,0.9-1,0.8
									c-0.5,0-0.8-0.4-0.8-0.9c0-1.8,0.4-3.5,0.8-5.2c0.5-1.6,1.1-3.2,1.8-4.7c1.3-3.1,2.9-6,4.6-8.9c0.5-0.8,1.6-1.1,2.4-0.6
									c0.8,0.5,1.1,1.6,0.6,2.4C587.1,592.1,587.1,592.1,587.1,592.2L587.1,592.2z"
                />
              </g>
              <g>
                <path
                  d="M577.8,627.1c-0.4,1.3-0.8,2.5-1.3,3.7l-1.3,3.6c-0.4,1.2-0.8,2.4-1.1,3.6c-0.3,1.2-0.6,2.5-0.7,3.4l0,0.1
									c0,0.6-0.5,1-1.1,1c-0.5,0-1-0.4-1-1c-0.1-1.6,0.1-2.8,0.4-4.2c0.2-1.3,0.5-2.6,0.8-3.8l0.9-3.8c0.3-1.2,0.6-2.5,0.9-3.7l0,0
									c0.2-0.9,1.1-1.6,2.1-1.4c0.9,0.2,1.6,1.1,1.4,2.1C577.8,627,577.8,627,577.8,627.1z"
                />
              </g>
              <g>
                <path
                  d="M571.7,659.8l-4.1,13.9l0,0.1c-0.1,0.4-0.6,0.7-1,0.5c-0.4-0.1-0.6-0.5-0.6-0.9l2.3-14.5c0.1-1,1-1.6,2-1.5
									c1,0.1,1.6,1,1.5,2C571.7,659.6,571.7,659.6,571.7,659.8L571.7,659.8z"
                />
              </g>
              <g>
                <path
                  d="M558.7,703.3c-0.4-1.8-0.9-3.5-1.2-5.3c-0.2-0.9-0.4-1.8-0.5-2.8c-0.1-0.9-0.2-1.9-0.2-3l0,0c0-1,0.8-1.7,1.8-1.7
									s1.7,0.8,1.7,1.8c0,0.1,0,0.2,0,0.2c-0.1,0.7-0.1,1.6-0.1,2.4c0,0.9,0.1,1.7,0.1,2.6c0.1,1.8,0.3,3.6,0.5,5.4
									c0.1,0.6-0.4,1.1-0.9,1.1C559.3,704.1,558.8,703.8,558.7,703.3z"
                />
              </g>
              <g>
                <path
                  d="M565.5,727.3c-0.1-1.3,0-2.6,0.1-3.8l0.2-1.8l0.1-0.9l0-0.4l0-0.2c0-0.1,0,0,0,0c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8
									c0,0.1,0,0.4-0.1,0.5l-0.1,0.3l-0.2,0.5l-0.3,0.9l-0.6,1.7c-0.4,1.1-0.8,2.2-0.9,3.3l0,0.1c-0.1,0.4-0.5,0.7-0.9,0.7
									C565.8,728,565.5,727.7,565.5,727.3z"
                />
              </g>
              <g>
                <path
                  d="M574.5,705.9c0.1-1.2,0.1-2.6,0.1-4c0-1.4,0-2.7-0.1-4.1c-0.1-1.4-0.1-2.7-0.2-4c-0.1-1.3-0.2-2.7-0.4-3.9l0,0
									c-0.2-1,0.4-1.9,1.4-2c1-0.2,1.9,0.4,2,1.4c0,0.1,0,0.1,0,0.2c0.1,1.5,0.1,2.9,0,4.3c0,1.4-0.1,2.8-0.2,4.2
									c-0.1,1.4-0.2,2.8-0.3,4.1c-0.2,1.4-0.3,2.7-0.6,4.2c-0.1,0.5-0.6,0.8-1,0.7C574.7,706.8,574.4,706.4,574.5,705.9L574.5,705.9z
									"
                />
              </g>
              <g>
                <path
                  d="M581.9,657.4c-0.1-2,0-4,0.2-6c0.1-1,0.2-2,0.3-3c0.1-1,0.3-1.9,0.5-3c0.2-0.9,1.1-1.6,2.1-1.4
									c0.9,0.2,1.6,1.1,1.4,2.1c0,0.1,0,0.1-0.1,0.2l0,0c-0.3,0.8-0.6,1.7-0.8,2.7c-0.2,0.9-0.5,1.8-0.7,2.8
									c-0.4,1.9-0.8,3.7-0.9,5.6l0,0c0,0.5-0.5,0.9-1.1,0.9C582.3,658.3,582,657.9,581.9,657.4z"
                />
              </g>
              <g>
                <path
                  d="M593.6,623.8c0.3-2.7,0.7-5.4,1.1-8.1c0.2-1.4,0.4-2.7,0.7-4.1c0.1-0.7,0.3-1.4,0.4-2.1c0.1-0.4,0.2-0.7,0.3-1.1
									c0.1-0.2,0.1-0.4,0.2-0.6l0.3-0.6c0.4-0.9,1.4-1.3,2.3-0.9s1.3,1.4,0.9,2.3c0,0.1-0.1,0.1-0.1,0.2l-0.1,0.2l-0.2,0.3
									c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.3-0.2,0.6-0.3,0.9c-0.2,0.6-0.4,1.2-0.6,1.9c-0.4,1.3-0.8,2.6-1.1,3.9
									c-0.7,2.6-1.3,5.3-1.9,7.9l0,0c-0.1,0.5-0.6,0.8-1,0.6C593.8,624.7,593.5,624.2,593.6,623.8z"
                />
              </g>
              <g>
                <path
                  d="M608.8,593.4c-0.6-2-1.3-4.1-1.9-6.3c-0.3-1.1-0.5-2.2-0.7-3.3c-0.2-1.1-0.3-2.3-0.2-3.6l0,0c0.1-1,0.9-1.7,1.9-1.6
									c1,0.1,1.7,0.9,1.6,1.9c0,0.1,0,0.1,0,0.2c-0.2,0.8-0.2,1.8-0.2,2.8c0,1,0.1,2,0.3,3.1c0.3,2.1,0.7,4.2,1.1,6.3
									c0.1,0.5-0.3,1.1-0.8,1.2C609.5,594.2,609,593.9,608.8,593.4L608.8,593.4z"
                />
              </g>
              <g>
                <path
                  d="M608.9,620c0.1-2.2,0.4-4.2,0.8-6.3c0.2-1,0.4-2.1,0.8-3.1c0.3-1.1,0.7-2.1,1.4-3.3l0,0c0.5-0.8,1.6-1,2.4-0.5
									c0.8,0.5,1,1.6,0.5,2.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.4,0.5-0.9,1.3-1.3,2.2c-0.4,0.9-0.8,1.8-1.1,2.7c-0.6,1.9-1.2,3.9-1.5,5.8
									l0,0c-0.1,0.5-0.5,0.8-1,0.7C609.2,620.8,608.9,620.4,608.9,620z"
                />
              </g>
              <g>
                <path
                  d="M602.5,651.6c-0.5-1.7-0.7-3.3-0.9-5c-0.2-1.6-0.3-3.3-0.4-4.9c-0.1-1.6-0.2-3.3-0.2-4.9c0-0.8,0-1.7,0-2.5
									c0-0.9,0.1-1.7,0.2-2.7c0.2-1,1.1-1.6,2-1.4s1.6,1.1,1.4,2c0,0,0,0.1,0,0.1l0,0c-0.2,0.6-0.3,1.4-0.3,2.1
									c-0.1,0.8-0.1,1.6-0.2,2.3c-0.1,1.6-0.2,3.2-0.2,4.8c0,1.6,0,3.2,0,4.8c0.1,1.6,0.1,3.2,0.4,4.6l0,0.1c0.1,0.5-0.2,1.1-0.8,1.2
									C603.1,652.4,602.6,652.1,602.5,651.6z"
                />
              </g>
              <g>
                <path
                  d="M591.7,683.2c-0.4-2.2-0.4-4.3-0.4-6.5c0-1.1,0.1-2.2,0.2-3.2c0-0.5,0.1-1.1,0.2-1.7c0.1-0.6,0.2-1.1,0.4-1.9l0-0.1
									c0.3-0.9,1.3-1.4,2.3-1.1c0.9,0.3,1.4,1.3,1.1,2.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.2-0.3,0.7-0.4,1.2c-0.1,0.5-0.2,0.9-0.3,1.4
									c-0.2,1-0.4,2-0.5,3c-0.3,2-0.4,4.1-0.3,6.1l0,0c0,0.6-0.4,1-1,1.1C592.2,684.1,591.8,683.7,591.7,683.2z"
                />
              </g>
              <g>
                <path
                  d="M589.4,729.7c0-0.9-0.2-1.9-0.4-2.8c-0.2-1-0.4-1.9-0.7-2.9c-0.5-1.9-1.1-3.8-1.7-5.8c-0.3-0.9,0.2-1.9,1.1-2.2
									c0.9-0.3,1.9,0.2,2.2,1.1c0,0.1,0,0.2,0.1,0.2c0.4,2,0.7,4.1,0.9,6.1c0.1,1,0.2,2.1,0.3,3.1c0.1,1.1,0.1,2.1-0.1,3.2
									c-0.1,0.5-0.5,0.8-1,0.8C589.7,730.5,589.4,730.1,589.4,729.7L589.4,729.7z"
                />
              </g>
              <g>
                <path
                  d="M599.2,708.3c-0.3-2.2-0.5-4.4-0.6-6.6c0-1.1-0.1-2.2,0-3.4c0.1-1.2,0.1-2.3,0.5-3.7c0.3-0.9,1.2-1.5,2.2-1.2
									c0.9,0.3,1.5,1.2,1.2,2.2c0,0.1,0,0.1-0.1,0.2l0,0c-0.3,0.7-0.5,1.7-0.6,2.7c-0.1,1-0.2,2.1-0.3,3.1c-0.1,2.1-0.2,4.3-0.1,6.4
									l0,0c0,0.6-0.5,1.1-1.1,1.1C599.7,709.3,599.3,708.9,599.2,708.3z"
                />
              </g>
              <g>
                <path
                  d="M607.5,676c0.8-1.8,1.5-3.8,2.1-5.7c0.3-1,0.6-2,0.8-2.9c0.2-1,0.4-2,0.4-2.8l0,0c0-1,0.9-1.7,1.8-1.7
									c1,0,1.7,0.9,1.7,1.8c0,0.1,0,0.2,0,0.2c-0.2,1.3-0.6,2.3-0.9,3.3c-0.4,1-0.8,2-1.2,3c-0.9,2-1.8,3.9-2.9,5.7
									c-0.3,0.5-0.9,0.6-1.3,0.3C607.4,677,607.3,676.5,607.5,676L607.5,676z"
                />
              </g>
              <g>
                <path
                  d="M620.3,648.2c0.1-1.1,0-2.4,0-3.7c-0.1-1.3-0.2-2.5-0.3-3.8c-0.1-1.3-0.3-2.5-0.5-3.8c-0.1-0.6-0.2-1.2-0.3-1.8
									c-0.1-0.6-0.3-1.2-0.4-1.6c-0.4-0.9,0.1-1.9,1-2.3s1.9,0.1,2.3,1c0,0.1,0,0.1,0.1,0.2l0,0c0.2,0.9,0.3,1.5,0.4,2.2
									c0.1,0.7,0.1,1.3,0.2,2c0.1,1.3,0.1,2.6,0.2,3.9c0,1.3,0,2.6,0,3.9c0,1.3-0.1,2.6-0.3,4c-0.1,0.6-0.6,0.9-1.2,0.8
									C620.6,649.3,620.2,648.8,620.3,648.2L620.3,648.2z"
                />
              </g>
              <g>
                <path
                  d="M627.9,615.2c-0.2-2.5-0.4-5-0.6-7.5l-0.2-3.8c0-1.3-0.1-2.5,0-3.9c0.1-1,0.9-1.7,1.8-1.7c1,0.1,1.7,0.9,1.7,1.8
									c0,0.1,0,0.1,0,0.2l0,0.1c-0.2,1-0.3,2.3-0.3,3.5l-0.2,3.7c-0.1,2.5-0.2,4.9-0.2,7.4c0,0.5-0.4,1-1,1
									C628.3,616.1,627.9,615.7,627.9,615.2z"
                />
              </g>
              <g>
                <path
                  d="M641,636.8c-0.3-1.3-0.7-2.6-1.2-3.9c-0.5-1.3-1-2.6-1.6-3.9c-1.1-2.5-2.3-5.1-3.6-7.5l0,0c-0.5-0.9-0.1-1.9,0.7-2.4
									c0.9-0.5,1.9-0.1,2.4,0.7c0,0.1,0.1,0.1,0.1,0.2c1.1,2.7,2,5.4,2.8,8.1c0.4,1.4,0.8,2.7,1.2,4.1c0.3,1.4,0.7,2.8,0.8,4.3
									c0,0.4-0.3,0.8-0.7,0.8C641.5,637.4,641.1,637.2,641,636.8L641,636.8z"
                />
              </g>
              <g>
                <path
                  d="M637.6,664.3c-0.1-0.8-0.4-1.7-0.7-2.5c-0.3-0.9-0.6-1.7-1-2.6c-0.3-0.9-0.7-1.7-1.1-2.6c-0.4-0.8-0.7-1.7-1.1-2.5
									c-0.4-0.9-0.1-1.9,0.8-2.3c0.9-0.4,1.9-0.1,2.3,0.8c0,0.1,0.1,0.2,0.1,0.3c0.3,1,0.5,1.9,0.7,2.8c0.2,0.9,0.4,1.8,0.6,2.8
									c0.2,0.9,0.4,1.9,0.5,2.8c0.1,1,0.3,1.9,0.3,3c0,0.4-0.3,0.7-0.8,0.7C638,665,637.7,664.7,637.6,664.3L637.6,664.3z"
                />
              </g>
              <g>
                <path
                  d="M654.6,660c-0.2-1-0.6-2-1-3c-0.4-1-0.8-2-1.3-2.9c-0.5-1-0.9-1.9-1.4-2.9c-0.5-0.9-1-1.9-1.5-2.7l0,0
									c-0.5-0.8-0.3-1.9,0.5-2.4s1.9-0.3,2.4,0.5c0,0.1,0.1,0.1,0.1,0.2c0.5,1.1,0.9,2.1,1.3,3.2c0.4,1.1,0.7,2.1,1.1,3.2
									c0.3,1.1,0.7,2.1,0.9,3.2c0.3,1.1,0.5,2.2,0.7,3.4c0.1,0.5-0.3,0.9-0.8,1C655.1,660.8,654.7,660.5,654.6,660L654.6,660z"
                />
              </g>
              <g>
                <path
                  d="M651.7,683.2c-0.2-1.3-0.6-2.7-1-4c-0.4-1.4-0.9-2.7-1.4-4c-0.5-1.3-1.1-2.7-1.6-4l-0.8-2c-0.3-0.7-0.6-1.3-0.9-2.1
									c-0.4-0.9,0.1-1.9,1-2.3c0.9-0.4,1.9,0.1,2.3,1c0,0,0,0.1,0,0.1l0,0.1l1.4,4.1c0.5,1.4,0.9,2.8,1.3,4.2
									c0.4,1.4,0.8,2.8,1.1,4.3c0.3,1.5,0.6,2.9,0.7,4.5c0,0.6-0.4,1.1-1,1.1C652.3,684.1,651.8,683.7,651.7,683.2L651.7,683.2z"
                />
              </g>
              <g>
                <path
                  d="M632.7,691.8c-0.2-1.1-0.2-2.1-0.2-3.1c0-1,0.2-2,0.3-2.9c0.3-1.9,0.7-3.8,1.2-5.7c0.2-0.9,1.2-1.5,2.1-1.2
									c0.9,0.2,1.5,1.2,1.2,2.1c0,0.1,0,0.1-0.1,0.2c-0.7,1.7-1.3,3.4-1.8,5.2c-0.2,0.9-0.5,1.7-0.6,2.6c-0.2,0.9-0.2,1.7-0.2,2.5
									l0,0c0,0.6-0.4,1.1-1,1.1C633.3,692.6,632.8,692.3,632.7,691.8z"
                />
              </g>
              <g>
                <path
                  d="M620.7,688c-0.1-2,0.1-4,0.5-5.9c0.3-1.9,0.8-3.8,1.4-5.7c0.3-0.9,1.2-1.5,2.2-1.2s1.5,1.2,1.2,2.2
									c0,0.1,0,0.1-0.1,0.2c-0.7,1.7-1.4,3.4-1.9,5.1c-0.5,1.7-1,3.5-1.1,5.3l0,0c0,0.6-0.5,1-1.1,1
									C621.1,688.9,620.7,688.5,620.7,688z"
                />
              </g>
              <g>
                <path
                  d="M614.9,715.2c-0.2-0.9-0.4-1.8-0.6-2.7l-0.7-2.8l-0.7-2.8c-0.2-1-0.4-1.9-0.5-3.1c-0.1-1,0.6-1.8,1.6-1.9
									c1-0.1,1.8,0.6,1.9,1.6c0,0.1,0,0.2,0,0.2l0,0c0,0.7,0,1.7,0.1,2.6l0.3,2.8l0.3,2.8c0.1,1,0.2,1.9,0.3,2.9c0,0.5-0.4,1-0.9,1
									C615.4,716,615,715.7,614.9,715.2L614.9,715.2z"
                />
              </g>
              <g>
                <path
                  d="M607.2,731.4c0.2-1.2,0.8-2,1.4-2.8l0.8-1.1c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.1,0.1-0.2l0,0c0,0-0.1,0.1-0.1,0.2
									c0.3-0.9,1.3-1.4,2.2-1.1c0.9,0.3,1.4,1.3,1.1,2.2c-0.1,0.2-0.2,0.3-0.2,0.5l-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.3
									c-0.2,0.2-0.4,0.3-0.6,0.5l-1,0.8c-0.6,0.5-1.2,1-1.5,1.5l-0.1,0.1c-0.3,0.5-0.8,0.6-1.3,0.4
									C607.3,732.2,607.1,731.8,607.2,731.4z"
                />
              </g>
              <g>
                <path
                  d="M637.8,719.5c-0.1-2.6,0-5.1,0.2-7.6c0.1-1.3,0.2-2.5,0.4-3.8c0.2-1.3,0.4-2.5,1.1-4.1c0.4-0.9,1.4-1.3,2.3-0.9
									c0.9,0.4,1.3,1.4,0.9,2.3c0,0.1-0.1,0.2-0.1,0.2l0,0c-0.4,0.7-0.9,1.9-1.2,3c-0.3,1.1-0.6,2.3-0.9,3.5
									c-0.5,2.4-0.9,4.9-1.1,7.3l0,0c0,0.4-0.4,0.8-0.9,0.7C638.1,720.2,637.8,719.9,637.8,719.5z"
                />
              </g>
              <g>
                <path
                  d="M628,732.4l-0.7-5.5l0-0.1c-0.1-1,0.6-1.8,1.5-2c1-0.1,1.8,0.6,2,1.5c0,0.1,0,0.2,0,0.3l-0.2,5.7
									c0,0.7-0.6,1.3-1.3,1.3c-0.6,0-1.2-0.5-1.2-1.1L628,732.4z"
                />
              </g>
              <g>
                <path
                  d="M651.4,732.2c-0.1-1-0.3-2.2-0.4-3.3c-0.2-1.1-0.4-2.2-0.6-3.3c-0.2-1.1-0.4-2.2-0.7-3.3l-0.4-1.6l-0.2-0.8l-0.1-0.3
									c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.4c-0.2-0.9,0.3-1.9,1.2-2.1c0.9-0.2,1.8,0.3,2.1,1.2c0.1,0.2,0.1,0.5,0.2,0.6l0.1,0.5l0.1,0.9
									l0.2,1.7c0.1,1.1,0.2,2.3,0.2,3.4c0.1,1.1,0.1,2.3,0.2,3.4c0,1.2,0.1,2.3,0,3.5c0,0.5-0.4,0.9-0.9,0.9
									C651.8,733,651.4,732.7,651.4,732.2L651.4,732.2z"
                />
              </g>
              <g>
                <path
                  d="M662.2,713.5c-0.5-2.5-1.1-4.9-1.7-7.4c-0.3-1.2-0.7-2.4-1-3.6c-0.4-1.2-0.8-2.4-1.2-3.4l0,0c-0.4-0.9,0-1.9,0.9-2.3
									c0.9-0.4,1.9,0,2.3,0.9c0,0.1,0.1,0.1,0.1,0.2c0.4,1.4,0.6,2.6,0.9,3.9c0.2,1.3,0.4,2.5,0.6,3.8c0.4,2.5,0.7,5.1,0.9,7.6
									c0,0.5-0.3,0.9-0.8,0.9C662.7,714.2,662.3,713.9,662.2,713.5z"
                />
              </g>
              <g>
                <path
                  d="M669.6,693c-1.4-2.8-3.1-5.5-4.8-8.3l-2.6-4.1c-0.9-1.4-1.8-2.7-2.7-4.1c-0.5-0.8-0.3-1.9,0.6-2.4
									c0.8-0.5,1.9-0.3,2.4,0.6c0,0,0,0.1,0.1,0.1l0,0c0.7,1.3,1.5,2.8,2.3,4.2l2.3,4.3c1.5,2.9,3.1,5.7,4.3,8.8
									c0.2,0.5,0,1.2-0.6,1.4C670.5,693.8,669.9,693.6,669.6,693L669.6,693z"
                />
              </g>
              <g>
                <path
                  d="M668.8,726.3c0.1-0.4,0.1-1,0.1-1.6c0-0.6,0-1.1,0-1.7c0-1.1-0.1-2.3-0.2-3.4c-0.1-1,0.6-1.8,1.6-1.9
									c1-0.1,1.8,0.6,1.9,1.6c0,0.1,0,0.3,0,0.4c-0.2,1.2-0.4,2.3-0.7,3.5c-0.1,0.6-0.3,1.2-0.4,1.7c-0.2,0.6-0.3,1.2-0.6,1.8
									c-0.2,0.4-0.7,0.7-1.1,0.5c-0.4-0.2-0.6-0.5-0.5-0.9L668.8,726.3z"
                />
              </g>
              <g>
                <path
                  d="M733.1,719.3c-0.2-1.6-0.5-3.1-0.8-4.6c-0.4-1.5-0.8-3-1.4-4.3c-0.3-0.6,0-1.2,0.5-1.5c0.6-0.3,1.2,0,1.5,0.5
									c0,0,0,0.1,0,0.1c0.6,1.6,0.9,3.2,1.2,4.8c0.2,1.6,0.4,3.2,0.5,4.8c0,0.4-0.3,0.8-0.7,0.8C733.5,719.9,733.2,719.6,733.1,719.3
									z"
                />
              </g>
              <g>
                <path
                  d="M697.9,725c0.1-1.1,0-2.3,0-3.5l-0.1-1.9c0-0.6,0-1.3,0.1-2c0.1-0.6,0.6-1.1,1.2-1c0.6,0.1,1.1,0.6,1,1.2
									c0,0,0,0.1,0,0.1l0,0c-0.1,0.5-0.1,1.1-0.2,1.7l-0.1,1.8l-0.1,1.9c0,0.6-0.1,1.3-0.2,1.9c-0.1,0.5-0.5,0.8-1,0.7
									C698.1,725.9,697.8,725.5,697.9,725L697.9,725z"
                />
              </g>
              <g>
                <path
                  d="M691.6,726.3l-0.6-12c0-0.6,0.4-1.1,1-1.2s1.1,0.4,1.2,1c0,0,0,0,0,0.1l0,0l-0.1,12c0,0.4-0.3,0.7-0.7,0.7
									C692,727,691.6,726.7,691.6,726.3L691.6,726.3z"
                />
              </g>
              <g>
                <path
                  d="M742.1,712.4c-0.1-1.8-0.4-3.7-0.8-5.5c-0.4-1.8-1-3.5-1.8-5.1l0,0c-0.3-0.6-0.1-1.4,0.6-1.7c0.6-0.3,1.4-0.1,1.7,0.6
									c0,0,0,0.1,0.1,0.1c0.7,1.9,1,3.8,1.2,5.8c0.2,1.9,0.3,3.9,0.2,5.8c0,0.3-0.3,0.6-0.6,0.5C742.4,712.9,742.1,712.7,742.1,712.4
									z"
                />
              </g>
              <g>
                <path
                  d="M720.7,706.1c0.5-3.2,0.9-6.5,0.7-9.6c0-0.7,0.5-1.3,1.2-1.4c0.7,0,1.3,0.5,1.4,1.2c0,0,0,0.1,0,0.1l0,0
									c-0.2,3.4-0.9,6.7-1.7,9.9c-0.1,0.4-0.5,0.7-1,0.6C720.8,706.9,720.6,706.5,720.7,706.1z"
                />
              </g>
              <g>
                <path
                  d="M695.9,708.2c-0.6-2.2-1.2-4.4-1.7-6.6c-0.3-1.1-0.5-2.2-0.8-3.4c-0.2-1.2-0.5-2.3-0.5-3.6c0-0.8,0.6-1.5,1.4-1.6
									c0.8,0,1.5,0.6,1.6,1.4c0,0,0,0.1,0,0.1l0,0c0,0.9,0.1,2.1,0.2,3.2c0.1,1.1,0.3,2.2,0.5,3.3c0.4,2.2,0.8,4.5,1.2,6.7
									c0.1,0.5-0.2,1-0.7,1.1C696.4,708.9,696,708.6,695.9,708.2z"
                />
              </g>
              <g>
                <path
                  d="M708,697.2c0-1,0-2.1,0-3.2c0-1.1-0.1-2.2-0.1-3.3l-0.2-3.3c-0.1-1.1-0.1-2.2-0.3-3.2l0-0.1c-0.1-0.7,0.4-1.4,1.1-1.5
									c0.7-0.1,1.4,0.4,1.5,1.1c0,0,0,0,0,0.1c0.1,1.2,0.1,2.3,0.1,3.4l0,3.3c0,1.1,0,2.2-0.1,3.3c0,1.1-0.1,2.2-0.2,3.4
									c-0.1,0.5-0.5,0.9-1.1,0.9C708.4,698.2,708,697.7,708,697.2L708,697.2z"
                />
              </g>
              <g>
                <path
                  d="M719,687.7c-0.1-0.5-0.2-1.2-0.4-1.8l-0.5-1.8l-1.1-3.7c-0.2-0.7,0.2-1.4,0.9-1.6c0.7-0.2,1.4,0.2,1.6,0.9
									c0,0.1,0,0.1,0,0.2l0,0.1l0.5,3.8l0.2,1.9c0.1,0.7,0.1,1.3,0.1,2.1c0,0.4-0.3,0.7-0.7,0.7C719.3,688.4,719.1,688.2,719,687.7
									L719,687.7z"
                />
              </g>
              <g>
                <path
                  d="M731.5,698.6c0.3-2.3,0.6-4.6,0.7-6.9c0.1-1.2,0.1-2.3,0.1-3.4c0-1.1,0-2.3-0.2-3.3l0,0c-0.1-0.7,0.4-1.4,1.1-1.5
									c0.7-0.1,1.4,0.4,1.5,1.1c0,0,0,0.1,0,0.1c0.1,1.3,0,2.5-0.1,3.7c-0.1,1.2-0.3,2.4-0.4,3.6c-0.3,2.3-0.8,4.7-1.3,7
									c-0.1,0.4-0.5,0.6-0.9,0.6C731.6,699.3,731.4,699,731.5,698.6L731.5,698.6z"
                />
              </g>
              <g>
                <path
                  d="M742.9,686.7c-0.1-2-0.5-4-0.9-6c-0.4-2-1-4-1.6-5.8l0,0c-0.2-0.6,0.1-1.3,0.7-1.5c0.6-0.2,1.3,0.1,1.5,0.7
									c0,0,0,0.1,0,0.1c0.6,2.1,1,4.2,1.3,6.2c0.3,2.1,0.6,4.2,0.5,6.4c0,0.4-0.4,0.8-0.8,0.8C743.2,687.5,742.9,687.2,742.9,686.7
									L742.9,686.7z"
                />
              </g>
              <g>
                <path
                  d="M729.6,673.1c-0.3-2.1-1-4.2-1.8-6.2c-0.4-1-0.9-2-1.3-3c-0.5-1-1-1.9-1.6-2.8l0,0c-0.4-0.6-0.2-1.3,0.3-1.7
									s1.3-0.2,1.7,0.3c0,0,0,0.1,0.1,0.1c0.6,1.1,1,2.1,1.5,3.1c0.4,1.1,0.8,2.1,1.2,3.2c0.7,2.2,1.2,4.4,1.4,6.7
									c0,0.4-0.3,0.7-0.6,0.7C729.9,673.7,729.6,673.5,729.6,673.1L729.6,673.1z"
                />
              </g>
              <g>
                <path
                  d="M699.2,684.2c-0.3-1.7-0.6-3.4-0.9-5.1c-0.1-0.9-0.2-1.7-0.3-2.6c0-0.9-0.1-1.8,0.1-2.9c0.1-0.7,0.8-1.2,1.5-1.1
									s1.2,0.8,1.1,1.5c0,0,0,0.1,0,0.1l0,0.1c-0.1,0.5-0.2,1.4-0.2,2.2c0,0.8,0,1.6,0.1,2.4c0.1,1.6,0.3,3.3,0.5,4.9l0,0
									c0.1,0.6-0.3,1.1-0.9,1.2C699.8,685.1,699.3,684.8,699.2,684.2z"
                />
              </g>
              <g>
                <path
                  d="M688.6,678.5c-0.5-0.8-0.9-1.6-1.3-2.4c-0.4-0.8-0.7-1.6-1.1-2.4c-0.3-0.8-0.7-1.6-1-2.4c-0.3-0.8-0.6-1.6-0.8-2.7
									c-0.2-0.8,0.3-1.5,1.1-1.7c0.8-0.2,1.5,0.3,1.7,1.1c0,0,0,0.1,0,0.1l0,0.1c0.1,0.6,0.3,1.5,0.5,2.2c0.2,0.8,0.5,1.6,0.7,2.4
									c0.3,0.8,0.6,1.6,0.9,2.4c0.3,0.8,0.6,1.5,1,2.2l0,0c0.3,0.5,0.1,1.1-0.4,1.4C689.4,679.1,688.9,678.9,688.6,678.5z"
                />
              </g>
              <g>
                <path
                  d="M709.3,666.7c-0.1-1.2-0.3-2.5-0.5-3.8c-0.2-1.3-0.5-2.5-0.9-3.8c-0.3-1.2-0.7-2.5-1.2-3.6c-0.5-1.1-1.1-2.3-1.7-3l0,0
									c-0.5-0.6-0.5-1.5,0.1-2.1c0.6-0.5,1.5-0.5,2.1,0.1c0,0,0.1,0.1,0.1,0.1c1,1.3,1.5,2.6,2,4c0.5,1.3,0.8,2.7,1.1,4
									c0.3,1.3,0.5,2.7,0.7,4c0.2,1.4,0.3,2.7,0.3,4.1c0,0.5-0.4,0.9-0.9,0.9C709.7,667.6,709.3,667.2,709.3,666.7L709.3,666.7z"
                />
              </g>
              <g>
                <path
                  d="M694.6,662c-0.5-1-1.1-2-1.7-3l-1.8-3c-0.6-1-1.2-2.1-1.7-3.2c-0.5-1.1-1-2.3-1.1-3.9c0-0.7,0.5-1.4,1.3-1.4
									s1.4,0.5,1.4,1.3c0,0,0,0.1,0,0.1l0,0.1c0,0.8,0.3,1.9,0.7,2.9c0.4,1,0.9,2.1,1.4,3.1l1.6,3.1c0.5,1.1,1.1,2.1,1.6,3.3
									c0.2,0.5,0,1.1-0.5,1.3C695.4,662.7,694.9,662.4,694.6,662L694.6,662z"
                />
              </g>
              <g>
                <path
                  d="M738,656.2c-0.7-1.8-1.9-3.5-3-5.2c-0.6-0.8-1.2-1.6-1.9-2.4c-0.3-0.4-0.7-0.7-1-1.1c-0.2-0.2-0.3-0.3-0.5-0.4
									l-0.2-0.2c-0.1,0-0.1,0-0.1-0.1l-0.3-0.3c-0.6-0.5-0.6-1.3-0.2-1.9c0.4-0.5,1.2-0.6,1.7-0.3c0.2,0.1,0.4,0.2,0.5,0.4l0.4,0.3
									c0.2,0.2,0.4,0.4,0.6,0.7c0.4,0.4,0.7,0.9,1,1.3c0.6,0.9,1.2,1.8,1.8,2.7c1.1,1.9,2.1,3.7,2.7,5.9c0.1,0.4-0.1,0.8-0.5,1
									C738.6,656.8,738.2,656.6,738,656.2L738,656.2z"
                />
              </g>
              <g>
                <path
                  d="M717.8,644.5c-0.1-0.7-0.3-1.7-0.6-2.5c-0.3-0.9-0.6-1.7-1-2.6c-0.4-0.9-0.8-1.7-1.2-2.5c-0.4-0.8-0.9-1.7-1.3-2.3l0,0
									c-0.5-0.7-0.3-1.6,0.4-2s1.6-0.3,2,0.4c0,0,0.1,0.1,0.1,0.1c0.6,1,0.9,1.9,1.3,2.8c0.4,0.9,0.7,1.8,1,2.8
									c0.3,0.9,0.6,1.9,0.9,2.9c0.2,1,0.5,2,0.5,3.1c0,0.5-0.4,1-1,1C718.2,645.4,717.8,645.1,717.8,644.5L717.8,644.5z"
                />
              </g>
              <g>
                <path
                  d="M693.7,637.7c-0.7-1.3-1.8-2.6-2.8-4c-0.5-0.7-1-1.4-1.5-2.1c-0.5-0.8-1-1.6-1.3-2.6l0,0c-0.3-0.9,0.2-1.8,1-2.1
									s1.8,0.2,2.1,1c0,0.1,0.1,0.2,0.1,0.3c0.1,0.6,0.4,1.3,0.7,2c0.3,0.7,0.7,1.4,1.1,2.2l1.2,2.2c0.4,0.8,0.8,1.6,1.1,2.5
									c0.2,0.5-0.1,1-0.6,1.2C694.4,638.4,693.9,638.2,693.7,637.7L693.7,637.7z"
                />
              </g>
              <g>
                <path
                  d="M680.7,647.5c-0.9-1.5-1.9-2.9-2.9-4.4c-0.5-0.8-0.9-1.5-1.4-2.3c-0.4-0.8-0.9-1.6-1.1-2.8c-0.1-0.6,0.3-1.3,0.9-1.4
									c0.6-0.1,1.3,0.3,1.4,0.9c0,0,0,0.1,0,0.1l0,0.1c0.1,0.5,0.4,1.4,0.7,2.1c0.3,0.8,0.7,1.5,1.1,2.3c0.8,1.5,1.7,3,2.5,4.6
									c0.2,0.4,0,0.8-0.3,1C681.4,648,680.9,647.9,680.7,647.5L680.7,647.5z"
                />
              </g>
              <g>
                <path
                  d="M668.8,625.2c-0.8-0.8-1.4-1.6-2.1-2.4c-0.7-0.8-1.3-1.7-1.9-2.5c-0.6-0.9-1.2-1.7-1.8-2.6c-0.3-0.5-0.6-0.9-0.9-1.4
									c-0.3-0.5-0.5-1-0.8-1.8c-0.3-0.9,0.3-1.9,1.2-2.2c0.9-0.3,1.9,0.3,2.2,1.2c0,0.1,0,0.2,0.1,0.2c0,0.2,0.2,0.7,0.4,1.1
									c0.2,0.4,0.4,0.9,0.6,1.3c0.4,0.9,0.9,1.8,1.4,2.7c0.5,0.9,1,1.8,1.6,2.6c0.5,0.9,1.1,1.7,1.7,2.5l0,0c0.4,0.5,0.3,1.2-0.2,1.5
									C669.8,625.6,669.2,625.6,668.8,625.2z"
                />
              </g>
              <g>
                <path
                  d="M673.3,613.4c-0.4-0.9-1-1.8-1.6-2.6l-1.8-2.7c-0.6-0.9-1.2-1.8-1.8-2.8c-0.3-0.5-0.6-1-0.8-1.6
									c-0.3-0.6-0.5-1.2-0.6-2l0,0c-0.2-1,0.5-1.9,1.4-2c1-0.2,1.9,0.5,2,1.4c0,0.1,0,0.2,0,0.3c0,0.5,0.4,1.6,0.8,2.5
									c0.4,0.9,0.9,1.9,1.4,2.8l1.5,2.9c0.5,1,1,2,1.4,3.1c0.2,0.5-0.1,1.1-0.6,1.3C674.1,614.1,673.6,613.8,673.3,613.4L673.3,613.4
									z"
                />
              </g>
              <g>
                <path
                  d="M691.1,609.7l-3.1-7c-0.4-0.9,0-1.9,0.9-2.3c0.9-0.4,1.9,0,2.3,0.9c0,0.1,0.1,0.2,0.1,0.3l0,0.2l1.8,7.2l0,0.1
									c0.2,0.6-0.2,1.2-0.8,1.4C691.8,610.5,691.3,610.2,691.1,609.7z"
                />
              </g>
              <g>
                <path
                  d="M711.1,616.2c-0.3-1-0.8-2.1-1.2-3.1c-0.5-1.1-0.9-2.1-1.4-3.2l-2.9-6.3c-0.4-0.8,0-1.8,0.8-2.1s1.8,0,2.1,0.8
									c0,0,0,0.1,0,0.1l0,0l2.5,6.5c0.4,1.1,0.8,2.2,1.2,3.3c0.4,1.1,0.8,2.2,1.1,3.4c0.2,0.6-0.2,1.2-0.8,1.4
									C711.8,617.1,711.3,616.8,711.1,616.2L711.1,616.2z"
                />
              </g>
              <g>
                <path
                  d="M724.4,630.5c-0.2-0.6-0.5-1.3-0.8-2c-0.4-0.7-0.7-1.3-1.1-2c-0.4-0.7-0.8-1.3-1.2-2c-0.4-0.7-0.8-1.3-1.3-2.1
									c-0.4-0.7-0.2-1.7,0.5-2.1s1.7-0.2,2.1,0.5c0,0,0.1,0.1,0.1,0.2l0,0c0.3,0.6,0.7,1.4,1,2.1c0.4,0.7,0.7,1.4,1,2.2
									c0.3,0.7,0.7,1.5,1,2.3c0.3,0.8,0.6,1.6,0.7,2.5c0.1,0.5-0.3,1.1-0.8,1.2C725,631.4,724.5,631,724.4,630.5L724.4,630.5z"
                />
              </g>
              <g>
                <path
                  d="M738.7,638.7c-0.8-1.7-1.7-3.3-2.7-4.8l0,0c-0.4-0.6-0.2-1.4,0.3-1.7c0.6-0.4,1.4-0.2,1.7,0.3c0,0,0.1,0.1,0.1,0.1
									c0.9,1.8,1.6,3.6,2.2,5.5c0.2,0.5-0.1,1-0.6,1.2C739.3,639.3,738.8,639.1,738.7,638.7L738.7,638.7z"
                />
              </g>
              <g>
                <path
                  d="M726.3,613.1c-0.3-0.6-0.7-1.3-1-2c-0.4-0.7-0.7-1.3-1.1-1.9c-0.4-0.6-0.8-1.3-1.2-1.9c-0.2-0.3-0.4-0.6-0.6-0.9
									c-0.2-0.3-0.5-0.6-0.5-0.6c-0.8-0.5-1-1.5-0.5-2.3c0.5-0.8,1.5-1,2.3-0.5c0.1,0.1,0.3,0.2,0.4,0.3l0.2,0.2
									c0.4,0.5,0.6,0.8,0.8,1.2c0.2,0.4,0.4,0.7,0.6,1.1c0.4,0.7,0.7,1.4,1,2.1c0.3,0.7,0.6,1.4,0.9,2.2c0.3,0.7,0.6,1.5,0.9,2.3
									c0.2,0.6-0.1,1.2-0.7,1.4C727.1,613.9,726.5,613.6,726.3,613.1L726.3,613.1z"
                />
              </g>
              <g>
                <path
                  d="M712.5,597.1c-0.3-1-0.8-2.2-1.3-3.2c-0.5-1.1-1.1-2.2-1.7-3.2c-0.6-1.1-1.2-2.1-1.9-3.1c-0.6-1-1.3-2-2-2.8l0,0
									c-0.6-0.7-0.5-1.8,0.2-2.5c0.7-0.6,1.8-0.5,2.5,0.2c0,0,0.1,0.1,0.1,0.1c0.8,1.2,1.4,2.3,2,3.4c0.6,1.1,1.1,2.3,1.7,3.4
									c0.5,1.1,1,2.3,1.5,3.5c0.4,1.2,0.9,2.4,1.2,3.7c0.1,0.6-0.3,1.2-0.8,1.3C713.3,598,712.7,597.7,712.5,597.1L712.5,597.1z"
                />
              </g>
              <g>
                <path
                  d="M696,586.1c-1.1-1.5-2.2-3-3.3-4.7c-0.5-0.8-1-1.7-1.4-2.6c-0.4-0.9-0.8-1.9-0.9-3.2l0-0.1c-0.1-1,0.6-1.8,1.6-1.9
									s1.8,0.6,1.9,1.6c0,0.1,0,0.2,0,0.3c-0.1,0.5,0.1,1.4,0.3,2.2c0.2,0.8,0.6,1.6,0.9,2.5c0.7,1.7,1.6,3.3,2.4,4.9
									c0.2,0.4,0.1,1-0.4,1.2C696.7,586.6,696.3,586.4,696,586.1z"
                />
              </g>
              <g>
                <path
                  d="M681.5,580c-0.8-1.2-1.6-2.5-2.2-3.8c-0.3-0.7-0.7-1.3-1-2c-0.3-0.7-0.6-1.4-0.8-2.3l0-0.1c-0.2-1,0.4-1.9,1.3-2.1
									c1-0.2,1.9,0.4,2.1,1.3c0,0.2,0.1,0.3,0,0.5c0,0.5,0.1,1.2,0.2,1.9c0.1,0.7,0.3,1.4,0.4,2c0.3,1.4,0.7,2.7,1.2,4.1l0,0
									c0.1,0.4-0.1,0.8-0.4,0.9C682,580.4,681.7,580.3,681.5,580z"
                />
              </g>
              <g>
                <path
                  d="M653.4,594.7c-0.5-1-1.1-2.1-1.6-3.2c-0.3-0.6-0.5-1.1-0.7-1.7c-0.2-0.6-0.4-1.2-0.5-2.1l0-0.1
									c-0.1-0.8,0.5-1.5,1.4-1.6c0.8-0.1,1.5,0.5,1.6,1.4c0,0.1,0,0.2,0,0.3c0,0.3,0,0.9,0.1,1.4c0.1,0.5,0.2,1.1,0.4,1.6
									c0.3,1.1,0.7,2.2,1.1,3.3c0.2,0.5-0.1,1-0.6,1.1C654.1,595.3,653.6,595.1,653.4,594.7L653.4,594.7z"
                />
              </g>
              <g>
                <path
                  d="M662.6,581.9c-0.6-2.3-1.3-4.6-1.8-7c-0.5-2.4-0.9-4.8-1-7.4c0-1,0.8-1.8,1.7-1.8c1,0,1.8,0.8,1.8,1.7
									c0,0.1,0,0.1,0,0.2l0,0c-0.2,2.2-0.1,4.5,0.1,6.8c0.2,2.3,0.6,4.7,1,7.1c0.1,0.5-0.3,1-0.8,1.1
									C663.2,582.6,662.8,582.3,662.6,581.9L662.6,581.9z"
                />
              </g>
              <g>
                <path
                  d="M704.5,572.2c-1.9-1.6-3.9-3.2-5.8-5c-0.9-0.9-1.9-1.8-2.8-2.7c-0.5-0.5-0.9-1-1.3-1.5c-0.2-0.3-0.4-0.6-0.6-0.9
									c-0.2-0.3-0.4-0.8-0.6-1.2c-0.4-0.9,0.1-1.9,1-2.3s1.9,0.1,2.3,1c0,0.1,0.1,0.2,0.1,0.3l0,0c0,0.2,0.3,0.7,0.5,1.2
									c0.3,0.5,0.6,1,1,1.5c0.7,1,1.5,1.9,2.3,2.9c0.8,0.9,1.6,1.9,2.5,2.8l2.6,2.8c0.3,0.3,0.3,0.8,0,1.1
									C705.3,572.5,704.8,572.5,704.5,572.2L704.5,572.2z"
                />
              </g>
              <g>
                <path
                  d="M574.3,772.4c0,0.5,0,0.8,0,1.1c0,0.3-0.1,0.6-0.1,1c-0.1,0.6-0.2,1.2-0.3,1.8c-0.1,0.5-0.5,0.8-1,0.7
									c-0.4-0.1-0.7-0.5-0.7-0.9l0,0c0-0.6,0-1.2,0-1.8c0-0.3,0-0.6-0.1-0.9c0-0.3-0.1-0.6-0.1-0.7c-0.2-0.6,0.1-1.3,0.7-1.5
									c0.6-0.2,1.3,0.1,1.5,0.7c0,0.1,0.1,0.2,0.1,0.3L574.3,772.4z"
                />
              </g>
              <g>
                <path
                  d="M587.4,773c-0.1,0.5-0.1,1-0.1,1.5c0,0.3,0.1,0.5,0.1,0.8c0,0.3,0.1,0.6,0.1,1c0,0.4-0.3,0.7-0.8,0.7
									c-0.4,0-0.7-0.3-0.7-0.6l0-0.1c0-0.1-0.1-0.4-0.2-0.7c-0.1-0.3-0.2-0.6-0.2-0.9c-0.1-0.6-0.2-1.3-0.2-1.9l0,0
									c0-0.5,0.5-1,1-0.9s1,0.5,0.9,1C587.4,772.9,587.4,773,587.4,773z"
                />
              </g>
              <g>
                <path
                  d="M603.7,773.4c0.2,1.1,0.1,2,0,2.9c-0.1,0.4-0.4,0.7-0.8,0.6c-0.3,0-0.6-0.3-0.6-0.6c-0.1-0.8-0.3-1.6-0.6-2.2
									c-0.3-0.5-0.1-1.2,0.4-1.5s1.2-0.1,1.5,0.4C603.6,773.1,603.6,773.2,603.7,773.4L603.7,773.4z"
                />
              </g>
              <g>
                <path
                  d="M614.6,774l-0.2,1.5c0,0.3-0.1,0.5-0.1,0.8c-0.1,0.3-0.1,0.6-0.4,0.9c-0.2,0.2-0.5,0.3-0.7,0.2
									c-0.2-0.1-0.3-0.3-0.2-0.5l0-0.2c0-0.1,0-0.3,0-0.5c0-0.2,0-0.5,0-0.7l-0.2-1.5c-0.1-0.5,0.3-0.9,0.8-1s0.9,0.3,1,0.8
									C614.6,773.9,614.6,774,614.6,774L614.6,774z"
                />
              </g>
              <g>
                <path
                  d="M619.9,773.9c0,0-0.1,0.3-0.2,0.5c0,0.3-0.1,0.5-0.1,0.8c0,0.6,0,1.1,0,1.7l0,0c0,0.3-0.2,0.5-0.5,0.5
									c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.6-0.3-1.2-0.5-1.8c-0.1-0.3-0.1-0.6-0.2-0.9c0-0.3-0.1-0.7,0.1-1.2c0.2-0.5,0.7-0.7,1.2-0.5
									C619.9,772.9,620.1,773.5,619.9,773.9z"
                />
              </g>
              <g>
                <path
                  d="M749,700.4c0.1,1.5,0,2.9,0,4.3c0,1.4,0,2.8,0.2,4.2l0,0c0,0.4-0.2,0.7-0.6,0.7c-0.3,0-0.6-0.2-0.7-0.5
									c-0.3-1.5-0.4-2.9-0.5-4.3c-0.1-1.4-0.2-2.8-0.3-4.2l0,0c-0.1-0.5,0.3-1,0.8-1C748.5,699.5,748.9,699.8,749,700.4
									C749,700.4,749,700.4,749,700.4z"
                />
              </g>
              <g>
                <path
                  d="M752.8,688.6c0,0.4,0,0.8,0,1.3c0,0.5,0.1,0.9,0.2,1.4c0.1,0.5,0.2,0.9,0.3,1.4c0.1,0.5,0.3,1,0.4,1.3l0,0.1
									c0.1,0.3,0,0.7-0.3,0.8c-0.2,0.1-0.5,0-0.7-0.2c-0.4-0.5-0.7-0.9-1-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.2-0.5-0.5-0.9-0.7-1.5
									c-0.2-0.5-0.4-1-0.5-1.7l0-0.1c-0.2-0.8,0.3-1.6,1.2-1.8c0.8-0.2,1.6,0.3,1.8,1.2C752.8,688.3,752.8,688.5,752.8,688.6z"
                />
              </g>
              <g>
                <path
                  d="M751.1,659.5c0.1,0.5,0.4,1.1,0.6,1.7c0.3,0.6,0.6,1.2,0.9,1.8c0.6,1.2,1.4,2.4,2.1,3.5l0,0c0.2,0.3,0.1,0.7-0.2,0.9
									c-0.3,0.2-0.6,0.1-0.8-0.1c-1-1-1.9-2.1-2.7-3.2c-0.4-0.6-0.9-1.1-1.3-1.8c-0.4-0.6-0.8-1.3-1.1-2l0,0
									c-0.3-0.7,0.1-1.4,0.7-1.7c0.7-0.3,1.4,0.1,1.7,0.7C751.1,659.4,751.1,659.5,751.1,659.5z"
                />
              </g>
              <g>
                <path
                  d="M734.2,604.2c0.3,0.5,0.6,1.2,1,1.7c0.4,0.6,0.8,1.2,1.2,1.7c0.4,0.6,0.9,1.1,1.3,1.6c0.5,0.5,1,1,1.4,1.3l0.1,0
									c0.3,0.2,0.5,0.7,0.2,1c-0.2,0.3-0.6,0.4-0.9,0.3c-0.9-0.3-1.5-0.8-2.1-1.2c-0.6-0.5-1.2-1-1.8-1.5c-0.6-0.5-1.1-1-1.6-1.6
									c-0.5-0.6-1-1.1-1.6-1.8l0,0c-0.5-0.7-0.4-1.7,0.3-2.2c0.7-0.5,1.7-0.4,2.2,0.3C734.1,604,734.2,604.1,734.2,604.2z"
                />
              </g>
              <g>
                <path
                  d="M716.8,574.7c0.5,1,0.8,1.9,1.2,2.8l1.2,2.7l1.2,2.7c0.4,0.9,0.8,1.9,1.2,2.5l0.1,0.1c0.2,0.4,0.1,0.9-0.3,1.1
									c-0.3,0.2-0.8,0.1-1-0.2c-0.4-0.5-0.7-0.9-1-1.3l-0.8-1.3l-1.6-2.5l-1.6-2.5c-0.5-0.8-1.1-1.7-1.6-2.4l0,0
									c-0.5-0.8-0.3-1.9,0.5-2.4c0.8-0.5,1.9-0.3,2.4,0.5C716.7,574.5,716.8,574.6,716.8,574.7z"
                />
              </g>
              <g>
                <path
                  d="M467,646.1c-0.9,2.4-2,4.5-3.1,6.7c-0.6,1.1-1.1,2.2-1.7,3.2c-0.6,1.1-1.2,2.1-1.9,3.2c-0.3,0.5-1,0.6-1.4,0.3
									c-0.5-0.3-0.6-1-0.3-1.4l0,0l0,0c0.6-0.9,1.2-2,1.8-3c0.6-1,1.1-2.1,1.7-3.2c1.1-2.1,2.2-4.3,3-6.5l0,0
									c0.2-0.5,0.8-0.8,1.3-0.6S467.2,645.6,467,646.1z"
                />
              </g>
              <g>
                <path
                  d="M481.6,612.6c-1.1,1.6-2.4,3.2-3.7,4.7c-0.6,0.7-1.3,1.5-2,2.2c-0.7,0.7-1.3,1.4-2.2,2.1c-0.3,0.3-0.8,0.2-1.1-0.1
									c-0.2-0.3-0.2-0.8,0.1-1l0,0c0.6-0.5,1.3-1.3,1.9-2c0.6-0.7,1.2-1.5,1.8-2.3c1.1-1.5,2.2-3.1,3.2-4.7l0,0
									c0.3-0.6,1-0.7,1.6-0.4C481.8,611.2,481.9,612,481.6,612.6C481.6,612.5,481.6,612.6,481.6,612.6z"
                />
              </g>
              <g>
                <path
                  d="M503.6,634c-1.1,1.8-2.1,3.7-3,5.6c-0.5,0.9-0.9,1.9-1.4,2.9c-0.4,0.9-0.9,2-1,2.8l0,0.1c-0.1,0.5-0.6,0.8-1.1,0.7
									c-0.4-0.1-0.7-0.5-0.7-1c0.1-1.3,0.4-2.3,0.7-3.4c0.3-1.1,0.7-2.1,1-3.1c0.7-2.1,1.5-4.1,2.3-6.1c0.4-0.9,1.4-1.3,2.3-0.9
									c0.9,0.4,1.3,1.4,0.9,2.3C503.6,633.8,503.6,633.9,503.6,634z"
                />
              </g>
              <g>
                <path
                  d="M488,660.9c-0.7,2.3-1.4,4.7-2.1,7.1c-0.3,1.2-0.6,2.4-0.9,3.6c-0.3,1.2-0.5,2.4-0.7,3.5l0,0c-0.1,0.6-0.6,0.9-1.1,0.9
									c-0.5-0.1-0.9-0.5-0.9-1c0-1.3,0.2-2.6,0.3-3.8c0.2-1.2,0.4-2.5,0.6-3.7c0.4-2.5,0.8-4.9,1.4-7.4c0.2-0.9,1.1-1.6,2.1-1.4
									c0.9,0.2,1.6,1.1,1.4,2.1C488,660.8,488,660.9,488,660.9L488,660.9z"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="nose">
          <g id="nose-fill">
            <path
              class="st3"
              d="M641,439.3l-1.4-1.5c-9-7.3-17.8-10.3-32.5-6.6c-14.7,3.7-28.2,12.4-33.5,22l6.1-0.8c0,0,0,0-0.1,0
							c0,0,1,1.1,3.2,1.1s26.2-4.2,34.5-5.5c8.3-1.3,21.2-1.1,25.2-0.5c4.1,0.7,16.7,1.5,16.7,1.5C656.5,444.1,649.2,441,641,439.3z"
            />
          </g>
          <g id="nose-shadow">
            <path
              class="st7"
              d="M634.8,446.7c-9.8-0.7-16-1-18.2-2.6c-2.3-1.6-5.5-3.9-11.1-3.3s-13-2-10.7-3.6l-4.2-0.7
							c0,0-16.3,11.2-16.6,17.4c0,0,17.4-1.7,25.1-3.2C605.9,449.5,634.8,446.7,634.8,446.7z"
            />
          </g>
          <g id="nose-lines">
            <path
              d="M638.8,439.6c-4.8-3.8-10.2-7-16.1-7.8c-5.9-0.9-12.1,0.1-18,1.8c-5.9,1.7-11.7,4.3-16.9,7.6c-2.6,1.7-5.1,3.5-7.3,5.6
							c-2.2,2.1-4.2,4.4-5.7,7l0,0c-0.4,0.6-1.1,0.8-1.8,0.5c-0.6-0.3-0.8-1.1-0.5-1.7c3.2-5.9,8.3-10.3,13.7-13.9
							c5.4-3.6,11.4-6.3,17.6-8.2c6.2-1.9,12.8-3.1,19.5-2c3.3,0.5,6.6,1.6,9.5,3.1c3,1.5,5.6,3.5,8.2,5.5c0.7,0.6,0.8,1.6,0.2,2.3
							C640.5,440.1,639.5,440.2,638.8,439.6L638.8,439.6z"
            />
            <path
              d="M578.5,451.2c3-2.6,6.2-4.3,9.5-6c3.3-1.6,6.7-3,10.1-4.1c6.9-2.3,13.9-4.2,21.3-4.9c3.7-0.3,7.3-0.1,11,0.2
							c3.6,0.3,7.2,0.8,10.8,1.6c3.6,0.8,7.1,1.8,10.5,3.3c3.3,1.5,6.6,3.8,8.7,7.1c0.3,0.5,0.2,1.2-0.4,1.5c-0.5,0.3-1.2,0.2-1.5-0.3
							l0-0.1c-1.8-2.7-4.7-4.7-7.8-6c-3.2-1.4-6.6-2.3-10-3c-3.4-0.7-7-1.1-10.5-1.3c-3.5-0.2-7.1-0.3-10.5,0
							c-6.9,0.7-13.8,2.6-20.5,4.9c-3.3,1.2-6.6,2.5-9.7,4.1c-3.1,1.5-6.2,3.3-8.7,5.4l-0.1,0.1c-0.7,0.6-1.7,0.5-2.3-0.1
							S577.8,451.8,578.5,451.2L578.5,451.2z"
            />
            <path
              d="M662.1,497.4c8.5,0.8,17,1.7,25.4,1.3c4.2-0.2,8.4-0.6,12.4-1.6c4-1,7.8-2.6,10.7-5.2c5.9-5.1,6.2-14.7,3-21.8
							c-1.6-3.6-4.4-6.7-7.7-9c-3.3-2.4-7.1-4.1-11-5.5c-3.9-1.4-8-2.3-12.1-3c-4.1-0.7-8.3-1.2-12.5-1.5c-2.1-0.1-4.2-0.2-6.3-0.2
							l-3.2,0c-1.1,0-2.2-0.1-3.3-0.1c-4.4-0.4-8.6-0.9-12.8-1.3c-8.4-0.7-16.8-0.6-25.2,0.3c-8.4,0.8-16.8,2.3-25.2,3.8
							c-2.1,0.4-4.2,0.7-6.4,1c-1.1,0.1-2.2,0.3-3.3,0.4c-0.5,0.1-1.1,0.1-1.7,0.1l-1.5,0.1c-2,0.2-4.1,0.5-6.2,0.8l-6.4,0.9
							c-8.5,1.1-17.1,1.9-25.7,2c-8.4,0.1-16.9,0.9-24.7,3.6c-3.9,1.4-7.6,3.2-10.7,5.7c-3.1,2.5-5.4,5.9-6.5,9.7
							c-0.6,1.9-0.8,3.9-0.8,5.9c0,2,0.2,4,0.8,5.8c0.6,1.8,1.5,3.5,2.8,5c1.2,1.5,2.8,2.8,4.5,3.8c3.4,2.2,7.3,3.5,11.4,4.4
							c4.1,0.9,8.2,1.4,12.4,1.7c8.4,0.5,16.9,0.1,25.3-0.8c4.2-0.4,8.4-1.1,12.6-1.8c2.1-0.4,4.2-0.8,6.2-1.2c2.1-0.5,4.1-0.9,6.1-1.6
							l0,0c0.5-0.2,1,0.1,1.1,0.6c0.2,0.4-0.1,0.9-0.5,1.1c-2.1,0.8-4.1,1.3-6.2,1.9c-2.1,0.5-4.2,1-6.3,1.4c-4.2,0.9-8.5,1.6-12.7,2.1
							c-8.5,1.1-17.1,1.7-25.8,1.3c-4.3-0.2-8.7-0.7-13-1.6c-4.3-1-8.5-2.4-12.4-4.8c-1.9-1.2-3.7-2.7-5.2-4.5
							c-1.5-1.8-2.6-3.9-3.4-6.1c-0.7-2.2-1-4.6-1-6.8c0-2.3,0.3-4.5,0.9-6.8c1.2-4.4,4-8.4,7.5-11.3c3.5-2.9,7.6-4.9,11.7-6.4
							c8.4-2.8,17.1-3.7,25.8-3.8c8.4-0.1,16.9-0.8,25.3-2l6.3-0.9c2.1-0.3,4.2-0.7,6.5-0.9l1.7-0.1c0.5,0,1,0,1.5-0.1
							c1-0.1,2-0.2,3.1-0.4c2.1-0.3,4.2-0.7,6.3-1c8.4-1.5,16.9-3.1,25.4-4c4.3-0.4,8.6-0.8,13-0.8c4.3,0,8.7,0.2,13,0.8
							c4.3,0.5,8.5,1.3,12.7,1.7c1,0.1,2.1,0.2,3.1,0.2c1,0,2.1,0,3.2,0c2.2,0,4.3,0,6.5,0.1c8.6,0.3,17.3,1.4,25.6,4.3
							c4.1,1.4,8.2,3.3,11.8,6c3.6,2.6,6.8,6.1,8.8,10.3c1.9,4.2,2.6,8.8,2.3,13.4c-0.2,2.3-0.8,4.6-1.8,6.7c-1,2.1-2.5,4-4.3,5.6
							c-3.5,3.1-7.9,4.7-12.2,5.6c-4.3,0.9-8.7,1.2-13,1.2c-4.3,0-8.6-0.4-12.9-0.9c-4.3-0.5-8.5-1.3-12.7-2l0,0
							c-0.3,0-0.5-0.3-0.4-0.6C661.6,497.6,661.9,497.4,662.1,497.4z"
            />
            <path
              d="M606.2,521.3c0,0.7,0.9,0.9,1.2,0.3c6.9-12.7-11.6-34.8-27.1-40c-22.7-8.8-45.9-6.6-48.2,4.8
							c1.5,13.7,35.9,12.3,51.9,6.5C586.4,492,606.2,497.9,606.2,521.3z"
            />
            <path
              d="M634.7,445.7c2.5,0.9,4.1,2.8,5.1,4.7c1,1.9,1.6,4,2,6c0.7,4.1,0.6,8.1,0.4,12c-0.5,7.9-1.6,15.7-3.6,23.3
							c-0.5,1.9-1.1,3.8-1.8,5.7c-0.3,0.9-0.7,1.9-1,2.8c-0.3,0.9-0.7,1.8-1,2.7c-1.3,3.6-2.4,7.3-3.3,11c-0.9,3.7-1.8,7.5-2.4,11.3
							c-0.7,3.8-1.2,7.6-1.5,11.5l0,0c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c-0.2-3.9,0.1-7.8,0.5-11.7c0.4-3.9,1-7.8,1.8-11.6
							c0.8-3.8,1.7-7.7,2.9-11.4c0.3-0.9,0.6-1.9,0.9-2.8c0.3-0.9,0.6-1.8,0.9-2.7c0.6-1.8,1.1-3.6,1.6-5.5c1-3.7,1.7-7.5,2.4-11.2
							c0.6-3.8,1.1-7.6,1.3-11.4c0.3-3.8,0.3-7.6-0.4-11.2c-0.3-1.8-0.9-3.5-1.7-5c-0.8-1.5-2-2.6-3.2-3l0,0c-0.9-0.3-1.5-1.3-1.2-2.2
							C632.7,445.9,633.7,445.4,634.7,445.7C634.6,445.7,634.6,445.7,634.7,445.7z"
            />
            <path
              d="M562.1,471.6c-1.7-0.5-3.6-0.8-5.5-1c-1.9-0.3-3.8-0.5-5.6-0.6c-3.8-0.3-7.6-0.3-11.3,0c-3.8,0.3-7.5,1-11,2.2
							c-3.5,1.3-6.9,3.1-9.6,5.7c-0.2,0.2-0.4,0.2-0.6,0c-0.1-0.1-0.2-0.4,0-0.5c2.5-3,5.9-5.2,9.6-6.7c3.7-1.5,7.5-2.3,11.4-2.7
							c3.9-0.4,7.8-0.5,11.7-0.3c1.9,0.1,3.9,0.3,5.8,0.6c1.9,0.3,3.8,0.6,5.8,1.1c0.6,0.2,1,0.8,0.8,1.4
							C563.4,471.4,562.7,471.8,562.1,471.6L562.1,471.6L562.1,471.6z"
            />
            <path
              d="M526.6,488.3c0.4,1.6,1.4,3.1,2.7,4.3c1.3,1.2,2.9,2.1,4.5,2.9c0.2,0.1,0.2,0.2,0.2,0.4c-0.1,0.1-0.2,0.2-0.4,0.2
							c-1.8-0.6-3.5-1.4-5.1-2.5c-1.6-1.2-2.9-2.7-3.6-4.7l0,0c-0.2-0.5,0.1-1,0.5-1.2C525.9,487.5,526.4,487.8,526.6,488.3
							C526.6,488.3,526.6,488.3,526.6,488.3z"
            />
            <path
              d="M599,489.3c-1.9-2-4-3.7-6.2-5.1c-2.3-1.4-4.7-2.4-7.3-3c-0.8-0.2-1.3-1-1.1-1.8c0.2-0.8,1-1.3,1.8-1.1c0,0,0.1,0,0.1,0
							l0,0c2.8,0.9,5.5,2.2,7.8,3.9c2.4,1.7,4.4,3.7,6.2,5.9c0.3,0.4,0.3,0.9-0.1,1.2C599.8,489.6,599.3,489.6,599,489.3z"
            />
            <path
              d="M628.6,492.1c0.3-0.8,0.6-1.7,0.8-2.6c0.2-0.9,0.4-1.8,0.6-2.7c0.4-1.8,0.7-3.7,1-5.5l0,0c0.1-0.7,0.7-1.1,1.4-1
							c0.7,0.1,1.1,0.7,1,1.4c0,0,0,0,0,0.1c-0.4,1.9-0.8,3.7-1.3,5.6c-0.2,0.9-0.5,1.8-0.8,2.8c-0.3,0.9-0.6,1.8-1,2.8
							c-0.2,0.4-0.7,0.6-1.2,0.4C628.6,493.1,628.4,492.6,628.6,492.1L628.6,492.1z"
            />
            <path
              d="M632.1,472.9c0.1-2.1,0.3-4.2,0.4-6.2c0.1-2.1,0-4.1-0.2-6.1c-0.4-4-1.5-7.9-3-11.7l0,0c-0.4-0.9,0.1-1.9,1-2.3
							c0.9-0.4,1.9,0.1,2.3,1c0,0,0,0.1,0,0.1c1.3,4.1,2.2,8.4,2.4,12.7c0.1,2.2,0,4.3-0.3,6.4c-0.2,2.1-0.6,4.2-0.8,6.2
							c-0.1,0.5-0.5,0.8-1,0.8C632.4,473.8,632.1,473.4,632.1,472.9z"
            />
            <path
              d="M640.6,516.1c0,0.8-1,1-1.4,0.3c-5.2-10.1,7.2-30.9,18.2-38.7c6.7-4.8,30.9-10.5,36.1,4.1c3.3,12.9-35.4,11.5-39.6,9.2
							C652.2,491.1,640.6,498.8,640.6,516.1z"
            />
            <path
              d="M667.1,468.1c1.7-0.6,3.6-1,5.4-1.1c1.8-0.2,3.6-0.2,5.5-0.2c3.6,0.1,7.2,0.6,10.8,1.5c3.5,0.9,7.3,2.5,9.9,5.6
							c1.3,1.5,2.1,3.5,2.3,5.5c0.2,2-0.3,4-1.2,5.6c-0.1,0.2-0.4,0.3-0.5,0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0.3-1.7,0.3-3.4-0.2-4.9
							c-0.4-1.5-1.2-2.9-2.3-4c-1.1-1.2-2.4-2.1-3.8-2.9c-1.4-0.8-3-1.3-4.7-1.7c-3.3-0.9-6.8-1.5-10.2-1.8c-3.5-0.3-7-0.5-10.4,0.1
							l0,0c-0.3,0.1-0.7-0.2-0.7-0.5C666.7,468.5,666.9,468.2,667.1,468.1z"
            />
            <path
              d="M512.1,503.3c9.3,4.4,15.6,6.8,21.7,8.9c3.7,1.3,5.7,1.2,3.9,7.2c-0.1,0.4-1.6,0.8-1.2,0.7c7.3-1.9,14.4-4.5,19.1-6.5
							c4.1-1.7,9.5-4.1,11.6-4.8c2.5-0.9,13.6-5,16.3-8.2C574.6,503,541.1,510.1,512.1,503.3z"
            />
            <path
              d="M662.7,498.3c-1.7-0.1,15.8,7.8,26.2,11c0.5-1.6-2.5-8.6-0.9-8.6C688,500.7,679,500.7,662.7,498.3z"
            />
          </g>
        </g>
      </g>
      <g id="woolSweater-6068">
        <g id="woolSweater-fill">
          <g>
            <path
              class="st14"
              d="M149.3,1049.3c-6,15.1-9,24.4-9.9,30.8h600.4c-3.1-26-14.9-66.3-15.6-71.2c-0.8-5.3-3.8-22.5-5.1-25.3
							c-1.3-2.8-5.7-20.9-5.9-23.4h-0.2c0-4.2-0.4-9.9-1.3-11.6c-1.1-2.3-4.1-5.8-5.8-4.7c-1.7,1.1-1.7-1.7-1.6-3.1
							c0.2-3.2-1.5-6.4-2.8-7.6c-1.3-1.1-2.8-4.2-5.1-7.4c-2.3-3.2-3.2-1.2-3.6,0.4c-0.3,1.2-0.8,5.8-0.6,1.7c0.4-7.6-1.9-11-2.3-11.7
							c-0.4-0.8-3.5-4.8-5.1-6.2c-5.9-5.1-8.1-1.7-8.3-1c-0.1,0.6-0.4,2.4-0.4,5.4c-0.2-3.6-0.8-7.3-1.8-10.6c-1.2-4.4-6.5-4.1-8.6-3.9
							c-1.9,0.2-3.7,2.5-3.9,4.5c-0.1-1.6-0.1-2.9-0.2-3.6c-0.4-1.9-0.6-4.8-3.1-6.2c-1.7-1-4.2-1.4-8.1-1.1c-4,0.2-4.3,1.7-4.9,4.9
							l-0.2,0c0-0.4,0-0.7,0-1c0-2.3-2.8-8.3-5.6-8.4c-1.1,0-4.3-0.3-5.9-0.3c-2.1,0.1-4.4,3.8-4.4,4.7c-1.6-4.8-3-9.2-6.6-8.6
							c-2.1,0.4-4,0.8-4.7,2.7l-0.3,0.1c-1-2.3-2.3-4.3-3.8-5.5c-4.9-3.9-9,1.5-9,1.5l-0.2-0.1c1-1.8,2.2-4.5,2.8-7.8l0.3,0.1
							c5.6-1.9,7.4-8.1,8.8-16.1c0.5-2.7-0.6-5.5-2.5-8.1l0.3-0.2c3.1-6,1.9-12.7-4.1-16.7l1.1-0.3c1-1.7-1.9-7-3.6-8.9
							c-1.7-1.9-6.8-5.4-11.9-5.7c-0.7,0-1.4,0-2.2,0l0-0.4c0.4-2.3,0.5-4.2-0.7-6.2c-1.2-2-3.9-4.2-8.4-4.6c-2.1-0.2-3.8-0.2-5.2,0.1
							c0.3-1.6-1.2-3.7-3-4.6c-1.9-1-3.1-1-4.4-1c-1.1,0-2.4,0.3-4.6,1.7c1.3-2.1-0.6-4.3-2.1-5.4c-1.5-1.1-3.2-1.1-5-0.2
							c-2.2,1-2.9,2.9-3.5,4.2l2.6,10.6l7.8-9c-0.3,0.2-0.6,0.4-1,0.7c-3,2.1-11.8,20.9-1.1,22.9l0.5,0c0,3.5,1.2,7.4,5.7,8.2
							c0.2,3.7,1.7,8.3,7.1,6.6c-1.5,0.7-2.2,1.8-1.9,3.2l0.1,1.2c-0.1,0-0.1,0-0.2,0c-4.2,0.4-5.7,1.5-5.9,3.9l-0.1,0.4
							c-2-0.4-4.3-0.6-5.7-0.3c-2.5,0.5-4.9,2.2-4.4,5c-1.2-0.3-2.6-0.4-4.2-0.4c-5.1-0.2-6.9,1.6-8.5,3.3l-1,0.1
							c-2.4-1.4-4.6-1.3-6-1.5c-2.1-0.2-4.5,2.1-5.3,4l-1.3,0c-2.3-1.4-5.6-1-7.8,0.4c-2.4,1.5-2.5,3.3-3.3,5.6
							c-1.8-3.8-4.9-4.9-7.5-4.9c-4.8,0-7.3,3.7-7,7.5c0.1,0.5,0.2,1.1,0.3,1.7c-0.2-0.5-0.3-1.1-0.3-1.7c-1.7-7.2-6.7-6.6-10.3-6.6
							c0,0-4.9-0.4-6.7,5.6h0c-0.2-4.5-1.1-5.7-4.1-6.3c-2.5-0.5-4.7-1.2-7.3,2.4c-0.1,0.2-0.2,0.3-0.4,0.6l-0.1-0.1c0,0,0-0.2,0-0.5
							c-0.2-1.1-0.9-3.7-4-4.5c-3.9-1-7.1,0.7-8.6,3.5c-0.1,0.3-0.3,0.5-0.4,0.8c0.4-3.8-1.5-7-5.6-7.3c-4.3-0.3-6.1,1-7.9,4.3
							c0.9-5.9-6.9-10.4-11.6-6.7c-0.5,0.4-1,1-1.5,1.7l-0.1-0.1c1.6-3.5-3.4-7.1-7.5-7.5c-2.2-0.2-4.2,0.2-6.3,1.6l-0.2-0.6
							c-0.6-4.1-2.4-6.2-8.1-7.1c-1.4-0.2-2.9,0.2-4.6,1l-0.1-0.2c0.2-4.7-4.7-7.2-7.7-7.5c-0.3,0-0.7,0-1.1,0l0-0.5
							c-1.9-3.2-5-5.1-9-5.7l0,0c0.5-2.1-1.9-4.2-5-5.7c-0.3-1.7-1.3-4.5-4.5-7.2l0.6-0.2c0-1.5-0.9-3.7-2.1-5.8l0.1,0
							c2.8-2.4,0.2-9.5-1.3-12.3l0.4-0.2c3.6-0.8,6.5-4.8,7.5-8.6l0.2,0c1.3,0,3.8-1,5.5-2.7c1.8-1.8,2.9-5.1,3.2-8.4
							c0.3-3.3,0.3-7.3-1.4-10.9c-1.9-4.1-3.4-5.2-5.7-6.5c-0.2-0.1-0.5-0.3-0.7-0.4l7.7,6.5l2.3-8.1c-1-2.5-9.1-3-10.2,1.5
							c-7.1-3.5-14.2,1.3-13.1,3.2c-2.6-0.5-5.4-0.2-8.5,0.7c-5.2,1.6-7.4,4.8-7.9,7.5l0.1,0.6c-3.7,0.3-7.4,1.4-9.6,2.9
							c-3.7,2.4-5.5,7.7-4.2,9.2c-1.5,0.3-2.8,0.8-4,1.4c-6.6,3.2-17.1,15-10.7,27.1c-1.1,1.9-1.9,4-2.5,5.6c-1,2.7-2.3,12.8,4.2,15.8
							l0.4,0c0,1.9,0.1,3.6,0.4,4.7c0.7,2.6,2.2,4,3.5,5.3c-5.7-0.6-12.4,4-17.5,7.1c-4.9,3-12,9-14.8,12.4c-2.5,3-6.3,9-7.1,10.7
							c-0.8,1.7-3.9,7.4-3,9.7l0,0.2c-1.7,0.2-3.5,1-5.3,1.5c-3.2,0.9-7,2.6-8,3.1c-1.4,0.7-2.3,3.1-0.6,6.1c-2.3-3.2-4.2-2.5-5.7-1.9
							c-1.9,0.8-11,4.3-12.3,5c-2.2,1.2-1.8,7.3-1.8,7.3c-0.4-1-0.7-1.6-0.9-2c-1.6-2.8-4.9-2.1-6.2-1.3c-1.3,0.8-7.3,4-9.1,5.4
							c-1,0.8-1.4,6.6-1.5,6.2c-1-2.3-3.3-4.3-6.7-2.8c-3.4,1.5-13.5,9.1-15.4,10.8c-1.9,1.7-1.4,5.7-0.8,7.6l-0.1,0
							c-0.8-1.7-1.3-2.6-1.6-2.9c-1.5-1.7-4.2-1-5.7,0.3c-1.5,1.3-8.6,7.2-9.6,8.7c-1,1.5-2.1,2.7,0.9,7.1c0.6,1.1-2.6-2.9-6.5,2.4
							c-1.6,2.1-9.3,12-10,14c-0.3,0.9-0.2,1.7,0.3,2.5l-0.2,0.1C187.2,969.4,159.3,1024,149.3,1049.3z"
            />
          </g>
          <path
            d="M571.2,835.6c-0.8,2.4-5.7-1-5.7-7.1c-2.1,0.1-4.2-2.3-4.8-3c0.3,2,3.9,10.7,4.5,12.2c0.1,0.2,0.1,0.3,0.2,0.5l5.6,10.4
						l5.4-2l-0.7-2.7c0,0-4.6-0.8-4.6-7.1"
          />
        </g>
        <g id="woolSweater-shadow">
          <g>
            <path
              class="st15"
              d="M177.6,1023.9c-7.6,6.1,17.5-47.3,20-50.8c0,0,0.5,2.6,1.2,4.6C195.7,984.3,183,1012.9,177.6,1023.9z"
            />
            <path
              class="st15"
              d="M185.8,1036.3c-0.5,2.5,19-42.2,20-44c1-1.8-1-6.2-1-6.2S188.8,1022.7,185.8,1036.3z"
            />
            <path
              class="st15"
              d="M212.3,1011.7c-1.7-2-3.3-3.2-4.1-1.2c-0.8,2-7.3,15.2-10.7,35.7L212.3,1011.7z"
            />
            <path
              class="st15"
              d="M206.4,993.3c-0.5,1.7,1.9,14.9,2.4,16c0.3,0.6,4.2,0.8,6.4,4.4c1.9,3-3.6,7.6,2.8,10.3
							c2.3,1-4.7,22.8-5,28.2l1.7,0.3c0,0,4.2-12.8,4.8-14.3s1.8-6.8,1.8-6.8l-0.8-4.4c0,0-2.3-4.7-1.8-7.7S206.4,993.3,206.4,993.3z"
            />
            <path
              class="st15"
              d="M217.6,1081.7h0.4c1.7-2.7,10.6-31.3,11.6-34.3c0.1-0.2,0.2-0.3,0.3-0.4c-0.3-0.7-0.6-1.1-0.7-1.4
							c1.2,2.2,10.7,19.4,7.5-5c-1.3-0.7-7.2-1.1-9.2-4.9c-2-3.8-6.6-15.1-6.8-22.2c-0.1-3.7-0.6,10.7-0.9,12.9
							c-2.3,12.7,1.6-1.6,3.8,11.5C227.6,1062.6,215.4,1078.2,217.6,1081.7z"
            />
            <path
              class="st15"
              d="M292,1081.7c-4.2-11.3-10.4-44.2-11.1-46.3c-0.8-2.5-5.2-7-7-8c-1.8-1-3.3,1.2-3,2.7
							c0.3,1.5-4.5,12.8-5.7,14.7c-1.2,1.8-10.7,34.6-10.9,36.9c0,0,0.2,0,0.4,0.1H292z"
            />
            <path
              class="st15"
              d="M201.8,945.2c1.3,2,12.9,25.6,15.1,38.4c0,0.2,0.1,0.3,0.1,0.5c2,12.7,0.3-16.8-10.5-41.5l-1.5-0.2
							L201.8,945.2z"
            />
            <path
              class="st15"
              d="M216.5,928.2c1.8,2.7,9.2,20.5,10.3,23.5c1.2,3,5.5,20.2,7.2,25.3c0,0-1.2-15.7-2.5-22.2
							s-5.7-22.5-7.3-24.7c-1.7-2.2-3.2-3.2-4.8-3C217.7,927.3,216.5,928.2,216.5,928.2z"
            />
            <path
              class="st15"
              d="M236.5,914.2c-1.6,0.5,5,1,6,3.3s7.7,19,8.8,38c0,0-2.3-32.3-4-36.5C245.7,914.8,244.8,911.3,236.5,914.2z"
            />
            <path
              class="st15"
              d="M254,905.8c-0.2,1.9,4-0.8,5,1c1,1.8,9,26.5,9.7,29.7c0.7,3.2,3.3,11,4,13.3c0,0,0.2-1.7,0-4.7
							c-0.2-3-1.5-7.7-1.7-9.7s-3.2-11.3-3-14.1c0.2-2.8-1.7-7.7-3.1-10.4c-1.3-2.7,0-6.5-3-7.2C260.1,903.4,254.1,904.9,254,905.8z"
            />
            <path
              class="st15"
              d="M273.3,897.7c2-0.5,4.3-1.3,5.8,1.7s2.8,8,3.5,9.8c0.7,1.8,5.5,13.2,6.5,15.2s2.8,6.5,3.5,8.2
							c0,0,0.2-5-0.3-7.5s-2.8-13.7-3.7-16c-0.8-2.3-2.8-9.5-4.3-11s-2.5-3-3.9-3C279.1,895,273.3,897.7,273.3,897.7z"
            />
            <path
              class="st15"
              d="M292.7,888.5c0.6,0,4.3,0.7,4.8,2s5.5,10.5,5.8,11.7c0.3,1.2,8.7,20.8,11.6,24.5c0,0-0.4-7.9-3.7-14.6
							c-1.4-2.7-2.2-9.5-2.8-11.7c-0.7-2.2-1.3-3.8-2.2-5.3c-0.8-1.5-2.2-3-3.2-3.7c-1-0.7-2-4.8-2.5-5s-6,0.7-6,0.7L292.7,888.5z"
            />
            <path
              class="st15"
              d="M314.2,915.2c-0.8-3.2-2.2-6.3-0.5-8.3c1.7-2,3.7-2.3,4.5-2.3c0.8,0,2.3,0.3,4.5,1.8c2.2,1.5,6,4.2,5.5,6
							c-0.9,3.1,3.5,3.7,4.5,4.8c1,1.2,4.2,4.5,4.3,5.5s-3.3-11.7-4-14.2s-1.8-4.8-3.8-5.7c-2-0.8-5-1.8-7-2.2c-2-0.3-4.8-2-5.5-2.5
							c-0.7-0.5-3.3-1.5-5.3-2s-5-0.2-5-0.2L314.2,915.2z"
            />
            <path
              class="st15"
              d="M353.8,947.2c0-3.3-1.8-7.7-2-10.2c-0.2-2.5-1.3-7-1.7-8.8c-0.3-1.8-1.5-6-4.3-6.7
							c-2.8-0.7-6.5-1.5-7.5-1.3c-1,0.2-5.5-5-5.5-5l-0.5-5.3c0,0,6.3,1.8,8.2,2.5c1.8,0.7,7.5,3,9,3.5s5.5,2.8,5.8,3.3
							c0.3,0.5,1.5,5.3,1.3,6.3C356.5,926.5,353.8,947.2,353.8,947.2z"
            />
            <path
              class="st15"
              d="M376.3,944c0-2.2-2-6.2-2.8-7.2s-2.5-4.7-3.5-5.3s-3.3-2.5-4.7-2.7c-1.3-0.2-7.2-1.7-8.2-3
							c-1-1.3-1.8-6.7-1.8-6.7l3-0.3l5.5,6.5l10.5,1l3.5,1L376.3,944z"
            />
            <path
              class="st15"
              d="M378.3,933.2c1.3,0,5.8,0.7,7.2,1.2s5.2,2.7,6.2,5.3c1,2.7,3.5,7.8,3.5,9.8s0.7,6.8,0.7,6.8s0-12,0.2-14
							s1.5-5.5,1.5-5.5s0.7-2.5-0.7-4.2c-1.3-1.7-3.8-2.8-5.5-2.5c-1.7,0.3-4.5,1-6,0.5s-4.8-3.3-4.8-3.3h-3.8L378.3,933.2z"
            />
            <path
              class="st15"
              d="M398.8,938.3c0.2-0.1,0.5-0.2,0.7-0.2c1.5-0.4,3.9-0.5,4.6,0.2c0.8,0.8,4.5,1.8,5.7,1.5
							c1.2-0.3,4.5,7.2,4.3,8.7C414,950,418,940,418,940l-1.3-4l-5.3-1.3l-9.2-0.2l-3.5-0.3L398.8,938.3z"
            />
            <path
              class="st15"
              d="M427.8,958.7c-0.5-2.7,0.7-7.2,0.3-9.5c-0.3-2.3-0.5-4.5-3.2-5.5s-8.3-1.3-8.3-1.3s-0.8-4.7,1.3-5.5
							c2.2-0.8,8,1.7,8.5,1.8c0.5,0.2,3.8,0.2,4.3,0.7s2.8,3.7,2.8,3.7l-1.8,8.7L427.8,958.7z"
            />
            <path
              class="st15"
              d="M449.7,971.7c-0.3-3.3-1.3-10.2-1.5-12.8c-0.2-2.7,0.3-10.2-3.7-11.3s-9.5-3.5-12.2-0.5l-2.2-4.2l5.7-3.5
							l11.2,3.2l6.2,1.8l-2.3,5.8L449.7,971.7z"
            />
            <path
              class="st15"
              d="M466.3,967.8c-0.2-2.2-1-7.5-1.2-9c-0.2-1.5-1.5-8.7-3.7-8.7s-5.2-2-6.7-1.5s-4,2.3-4.3,3.3l3.2-8.5
							l17.5,1.3L466.3,967.8z"
            />
            <path
              class="st15"
              d="M485.8,971c0.4-3.5-0.5,13.2-1.8,14.8c-1.3,1.7-1.2,3.7-2.8,4.2c-1.7,0.5-3.1,0.5-3.8,0.7
							c-1.5,0.2-2.3,1.2-5,0.9c-3.9-0.6-4,0.2-3.4,1s2.2,3.7,4.5,3.8c2.3,0.2,6,0.5,7.8,1.3c1.8,0.8,5.2,0.2,5.2,0.2s2,2.8,2.3,6.2
							c0.3,3.3,0.2,3.8,0.2,3.8c1-3.8,4.2-6.3,6.8-6.2c2.7,0.2,6.8,3.5,7.5,5c0.7,1.5,1.5,2.2,1.5,2.2s3.2-5.7,7-5.5
							c3.8,0.2,8.5,3.7,9.3,5.7c0.8,2,0.7,0.5,0.7,0.5s3-3.8,7.2-4.2c4.2-0.3,4.8,0.7,6.7,1.3c1.8,0.7,5,5.2,5,5.2s1.8-2.8,2.3-3.5
							c0.5-0.7,3-1.5,5-1.3s10.3,2.7,10.2,4c0,0,1.8-2.5,3.8-2.8c2-0.3,5.8-0.7,7.3,0.5c1.5,1.2,6.3,3,6.3,3s-0.3-1.5,2.3-2.5
							s6.5-0.5,7.8,0c1.3,0.5,5.7,1.3,6.5,2.8c0.8,1.5,0.5-0.2,0.5-0.2s1.3-1.2,2.3-2.3s4.2-1.2,6-0.7c1.8,0.5,4.3,1.7,4.8,1.8
							c0.5,0.2,3.2-1,4.5-0.8c1.3,0.2,7.3-0.5,7.3-0.5l4-1.5l6.9,1.9c-1.5-0.6-2.1-1.4-3.1-2.9c-0.7-1.2-0.2-10.5,0.1-11.5
							c0.3-1-1.3-1-1.3-1c-0.8,2.5-2.7,6-4.8,7.8c-2.2,1.8-4.8,1.6-6.2,1.5c-3.1-0.2-6.3-3-6.2-5.2c0.2-2.2,0.2-16.1,0.2-16.1
							l-1.7,11.8c0,0-0.3,1.7-0.5,2.7c-0.2,1-2,2.8-3.5,3.3s-3.7,0.7-5.5-0.5c-1.8-1.2-5.7-3.8-5.5-6.3c0,0,0-0.2-1,1.2s-2.2,3-3.8,3.3
							c-1.7,0.3-4.9-1.3-6-1.5c-2-0.4-2.9-1-3.8-1.5c-1.9-1-0.6-10.5-0.6-10.5l-0.4-2.8c-1.5,4-3.2,8.3-5.5,9.7c-2.3,1.3-3.7,2-5.7,2
							s-4.3-0.2-5-2.5c-0.7-2.3-0.8-13.2-0.8-13.2s-0.5,4.8-1.5,6.8s-1.8,4-4,5.2c-2.2,1.2-4.9,1.4-6.7,1.3c-1.6-0.1-5.2-0.8-5.5-2.7
							c-0.3-1.8,0.1-14.9,0.1-14.9s-1.5,2.4-1.6,4.2s-0.8,5.5-2.3,7.5s-3,3.3-4.5,3.7c-1.8,0.4-4.5,0-5.7-0.2s-4.5-1.2-4.5-4.5
							s0.7-9,0.7-9c-0.7,3.2-0.7,2-1.7,3.8c-1,1.8-1.7,3.5-2.3,4.3c-0.7,0.8-1.2,2.6-3.2,3.3c-2.6,1-6.8,0.2-8.2-0.2
							c-1.3-0.3-4.2-1-3.8-5.8s-0.2-13.3-0.2-13.3c-0.3,4.3,0,5.8-1.2,9.3c-1.2,3.5-4,7.8-7.7,9.8s-4.8,2-6.3,1.5
							C486.7,987.4,485.1,976.7,485.8,971z"
            />
            <path
              class="st15"
              d="M558.8,965.8c-0.5-4.3-2.8-10.8-7.3-13c-4.5-2.2-7.3-1.8-8.5-1.8s-1.9,2.1-3.2,1.9
							c-1.3-0.2-6.3-2.9-7.6-2.9c-1.3,0-10.2,1.3-10.7,1.8s-3.8-2-7.5-2.3c-3.7-0.3-9.2,1.1-9.9,1.9c-0.7,0.8-1.8-1.9-3.3-2.3
							c-1.5-0.3-9.2,0.2-10.3,2.4c-2.8,5.7-3.9,0.4-5.9-0.1s-8.4-0.8-10.4,0.9c-2,1.7-4,3.7-4.5,4.5c-0.5,0.8-2-3.7-1.5-6
							c0.5-2.3,2.2-8.2,3.2-7.7s4.2,1.3,5.5,1.3s10.9-2,14.1-1.9s8.8,3.7,10.6,3.5c1.8-0.2,5.5,0.7,7.2-0.5c1.7-1.2,3-5,3-5
							s0.5,3.5,1.7,3.6c1.2,0.2,5.3,1,7.3,0.8c2-0.2,7-1.2,8.2-2.2s1.6-2.1,3.5-1.9c1.8,0.2,5.5,1.9,7.5,1.4s7-0.3,9-2.2
							c2-1.8,3.3-4.2,3.3-4.2l2.9,2.8l5-1.5c0,0,6.8-0.8,7.3-1.3s5.5-3.5,5.5-3.5l7.5-2.3l7.2-3l6.5-3.8l7.5-4.5l6-6.3l4.7-5l2.7-5.3
							l-0.6-8.2l3.1-4l2-4.7l6.1,0.5l2.5,5.4c0,0,1.9,4.5,2.2,5.6c0.3,1.2-0.1,3.4-0.8,5.7c-0.7,2.3-2.7,2.7-3.2,4.2s-3.2,6.7-5.3,8.3
							c-2.2,1.7-4,4.5-6.7,7c-2.7,2.5-6.3,6.5-6.7,8.2c-0.3,1.7-1.3,1.8-1.3,1.8s-0.3-2.5-1.2-3.2c-0.8-0.7-4.7,0-6.7,2.3
							c-2,2.3-5,6.7-5.3,13.5c0,0-2-2.8-5.2-5c-3.2-2.2-4.7-2.8-6.2-2.5c-1.5,0.3-5.7,4.8-6.8,9.2s-0.2,9.8,0.2,11.2
							c0.3,1.3,0,5.7,0,6.7s-1.5-5.3-2.7-7c-1.2-1.7-3.2-4-5.3-4.8c-2.2-0.8,3.3-1.7,3.3-1.7s1.3-6.3,1.3-7.5c0-1.2-0.3-3.7-2.8-2.5
							c-2.5,1.2-8.3,3.9-8.3,6.1c0,1.3,7,3.5,9.6,2.6c0.8-0.3,1.3,1.7,0.5,2c-3.1,1-11.5,2.6-11.5,2.9
							C559.3,954.9,558.8,965.8,558.8,965.8z"
            />
            <path
              class="st15"
              d="M632.8,891c2.7,0,4.5,1.3,5.3,3.3c0.8,2,6.8,14.8,7.8,20c1,5.2-0.8-10.3-0.8-12.2c0-1.8,0.3-7.3,0.3-7.3
							s-2.5-4-3.8-4.2C640.3,890.5,632.8,891,632.8,891z"
            />
            <path
              class="st15"
              d="M649.2,894.5c2-0.3,5.2,1.3,5.8,3.5s6,20.3,6.7,24c0.7,3.7,1.5,6.2,1.5,6.2s-1.3-13.5-1.5-14.5
							c-0.2-1-0.2-10.8-0.2-10.8s2.3-2.5,1.5-3.3s-3.7-4.5-4.8-4.8C657,894.3,649.2,894.5,649.2,894.5z"
            />
            <path
              class="st15"
              d="M666.5,901.2c1.8,1.2,3.3,1.2,4.5,5c1.2,3.8,3.8,18.5,4,21s1,4.2,1,4.2l-0.7-22.3l-0.7-4.8
							c0,0-2.3-5.8-5.7-5.8S666.5,901.2,666.5,901.2z"
            />
            <path
              class="st15"
              d="M677.2,935.5c0-2.7,0.5-13.2,1-15.7s1.7-4.5,2-6.7c0.3-2.2-0.5-5-1.5-5s-3.8,3.3-3.8,3.3L677.2,935.5z"
            />
            <path
              class="st15"
              d="M707.8,1080c-2-2.3-7-36.1-7.2-40.1c-0.2-4-2.6-23.9-2.6-23.9s-1.1,2-2.4,1.9c-1.3-0.2-7-2.8-7-2.8
							s0.2,3.2,0.5,9.3c0.3,6.2,1.3,20.3,1,22.8s-4.4,33.1-4.4,33.1L707.8,1080z"
            />
            <path
              class="st15"
              d="M690.7,976.8c0.7,6.8,1,24.7,1.8,26c0.8,1.3,3.3,3.2,4.8-0.8s2.3-6.8,2.3-6.8s-2,10.3-1.8,11.2
							c0.2,0.8,2,3,6.5,0.3c4.5-2.7,4.9-2.8,4-1.1c-0.8,1.7-9.1,9.9-10.5,10.4s-5.4,3.9-7.4,1.2c-2-2.7-3.8-6-6.8-7
							c-2.9-0.9-0.2-2.4,1.5-2.5c1.7-0.2,3.7-3.1,3.7-5.1S690.7,976.8,690.7,976.8z"
            />
            <path
              class="st15"
              d="M580.8,922c0.5,1.7,0,4.8-2.2,7c-2.2,2.2,0,3.3,0,3.3l4.5-2L580.8,922z"
            />
            <path
              class="st15"
              d="M563.2,924.7c0.5,0.8,2.1,6.3,0.9,7.5c-1.2,1.2-4.2,5.8-5.8,6.2c-1.7,0.3,8,0,8,0l2.2-2.3l-2.2-11.6
							L563.2,924.7z"
            />
            <path
              class="st15"
              d="M551,931c0,1.7-1,4.5-3,6.2c-2,1.7-4.2,3.7-6.7,4.2s0.7,3.3,0.7,3.3l8.3-0.3L551,931z"
            />
            <path
              class="st15"
              d="M530.5,929.8c-0.5,1.8-2.7,5.7-3.3,7c-0.7,1.3-1.3,4.3-4.8,4.8s-7.2,0.7-8.2,0.5c-1-0.2-2.2,4.3,1.3,4.8
							s12.2,0,13.7-1.2c1.5-1.2,3.5-4.8,3.7-7.5C533,935.7,530.5,929.8,530.5,929.8z"
            />
            <path
              class="st15"
              d="M508.8,894c-0.5,4.2,0,7.5-2.3,10s-3.8,6.2-5.2,7.4c-1.3,1.2-6.5,4.3-3.2,4.1c1.3-0.1,5.8,0.6,7.2-1.8
							c0.8-1.5,1.1,1-0.4,1.5s-5,4.7-4.8,5.8c0.2,1.2,5,6.5,7.8,6.5s5-0.5,6.7-0.3c1.7,0.2,5.5,1.3,7,1.3s5.8,1,7.8,0.3
							c2-0.7,6.2-0.8,7.5-0.8s7.2-1.5,9-1.2c1.8,0.3,3.8,0.7,4.2-0.2c0.3-0.8,5.3-1.8,7.2-1.5c1.8,0.3,3.3,0,4.3,0s1.7,0.8,3.7-0.7
							s9.3-2,10.7-1.3c1.3,0.7,3.3,1.3,4.2-0.7c0.8-2,1.3-4.5,3.5-5.5c2.2-1,8.6-3.3,10.1-1.5c1.5,1.8,3,2,2.4,0.5
							c-0.7-1.5-2.3-3.5-0.7-5.5s4.7-4.5,5.7-4.3c1,0.2,3.6-0.5,5.2,1.9c0.5,0.7,0.6-2.2,0-3.9c-0.7-1.7,0.5-5.3,2.5-6.2
							s4.3,0.3,5.2-0.8c0.8-1.2,0.3,4.3,0.3,4.3l4-12.7c0,0-0.8-2.3-2.2-3.7c-1.3-1.3-6.7-2.8-7.5-3.3c-0.8-0.5-2.2-2.3-1.5-3.7
							c0.7-1.3,4-3.8,1.2-11.3c-2.8-7.5-1.2,0.2-1.2,0.2s-0.8,9-7.3,13.5s-2.5-0.2-2.5-0.2s-0.3-4.7-0.7-6.2c-0.3-1.5-0.8,1.7-1.2,3.8
							s-1.8,7.3-4.2,8.5c-2.3,1.2-6.2,5.5-8,6.3c-1.8,0.8-4.3,1.3-4.2-2.2c0.2-3.5-0.2-8.8-0.8-10.7c-9.5-26-20-21.8-21.3-23.1
							c1.5,1.7,16.1,9.4,18.8,26.6c0.4,2.5-1,9-1.7,9.5c-0.7,0.5-1.9,2.2-3,3.8c-0.9,1.3-2.2,3.7-4.4,3.7c-2.2,0-4.7-0.5-5-5.7
							c-0.3-5.2-3.2-12.3-3.2-12.3s-0.2,5.5-0.3,8.7c-0.2,3.2-1.8,7.7-4.7,10.7c-2.8,3-3.7,4.3-5.8,5c-2.2,0.7-6,2.3-4.7-3.2
							c1.3-5.5,0.5-17,0.5-17s-0.8,5.7-1.2,7.7s-4,9-6,11.2s-5.2,4.7-7,4.8c-1.8,0.2-4.2-0.7-3.3-6.3c0.8-5.7,0.5-14.3,0.5-14.3
							s-1.2,7.2-1.3,9.2c-0.2,2-2.8,7.8-7,11.2c-4.2,3.3-8.5,6-8.8,2.2c-0.3-3.8,0.5-14.3,0.5-14.3L508.8,894z"
            />
            <path
              class="st15"
              d="M492.4,936.4c0,1-1.1,6.4,0.9,6.4s7,0.8,8.5,0.5c1.5-0.3,4.3-3.2,4.5-4.8c0.2-1.7,0.3-2.7,2.3-4.5
							s3-5.3,3.2-3.3c0.2,2,0.2,8.3,0.2,9c0,0.7,0,4.2-2,5c-2,0.8-1.3,3.7-5.2,3.5c-3.8-0.2-15.5-1-20-1.3c-4.5-0.3-13.2-2.5-13.7-2
							s-11.7,1.3-11.7,1.3l-10.3,0.3l-14-4.2h-6.3l-9.7-2.3c0,0-22.7-4.8-24.7-5.7c-2-0.8-14-2.8-14-2.8l-8.7-2.7l-10.3-3.3l-10.2-4.8
							l-13.5-6.7l-9.2-5.8l-4-4.7l-12.2-2.8c0,0,4.7-11.3,4.7-9.7s-1.7,4.8,0.7,6c2.3,1.2,8.2,2.2,11.8-1c3.7-3.2,0.7,2.3,0.8,3.5
							s1.3,5.3,3.8,6.3s10.5-1.8,13-4.7c2.5-2.8-1.7,5.8-1.3,7.3s1.7,6.2,5,6.2s8.5-3,9.8-4.7c1.3-1.7,3.6,0.4,3.6,0.4
							s-3.4,9.3-0.6,10.3c2.8,1,5.5,2.1,7.6,1.1c2.4-1.1,4.7-4.6,6-6.3s0.2,4.8,0,5.5s-0.3,2.8,0.8,3.2c1.2,0.3,10,2.7,12.3,1.5
							c2.3-1.2,2.8-2.8,4-4.2c1.2-1.3,4.3-3.9,4.3-3.9s-2.8,11.2,0.2,11.6c3,0.3,11.8,2.3,14,2c2.2-0.3,3.7-2.7,3.7-2.7v3.8l2.2-5
							c0,0,2,0.9,1.8,3c-0.3,2.9,5.7,3.5,8.8,3.7c3.2,0.2,6,0.2,7.5-0.7c1.5-0.8,4.5,1.2,4.5,1.2s9,1.3,10.3,0.7
							c1.3-0.7,4.6-3.2,5.6-4.5c1-1.3-1.1,6.2-1.1,6.2s1.8-0.3,4.2,0.7c2.3,1,5.5,1.3,7.2,0.3c1.7-1,4.7-1.3,4.8-2.7
							c0.2-1.3,0.3,3,0.3,3s-0.5,3.7,1.3,4c1.8,0.3,7.3,0.7,8.2,0.3s3.1-0.8,5.6-3c2.5-2.1,3.1-9.3,3.1-9.3L492.4,936.4z"
            />
            <path
              class="st15"
              d="M439,930.4c1.6-3.3,1.9-8.9,0.7-12.4c-1.4-4.4,1.2-10.1-1.6-10.3c-2.2-0.2-6.3-0.7-8.8,0.5
							c-2.5,1.2-5.8,7.3-6.5,8.8c-0.7,1.5-2.3,5-2.5,6.8c-0.2,1.8-1,4.5-1.5,5.3c-0.5,0.8-2.7,1.8-2.5-1c0.2-2.8,0.7-10,1-11.3
							c0.3-1.3,3.7-7.5,4.2-8.8s0.3-3.2-1.3-3.8c-1.7-0.7-3.7-0.8-6.2,0.2s-9.5,6.5-10.5,8s-3,3.2-3.8,4.3c-0.8,1.2-6.2,8.3-6.2,7.5
							c0-0.8,2.2-5.3,3.3-6.5c1.2-1.2,3.2-4,3.5-5.7c0.3-1.7,1.3-5,2-5.5c0.7-0.5,2.2-1.5,2.3-2.5c0.2-1-0.2-4-3.8-3.5
							c-3.7,0.5-7,0.5-9.8,2.7c-2.8,2.2-4.8,4-6,6.1c-1.2,2.2-3.5,5.7-5.2,6.7c-1.7,1-3.2,3.3-2.7,1s4-6.2,4.7-8.5c0.7-2.3,3-7.2,3-7.2
							s2.2-2.5,0.8-3.8c-1.3-1.3-4.3-3-6-2.7c-1.7,0.3-4,1.8-4.7,2.3s-7,4.8-7,4.8s-2.5,5.9-3.1,7.4c-0.7,1.5-5.4,2.6-5.4,2.6
							s3.5-5.2,4.3-6.5c0.8-1.3,1.2-6.7,2.2-8.2s2.7-4.3,1.2-5.5c-1.5-1.2-4-2.8-5-2.3s-4.2,3.3-5.2,4.3s-5.5,6-6.7,6.7
							c-1.2,0.7-1.2-0.1-1.2-0.1s-1.1-2.4-0.8-3.9c0.3-1.5,1-4,1.8-5.3c0.8-1.3,2.3-2,1.8-4.2s-1.7-3.2-2.7-3.3c-1-0.2-4.7-2-6.2-1.3
							c-1.5,0.7-4.8,4.3-6,5.8c-1.2,1.5-3.5,3-3.5,3s-0.5-1.7,0-3.8c0.5-2.2,1.7-4,2-5.3c0.3-1.3-0.2-5.3-1.2-5.8s-2.8-1.7-4.8,0.2
							c-2,1.8-4.2,4.1-6.1,6.7c-1.5,2.1-12.1,22.5-18.6,9c9.5,2.1,16.6-16.7,17-17.2s1-4.5,0.8-5.5c-0.2-1-2.2-2.8-5.7-0.3
							c-3.1,4-9.7,10.1-9.7,10.1s9.4-14.4,8.7-15.8c-2,0.2-9.2,7.5-15.1,13.6c4.5-11.5,23.6-25.4,27.7-27.6c3.8-2,6.3-2.8,8.2-3.3
							s9.3,1.6,11.1,5.4s-1.1,4.8,2,4.3c3.7,3.9,11-1.7,13.7-5.2c2.7-3.5,2-2.3,2-2.3s-3,9.7-2.5,12c0.5,2.3-0.3,6.3,2.8,4.8
							c3.2-1.5,5.5-3.7,7.2-4.8c1.7-1.2,5.5-2,5.5-2s0,6-0.3,6.5s-3.2,4.5-3.2,4.5s-3,2.5-1,3.8s2.5,1.7,4.2,1.2s3.8,0.3,4.8,1.2
							c1,0.8,3.3-0.7,4.7-2.3s6-5.2,7.2-7c1.2-1.8,0.3,3,0,3.8c-0.3,0.8-3.5,10.3-3.5,10.3s0.2-0.5,0.3,1s0.7,3.3,3.8,3.7
							c3.2,0.3,5.2-1.2,8.7-4.7s4.7,0.2,4.2,1c-0.5,0.8-2,6.2-2,6.2l-0.1,2.8l-0.1,1.3c0,0,1.2,1.5,5.2,1.5s6.3,0.3,8.2-1.2
							c1.8-1.5,4-4,5.8-6.2c1.8-2.2,3-3.3,3-3.3l-3.3,8.5l-2.3,3.5l-0.8,2l1.3,2.5l1.8,2.6l2.8,1.7c0,0,2.3,0.8,4.7-0.8
							c2.3-1.7,6.3-4,7.7-6.7c1.3-2.7,0.3,3.3,1.3,5c1,1.7,3.8,3.8,4.8,2.8s2.7,0.2,3.8-0.2c1.2-0.3,3.8-1.7,4.5-3.5
							c0.7-1.8-0.2,3-0.2,3s-0.8-0.3,0.8,1.5c0.4,0.5,1,0.8,1.5,1.1c8.8,3.8,4.5,1,9.1,4.9c3.3,2.8,2.7-1,2.7-1l1.2-5.7
							c0,0,0.2,2.8,1.3,4.2c0.5,0.6,1.4,1.2,2.3,1.8c1.3,0.8,2.4,1.8,3.5,2.8c0.8,0.8,1.9,1.6,3.1,1.7c2.3,0.2-7,0.5-7,0.5l-3.8-4.3
							l-2.6,1.8l-6.2,1.2l-4.7-4l-2.4-2.2l-4.4,2l-5.3-1.2l0.8,5.2l-2,7.9l-3.4,8.8l-0.8,5.3C438.8,935,435.8,937.2,439,930.4z"
            />
            <path
              class="st15"
              d="M399,774.5c-0.4-1.7-1.3,3.3-3,3.7c-1.7,0.3-3.8-2.8-6-3.7s-6.5-6.7-4.2-3.8c2.3,2.8,3.3,6.8,3.3,8.2
							c0,1.3-1.2,4.8-2.8,5c-1.7,0.2-5.7-1.7-6.7-2.5c-1-0.8-3.5-2.8-3.5-2.8s0-1.5,1.8,1.5s3.7,4.7,2.8,6.3c-0.8,1.7-1.3,5.8-4.7,4.5
							c-3.3-1.3-1,0.3,0.2,1.7c1.2,1.3,1.3,4.8,1.3,6.3s0,4.2-2.5,4.1c-0.9,0,1.2,2.9,0.2,2.8c-1-0.2,2.8,2.4,3.2,3.5
							c0.7,1.8,1.8,5.5-0.3,5.3c-2.2-0.2,8,5.3,8,5.3l-0.7-5.7l0.7-5.7l-3.7-8c0,0,1.9-0.2,4.2-2.8c2.3-2.7,3.9-7.5,3.9-7.5l3.7,0.3
							C394.2,790.5,401.2,783,399,774.5z"
            />
            <path
              class="st15"
              d="M355.2,835.3c-2.7,2.7-7.6,4.6-9.9,5.4c-2.3,0.8-5.5-0.2-6.3-2.7s-0.4-7.3,1.1-9.8s7.1-8,7.1-8.5
							s-8.7,7.8-8.7,7.8s-1.7,1.9-3.2,2c-3.2,0.3-4.5-2.9-4.3-6.2c0.2-3.3-0.1,6.5-0.1,6.5l5.7,9.7l4.3,8.8c0,0,4.7,3.8,6.2,4.3
							s1.7-6.8,1.7-6.8L355.2,835.3z"
            />
            <path
              class="st15"
              d="M323.3,881.8c-2.7,2.7-11.8,23.7-18.3,10.2c9.5,2.1,16.6-16.7,17-17.2"
            />
          </g>
        </g>
        <g id="woolSweater-lines">
          <path
            class="st16"
            d="M234.5,1054.7c-3.8-6.6-12.4-23.3-14.1-28c-1.7-4.7-0.9-6.9-0.9-10c0-4.2-0.4-48.4-12.5-72.1
						c-3-4.4-1.8-5.6-0.9-7.1c0.9-1.5,8.1-7.3,9.6-8.7c1.5-1.3,4.2-2,5.7-0.3c1.5,1.7,13.1,25.7,16.3,87.6S234.5,1054.7,234.5,1054.7z"
          />
          <path
            class="st16"
            d="M253.3,1080.4c-0.8-5.7,6.9-23.1,2.3-55c-1.6-11.1-2.1-62.4-2.5-68.9c-0.4-6.4-6.2-38.6-7.2-40.9
						c-0.9-2.3-3.3-4.3-6.7-2.8c-3.4,1.5-13.6,9.1-15.4,10.8c-1.9,1.7-1.4,5.7-0.8,7.6"
          />
          <path class="st16" d="M231.6,1080.4c-0.8-5.7,7.4-20,6.9-31.2" />
          <path
            class="st16"
            d="M218.7,1017.7c2.5,9.3-0.1-40.8-9.5-68.2c-1.3-3.7-4.2-8.7-8.7-2.6c-1.6,2.1-9.3,12-10,14
						c-1,2.8,2.6,4.6,4.8,8.1C197.5,972.9,217.4,1012.8,218.7,1017.7z"
          />
          <path class="st16" d="M153.4,1080.4c17.6-33.1,27.6-69.4,45.4-102.8" />
          <path
            class="st16"
            d="M190.6,963.5C173,994,158,1026,146,1059c-3,7-7,13.3-6.4,21.4"
          />
          <path class="st16" d="M168.9,1080.4c12.1-30.1,24.1-59.4,37.4-88.6" />
          <path
            class="st16"
            d="M185.7,1080.4c3.4-9.4,6.7-17.3,10-26.7c4.1-11.5,8.2-23,12.5-34.4c1.1-2.9,2.1-6.1,3.6-8.8"
          />
          <path
            class="st16"
            d="M203.5,1080.4c6.1-15.4,10.6-29.3,16-45c0.8-2.2,1.4-4.4,2.4-6.5"
          />
          <path class="st16" d="M217,1080.4c5-12.2,7-22.4,12.8-34.6" />
          <path
            class="st16"
            d="M247.2,921c-1.7-7.7-0.8-10.6,0.3-11.5c1.8-1.4,7.8-4.6,9.1-5.4c1.3-0.8,4.6-1.5,6.2,1.3
						c1.2,2.1,6.8,18.6,8.9,31.3c2.1,12.7,3.4,35.2,2.6,49c-0.8,13.8-1.7,35.4,1.5,47.6c4.1,15.9-2.2,42.3-2.9,47"
          />
          <path
            class="st16"
            d="M293.8,1080.4c1.2-34-0.8-67.4,1.2-101.4c0-14,1-28-1-42c-3-13-5-25-9-38c-1-2-2-4-3-4c-7,0-20,3-18.2,12.4"
          />
          <path
            class="st16"
            d="M312.7,1080.4c0.2-11.9,2.3-74.4,2.5-81.2c0.2-6.8-0.4-26.7,0-35.4c0.4-8.7,1.3-25.2,1.1-28.9
						c-0.2-3.8,0.2-9.6-4.5-23.5s-8.3-22.1-10.8-24.2c-2.5-2.1-5.7-0.4-8.9,0.6s-7,2.6-8.1,3.1c-1.4,0.7-2.4,3.1-0.7,6.1"
          />
          <path
            class="st16"
            d="M333.2,907.3C336,913,336,919,337,925c0,11-2,21-2,32c-2,26,0,52-1,78c-1,15-1,30.3-2,45.4"
          />
          <path
            class="st16"
            d="M355.7,919.7c0,3.2-1.9,25.3-1.7,31.6c0.2,6.2,2.5,17.2,2.1,23.3c-0.4,6.1-3.4,103-3.8,105.8"
          />
          <path
            class="st16"
            d="M378.8,928.2C375,934,376,942,375,949c-3,44-4,87.4-5.4,131.4"
          />
          <path
            class="st16"
            d="M399,933.2c-1.7,3.8-2.1,8.3-2.7,11.7c-0.6,3.4-0.9,14.8-2.1,18.9c-1.1,4.2-2.5,9.3-2.3,14.6
						c0.2,5.3-0.8,97.9-0.9,102.1"
          />
          <path
            class="st16"
            d="M417.9,937.9c-1.9,4.4-4.5,13.6-5.1,18.5s-0.6,38-0.8,44.1c-0.2,6.1,0.6,42.9,0.2,45.4s0,34.5,0,34.5"
          />
          <path
            class="st16"
            d="M451.4,1080.4c0.6-42-1.4-82.4-1.4-124.4c0-4,3-7,3-11c0-1-1-2-0.5-3.5"
          />
          <path
            class="st16"
            d="M433.4,940.2c0.8,5.7-4.4,11.6-4.5,17.9c-0.1,4-1.3,34.4-0.9,38.6c0.4,4.2,2.1,16.8,2.1,21
						s1.3,60.3,0.9,62.7"
          />
          <path class="st16" d="M488.4,1080.4c0.6-29.1-2.4-57.4,0.8-86.2" />
          <path
            class="st16"
            d="M470.4,943.2C470,948,469,954,469,959c-1,41,1,80.4,1.6,121.4"
          />
          <path class="st16" d="M523.6,1080.4c0.4-28.1-0.6-56.4-1.5-84.3" />
          <path
            class="st16"
            d="M503.4,994.5c0.6,2.5,1.6,5.5,1.6,8.5c0,26,0,51.3-0.2,77.4"
          />
          <path class="st16" d="M559.8,1080.4c0.2-27.2-1.8-52.4-0.9-79.9" />
          <path class="st16" d="M541.4,998.8c3.6,28.2-0.4,53.3,2.1,81.6" />
          <path class="st16" d="M593.2,1080.4c-0.2-25-0.2-49.4,0.2-74.4" />
          <path
            class="st16"
            d="M575.5,1001.5c0.4,1.3,0.8,5.9,0.8,8.3s-0.2,67.4,0,70.7"
          />
          <path
            class="st16"
            d="M622.2,957.8c-0.9-3.4-1.2-7.8-0.6-10.1c0.6-2.3,0.8-11.2-0.2-13.8c-0.9-2.6-2.8-15.5-2.8-18
						s-1.5-8.3-3.2-10.4"
          />
          <path
            class="st16"
            d="M624.7,1080.4c-0.7-20.3,1.3-37.4-0.7-58.4c0-4-1-8,1.2-12"
          />
          <path
            class="st16"
            d="M606.3,998.3c0.6,1.5,0.6,8.7,1,11.5c0.4,2.4,0.9,30.5,0.9,32.4s-0.4,37,0,38.3"
          />
          <path
            class="st16"
            d="M636.8,1007.9c1.5-4.2,3.8-18.9,3.8-25.9c0-7-2.6-22.7-4.4-29.7c-1.7-7-3-28.8-3.6-31.8
						c-0.6-3-1.3-8.3-1.1-12.1c0.2-3.8-1.5-11.4-2.1-14.9c-1.1-6.4-4.2-8.1-6.2-8.5c-2.4-0.5-4.9-0.3-5.6,1.6"
          />
          <path
            class="st16"
            d="M638.8,1080.4c0-5.1-0.8-46.1-0.9-47.8c-0.2-1.7,0-14.8-0.2-16.1"
          />
          <path
            class="st16"
            d="M654.3,1080.4c-0.4-7.8-1.3-50.2-1.3-55.3c0-5.1,0-16.8,0.2-18.9c0.2-2.1,1.5-19.5,1.3-25.3
						s-1.7-13.1-1.7-15.7s-1.5-24.8-2.8-30.1c-1.3-5.3-2.8-13.6-2.8-15.1c0-1.5-0.9-9.6-1.1-11.5c-0.2-1.9-0.8-8.7-0.8-11s-3-8-5.8-8
						c-1.1,0-4.5-0.5-6.2-0.4c-2.1,0.1-3.9,3.5-3.9,4.4"
          />
          <path
            class="st16"
            d="M668.3,1080.4c0-6.6,0-58.9,0-64.2c0-5.3-1.5-36.3-1.9-41.8c-0.4-5.5-2.1-33.3-2.8-36.5s-0.8-19.1-1.3-22.9
						c-0.6-3.8-0.4-12.3-0.8-14.2c-0.4-1.9-0.6-4.8-3.1-6.2c-1.7-1-4.2-1.4-8.1-1.1c-4,0.2-4.3,1.7-4.9,4.9"
          />
          <path
            class="st16"
            d="M661.7,904.9c0.3-0.9,0.3-2.9,1.3-3.9c5-3,11-1,12,5c1,23,2,45,4,68c0,10,2,20,3,30c3,27,2,50.5,1.7,76.4"
          />
          <path class="st16" d="M693.7,1018.9c0.3,21.1,3.3,40.5,5.2,61.5" />
          <path class="st16" d="M688.5,1015c-0.2,8,3.7,63.7,3.9,65.4" />
          <path class="st16" d="M697.9,1016c3.3,17.9,5.3,62.8,5.5,64.5" />
          <path class="st16" d="M703.4,1011.6c4.6,23.4,7.6,45.7,9.9,68.9" />
          <path
            class="st16"
            d="M711.1,1000.7c0.8,4.2,4.4,18.2,5.5,22.9c1.1,4.7,4.4,18,4.7,19.7c0.4,1.7,5.4,35.7,5.2,37.2"
          />
          <path
            class="st16"
            d="M739.4,1080.4c0.1-2.4-0.4-1.9-0.4-4.9c-8-40-17-77.5-25.9-115.4"
          />
          <path
            class="st16"
            d="M694.3,1017.9c3.1-0.9,10.6-7,12.3-9.5s5.3-6.8,5.7-14c0.4-7.2,0.2-27.2,0.6-31c0.4-3.8,0-12.7-1.1-14.9
						c-1.1-2.3-4.1-5.8-5.8-4.7s-2.2,10.7-2.3,16.4s-1.1,25-1.5,27.8c-0.4,2.8-2.3,14.4-4,18c-1.7,3.6-5.1,7-5.7,8.3
						C691.8,1015.6,690.9,1018.9,694.3,1017.9z"
          />
          <path
            class="st16"
            d="M687.3,1012.1c1.3-2.2,3.2-5.5,3.8-9.8c0.6-4.4,1.1-40.5,1.1-43.9c0-3.4,0-23.1,0-24.6s0.2-6.3,0.6-7.6
						c0.4-1.6,1.3-3.6,3.6-0.4s3.8,6.2,5.1,7.4c1.3,1.1,3,4.4,2.8,7.6s-1.7,45-2.3,48s-3,12.9-3.4,14.8s-2.2,5.5-4,7.5
						c-1,1.1-3,4-4.2,3.8S685.9,1014.3,687.3,1012.1z"
          />
          <path
            class="st16"
            d="M684.8,909.9c1.6,1.4,4.7,5.5,5.1,6.2c0.4,0.8,2.6,4.2,2.3,11.7c-0.4,7.6-0.4,53-0.6,55
						c-0.2,2.1-0.2,13.5-0.4,15.3c-0.2,2.1-0.6,7.9-2.5,10c-1.9,2.1-3.8,3-4.7,0.9c-0.9-2.1-4.5-21.6-4.5-25s-2.6-27.8-2.8-37.3
						c-0.2-9.5-0.4-23.5-0.6-28.8c-0.2-5.3,0.2-8.5,0.4-9.3S678.9,904.8,684.8,909.9z"
          />
          <path
            class="st16"
            d="M602.3,918.2c1.9,1.7,3.6,6,3.6,9c0,1.1,0.9,8.7,1.3,14.1c0.3,5.4,0.3,12.7-0.5,17.6"
          />
          <path
            class="st16"
            d="M588,931.5c1.1,1.5,4.5,7.4,4.9,11.2c0.4,3.8,1.7,13.1,1.3,16.5c-0.4,3.4-0.5,13-0.9,18.3
						c-0.4,4.7-2.6,12.8-3,15.2c-0.4,2.5-0.8,6.9-0.3,8.8c0.6,1.9,1.9,4.6,5.9,4.9c3.4,0.3,7.5-0.4,8.6-3.2c1-2.3,2.4-15.5,2.6-19.5
						c0.2-4.3,0.5-13.7,0.6-17.3c0-1,0.6-4.9-0.5-6.8c-0.7-1.2-2.3-3.4-6.5-2.6"
          />
          <path
            class="st16"
            d="M606.7,996.6c-0.2,3.4,0.4,11.5,5.3,12.2s8.6,1.2,10.1-1.5c1.5-2.8,3-9.3,3.2-13.4c0.2-4,0.5-20.8,0.6-23.8
						c0.1-3.1,0.3-8-1.1-9.9c-1.3-1.9-3.9-3.2-6.9-3.2c-3,0-7.6,0.4-8.5,2.6s-2.3,22.1-2.5,28.4C607,993,606.7,996.6,606.7,996.6z"
          />
          <path class="st16" d="M629.2,1010.4c-4.1,0.8-6.1-3.3-6.1-5.4" />
          <path
            class="st16"
            d="M581.9,1001.5c-2.9,0.7-8.2,0.5-9.1-2.3c-0.9-2.8,1.1-12.1,1.7-14.2c1-3.6,1.8-9.2,1.9-15.9
						c0-5.5-1.3-10.4-1.5-11.5c-0.2-1.1-0.3-4.4,2-5.9c2.3-1.5,4.4,0.3,4.9,0.7"
          />
          <path
            class="st16"
            d="M572.7,993.8c-0.1,3-0.8,5.1-3.1,5.3s-6.5,0.4-8.8-0.4s-3.9-3.9-3.5-6c0.5-3.5,2.1-11.7,1.9-16.3
						c-0.2-4.5,0.2-15.1,0.2-17s-0.1-3.4,1.5-5.1s3.9-2.4,6.3-2.3c1.9,0.1,7.1-0.3,7.9,6.6"
          />
          <path
            class="st16"
            d="M559.6,956.9c-0.8-1.7-2.1-4-4.4-4.6c-2.3-0.6-8.8-0.8-10.2-0.8c-2,0.1-4.2,1.1-5.1,2.1"
          />
          <path
            class="st16"
            d="M558.6,995.8c-2.1,1.3-5.9,4.4-9.3,4.4c-3.4,0-8.1-1.3-9.6-3.2c-1.5-1.9-0.8-4.7-0.8-4.7"
          />
          <path
            class="st16"
            d="M522,952.8c1.8-2.9,5.7-2.8,8.3-2.8s5.6,0.9,6.6,1.1s3.4,0.8,3.4,7.2c0,6.4,0.9,21.4,0.2,25.7
						s-1.5,9.8-3.8,11.5s-9,1.5-11.2,1.3c-2.1-0.2-6.6-2.1-6.6-3.4"
          />
          <path
            class="st16"
            d="M500.8,991.2c2,4.7,10.4,4.4,12.9,4.4s5.5-2.1,6.2-3.6s1.9-10.4,2.5-16.6c0.6-6.2,1.4-19.7-0.3-22.6
						c-1.7-2.8-5.4-2.7-6.7-3c-2.3-0.5-6.6-1.1-8.3-0.4c-1.7,0.8-2.8,3-3,4"
          />
          <path
            class="st16"
            d="M493.8,994.7c2.5-0.3,5.5,0.4,7-3.4c1.5-3.8,2.1-12.1,2.6-17.8c0.6-5.7,0.4-13.8,0.6-16.3s-0.4-7-3.2-7.6
						s-7.2-0.9-8.7,0.2c-1.5,1.1-2.6,3.4-3.4,6.4c-0.5,2.1-2.8,12.3-3,15.9c-0.2,3.6-0.2,14.9,0,17.4C485.8,992,490.5,995,493.8,994.7z
						"
          />
          <path
            class="st16"
            d="M487.8,959.1c0.4-2.3-1-6.2-2.1-7.2c-1.1-0.9-2.7-1.4-6.3-1.2c-3.6,0.2-8.5,2.8-9.5,6.8
						c-0.9,4-2.1,17.4-2.1,21.4s0.1,12.3,3.4,13.6"
          />
          <path
            class="st16"
            d="M476.7,993.1c1.5,0.4,4.7,1,6,0.7c0.9-0.2,2.9-2,2.9-4.3"
          />
          <path
            class="st16"
            d="M566.6,933.5c3.9,0.9,5.4,4.8,5.8,7.3c0.4,2.5-0.9,5.3-1.1,6.6c-0.2,1.3-0.8,3.9,1,6"
          />
          <path
            class="st16"
            d="M555.8,938.1c1.1,1.5,1.1,4.2,1.1,5.3c0,1.1,0.7,3.4,1.3,4.5c0.8,1.4,0,4.3-1.8,4.9"
          />
          <path
            class="st16"
            d="M534.5,942c1.1,0.6,3.7,4,3.1,5.5c-0.6,1.5-2.1,3-2.1,3"
          />
          <path class="st16" d="M506,945.4c0,0.9-0.2,4.4-0.2,4.4" />
          <path class="st16" d="M518.9,944.5c2.3,1.5,1.3,6.2,1.3,6.2" />
          <path class="st16" d="M487.5,945.1c0.8,2-0.5,7.8-0.5,7.8" />
          <path
            class="st16"
            d="M535.4,862.2c0.8-1.9,3.2-4.2,5.3-4c2.1,0.2,6.6-0.2,10.2,6.1c3.6,6.2,9.3,20.1,10,25.7s0.6,11.4,0.4,13.1
						c-0.6,4.7-2.6,5.6-3.3,6.7c-1.1,1.8-2.4,2.6-2,4.7c0.3,1.5,1.3,4.2,3.5,5.5c1.4,0.8,3.4,2.5,5.9,4.2c1.7,1.1,2.8,6.2,0.8,9.1
						c-2.1,2.8-3.6,4.1-6.6,4.8c-4.6,1.1-6.5-1-7.9-2.8"
          />
          <path
            class="st16"
            d="M547.7,859.6c1.5-1.7,3.4-3.5,8.5-3.3c5.1,0.2,7.4,0.8,12.2,5.8c4.7,4.9,6.7,9.9,8.2,13.3s3.3,10.4,2.2,15.3
						c-1.1,4.9-2.4,8.1-2.3,10.9c0.1,3.4-0.7,4.8-1.7,6.9c-0.9,1.9-4.5,4.7-7.6,5.5"
          />
          <path
            class="st16"
            d="M566.9,932.4c3.1,1.9,6.1,1.1,8.6,0.6c2.5-0.6,5.2-1.8,6.2-3c1.1-1.4,1.3-4.3,0.3-7.7c-0.9-3.2-4-5-6.7-5.3
						c-2.6-0.4-3.4-3.7-3.6-4.4"
          />
          <path
            class="st16"
            d="M582.4,927.4c1.5,2,6,1.3,8.3,0s4.6-3,5.2-5.4c0.7-2.7,0.9-7.3-0.8-9.6c-2.2-2.9-5.3-4-6.6-4.5
						c-1.3-0.6-4.6-3.7-1.2-9"
          />
          <path
            class="st16"
            d="M578.5,903.1c8.6,2,14.4-13.6,16.1-17.3c1.6-3.4,3.7-10.5,0.6-17.7c-1.6-3.8-6.5-8.1-10.5-10.3
						c-4.6-2.5-8.2-4.2-10.1-4.8c-1.9-0.6-7.3-1.9-9.9-1.4c-2.5,0.6-4.9,2.2-4.4,5"
          />
          <path
            class="st16"
            d="M570.5,851.6c0.2-2.5,1.6-3.5,5.9-3.9c6.9-0.6,11.2,0.7,16.6,3.7c5.4,2.9,13.4,10,14.7,17.3
						c1.3,7.4-2.2,13.7-3.7,16.1s-9.5,12.7-14.9,10.5"
          />
          <path
            class="st16"
            d="M576.4,846.5c-1.3-5.4,12.9-5.3,22.5-3.8c9.6,1.6,18.9,9.9,17.7,17c-1.4,8-3.2,14.2-8.8,16.1"
          />
          <path
            class="st16"
            d="M578.7,842.6c-1.6-7.5,7.1-12.8,21.6-11.2c14.4,1.7,18.5,11.5,14.2,20"
          />
          <path class="st16" d="M573.2,845.6" />
          <path
            class="st16"
            d="M611.4,834.4c0.9-1.7-1.9-7-3.6-8.9c-1.7-1.9-6.8-5.4-11.9-5.7c-4.3-0.2-12.4,1.1-14.8,2.3
						c-7.5,3.6-10.2,10.7-10,14.6c0.2,3.7,1.7,8.3,7.1,6.6"
          />
          <path
            class="st16"
            d="M593.6,819.5c0.4-2.3,0.5-4.2-0.7-6.2c-1.2-2-3.9-4.2-8.4-4.7c-4.5-0.5-6.8,0-9.6,2.7
						c-2.8,2.6-7.4,9.2-8.3,11.2c-0.9,2.1-3.2,12.7,4.6,14.2"
          />
          <path
            class="st16"
            d="M579.2,809c0.5-1.6-1-3.9-2.9-4.8c-1.9-0.9-3.1-0.9-4.4-0.9s-2.8,0.4-5.7,2.5c-3,2.1-9.5,18.7-1.1,22.9"
          />
          <path
            class="st16"
            d="M567.2,805c1.5-2.1-0.4-4.4-2-5.6c-1.5-1.1-3.2-1.1-5-0.2c-2.2,1-3.2,3.9-2.9,5.3c0.7,3.3,0.2,10,3.2,10"
          />
          <path class="st16" d="M559.9,799.2c-0.3-2.4-1.5-3-2.9-2.5l0,4.4" />
          <path
            class="st16"
            d="M522.9,868.5c0.9-2.5,0.9-4.4,3.4-5.9c2.5-1.5,6.4-1.9,8.7,0.4s6.4,9.6,7,12.7c0.6,3,2.3,11.3,1.9,14
						c-0.4,2.6-0.6,6.1-0.8,8.5s-1.5,7-1.5,9.1c0,2.1-1.3,5.7,0.4,8.7c1.7,3,2.8,3.8,4.4,4.9c1.5,1.1,4.9,4,5.1,8.1s1.3,8.5-1.1,10
						s-5,2.9-7.5,3.6s-9.4,0.5-11.2-2.9"
          />
          <path
            class="st16"
            d="M508.8,872.5c-1.3-4.2,1.1-9.1,6.7-9.1c3.2,0,7.4,1.7,8.5,8.3c1.1,6.6,1.9,16.8,1.4,23.4
						c-0.7,10.5-2.2,15.1-3.6,16.8c-2.3,2.6,1.3-0.5,2.8,6.2c0.7,2.9,0.7,7,2.8,7.9c3,1.2,5.1,6.7,5,9.4c-0.1,3.3-1.4,5.8-3.3,7.1
						c-1.9,1.3-9.3,1.5-11.2,1.7s-4.8,0.5-5.6-2.8c0,0-0.5-2,0-5.2c0.3-2.1,0.8-4,0.3-6.4c-0.6-3-2.5-3-4.8-3.7c-3.5-1.1-5-10.9-3.7-11
						c2.8-0.2,3.9-4.5,4.3-8.1s1.3-14.4,1.3-18.2C509.8,885.1,509.8,879.1,508.8,872.5c-1.3-9-6.8-8.3-10.6-8.3c0,0-4.9-0.4-6.7,5.6"
          />
          <path
            class="st16"
            d="M488.7,911.1c-1.6,4.4-7.3,4.7-11.2,4.1c-5.3-0.7-8.7-3.4-8.3-7.1c0.1-1.4,3.8-15.7,3.8-16.8
						c0-1.2,4.4-21.7,7-25.3c2.6-3.6,4.8-2.9,7.3-2.4c3.3,0.6,4.1,2,4.1,8.1c0,4.4-1.4,12.2-1.6,19.1c-0.2,6.9-1.1,13.1-1,16.8
						c0.1,1.5-0.8,5.6,0.7,6.4c4.1,2.3-0.5-4.4,1.8,15.1c0.3,2.7,2,8.8,0.2,11.9c-1.8,3.1-5.3,4.7-10.4,4.7c-5.2,0-9-3.1-8.1-6.8"
          />
          <path
            class="st16"
            d="M469.2,909.3c-1.2,2.2-4.5,3.6-6.5,3.4c-1.4-0.1-7.3-0.7-7.9-5c-0.4-2.5,1.3-7.3,2.3-11.2
						c1-3.8,3.8-13.5,5.4-18.8c1.4-5,2.7-9.9,4.4-12.9c1.5-2.7,4.7-4.4,8.6-3.5c4.7,1.2,4,6.6,4,4.5"
          />
          <path
            class="st16"
            d="M454.8,905.8c-2.2,3.4-6.7,3.4-8.7,3c-4.5-0.9-5.8-3.7-5.8-5.8c0-3.9,1.9-9.5,2.9-14
						c1.2-5.1,3.7-10.7,4.6-13.7c0.8-3,2.6-7,3.7-9.6c2.4-5.5,3.8-7.7,9.3-7.3c4.1,0.3,6,3.5,5.6,7.4"
          />
          <path
            class="st16"
            d="M453,862.8c1-6-6.8-10.5-11.6-6.8c-2.7,2.1-6.3,11.6-7.3,13.8c-1,2.2-4.8,9.1-6.5,13.6
						c-2,5.3-5.5,11.5-4.2,15.4c1.6,4.8,11.1,9.7,16.3,4.2"
          />
          <path
            class="st16"
            d="M439.8,857.7c1.6-3.4-3.4-7.1-7.5-7.5s-7.6,1.5-11.3,6.9c-3.2,4.7-4.6,8.4-7.7,14.8s-4.7,9.9-5.5,14
						c-1,5.2,0.3,8.9,4.6,10.4c4.4,1.5,10.3,0.4,11-2.1"
          />
          <path
            class="st16"
            d="M425.8,851.2c-0.6-4.1-2.4-6.1-8.1-7.1s-14.4,8.6-19.1,16.1c-4.6,7.4-10.4,21.6-8.5,25.9
						c2.4,5.5,9.1,8.5,16.8,3.2"
          />
          <path
            class="st16"
            d="M413.1,844.9c0.2-4.7-4.7-7.2-7.7-7.5c-4-0.4-10.5,2.6-19.2,12.2c-8.7,9.5-12.3,21.7-11.6,25.4
						c0.8,4.5,3.3,11,15.5,8.8"
          />
          <path
            class="st16"
            d="M404.3,836.9c-3-5.1-8.7-6.8-16.7-5.6c-7.7,1.2-13.3,6-18.2,12c-4.9,6-6.8,11.7-6.3,18.6
						c0.4,5.3,3.6,11.8,10.5,11.8"
          />
          <path
            class="st16"
            d="M395.2,831.1c0.8-3.4-5.9-6.8-10.9-7.7c-5.5-1-13.2-0.9-23.3,6.9c-10.5,8-13.1,19.8-11.8,25.2
						c1.3,5.4,7,10.9,15.3,11.5"
          />
          <path
            class="st16"
            d="M390.3,825.8c-0.2-1.8-1.4-5.5-6.2-8.9c-4.8-3.3-7.8-4.9-15.8-5.3c-8-0.3-13.8,2.6-19.9,6.5
						c-6,3.8-9.7,8.4-11.3,11.7c-1.6,3.2-1.6,8.7-0.9,11c0.7,2.6,2.2,4,3.5,5.3c0,0,4.1,3,8.7,2.8"
          />
          <path
            class="st16"
            d="M386.3,818c0-1.7-1.2-4.4-2.7-6.7c-1.7-2.6-7.2-6.3-9.8-7.6c-2.6-1.2-7.4-3.1-13.2-2.9s-10.1,0.1-14,2.1
						c-3.7,1.9-7.6,5-10.5,8.4c-2.3,2.7-3.9,6.4-4.9,9c-1,2.7-2.3,12.8,4.2,15.8"
          />
          <path
            class="st16"
            d="M384.3,812.2c3.1-2.7-0.5-11.3-1.9-13.1c-2-2.7-4-6-11.6-9.5c-7.8-3.6-19.3-5.4-26.3-1.9
						c-6.6,3.2-17.1,15-10.7,27.1"
          />
          <path
            class="st16"
            d="M382.4,798.5c2.5-3.6,2.4-10.6-1.6-15.6s-7.5-6.9-11.4-8.2c-4.6-1.5-12.8,0-16.7,2.4c-3.8,2.4-5.6,8-4.1,9.4
						"
          />
          <path
            class="st16"
            d="M383.3,799.7c4.1-0.9,7.3-5.9,7.8-10s0.5-7.7-0.5-12.3c-1-4.7-2.9-7.5-6.7-9.9c-4.1-2.6-8.5-3-13.8-1.4
						c-5.2,1.6-7.4,4.8-7.9,7.5"
          />
          <path
            class="st16"
            d="M391,791.2c1.3,0,3.8-1,5.5-2.7c1.8-1.8,1.9-5.1,2.2-8.4c0.3-3.3,1.3-7.3-0.4-10.9c-1.9-4.1-3.4-5.1-5.7-6.5
						c-7.6-4.5-15.4,1-13.9,2.8"
          />
          <path
            class="st16"
            d="M391.7,762.3c0.9-4.7,5.3-3.9,8.2-1.6l-0.9,9.8"
          />
          <path
            class="st16"
            d="M339.8,846.2c-5.7-0.6-12.4,4-17.5,7.1c-4.9,3-12,9-14.8,12.4c-2.5,3-6.3,9-7.1,10.7
						c-0.8,1.7-3.9,7.4-3.1,9.7"
          />
          <path
            class="st16"
            d="M348,850.4c-6.9-0.5-13.5,1.9-20.1,6.8c-7,5.2-14.7,12.8-18.7,18.9c-4,6.1-6.1,12.8-5.5,14.8"
          />
          <path
            class="st16"
            d="M351.7,859.2c-6,1.2-13.3,4.8-17.8,9.4c-4.5,4.7-7.7,7-10.2,10.5s-3.7,5.4-5.1,8.6c-1.1,2.3-2.8,5.9-3.5,7.3
						c-1.2,2.1-6.5,2.9-9.6,0.1"
          />
          <path
            class="st16"
            d="M315.8,893.7c-0.1,1.6-0.1,6.4,3.1,8.1c3.3,1.8,8.2,1.9,9.6,0.7c1.5-1.4,2.5-3.5,3.8-7.1
						c1.3-3.7,4.1-7.8,6.9-11.8c2.8-4,7.7-8.1,10.7-10.1c3.7-2.4,9.8-5.3,15.2-4.6"
          />
          <path
            class="st16"
            d="M375.3,879.5c-8.4,2.6-14.7,8.2-19.8,14.3c-5,6.1-9.3,13.8-9.6,17c-0.2,3.2,3.3,6.7,4.7,7.3
						c2.5,1,8.3,2.3,11-1.6"
          />
          <path
            class="st16"
            d="M347,907.1c-1.9,3.1-5.2,3.5-8.2,2.9c-2.3-0.4-4.1-1.4-5.8-3.2c-2.1-2.3-2.6-7.1-1.4-9.6"
          />
          <path
            class="st16"
            d="M389.8,886.7c-4.2,0.5-7.8,2.7-11.3,5.2c-3.5,2.5-8.6,8.7-10.7,12.6s-6.1,11.9-6.1,11.9s-1.7,3.1-0.4,5.7
						c1.9,3.7,5.7,4.5,7.8,4.8c2.1,0.3,7.6-0.7,8.3-3.3"
          />
          <path
            class="st16"
            d="M407.3,890.5c-3.2,5.6-5.9,0.7-17.7,11.2c-5.9,5.2-13.3,17.7-12.3,22.7c0.8,3.9,2.8,5.6,5.1,6.1
						s6.3,0.7,8.3,0.3c3.8-0.7,6.4-3.7,6.8-4.2"
          />
          <path
            class="st16"
            d="M423.4,894.1c-1.1,3.9-7.8,3.6-12.5,8.1c-2.1,2-6,7.9-7.3,9.8c-1.3,1.8-5.4,7.7-6.1,12.1
						c-0.7,4.2-0.7,7.2,1.5,9c1.9,1.5,7,3.1,10.2,3.2c3.2,0.1,7.2-2,8.1-3.2"
          />
          <path
            class="st16"
            d="M431.5,905.2c-5.2,3.4-7.1,10-9.6,14.6c-2.4,4.6-4.2,9.8-4.4,12.2c-0.2,2.2,0,6.7,3.1,7.7
						c3.2,1,7.7,1.3,10.7,1.2c3-0.2,5.3-2.3,6.7-3.8"
          />
          <path
            class="st16"
            d="M462.7,912.8c-0.7,2-2.4,6.2-2.5,8.5c-0.2,2.3-0.8,3.3-1.5,7.2c-0.7,3.8-2.8,11.2-2.8,11.2s-4.6,3.6-9.5,2.9
						s-8.3-2.6-8.3-5.5c-0.2-6,3.9-10,5-16.1c1.2-6.2,1.4-10.3,1.1-13"
          />
          <path
            class="st16"
            d="M455.8,939.7c0.5,5.6,3.6,4.6,7.5,5s7.5-1.5,8.5-3.5c2.3-4.5,2.7-11.2,3-13.2c0.3-2-0.9-7.5-3.3-9.3"
          />
          <path class="st16" d="M477.9,918.4c-1.1,1.6-2.8,4.2-3.1,6.4" />
          <path
            class="st16"
            d="M491.5,940.9c0.2,1.3,1.4,3.7,3.1,4.1c1.7,0.3,7.8,0.5,11.4,0.3c3.6-0.2,5.4-4,6-5.9"
          />
          <path
            class="st16"
            d="M597.1,921c2.7,0,9-3.9,10-7.1c1-3.2,0.7-9.8-2.7-12.2c-3.4-2.4-8.1-4.6-9.5-6.8"
          />
          <path
            class="st16"
            d="M608.6,909.8c2,0.5,6.1-2.4,6.6-4.9c0.5-2.4-0.7-12.5-5.6-14.2c-4.9-1.7-7.1-2.9-7.1-3.9"
          />
          <path
            class="st16"
            d="M615.4,902.2c6.4,0,7.4-12.9-1.5-19.6c-5-3.8-9.1,1-9.1,1"
          />
          <path
            d="M389.6,820.7c1.9-3.2,7-14.6,9.2-34.3c-2.8,2.9-4.6,4.5-7,5c-0.9,1.4-4.4,7.2-7.8,8c0.5,2.5,2.1,9.9,1,12.2
						c0.5,1.1,1.7,5.3,1.3,6.4C387.4,819.2,389.6,820.7,389.6,820.7z"
          />
        </g>
      </g>
      <g id="militaryHat">
        <g id="militaryHat-fill">
          <path
            class="st17"
            d="M818.9,354.7c0.4-7.1-6.2-13.8-18.2-18.3l0.4-0.8l-87.6-41.9c-0.8-0.4-1.3-1.2-1.3-2
						c0-6.3-0.1-31.4-0.1-37.5c0-0.2,0-0.4,0-0.6c0-1.7-0.3-3.1-0.6-4.2c-0.9-3.5-2.7-4.9-2.7-4.9c-4.4-53.4-21.2-85.4-27.1-96.5
						c-1.5-2.9-3-3.3-6.1-4.2c-12.5-3.8-42.4-9.9-145.8-0.7c-33,2.9-98.7,15.5-127.4,22.6c-6,1.5-17.8,6.9-21.1,9.8
						c-4.1,3.5-11.6,14.3-15.6,22.3c-3.4,6.8-4.5,18.2-4.2,26.9c1,22.6,5.5,51.6,10,79c2.7,16.2,5.3,31.7,7.2,45
						c0.2,1.3,0.6,2.5,1.3,3.5l8.2,12.4c0,0,14.1-0.3,40.4-8.5c34.4,35,100.2,51.2,115.5,52.1c10.3,0.6,29-3.2,51.7-10.5l-0.2-1.5
						c48.2-17.9,84.2-46.2,136.8-52.9c49.2-6.3,85.2,10.8,83.9,20.2C817.8,361.3,818.7,358.4,818.9,354.7z"
          />
        </g>
        <g id="militaryHat-shadow">
          <g>
            <path
              class="st18"
              d="M434.7,346.9l-31.1,8.5c-0.2,0.1-0.4,0-0.5-0.2c-0.7-0.9-3.3-4.4-3.5-7.6c-0.2-3.7,1-5.5,4.4-6.5
							c2.9-0.8,33.6-11.3,42.3-14.2c0.2-0.1,0.1-0.3-0.1-0.3l-41.6,8.9c-0.2,0-0.4,0-0.6-0.1l-3-2.3c-0.4-0.3-0.7-0.7-0.7-1.2l-1-6.1
							c-0.1-0.4,0.2-0.8,0.6-0.9l5.7-1.9l175.6-40.8c0.3-0.1,0.2-0.5-0.1-0.5l-47.8,7.8c-2.7,0.4-5.4,1-8,1.6L434.4,312l-27.5,7.2
							c-0.4,0.1-0.8,0-1.1-0.2l-2.4-1.7c-0.3-0.2-0.4-0.7-0.2-1l0.6-1.1c0.2-0.3,0.5-0.5,0.8-0.6l32.2-10.3l25.9-8.3l50.3-15.2
							c0.4-0.1,0.3-0.8-0.2-0.7l-92.2,21.5l-21.8,9.1c-0.3,0.1-0.6,0.1-0.8-0.2l-2.2-2.4c-1.1-1.1-1.8-2.4-2.3-3.9l-1.7-5.1
							c0,0-5.9-63-5.7-66.9c0.3-6.3,11-33.4,14.2-40.4c0.5-1.1,1.4-1.8,2.6-2.1l47.6-10.4c3.6-0.8,15.8-3.5,23.6-4.2
							c6.5-0.5,37.2-4.4,47.4-5.8c2.2-0.3,4.9-0.5,6.9-1.6c0,0,0,0,0,0c0.7-0.2,0.6-1.2-0.1-1.2l-0.6,0c-3.4-0.3-16.9,0.6-20.3,1
							l-47.9,4.6c-2.6,0.3-4-1-6.5-0.5l-10.4,1.5l-26.7,3.6c-0.6,0.1-0.9-0.7-0.4-1l15.3-9.1c0.9-0.5,1.8-1,2.7-1.5l18.1-8.6l-42.5,8.1
							l-22.5,6.6l-6.1,4.2l-9.3,13.7l-4.2,5.9L363,205l-1.5,11l0.5,12.2l10,76l6.8,47.6l8.8,12.9l2.9,1l34.4-10l3.4-2L434.7,346.9z"
            />
            <g>
              <path
                class="st18"
                d="M461.9,344.4c3.3,1.9,6.7,3.5,10.1,5.2c3.4,1.6,6.9,3.2,10.4,4.7c7,3,14.1,5.9,21.2,8.5
								c7.1,2.6,14.4,5,21.7,7.1c7.3,2.1,14.7,3.8,22.2,4.8c15.1,2.1,30.3,3,45.4,1.3c15.1-1.6,29.8-5.8,44.3-10.6
								c0.2-0.1,0.4,0,0.5,0.2c0.1,0.2,0,0.4-0.2,0.5c-14.2,5.5-29,10.1-44.3,12c-7.6,1-15.4,1.3-23,1c-7.7-0.3-15.3-1.1-22.9-2.2
								c-7.6-1-15.1-2.9-22.5-5c-7.4-2.2-14.6-4.6-21.8-7.4c-7.2-2.7-14.2-5.6-21.2-8.7c-3.5-1.6-7-3.1-10.4-4.8
								c-3.4-1.7-6.9-3.4-10.2-5.3c-0.4-0.2-0.5-0.7-0.3-1C461.1,344.3,461.5,344.2,461.9,344.4L461.9,344.4z"
              />
            </g>
            <g>
              <path
                class="st18"
                d="M490.2,335.7c2.1,1.2,4.5,2.2,6.8,3.2c2.3,1,4.6,1.9,7,2.8c4.7,1.8,9.4,3.4,14.2,5
								c9.6,3.1,19.3,5.7,29.1,7.8c4.9,1.1,9.8,2,14.8,2.7c5,0.8,9.9,1.4,14.9,1.8c10,0.9,20,0.9,30-0.2c0.2,0,0.4,0.1,0.4,0.3
								c0,0.2-0.1,0.3-0.3,0.4c-9.9,2-20.2,2.4-30.3,1.7c-5.1-0.3-10.1-0.8-15.1-1.5c-5-0.8-10-1.7-15-2.7c-9.9-2.2-19.7-5-29.2-8.2
								c-4.8-1.6-9.5-3.4-14.2-5.3c-2.3-1-4.7-2-7-3c-2.3-1.1-4.6-2.1-6.8-3.5c-0.3-0.2-0.4-0.6-0.2-1
								C489.4,335.7,489.8,335.5,490.2,335.7L490.2,335.7z"
              />
            </g>
          </g>
        </g>
        <g id="militaryHat-lines">
          <path
            d="M675.4,350.8c5.6-2.7,11.3-5.2,17.1-7.5c5.8-2.3,11.7-4.4,17.6-6.1c11.9-3.7,24.2-6.3,36.7-7.7c6.2-0.8,12.5-1.1,18.8-1
						c6.3,0.1,12.6,0.4,18.9,1.4c6.2,1,12.5,2.5,18.4,5.1c3,1.3,5.8,2.7,8.5,4.6c2.7,1.9,5.2,4.1,7.1,7.1c0.9,1.5,1.7,3.1,2,4.8
						c0.2,0.9,0.3,1.8,0.3,2.7c0,0.5,0,0.9-0.1,1.3c0,0.4-0.1,0.8-0.1,1.2c-0.4,3.3-1.6,6.7-3.9,9.4c-2.3,2.7-5.6,4.4-9,5
						c-3.4,0.6-6.7,0.3-9.9-0.4c-3.2-0.8-6.1-1.9-9-3.1l-8.6-3.6c-5.7-2.3-11.4-4.8-17.2-6.8c-2.9-1-5.8-1.9-8.7-2.6
						c-2.9-0.7-5.9-1.2-8.9-1.5c-6-0.7-12.1-0.6-18,0.5c-6,1-12,2.5-17.9,4.2c-5.9,1.7-11.8,3.6-17.6,5.5c-11.7,4-23.2,8.3-34.7,12.9
						c-5.7,2.3-11.5,4.6-17.2,7c-5.7,2.4-11.4,4.8-17.2,7c-11.6,4.5-23.3,8.6-35.2,12.2c-6,1.8-12,3.4-18.1,4.7
						c-6.1,1.3-12.2,2.5-18.6,3c-1.6,0.1-3.2,0.2-4.8,0.2c-1.6,0-3.3-0.1-4.8-0.3c-3.2-0.4-6.2-1-9.3-1.6c-6.1-1.3-12.1-2.9-18.1-4.6
						c-11.9-3.5-23.7-7.8-35.1-12.8c-11.4-5.1-22.4-11-32.8-18.1c-5.1-3.6-10.1-7.4-14.7-11.7c-1.2-1.1-2.3-2.2-3.4-3.3l-0.2-0.2
						c-0.1-0.1-0.1-0.1-0.3-0.3c-0.3-0.3-0.5-0.6-0.6-1c-0.3-0.7-0.4-1.5-0.2-2.2c0.1-0.7,0.5-1.4,0.9-1.9c0.1-0.1,0.3-0.3,0.4-0.4
						l0.2-0.2l0.4-0.4l3.6-3c1.5-1.2,3.5-1.8,5.5-1.8c0.1,0,0.2,0,0.3,0l2.6,0.6c0.9,0.2,1.5,1.2,1.3,2.1s-1.2,1.5-2.1,1.3l-2.6-0.6
						l0.3,0c-1.1,0-2.3,0.3-3.2,1l-3.5,2.9l-0.4,0.4l-0.2,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0
						c0,0,0.1,0.1,0.1,0.1l0.2,0.2c1.1,1.1,2.2,2.1,3.3,3.2c4.5,4.1,9.3,7.9,14.3,11.4c10.1,6.9,21,12.7,32.2,17.7
						c11.2,5,22.8,9.2,34.6,12.7c5.9,1.7,11.9,3.3,17.9,4.5c3,0.6,6,1.2,9,1.6c3,0.4,5.9,0.4,8.9,0.2c6-0.5,12.1-1.6,18.1-2.9
						c6-1.3,11.9-2.9,17.8-4.7c11.8-3.5,23.5-7.6,35-12c5.8-2.2,11.4-4.6,17.2-7c5.7-2.4,11.5-4.7,17.2-7c11.5-4.5,23.1-8.9,34.9-12.9
						c5.9-2,11.8-3.9,17.8-5.6c6-1.7,12-3.3,18.3-4.3c6.2-1.1,12.7-1.2,19-0.5c3.1,0.3,6.3,0.9,9.3,1.6c3.1,0.7,6.1,1.6,9.1,2.6
						c3,1,5.9,2.2,8.8,3.3l8.6,3.5l8.5,3.6c2.8,1.2,5.7,2.2,8.5,2.9c2.8,0.6,5.7,0.9,8.5,0.4c2.7-0.5,5.2-1.8,7-3.8
						c1.7-2,2.7-4.7,3-7.6c0.2-1.5,0.2-2.8-0.1-4c-0.3-1.3-0.8-2.5-1.6-3.6c-1.5-2.3-3.7-4.2-6.2-5.7c-2.5-1.6-5.2-2.8-8-3.9
						c-2.8-1.1-5.7-1.9-8.6-2.5c-2.9-0.7-5.9-1.2-8.9-1.7c-6-0.8-12.1-1.3-18.1-1.3c-6.1,0-12.2,0.3-18.3,0.9
						c-24.4,2.4-48.2,9.1-71.2,18.2c-0.5,0.2-1,0-1.2-0.5C674.8,351.6,675,351.1,675.4,350.8z"
          />
          <path
            class="st5"
            d="M801.8,336l-88.4-42.3c-0.8-0.4-1.3-1.2-1.3-2c0-6.3-0.1-31.4-0.1-37.5c0-7-3.3-9.8-3.3-9.8
						c-4.4-53.4-21.3-85.4-27.1-96.5c-1.5-2.9-3-3.3-6.1-4.2c-12.5-3.8-42.4-9.9-145.8-0.7c-33,2.9-98.7,15.5-127.4,22.6
						c-6,1.5-17.7,6.9-21.1,9.8c-4.2,3.5-11.6,14.3-15.6,22.4c-3.4,6.8-4.5,18.2-4.2,26.9c1.5,36,12,88.2,17.2,124
						c0.2,1.3,0.6,2.5,1.4,3.6l8.2,12.4c0,0,14.1-0.3,40.4-8.5"
          />
          <path
            d="M549.9,393.2c-5.1,0.8-10.3,0.8-15.4,0.3c-5.1-0.5-10.2-1.3-15.2-2.4c-10-2.2-19.7-5.3-29.2-9
						c-9.5-3.7-18.8-7.9-27.9-12.5c-2.3-1.2-4.6-2.4-6.7-3.8c-2.2-1.4-4.3-2.9-6.3-4.5c-2-1.6-4-3.3-5.8-5.1c-0.9-0.9-1.8-1.9-2.7-2.9
						c-0.4-0.5-0.8-1.1-1.2-1.7c-0.2-0.3-0.4-0.6-0.6-1c-0.1-0.2-0.2-0.4-0.3-0.7c-0.1-0.3-0.2-0.7,0-1.3l0,0c0.1-0.3,0.2-0.5,0.4-0.7
						c2.8-2.7,6-4.3,9.2-5.9c3.2-1.6,6.4-2.9,9.7-4.2c1.6-0.6,3.2-1.3,5-1.9c1.7-0.6,3.4-1.1,5-1.6c3.3-1,6.7-2,10-3
						c13.4-3.8,26.8-7.6,40.2-11.2c6.7-1.8,13.4-3.6,20.2-5.2c6.9-1.6,13.7-2.9,20.6-4.1c13.7-2.5,27.4-4.7,41.2-6.8l20.6-3.1
						c7-1,13.9-1.7,20.8-2.5c13.8-1.5,27.7-3,41.5-4.4l10.4-1l5.2-0.5c1.8-0.2,3.5-0.2,5.1-0.4c1.6-0.2,3.3-0.5,4.6-1
						c0.7-0.2,1.2-0.5,1.5-0.8c0.1-0.1,0.2-0.2,0.2-0.2c0,0,0,0,0-0.1c0,0,0,0,0-0.1l0-0.3l0-10.4l0-20.9l0-2.6c0-0.9,0-1.7,0-2.5
						c0-0.8-0.1-1.6-0.2-2.1c-0.1-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.9-0.3-1.6-0.5c-0.8-0.1-1.6-0.2-2.4-0.3
						l-2.6-0.3c-0.8,0-1.6-0.1-2.4-0.1c-6.8-0.2-13.8,0-20.7,0.1l-20.8,0.5l-20.8,0.5c-6.9,0.2-13.9,0.5-20.8,1
						c-6.9,0.4-13.7,1.4-20.6,2.4c-6.9,1-13.7,2.2-20.5,3.4c-13.7,2.4-27.3,5-41,7.6c-13.6,2.6-27.3,5.1-40.9,8.1l-20.3,4.6l-10.1,2.4
						c-3.4,0.8-6.7,1.6-10.1,2.5c-13.4,3.5-26.6,7.5-39.7,12.1c-6.5,2.3-13,4.8-19.3,7.4c-6.3,2.7-12.7,5.5-18.7,8.7l0,0l0,0
						c-0.8,0.4-1.8,0.2-2.3-0.6l-3.3-5.2c-0.5-0.8-0.3-1.9,0.5-2.4c0.8-0.5,1.9-0.3,2.4,0.5c0,0,0,0,0,0l3.3,5.3l-2.3-0.6l0,0
						c6.1-3.6,12.4-6.6,18.8-9.5c6.4-2.8,12.9-5.5,19.4-8c6.5-2.4,13.2-4.7,19.8-6.8c3.3-1.1,6.7-2.1,10-3.1c3.4-0.9,6.7-1.9,10.1-2.8
						c3.4-0.9,6.8-1.7,10.2-2.5c1.7-0.4,3.4-0.8,5.1-1.2l5.1-1.1c6.8-1.5,13.7-2.7,20.5-4.1c13.7-2.6,27.3-5.5,41-8
						c13.7-2.5,27.4-5,41.1-7.2c6.9-1.1,13.7-2.2,20.6-3.2c3.4-0.5,6.9-1,10.4-1.4c3.5-0.4,7-0.8,10.5-1.1c13.9-1,27.8-2,41.7-2.5
						c7-0.3,13.9-0.5,20.9-0.6c7-0.1,13.9-0.2,21,0c0.9,0,1.8,0.1,2.8,0.2l2.6,0.3c0.9,0.1,1.8,0.2,2.7,0.4c0.9,0.2,2,0.4,3.3,1.1
						c0.6,0.4,1.2,1,1.6,1.7c0.4,0.7,0.6,1.3,0.7,1.9c0.3,1.1,0.3,2.1,0.3,3c0,0.9,0,1.8,0,2.7l0,2.6l0,20.8l0,10.4l0,0.4
						c0,0.2,0,0.4,0,0.6c0,0.4-0.2,0.8-0.3,1.2c-0.3,0.8-0.8,1.4-1.3,1.9c-1,0.9-2.1,1.4-3,1.7c-1.9,0.7-3.8,1-5.6,1.2
						c-1.8,0.2-3.6,0.3-5.3,0.4l-5.2,0.5l-10.4,1c-13.8,1.3-27.7,2.8-41.5,4.2c-6.9,0.8-13.8,1.5-20.6,2.4l-20.6,3.1
						c-13.7,2.1-27.5,4.3-41.1,6.7c-6.8,1.2-13.7,2.5-20.4,4c-6.7,1.6-13.4,3.4-20.2,5.1c-13.4,3.5-26.9,7.1-40.2,10.8
						c-3.3,0.9-6.7,1.9-10,2.9c-1.7,0.5-3.3,1-4.9,1.5c-1.6,0.5-3.2,1.2-4.8,1.8c-3.2,1.2-6.4,2.6-9.5,4c-3,1.5-6.1,3.1-8.4,5.2
						l0.4-0.7l0,0c0.1-0.3,0-0.4,0-0.4c0,0,0,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.4,0.7,0.9,1.1,1.3c0.8,0.9,1.7,1.7,2.6,2.6
						c1.8,1.7,3.7,3.3,5.7,4.8c4,3,8.1,5.5,12.6,7.9c4.4,2.4,9,4.5,13.6,6.5c4.6,2,9.3,4,13.9,5.8c9.4,3.6,18.9,6.9,28.6,9.3
						c9.7,2.4,19.7,4.2,29.6,3.2l0,0c0.6-0.1,1.1,0.4,1.2,1C550.9,392.6,550.5,393.1,549.9,393.2z"
          />
          <path
            d="M671.6,154.6c-12.3-0.7-24.5-1.4-36.7-0.9c-12.3,0.4-24.5,1-36.8,1.6c-6.1,0.3-12.3,0.6-18.4,1.1
						c-6.1,0.4-12.2,1.1-18.3,1.7c-12.2,1.3-24.4,2.7-36.6,4.1c-12.2,1.4-24.4,3-36.6,4.5c-3,0.4-6.1,0.8-9.1,1.3
						c-1.5,0.2-3,0.5-4.5,0.8c-1.5,0.3-3,0.5-4.5,0.8c-6,1.2-12,2.5-18,3.8c-24,5.1-48.1,10.2-72.2,15.1c-0.3,0.1-0.6-0.1-0.6-0.4
						c-0.1-0.3,0.1-0.5,0.4-0.6c11.8-3.4,23.7-6.5,35.6-9.6c11.9-3,23.9-6.1,35.9-8.6c6-1.3,12.1-2.5,18.1-3.6c6.1-1.1,12.2-2.1,18.3-3
						c12.2-1.8,24.4-3.3,36.6-4.9c12.2-1.5,24.4-2.9,36.7-4.2c6.1-0.6,12.2-1.3,18.4-1.7c6.2-0.4,12.3-0.6,18.5-0.9
						c12.3-0.5,24.6-0.8,36.9-0.8c3.1,0,6.2,0,9.3,0.1c3.1,0.1,6.2,0.3,9.3,0.6c6.2,0.5,12.3,1.3,18.4,2.3c0.4,0.1,0.7,0.5,0.7,0.9
						C672.4,154.3,672,154.6,671.6,154.6L671.6,154.6z"
          />
          <path
            d="M598.8,153.7c2.4,8,4.8,15.9,6.9,24c0.5,2,1.1,4,1.5,6.1l1.3,6.1l2.7,12.1c1.8,8.1,3.6,16.2,5.4,24.3
						c0.4,2,0.9,4.1,1.3,6.1c0.4,2.1,0.7,4.1,1.2,6c0.4,2,0.9,3.9,1.7,5.6c0.4,0.8,0.8,1.7,1.3,2.2c0.5,0.6,0.9,0.8,1.3,0.8l0.2,0
						c1,0,1.7,0.8,1.7,1.8c0,1-0.8,1.7-1.8,1.7c0,0-0.1,0-0.1,0c-0.4,0-0.8-0.1-1.2-0.1c-0.4-0.1-0.8-0.2-1.1-0.4
						c-0.3-0.2-0.7-0.4-1-0.6c-0.3-0.2-0.5-0.5-0.8-0.7c-0.9-1-1.4-2.1-1.9-3.1c-0.9-2.1-1.4-4.2-1.9-6.3c-0.5-2.1-0.8-4.1-1.2-6.2
						c-0.4-2-0.8-4-1.2-6.1c-1.7-8.1-3.5-16.2-5.3-24.3l-2.7-12.2l-1.3-6.1c-0.5-2-1-4-1.5-6c-2.1-8-4.5-15.9-6.9-23.8l0,0
						c-0.3-0.9,0.2-1.9,1.2-2.2C597.5,152.2,598.5,152.7,598.8,153.7z"
          />
          <path
            d="M598.8,153.7c1.2,4.1,2.3,8.1,3.5,12.2c1.1,4.1,2.3,8.1,3.4,12.3c0.5,2.1,1.1,4.1,1.5,6.2c0.5,2.1,0.9,4.2,1.3,6.2
						l2.5,12.4c1.6,8.3,3.5,16.5,5.4,24.8c0.5,2.1,0.9,4.1,1.4,6.2c0.5,2.1,0.9,4.1,1.2,6.3c0.1,1.1,0.3,2.2,0.3,3.4
						c0,1.2-0.1,2.6-0.8,4c-0.7,1.4-2,2.5-3.2,3c-1.3,0.5-2.4,0.7-3.6,0.8c-1,0.1-1.8-0.6-1.9-1.5c-0.1-0.9,0.5-1.7,1.3-1.9l0.1,0
						c0.9-0.2,1.8-0.5,2.5-0.9c0.7-0.4,1-0.7,1.2-1.3c0.2-0.5,0.3-1.3,0.3-2.2c0-0.9-0.1-1.9-0.3-2.9c-0.3-2-0.6-4.1-1.1-6.2
						c-0.4-2.1-0.8-4.1-1.1-6.2c-1.5-8.3-2.9-16.6-4.7-24.9l-2.5-12.4c-0.4-2.1-0.8-4.2-1.3-6.2c-0.5-2-1-4.1-1.5-6.1
						c-2.2-8.1-4.7-16.2-7.2-24.2l0,0c-0.3-0.9,0.2-1.9,1.1-2.2S598.5,152.7,598.8,153.7C598.7,153.6,598.8,153.6,598.8,153.7z"
          />
          <path
            d="M687,290.3c-8.9,0.4-17.9,1.3-26.8,2.2l-26.9,2.6l-27,2.6c-8.9,1-17.8,2.6-26.7,4c-8.9,1.5-17.8,3-26.7,4.3l-13.4,1.9
						c-2.2,0.3-4.4,0.7-6.6,1.1c-2.2,0.4-4.4,0.9-6.6,1.3c-4.4,0.9-8.8,1.9-13.3,2.8l-13.3,2.6c-4.4,0.9-8.8,1.8-13.2,2.7l-6.6,1.4
						c-1.1,0.3-2.2,0.5-3.3,0.8l-1.6,0.4l-1.5,0.5l-0.1,0c-0.5,0.2-1.1-0.1-1.3-0.7c-0.2-0.5,0.1-1.1,0.6-1.3l1.7-0.6l1.6-0.5
						c1.1-0.3,2.2-0.6,3.3-0.9c2.2-0.6,4.4-1.1,6.6-1.6c4.4-1,8.8-2,13.2-3l13.2-2.8l13.3-2.7c4.4-0.9,8.8-2,13.3-2.9
						c4.4-0.9,8.9-1.8,13.3-2.6c8.9-1.6,17.8-2.9,26.8-4c9-1.1,17.9-2.3,26.9-3.3c4.5-0.4,8.9-0.9,13.4-1.5l13.4-1.8
						c4.5-0.6,8.9-1.2,13.4-1.7l13.5-1.3c4.5-0.5,9-0.8,13.5-1.1c4.5-0.3,9.1-0.5,13.6-0.5c1,0,1.7,0.8,1.7,1.7
						C688.7,289.5,688,290.2,687,290.3L687,290.3z"
          />
          <path
            d="M421.2,301.1c5.7-1.8,11.5-3.4,17.2-5c5.8-1.6,11.5-3.1,17.3-4.7c11.6-3.1,23.1-6.1,34.7-9c5.8-1.5,11.6-2.9,17.4-4.3
						c5.8-1.4,11.7-2.6,17.6-3.8c5.9-1.2,11.7-2.3,17.6-3.4c5.9-1.1,11.8-2.1,17.7-3.1c11.8-2,23.6-3.9,35.5-5.4
						c11.9-1.5,23.8-2.5,35.8-3.4c23.9-1.7,47.8-2.4,71.8-2.2c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-23.9,0.2-47.8,1.1-71.5,3.2
						c-11.9,1-23.8,2.2-35.6,3.8c-11.8,1.6-23.6,3.4-35.4,5.4c-11.8,2.1-23.5,4.2-35.2,6.5c-11.7,2.3-23.3,4.9-35,7.6
						c-11.6,2.7-23.3,5.5-34.9,8.3l-17.4,4.3c-5.8,1.4-11.6,2.9-17.3,4.5l0,0c-0.3,0.1-0.7-0.1-0.8-0.4
						C420.7,301.6,420.9,301.2,421.2,301.1z"
          />
          <path class="st5" d="M608.8,242.1c0-5.9-2.9-36.6-16.9-87.7" />
          <path
            d="M732.4,343.3c-52.6,6.7-88.6,35-136.8,52.9l0.2,2c11.8-4,24.6-9,38.3-14.7c39.2-16.3,79.2-31,98.8-32.4
						c19.6-1.4,34.2,5.7,45.2,10.1s18.1,8.4,25.7,8.4c4.2,0,9.6-1.6,12.4-4.9l0-0.7C818.9,354.7,782.5,336.9,732.4,343.3z"
          />
          <path
            d="M595.7,168.6c1.8-0.1,5.5,1.6,6.1,3.4c-0.9-3.5-5-18.4-5-18.4l-5.6,0.4L595.7,168.6z"
          />
        </g>
      </g>
    </svg>
  </div>
</main>
{/if}


